
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aJxVU", function(module, exports) {
var $4ebec39a07b8f9ed$export$5ad15ff4d6b74b3f = /*#__PURE__*/ function(ConvoAIResponseState) {
    ConvoAIResponseState["Initialization"] = "Initialization";
    ConvoAIResponseState["ChannelId"] = "ChannelId";
    ConvoAIResponseState["AnswerPart"] = "AnswerPart";
    ConvoAIResponseState["FinalResponse"] = "FinalResponse";
    ConvoAIResponseState["FollowUp"] = "FollowUp";
    ConvoAIResponseState["Error"] = "Error";
    ConvoAIResponseState["Trace"] = "Trace";
    return ConvoAIResponseState;
}({});
function $4ebec39a07b8f9ed$export$c25f824513be9f8a() {
    return {
        content: null,
        responseState: "Initialization"
    };
}
module.exports["ConvoAIResponseState"] = $4ebec39a07b8f9ed$export$5ad15ff4d6b74b3f;
module.exports["getDefaultConvoAIStreamingState"] = $4ebec39a07b8f9ed$export$c25f824513be9f8a;

});

parcelRegister("6yMHm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5BvyC = parcelRequire("5BvyC");

var $8jDil = parcelRequire("8jDil");

var $7GbwS = parcelRequire("7GbwS");

const $94c9263f0d9de177$export$baf23e7d4a1078c1 = (siteId, contentId, contentType)=>{
    const pageAri = (0, $cozmU.useMemo)(()=>{
        try {
            switch(contentType){
                case 'page':
                    return (0, $8jDil.ConfluencePageAri).create({
                        siteId: siteId,
                        pageId: contentId
                    }).toString();
                case 'blogpost':
                    return (0, $5BvyC.ConfluenceBlogpostAri).create({
                        siteId: siteId,
                        blogpostId: contentId
                    }).toString();
                case 'whiteboard':
                    return (0, $7GbwS.ConfluenceWhiteboardAri).create({
                        siteId: siteId,
                        whiteboardId: contentId
                    }).toString();
            }
        } catch  {
            return null;
        }
    }, [
        contentType,
        siteId,
        contentId
    ]);
    return {
        pageAri: pageAri
    };
};
module.exports["useConfluencePageAri"] = $94c9263f0d9de177$export$baf23e7d4a1078c1;

});

parcelRegister("h0VcS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gGP9M = parcelRequire("gGP9M");

function $72db1ee7290474aa$export$42102e336cc49836(onObservableInit, inputs) {
    const [inputSubject$] = (0, $cozmU.useState)(()=>new (0, $gGP9M.Subject)());
    const [observable$] = (0, $cozmU.useState)(()=>onObservableInit(inputSubject$));
    (0, $cozmU.useEffect)(()=>{
        const subscription$ = observable$.subscribe();
        return ()=>{
            subscription$.unsubscribe();
        };
    }, [
        observable$
    ]);
    const callback = (0, $cozmU.useCallback)((nextState)=>inputSubject$.next(nextState), [
        inputSubject$
    ]);
    (0, $cozmU.useEffect)(()=>{
        inputSubject$.next(inputs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        callback
    ];
}
module.exports["useObservableEffect"] = $72db1ee7290474aa$export$42102e336cc49836;

});

parcelRegister("4gJu8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2j0AL = parcelRequire("2j0AL");


var $gGP9M = parcelRequire("gGP9M");

function $03b026949f955090$export$7e63706be514842f(onObservableInit, initialState) {
    const [inputSubject$] = (0, $cozmU.useState)(()=>new (0, $gGP9M.Subject)());
    const [observable$] = (0, $cozmU.useState)(()=>onObservableInit(inputSubject$));
    const stateSnapshot = (0, $cozmU.useRef)(initialState);
    const subscribe = (0, $cozmU.useCallback)((handleStoreChange)=>{
        const subscription = observable$.subscribe({
            next: (nextState)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($2j0AL)))(nextState, stateSnapshot.current)) {
                    stateSnapshot.current = nextState;
                    handleStoreChange();
                }
            },
            // eslint-disable-next-line no-console
            error: (err)=>console.error(err),
            complete: ()=>inputSubject$.complete()
        });
        return ()=>subscription.unsubscribe();
    }, [
        inputSubject$,
        observable$
    ]);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        return stateSnapshot.current;
    }, [
        stateSnapshot
    ]);
    const callback = (0, $cozmU.useCallback)((nextState)=>{
        inputSubject$.next(nextState);
    }, [
        inputSubject$
    ]);
    // Provide a server snapshot for SSR
    const getServerSnapshot = (0, $cozmU.useCallback)(()=>{
        return stateSnapshot.current;
    }, [
        stateSnapshot
    ]);
    const state = (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, getServerSnapshot);
    return [
        state,
        callback
    ];
}
module.exports["useStatefulObservableLazyEffect"] = $03b026949f955090$export$7e63706be514842f;

});

parcelRegister("aedCm", function(module, exports) {

var $2j0AL = parcelRequire("2j0AL");


var $lv9Cv = parcelRequire("lv9Cv");


var $1PPDm = parcelRequire("1PPDm");


var $ifZfw = parcelRequire("ifZfw");


var $hrJHY = parcelRequire("hrJHY");


var $1xJn2 = parcelRequire("1xJn2");


var $8Bx1z = parcelRequire("8Bx1z");


var $5pyN0 = parcelRequire("5pyN0");


var $ebEo2 = parcelRequire("ebEo2");


var $c7Xul = parcelRequire("c7Xul");


var $1mLOG = parcelRequire("1mLOG");


var $cmyqT = parcelRequire("cmyqT");


var $6ahXt = parcelRequire("6ahXt");

const $1b669b423c0aa45c$export$39a530c281991f7b = (request, config)=>{
    const requestInitParams = {
        method: 'POST',
        headers: new Headers({
            ...config.headers
        }),
        body: JSON.stringify(request)
    };
    return {
        requestInitParams: requestInitParams,
        url: `${config.baseUrl}/${config.apiPath}`
    };
};



var $8JfQr = parcelRequire("8JfQr");

const $0044dc2f4e50da38$export$7c03f5942efb8a41 = '/gateway/api/assist/api/ai';


const $3fedd9e41e604118$var$baseUrl = (0, $8JfQr.Lens).fromNullableProp()('baseUrl', (0, $0044dc2f4e50da38$export$7c03f5942efb8a41));
const $3fedd9e41e604118$var$enablePartialJson = (0, $8JfQr.Lens).fromNullableProp()('enablePartialJson', false);
const $3fedd9e41e604118$var$enableFollowUp = (0, $8JfQr.Lens).fromNullableProp()('enableFollowUp', false);
const $3fedd9e41e604118$var$enableLocalVerboseLogs = (0, $8JfQr.Lens).fromNullableProp()('enableLocalVerboseLogs', false);
const $3fedd9e41e604118$var$enableTraceMessage = (0, $8JfQr.Lens).fromNullableProp()('enableTraceMessage', false);
const $3fedd9e41e604118$var$skip = (0, $8JfQr.Lens).fromNullableProp()('skip', false);
const $3fedd9e41e604118$var$contentType = (0, $8JfQr.Lens).fromNullableProp()('content-type', 'application/json;charset=UTF-8');
const $3fedd9e41e604118$var$xIssyntheticTraffic = (0, $8JfQr.Lens).fromNullableProp()('x-issynthetic-traffic', 'false');
function $3fedd9e41e604118$var$getHeaders(config) {
    const headers = {
        'content-type': $3fedd9e41e604118$var$contentType.get(config.headers),
        'x-product': config.headers['x-product'],
        'x-experience-id': config.headers['x-experience-id'],
        'x-issynthetic-traffic': $3fedd9e41e604118$var$xIssyntheticTraffic.get(config.headers)
    };
    if (config.headers['x-channel-id']) headers['x-channel-id'] = config.headers['x-channel-id'];
    return headers;
}
const $3fedd9e41e604118$export$98f0249d9632eade = (config)=>({
        baseUrl: $3fedd9e41e604118$var$baseUrl.get(config),
        apiPath: config.apiPath,
        enablePartialJson: $3fedd9e41e604118$var$enablePartialJson.get(config),
        enableFollowUp: $3fedd9e41e604118$var$enableFollowUp.get(config),
        enableTraceMessage: $3fedd9e41e604118$var$enableTraceMessage.get(config),
        enableLocalVerboseLogs: $3fedd9e41e604118$var$enableLocalVerboseLogs.get(config),
        timeoutDelay: config.timeoutDelay,
        skip: $3fedd9e41e604118$var$skip.get(config),
        headers: $3fedd9e41e604118$var$getHeaders(config)
    });



var $4Otfs = parcelRequire("4Otfs");


var $aJxVU = parcelRequire("aJxVU");


var $4sZo0 = parcelRequire("4sZo0");

function $d998a7407bd111dd$export$2f20a85d8fafe2d9(requestConfig) {
    const behaviorSubject = new (0, $4Otfs.BehaviorSubject)((0, $aJxVU.getDefaultConvoAIStreamingState)());
    fetch(requestConfig.url, {
        credentials: 'include',
        ...requestConfig.requestInitParams
    }).then((response)=>(0, $4sZo0.readStream)(response)).then(async (stream)=>{
        let bufferContent = '';
        let answerChunkIndex = 0;
        for await (const chunk of stream){
            const state = behaviorSubject.getValue();
            switch(chunk.type){
                case 'ANSWER_PART':
                    bufferContent += chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $aJxVU.ConvoAIResponseState).AnswerPart,
                        content: bufferContent,
                        answerChunkIndex: answerChunkIndex
                    });
                    answerChunkIndex += 1;
                    break;
                case 'CHANNEL_ID':
                    const channelId = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $aJxVU.ConvoAIResponseState).ChannelId,
                        content: channelId,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FINAL_RESPONSE':
                    bufferContent = chunk.message.content;
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $aJxVU.ConvoAIResponseState).FinalResponse,
                        content: bufferContent,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'FOLLOW_UP_QUERIES':
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $aJxVU.ConvoAIResponseState).FollowUp,
                        answerChunkIndex: undefined,
                        followUpContent: chunk.message.follow_ups ?? []
                    });
                    break;
                case 'TRACE':
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $aJxVU.ConvoAIResponseState).Trace,
                        traceContent: chunk.message?.content ?? null,
                        answerChunkIndex: undefined
                    });
                    break;
                case 'ERROR':
                    behaviorSubject.next({
                        ...state,
                        responseState: (0, $aJxVU.ConvoAIResponseState).Error,
                        answerChunkIndex: undefined,
                        error: {
                            ...chunk
                        }
                    });
                    break;
            }
        }
    }).finally(()=>{
        behaviorSubject.complete();
    });
    return behaviorSubject;
}



var $aLFsc = parcelRequire("aLFsc");




function $849dab5d3e432f74$export$d2c9dfa182282b6d(state, config) {
    if (state.responseState !== (0, $aJxVU.ConvoAIResponseState).Initialization && config.enablePartialJson && state.content) try {
        const parsedContent = (0, $aLFsc.parse)(state.content);
        return {
            ...state,
            content: parsedContent
        };
    } catch (error) {}
    return state;
}


const $737d61536074c554$export$7eba3e1ed428e5ae = (message, config, data)=>{
    if (config.enableLocalVerboseLogs) // eslint-disable-next-line no-console
    console.info(`[@atlassian/convo-ai-streaming] [${message}]:`, data);
};





function $936dbaae2c731cc1$export$a0d56a856e9914d2(input$) {
    return input$.pipe((0, $ebEo2.skipWhile)(({ inputs: [_, { skip: skip }] })=>!!skip), (0, $1xJn2.distinctUntilChanged)(({ inputs: [prevRequest, prevConfig, prevRefetchId] }, { inputs: [nextRequest, nextConfig, nextRefetchId] })=>(0, (/*@__PURE__*/$parcel$interopDefault($2j0AL)))(prevRequest, nextRequest) && (0, (/*@__PURE__*/$parcel$interopDefault($2j0AL)))(prevConfig, nextConfig) && prevRefetchId === nextRefetchId), (0, $5pyN0.map)(({ inputs: [request, config] })=>({
            config: (0, $3fedd9e41e604118$export$98f0249d9632eade)(config),
            request: request
        })), (0, $5pyN0.map)(({ request: request, config: config })=>({
            requestConfig: (0, $1b669b423c0aa45c$export$39a530c281991f7b)(request, config),
            config: config
        })), (0, $c7Xul.switchMap)(({ requestConfig: requestConfig, config: config })=>{
        (0, $737d61536074c554$export$7eba3e1ed428e5ae)('pre request data', config, requestConfig);
        let $request = (0, $d998a7407bd111dd$export$2f20a85d8fafe2d9)(requestConfig);
        if (config.timeoutDelay) return $request.pipe((0, $cmyqT.timeout)(config.timeoutDelay), (0, $5pyN0.map)((state)=>({
                config: config,
                state: state
            })));
        return $request.pipe((0, $5pyN0.map)((state)=>({
                config: config,
                state: state
            })));
    }))// pipe() has an apparent limit of 9 operators
    // https://github.com/ReactiveX/rxjs/issues/4221#issuecomment-426774631
    .pipe((0, $8Bx1z.filter)(({ config: config, state: state })=>{
        if (!config.enableFollowUp && state.responseState === (0, $aJxVU.ConvoAIResponseState).FollowUp) return false;
        if (!config.enableTraceMessage && state.responseState === (0, $aJxVU.ConvoAIResponseState).Trace) return false;
        return true;
    }), (0, $5pyN0.map)(({ config: config, state: state })=>{
        (0, $737d61536074c554$export$7eba3e1ed428e5ae)('response data', config, state);
        const nextState = (0, $849dab5d3e432f74$export$d2c9dfa182282b6d)(state, config);
        (0, $737d61536074c554$export$7eba3e1ed428e5ae)('post json parsing content', config, state);
        return {
            state: nextState,
            config: config
        };
    }), (0, $1mLOG.timeInterval)(), (0, $ifZfw.concatMap)(({ value: { state: state, config: config }, interval: interval })=>{
        if (!config.delayChunkUpdate) return (0, $lv9Cv.of)(state);
        const { time: time, gap: gap } = config.delayChunkUpdate;
        if (interval < gap) return (0, $lv9Cv.of)(state).pipe((0, $hrJHY.delay)(time));
        return (0, $lv9Cv.of)(state);
    }), (0, $1PPDm.catchError)((error)=>{
        if (error.name === 'TimeoutError') {
            const timeoutErrorState = {
                responseState: (0, $aJxVU.ConvoAIResponseState).Error,
                content: null,
                answerChunkIndex: undefined,
                error: {
                    type: 'ERROR',
                    message: {
                        content: error.message,
                        message_template: (0, $6ahXt.ConvoAIErrorMessage).TIMEOUT,
                        status_code: (0, $6ahXt.CONVOAI_DEFAULT_ERROR_CODE)
                    }
                }
            };
            return (0, $lv9Cv.of)(timeoutErrorState);
        }
        const unexpectedErrorState = {
            responseState: (0, $aJxVU.ConvoAIResponseState).Error,
            content: null,
            error: {
                type: 'ERROR',
                message: {
                    content: error.message,
                    message_template: (0, $6ahXt.ConvoAIErrorMessage).UNEXPECTED,
                    status_code: (0, $6ahXt.CONVOAI_DEFAULT_ERROR_CODE)
                }
            }
        };
        return (0, $lv9Cv.of)(unexpectedErrorState);
    }));
}
module.exports["convoAIStreamingEffect"] = $936dbaae2c731cc1$export$a0d56a856e9914d2;

});

parcelRegister("8JfQr", function(module, exports) {
$parcel$export(module.exports, "Lens", () => Lens);
/**
 * @since 1.0.0
 */ /**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ var $195a10ed7200bcca$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $195a10ed7200bcca$export$f37f1abb2c955577 = function(B) {
    return function() {
        return {
            meet: function(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function() {
                return B.zero;
            },
            one: function() {
                return B.one;
            },
            implies: function(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var $195a10ed7200bcca$export$e759a9a7f8d04692 = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var $195a10ed7200bcca$export$c2a7ef2cc9b32b31 = function(M) {
    var getSemigroupM = $195a10ed7200bcca$export$e759a9a7f8d04692(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function() {
                return M.empty;
            }
        };
    };
};
var $195a10ed7200bcca$export$3d48c7fefc7b8ec2 = function(S) {
    return {
        add: function(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function() {
            return S.zero;
        },
        mul: function(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function() {
            return S.one;
        }
    };
};
var $195a10ed7200bcca$export$575097c1c561f76f = function(R) {
    var S = $195a10ed7200bcca$export$3d48c7fefc7b8ec2(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var $195a10ed7200bcca$export$5635d7ef4b8fee1c = function(a) {
    return function(f) {
        return f(a);
    };
};
function $195a10ed7200bcca$export$f0954fd7d5368655(a) {
    return a;
}
var $195a10ed7200bcca$export$401372c57776dc = $195a10ed7200bcca$export$f0954fd7d5368655;
function $195a10ed7200bcca$export$c983f826f44ff86(a) {
    return function() {
        return a;
    };
}
var $195a10ed7200bcca$export$a68382d9631f6c53 = /*#__PURE__*/ $195a10ed7200bcca$export$c983f826f44ff86(true);
var $195a10ed7200bcca$export$7349232f2648ca80 = /*#__PURE__*/ $195a10ed7200bcca$export$c983f826f44ff86(false);
var $195a10ed7200bcca$export$243c2ee5e7d8b05c = /*#__PURE__*/ $195a10ed7200bcca$export$c983f826f44ff86(null);
var $195a10ed7200bcca$export$3d16a43570087548 = /*#__PURE__*/ $195a10ed7200bcca$export$c983f826f44ff86(undefined);
var $195a10ed7200bcca$export$fe2a8306a887c223 = $195a10ed7200bcca$export$3d16a43570087548;
function $195a10ed7200bcca$export$8a83211c878a3f1f(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function $195a10ed7200bcca$export$ccc7b0636abaffc3(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function $195a10ed7200bcca$export$65e3907585753458() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function $195a10ed7200bcca$export$a2647aa13413c947(n) {
    return n + 1;
}
function $195a10ed7200bcca$export$8f85cc9753f280aa(n) {
    return n - 1;
}
function $195a10ed7200bcca$export$f172309911142386(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function $195a10ed7200bcca$export$91744c046de1af50(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function $195a10ed7200bcca$export$db52c4d43c315cb5(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function $195a10ed7200bcca$export$a4627e546088548d(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var $195a10ed7200bcca$export$5cc5fd8bb7edf254 = $195a10ed7200bcca$export$f172309911142386;
var $195a10ed7200bcca$export$5f584391ee0d99b4 = function(_, b) {
    return b;
};
function $195a10ed7200bcca$export$6003a5f097c73977(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var $195a10ed7200bcca$export$5c6d2e402d334f37 = function() {
    return {
        concat: function(first, second) {
            return $195a10ed7200bcca$export$ccc7b0636abaffc3(first, second);
        },
        empty: $195a10ed7200bcca$export$f0954fd7d5368655
    };
};
var $195a10ed7200bcca$export$d1699a1bbdf17835 = function(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, $195a10ed7200bcca$var$__spreadArray([
                self
            ], args, false));
        };
    };
};



var $f506e8da188a4a28$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $f506e8da188a4a28$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $f506e8da188a4a28$export$5d7e502287836e58 = function(fa) {
    return fa._tag === 'Some';
};
var $f506e8da188a4a28$export$f883a24d5edde77c = {
    _tag: 'None'
};
var $f506e8da188a4a28$export$ad14ef4001db2bcd = function(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var $f506e8da188a4a28$export$d649b6842e09f2b = function(ma) {
    return ma._tag === 'Left';
};
var $f506e8da188a4a28$export$a9d71693f0c1a85d = function(ma) {
    return ma._tag === 'Right';
};
var $f506e8da188a4a28$export$eabcd2c8791e7bf4 = function(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var $f506e8da188a4a28$export$79ffe56a765070d2 = function(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var $f506e8da188a4a28$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $f506e8da188a4a28$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $f506e8da188a4a28$export$5fd5031fecdacec3 = function(as) {
    return as[0];
};
var $f506e8da188a4a28$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $f506e8da188a4a28$export$6ca726a2417e0f3f = [];
var $f506e8da188a4a28$export$4de80339753b012b = {};
var $f506e8da188a4a28$export$a4f4bb6b1453fff5 = Object.prototype.hasOwnProperty;
var $f506e8da188a4a28$export$7e77326b0f0e268c = function(as) {
    return $f506e8da188a4a28$var$__spreadArray([
        as[0]
    ], as.slice(1), true);
};
var $f506e8da188a4a28$export$cd139e14432f317b = function(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? $f506e8da188a4a28$export$eabcd2c8791e7bf4(onNullable.apply(void 0, a)) : $f506e8da188a4a28$export$79ffe56a765070d2(o));
        };
    };
};
var $f506e8da188a4a28$export$ea4a22f93200df79 = function(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither($f506e8da188a4a28$export$e56af863d5645d5f(o) ? $f506e8da188a4a28$export$eabcd2c8791e7bf4(onNone.apply(void 0, a)) : $f506e8da188a4a28$export$79ffe56a765070d2(o.value));
        };
    };
};
var $f506e8da188a4a28$export$1a0515933c5c84fe = function(F, M) {
    return /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(3, function(self, f, onNullable) {
        return M.flatMap(self, $f506e8da188a4a28$export$cd139e14432f317b(F)(f, onNullable));
    });
};
var $f506e8da188a4a28$export$b5f02b7beb8ed7d8 = function(F, M) {
    return /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(3, function(self, f, onNone) {
        return M.flatMap(self, $f506e8da188a4a28$export$ea4a22f93200df79(F)(f, onNone));
    });
};
var $f506e8da188a4a28$export$979f2bb6a976172d = function(F, M) {
    return /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var $f506e8da188a4a28$export$8b635ef81222764c = function(F, M) {
    return /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var $f506e8da188a4a28$export$43849ff3f7ffa51c = function(F, M) {
    return /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var $f506e8da188a4a28$export$6481f4ccd0f47bbd = function(F, M) {
    return /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};


function $9465861535336ff3$export$2f6ca3d3b1f80bf5(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function $9465861535336ff3$export$5f28d9feedcfd46e(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function $9465861535336ff3$export$ed01bc59c3d06bf3(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function $9465861535336ff3$export$8cbfc0239f42bb49(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function $9465861535336ff3$export$18979a515d2a828e(F) {
    return function(S) {
        return {
            concat: function(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function $9465861535336ff3$var$curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : $9465861535336ff3$var$curried(f, n - 1, combined);
    };
}
var $9465861535336ff3$var$tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function $9465861535336ff3$var$getTupleConstructor(len) {
    if (!$f506e8da188a4a28$export$a4f4bb6b1453fff5.call($9465861535336ff3$var$tupleConstructors, len)) $9465861535336ff3$var$tupleConstructors[len] = $9465861535336ff3$var$curried((0, $195a10ed7200bcca$export$65e3907585753458), len - 1, []);
    return $9465861535336ff3$var$tupleConstructors[len];
}
function $9465861535336ff3$export$6ec24752b7e97e26(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $9465861535336ff3$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function $9465861535336ff3$var$getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return $9465861535336ff3$var$curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function $9465861535336ff3$export$d04bd2c3b28691e(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $9465861535336ff3$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}


function $a048b5cdbfcd6533$export$e3821ef4970c339c(M) {
    var tapM = $a048b5cdbfcd6533$export$3f23594af5f37336(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function $a048b5cdbfcd6533$export$3f23594af5f37336(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function $a048b5cdbfcd6533$export$2385a24977818dd0(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}


/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ 


function $e877117324731de7$export$172ec0a6ebfeb6fa(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither($f506e8da188a4a28$export$e56af863d5645d5f(ma) ? $f506e8da188a4a28$export$eabcd2c8791e7bf4(onNone()) : $f506e8da188a4a28$export$79ffe56a765070d2(ma.value));
        };
    };
}
function $e877117324731de7$export$23f31c55d7162b91(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? $f506e8da188a4a28$export$79ffe56a765070d2(a) : $f506e8da188a4a28$export$eabcd2c8791e7bf4(onFalse(a)));
        };
    };
}
function $e877117324731de7$export$a907462f448b49f8(F) {
    var fromOptionF = $e877117324731de7$export$172ec0a6ebfeb6fa(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(f, from);
        };
    };
}
function $e877117324731de7$export$12d26179deb6a68a(F, M) {
    var fromOptionKF = $e877117324731de7$export$a907462f448b49f8(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function $e877117324731de7$export$8138b0ae92c9b5d8(F) {
    return function(f) {
        return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(f, F.fromEither);
    };
}
function $e877117324731de7$export$a3eef2eba9908c3e(F, M) {
    var fromEitherKF = $e877117324731de7$export$8138b0ae92c9b5d8(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function $e877117324731de7$export$c5f2bdbf9b43f0c0(F, M) {
    var tapEitherM = $e877117324731de7$export$be3ff275bb5a8ac9(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function $e877117324731de7$export$30af8ca9498ddf5b(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? $f506e8da188a4a28$export$79ffe56a765070d2(a) : $f506e8da188a4a28$export$eabcd2c8791e7bf4(onFalse(a)));
            });
        };
    };
}
function $e877117324731de7$export$be3ff275bb5a8ac9(F, M) {
    var fromEither = $e877117324731de7$export$8138b0ae92c9b5d8(F);
    var tapM = (0, $a048b5cdbfcd6533$export$3f23594af5f37336)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}



/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ 
function $b90291f3b522edda$export$871de8747c9eaa88(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function $b90291f3b522edda$export$18c957606d8bdf09(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function $b90291f3b522edda$export$7c052ae73f8acff0(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function $b90291f3b522edda$export$5d537b797c421217(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function $b90291f3b522edda$export$7b0f6fce42e2b480(F, G) {
    var _map = $b90291f3b522edda$export$871de8747c9eaa88(F, G);
    return {
        map: function(fga, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fga, _map(f));
        }
    };
}
function $b90291f3b522edda$export$6554612db691658e(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function $b90291f3b522edda$export$9284b360ca18a0fd(F) {
    var asM = $b90291f3b522edda$export$6554612db691658e(F);
    return function(self) {
        return asM(self, undefined);
    };
}









var $621782213ab3b52c$export$fec6acd8d60e8568 = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
var $621782213ab3b52c$export$8cf3da7c1c9174ea = function(eqs) {
    return $621782213ab3b52c$export$fec6acd8d60e8568(function(first, second) {
        for(var key in eqs){
            if (!eqs[key].equals(first[key], second[key])) return false;
        }
        return true;
    });
};
var $621782213ab3b52c$export$65e3907585753458 = function() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $621782213ab3b52c$export$fec6acd8d60e8568(function(first, second) {
        return eqs.every(function(E, i) {
            return E.equals(first[i], second[i]);
        });
    });
};
/* istanbul ignore next */ var $621782213ab3b52c$var$contramap_ = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $621782213ab3b52c$export$53b696d27ecb7ba7(f));
};
var $621782213ab3b52c$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $621782213ab3b52c$export$fec6acd8d60e8568(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    };
};
var $621782213ab3b52c$export$9156e739aa33e19f = 'Eq';
var $621782213ab3b52c$export$37a88d8211c10fd3 = {
    equals: function(a, b) {
        return a === b;
    }
};
var $621782213ab3b52c$var$empty = {
    equals: function() {
        return true;
    }
};
var $621782213ab3b52c$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(x, y) {
            return $621782213ab3b52c$export$fec6acd8d60e8568(function(a, b) {
                return x.equals(a, b) && y.equals(a, b);
            });
        }
    };
};
var $621782213ab3b52c$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $621782213ab3b52c$export$e759a9a7f8d04692().concat,
        empty: $621782213ab3b52c$var$empty
    };
};
var $621782213ab3b52c$export$def901a57d5539c3 = {
    URI: $621782213ab3b52c$export$9156e739aa33e19f,
    contramap: $621782213ab3b52c$var$contramap_
};
var $621782213ab3b52c$export$1a50cb133a346493 = $621782213ab3b52c$export$65e3907585753458;
var $621782213ab3b52c$export$b35b2bde1875587a = $621782213ab3b52c$export$8cf3da7c1c9174ea;
var $621782213ab3b52c$export$24d177074f8dc6ef = $621782213ab3b52c$export$37a88d8211c10fd3.equals;
var $621782213ab3b52c$export$9663ddc1cf085b32 = $621782213ab3b52c$export$def901a57d5539c3;
var $621782213ab3b52c$export$d7927e8ffc1afb48 = $621782213ab3b52c$export$37a88d8211c10fd3;
var $621782213ab3b52c$export$fa624555ca2acbc8 = $621782213ab3b52c$export$37a88d8211c10fd3;
var $621782213ab3b52c$export$e24978670be1e4f3 = $621782213ab3b52c$export$37a88d8211c10fd3;
var $621782213ab3b52c$export$4eced57d6183c43d = {
    equals: function(first, second) {
        return first.valueOf() === second.valueOf();
    }
};



var $def12e545a21c13b$export$19fbc5aa8790347c = function(compare) {
    return function(first, second) {
        return first === second || compare(first, second) === 0;
    };
};
var $def12e545a21c13b$export$aa9e0de96ff2f1fd = function(compare) {
    return {
        equals: $def12e545a21c13b$export$19fbc5aa8790347c(compare),
        compare: function(first, second) {
            return first === second ? 0 : compare(first, second);
        }
    };
};
var $def12e545a21c13b$export$65e3907585753458 = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    return $def12e545a21c13b$export$aa9e0de96ff2f1fd(function(first, second) {
        var i = 0;
        for(; i < ords.length - 1; i++){
            var r = ords[i].compare(first[i], second[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(first[i], second[i]);
    });
};
var $def12e545a21c13b$export$66c1ae025e96b4bc = function(O) {
    return $def12e545a21c13b$export$aa9e0de96ff2f1fd(function(first, second) {
        return O.compare(second, first);
    });
};
/* istanbul ignore next */ var $def12e545a21c13b$var$contramap_ = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $def12e545a21c13b$export$53b696d27ecb7ba7(f));
};
var $def12e545a21c13b$export$53b696d27ecb7ba7 = function(f) {
    return function(fa) {
        return $def12e545a21c13b$export$aa9e0de96ff2f1fd(function(first, second) {
            return fa.compare(f(first), f(second));
        });
    };
};
var $def12e545a21c13b$export$9156e739aa33e19f = 'Ord';
var $def12e545a21c13b$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $def12e545a21c13b$export$aa9e0de96ff2f1fd(function(a, b) {
                var ox = first.compare(a, b);
                return ox !== 0 ? ox : second.compare(a, b);
            });
        }
    };
};
var $def12e545a21c13b$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $def12e545a21c13b$export$e759a9a7f8d04692().concat,
        empty: $def12e545a21c13b$export$aa9e0de96ff2f1fd(function() {
            return 0;
        })
    };
};
var $def12e545a21c13b$export$def901a57d5539c3 = {
    URI: $def12e545a21c13b$export$9156e739aa33e19f,
    contramap: $def12e545a21c13b$var$contramap_
};
var $def12e545a21c13b$export$e5bb9f0f2dedbef6 = {
    equals: (0, $195a10ed7200bcca$export$a68382d9631f6c53),
    compare: /*#__PURE__*/ (0, $195a10ed7200bcca$export$c983f826f44ff86)(0)
};
var $def12e545a21c13b$export$e9bab7fafb253603 = function(O) {
    return function(second) {
        return function(first) {
            return first === second || O.compare(first, second) === 0;
        };
    };
};
var $def12e545a21c13b$export$b961576059b7aeb6 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === -1;
    };
};
var $def12e545a21c13b$export$dafeacbfe3530cd9 = function(O) {
    return function(first, second) {
        return O.compare(first, second) === 1;
    };
};
var $def12e545a21c13b$export$8c5f3ec5d3a940d = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== 1;
    };
};
var $def12e545a21c13b$export$61f00a763551642c = function(O) {
    return function(first, second) {
        return O.compare(first, second) !== -1;
    };
};
var $def12e545a21c13b$export$96ec731ed4dcb222 = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) < 1 ? first : second;
    };
};
var $def12e545a21c13b$export$8960430cfd85939f = function(O) {
    return function(first, second) {
        return first === second || O.compare(first, second) > -1 ? first : second;
    };
};
var $def12e545a21c13b$export$7d15b64cf5a3a4c4 = function(O) {
    var minO = $def12e545a21c13b$export$96ec731ed4dcb222(O);
    var maxO = $def12e545a21c13b$export$8960430cfd85939f(O);
    return function(low, hi) {
        return function(a) {
            return maxO(minO(a, hi), low);
        };
    };
};
var $def12e545a21c13b$export$cf95c51b03f10bae = function(O) {
    var ltO = $def12e545a21c13b$export$b961576059b7aeb6(O);
    var gtO = $def12e545a21c13b$export$dafeacbfe3530cd9(O);
    return function(low, hi) {
        return function(a) {
            return ltO(a, low) || gtO(a, hi) ? false : true;
        };
    };
};
var $def12e545a21c13b$export$c41db498223b95e9 = $def12e545a21c13b$export$65e3907585753458;
var $def12e545a21c13b$export$35315ebcdff1b05c = $def12e545a21c13b$export$66c1ae025e96b4bc;
var $def12e545a21c13b$export$ad12338f1fefb50e = $def12e545a21c13b$export$def901a57d5539c3;
// default compare for primitive types
function $def12e545a21c13b$var$compare(first, second) {
    return first < second ? -1 : first > second ? 1 : 0;
}
var $def12e545a21c13b$var$strictOrd = {
    equals: (0, $621782213ab3b52c$export$37a88d8211c10fd3).equals,
    compare: $def12e545a21c13b$var$compare
};
var $def12e545a21c13b$export$ef759d57a4e44836 = $def12e545a21c13b$var$strictOrd;
var $def12e545a21c13b$export$c5f2758e49b2b86a = $def12e545a21c13b$var$strictOrd;
var $def12e545a21c13b$export$5ed021ff2336715c = $def12e545a21c13b$var$strictOrd;
var $def12e545a21c13b$export$722593c82468f9f4 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$a4627e546088548d)($def12e545a21c13b$export$5ed021ff2336715c, /*#__PURE__*/ $def12e545a21c13b$export$53b696d27ecb7ba7(function(date) {
    return date.valueOf();
}));









var $3b02c86b535b1f01$exports = {};
/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */ 

/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */ // -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @since 2.11.0
 */ var $2c1b052a3ca228f6$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: function(first, second) {
            return M.concat(second, first);
        }
    };
};
var $2c1b052a3ca228f6$export$33379f09626d85d4 = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(first) ? M.concat(first, second) : second;
            }
        };
    };
};
var $2c1b052a3ca228f6$export$dfdff08f074d9f6c = function(predicate) {
    return function(M) {
        return {
            concat: function(first, second) {
                return predicate(second) ? M.concat(first, second) : first;
            }
        };
    };
};
var $2c1b052a3ca228f6$export$235e42f0cd5f5e93 = function(f) {
    return function(M) {
        return {
            concat: function(first, second) {
                return M.concat(f(first), f(second));
            }
        };
    };
};
var $2c1b052a3ca228f6$export$b314777ae20abca9 = function(M) {
    return function(startWith) {
        return function(as) {
            return as.reduce(function(a, acc) {
                return M.concat(a, acc);
            }, startWith);
        };
    };
};



var $3b02c86b535b1f01$export$96ec731ed4dcb222 = function(O) {
    return {
        concat: $def12e545a21c13b$export$96ec731ed4dcb222(O)
    };
};
var $3b02c86b535b1f01$export$8960430cfd85939f = function(O) {
    return {
        concat: $def12e545a21c13b$export$8960430cfd85939f(O)
    };
};
var $3b02c86b535b1f01$export$c983f826f44ff86 = function(a) {
    return {
        concat: function() {
            return a;
        }
    };
};
var $3b02c86b535b1f01$export$66c1ae025e96b4bc = $2c1b052a3ca228f6$export$66c1ae025e96b4bc;
var $3b02c86b535b1f01$export$8cf3da7c1c9174ea = function(semigroups) {
    return {
        concat: function(first, second) {
            var r = {};
            for(var k in semigroups)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(semigroups, k)) r[k] = semigroups[k].concat(first[k], second[k]);
            return r;
        }
    };
};
var $3b02c86b535b1f01$export$65e3907585753458 = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(first, second) {
            return semigroups.map(function(s, i) {
                return s.concat(first[i], second[i]);
            });
        }
    };
};
var $3b02c86b535b1f01$export$739ec22334c44788 = function(middle) {
    return function(S) {
        return {
            concat: function(x, y) {
                return S.concat(x, S.concat(middle, y));
            }
        };
    };
};
var $3b02c86b535b1f01$export$43128fadae87b74a = function() {
    return {
        concat: (0, $195a10ed7200bcca$export$f0954fd7d5368655)
    };
};
var $3b02c86b535b1f01$export$4c7897fafd92b108 = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
var $3b02c86b535b1f01$export$b314777ae20abca9 = $2c1b052a3ca228f6$export$b314777ae20abca9;
var $3b02c86b535b1f01$export$36aabcd6b6e45f3b = $3b02c86b535b1f01$export$c983f826f44ff86(undefined);
var $3b02c86b535b1f01$export$2f965793fef2fb8a = function() {
    return {
        concat: function(first, second) {
            return Object.assign({}, first, second);
        }
    };
};
var $3b02c86b535b1f01$export$edb0acd3f464ffc5 = $3b02c86b535b1f01$export$4c7897fafd92b108;
var $3b02c86b535b1f01$export$84a57d7a8bf6c3ea = $3b02c86b535b1f01$export$43128fadae87b74a;
var $3b02c86b535b1f01$export$bd94daf2735ef9c = $3b02c86b535b1f01$export$65e3907585753458;
var $3b02c86b535b1f01$export$98d1814f8ed74e13 = $3b02c86b535b1f01$export$8cf3da7c1c9174ea;
var $3b02c86b535b1f01$export$e0cea6c43ec66a1 = $3b02c86b535b1f01$export$66c1ae025e96b4bc;
var $3b02c86b535b1f01$export$4278e54cd9769e6d = $3b02c86b535b1f01$export$8960430cfd85939f;
var $3b02c86b535b1f01$export$7baccd77d16d1a41 = $3b02c86b535b1f01$export$96ec731ed4dcb222;
var $3b02c86b535b1f01$export$fcc2cca196b2daf0 = $3b02c86b535b1f01$export$739ec22334c44788;
function $3b02c86b535b1f01$export$93e2b83da34ff82a(S) {
    var concatAllS = $3b02c86b535b1f01$export$b314777ae20abca9(S);
    return function(startWith, as) {
        return as === undefined ? concatAllS(startWith) : concatAllS(startWith)(as);
    };
}
var $3b02c86b535b1f01$export$e8f9875ab703bdff = {
    concat: function(x, y) {
        return x && y;
    }
};
var $3b02c86b535b1f01$export$9511aba5be5ac81b = {
    concat: function(x, y) {
        return x || y;
    }
};
var $3b02c86b535b1f01$export$b2ecf5de014857c2 = (0, $195a10ed7200bcca$export$e759a9a7f8d04692);
var $3b02c86b535b1f01$export$d9b7100b101f2c5b = {
    concat: function(x, y) {
        return x + y;
    }
};
var $3b02c86b535b1f01$export$1481126044ad2de0 = {
    concat: function(x, y) {
        return x + y;
    }
};
var $3b02c86b535b1f01$export$a22a2283cc3aa839 = {
    concat: function(x, y) {
        return x * y;
    }
};
$3b02c86b535b1f01$exports["min"] = $3b02c86b535b1f01$export$96ec731ed4dcb222;
$3b02c86b535b1f01$exports["max"] = $3b02c86b535b1f01$export$8960430cfd85939f;
$3b02c86b535b1f01$exports["constant"] = $3b02c86b535b1f01$export$c983f826f44ff86;
$3b02c86b535b1f01$exports["reverse"] = $3b02c86b535b1f01$export$66c1ae025e96b4bc;
$3b02c86b535b1f01$exports["struct"] = $3b02c86b535b1f01$export$8cf3da7c1c9174ea;
$3b02c86b535b1f01$exports["tuple"] = $3b02c86b535b1f01$export$65e3907585753458;
$3b02c86b535b1f01$exports["intercalate"] = $3b02c86b535b1f01$export$739ec22334c44788;
$3b02c86b535b1f01$exports["first"] = $3b02c86b535b1f01$export$43128fadae87b74a;
$3b02c86b535b1f01$exports["last"] = $3b02c86b535b1f01$export$4c7897fafd92b108;
$3b02c86b535b1f01$exports["concatAll"] = $3b02c86b535b1f01$export$b314777ae20abca9;
$3b02c86b535b1f01$exports["semigroupVoid"] = $3b02c86b535b1f01$export$36aabcd6b6e45f3b;
$3b02c86b535b1f01$exports["getObjectSemigroup"] = $3b02c86b535b1f01$export$2f965793fef2fb8a;
$3b02c86b535b1f01$exports["getLastSemigroup"] = $3b02c86b535b1f01$export$edb0acd3f464ffc5;
$3b02c86b535b1f01$exports["getFirstSemigroup"] = $3b02c86b535b1f01$export$84a57d7a8bf6c3ea;
$3b02c86b535b1f01$exports["getTupleSemigroup"] = $3b02c86b535b1f01$export$bd94daf2735ef9c;
$3b02c86b535b1f01$exports["getStructSemigroup"] = $3b02c86b535b1f01$export$98d1814f8ed74e13;
$3b02c86b535b1f01$exports["getDualSemigroup"] = $3b02c86b535b1f01$export$e0cea6c43ec66a1;
$3b02c86b535b1f01$exports["getJoinSemigroup"] = $3b02c86b535b1f01$export$4278e54cd9769e6d;
$3b02c86b535b1f01$exports["getMeetSemigroup"] = $3b02c86b535b1f01$export$7baccd77d16d1a41;
$3b02c86b535b1f01$exports["getIntercalateSemigroup"] = $3b02c86b535b1f01$export$fcc2cca196b2daf0;
$3b02c86b535b1f01$exports["fold"] = $3b02c86b535b1f01$export$93e2b83da34ff82a;
$3b02c86b535b1f01$exports["semigroupAll"] = $3b02c86b535b1f01$export$e8f9875ab703bdff;
$3b02c86b535b1f01$exports["semigroupAny"] = $3b02c86b535b1f01$export$9511aba5be5ac81b;
$3b02c86b535b1f01$exports["getFunctionSemigroup"] = $3b02c86b535b1f01$export$b2ecf5de014857c2;
$3b02c86b535b1f01$exports["semigroupString"] = $3b02c86b535b1f01$export$d9b7100b101f2c5b;
$3b02c86b535b1f01$exports["semigroupSum"] = $3b02c86b535b1f01$export$1481126044ad2de0;
$3b02c86b535b1f01$exports["semigroupProduct"] = $3b02c86b535b1f01$export$a22a2283cc3aa839;


var $694b1cc3e43dcc88$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $694b1cc3e43dcc88$export$6e22c362a0406a2c = $f506e8da188a4a28$export$6ca726a2417e0f3f;
var $694b1cc3e43dcc88$export$a978c53b4062a525 = $f506e8da188a4a28$export$a978c53b4062a525;
var $694b1cc3e43dcc88$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $694b1cc3e43dcc88$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $694b1cc3e43dcc88$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $694b1cc3e43dcc88$export$68159836694e22c1 = $694b1cc3e43dcc88$export$c4c4d41eab625797;
var $694b1cc3e43dcc88$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $694b1cc3e43dcc88$var$__spreadArray($694b1cc3e43dcc88$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $694b1cc3e43dcc88$export$10d8903dec122b9d = $694b1cc3e43dcc88$export$19903a1bf1942f6;
var $694b1cc3e43dcc88$export$f4863e1822a1860c = function(i, a, as) {
    if ($694b1cc3e43dcc88$export$a978c53b4062a525(as)) {
        var xs = $f506e8da188a4a28$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $694b1cc3e43dcc88$export$9c0c6889b1fa9bfc = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $f506e8da188a4a28$export$7e77326b0f0e268c(as);
        xs[i] = a;
        return xs;
    }
};
var $694b1cc3e43dcc88$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return as;
        var out = [
            $694b1cc3e43dcc88$export$5fd5031fecdacec3(as)
        ];
        var rest = $694b1cc3e43dcc88$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $694b1cc3e43dcc88$export$b035e44d7bb4278f = function(ords) {
    if ($694b1cc3e43dcc88$export$a978c53b4062a525(ords)) {
        var M = (0, $def12e545a21c13b$export$c2a7ef2cc9b32b31)();
        return $694b1cc3e43dcc88$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return 0, $195a10ed7200bcca$export$f0954fd7d5368655;
};
var $694b1cc3e43dcc88$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $694b1cc3e43dcc88$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $195a10ed7200bcca$export$a4627e546088548d)(first, $694b1cc3e43dcc88$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $694b1cc3e43dcc88$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($694b1cc3e43dcc88$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return as;
        if (m < 0) {
            var _a = $694b1cc3e43dcc88$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(s, $694b1cc3e43dcc88$export$ee1b3e54f0441b22(f));
        } else return $694b1cc3e43dcc88$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $694b1cc3e43dcc88$export$9288e031f1846591 = function(as) {
    return $694b1cc3e43dcc88$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd(as) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $694b1cc3e43dcc88$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $694b1cc3e43dcc88$export$606959e7ccb797f0 = function(a) {
    return $694b1cc3e43dcc88$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $694b1cc3e43dcc88$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $694b1cc3e43dcc88$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $694b1cc3e43dcc88$export$c04edabe9c8d994f = function(as) {
    return [
        $694b1cc3e43dcc88$export$5fd5031fecdacec3(as),
        $694b1cc3e43dcc88$export$c01875f616615628(as)
    ];
};
var $694b1cc3e43dcc88$export$89a97afc72a83708 = function(as) {
    return [
        $694b1cc3e43dcc88$export$2cd8252107eb640b(as),
        $694b1cc3e43dcc88$export$4c7897fafd92b108(as)
    ];
};
var $694b1cc3e43dcc88$export$571d59b505e6bb4e = function(as) {
    return $694b1cc3e43dcc88$export$9288e031f1846591(as.slice());
};
function $694b1cc3e43dcc88$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $694b1cc3e43dcc88$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $694b1cc3e43dcc88$export$66c1ae025e96b4bc = function(as) {
    return as.length === 1 ? as : $694b1cc3e43dcc88$var$__spreadArray([
        $694b1cc3e43dcc88$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $694b1cc3e43dcc88$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return $694b1cc3e43dcc88$export$6e22c362a0406a2c;
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $694b1cc3e43dcc88$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $694b1cc3e43dcc88$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length === 1 ? as : as.slice().sort(O.compare);
    };
};
var $694b1cc3e43dcc88$export$b6d8713d53419d4c = function(i, a) {
    return $694b1cc3e43dcc88$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $694b1cc3e43dcc88$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $694b1cc3e43dcc88$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $694b1cc3e43dcc88$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $694b1cc3e43dcc88$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $694b1cc3e43dcc88$export$8901015135f2fb22(bs, as);
    };
    return $694b1cc3e43dcc88$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $694b1cc3e43dcc88$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $694b1cc3e43dcc88$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $694b1cc3e43dcc88$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $694b1cc3e43dcc88$export$c01875f616615628(as);
        return $694b1cc3e43dcc88$export$a978c53b4062a525(rest) ? (0, $195a10ed7200bcca$export$a4627e546088548d)(rest, $694b1cc3e43dcc88$export$849c7567cbd62acc(middle), $694b1cc3e43dcc88$export$68159836694e22c1($694b1cc3e43dcc88$export$5fd5031fecdacec3(as))) : as;
    };
};
var $694b1cc3e43dcc88$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $f506e8da188a4a28$export$7e77326b0f0e268c(f(0, $694b1cc3e43dcc88$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $694b1cc3e43dcc88$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($694b1cc3e43dcc88$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $694b1cc3e43dcc88$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            as,
            $694b1cc3e43dcc88$export$6e22c362a0406a2c
        ] : [
            (0, $195a10ed7200bcca$export$a4627e546088548d)(as.slice(1, m), $694b1cc3e43dcc88$export$68159836694e22c1($694b1cc3e43dcc88$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $694b1cc3e43dcc88$export$2f0184d5df52135f = function(n) {
    return $694b1cc3e43dcc88$export$433fe05b12ba833f($694b1cc3e43dcc88$export$b0d75975ac0be0e1(n));
};
var $694b1cc3e43dcc88$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_mapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$8f07ddce13659f50(f));
};
var $694b1cc3e43dcc88$var$_ap = function(fab, fa) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fab, $694b1cc3e43dcc88$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_extend = function(wa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(wa, $694b1cc3e43dcc88$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_reduce = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_foldMap = function(M) {
    var foldMapM = $694b1cc3e43dcc88$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_reduceRight = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_traverse = function(F) {
    var traverseF = $694b1cc3e43dcc88$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_alt = function(fa, that) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $694b1cc3e43dcc88$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $694b1cc3e43dcc88$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $694b1cc3e43dcc88$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $694b1cc3e43dcc88$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $694b1cc3e43dcc88$export$ba255e9e49e00608 = $f506e8da188a4a28$export$439306a4dcaafbb9;
var $694b1cc3e43dcc88$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(as, $694b1cc3e43dcc88$export$c8c959650bbe80e2(that()));
    };
};
var $694b1cc3e43dcc88$export$228be17d80722ab = $694b1cc3e43dcc88$export$1517cca7889d6aaa;
var $694b1cc3e43dcc88$export$2f6ca3d3b1f80bf5 = function(as) {
    return $694b1cc3e43dcc88$export$5b8affa63fc6df16(function(f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(as, $694b1cc3e43dcc88$export$871de8747c9eaa88(f));
    });
};
var $694b1cc3e43dcc88$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(ma, $694b1cc3e43dcc88$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $694b1cc3e43dcc88$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $694b1cc3e43dcc88$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($694b1cc3e43dcc88$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $694b1cc3e43dcc88$export$c01875f616615628(next);
        }
        return out;
    };
};
var $694b1cc3e43dcc88$export$ecd5e8ace626722c = /*#__PURE__*/ $694b1cc3e43dcc88$export$8b58be045bf06082((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $694b1cc3e43dcc88$export$bffa455ba8c619a6 = /*#__PURE__*/ $694b1cc3e43dcc88$export$5b8affa63fc6df16((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $694b1cc3e43dcc88$export$871de8747c9eaa88 = function(f) {
    return $694b1cc3e43dcc88$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $694b1cc3e43dcc88$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $694b1cc3e43dcc88$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $694b1cc3e43dcc88$export$533b26079ad0b4b = function(b, f) {
    return $694b1cc3e43dcc88$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $694b1cc3e43dcc88$export$b66cdc0497d8a99a = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a) {
                return S.concat(s, f(a));
            }, f(as[0]));
        };
    };
};
var $694b1cc3e43dcc88$export$7fef8bcdbb34f435 = function(b, f) {
    return $694b1cc3e43dcc88$export$ce2b2fe0b88ccd0a(b, function(_, b, a) {
        return f(b, a);
    });
};
var $694b1cc3e43dcc88$export$bbd3ef8720e22369 = function(b, f) {
    return function(as) {
        return as.reduce(function(b, a, i) {
            return f(i, b, a);
        }, b);
    };
};
var $694b1cc3e43dcc88$export$18153bb1181268e5 = function(S) {
    return function(f) {
        return function(as) {
            return as.slice(1).reduce(function(s, a, i) {
                return S.concat(s, f(i + 1, a));
            }, f(0, as[0]));
        };
    };
};
var $694b1cc3e43dcc88$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(as) {
        return as.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $694b1cc3e43dcc88$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $694b1cc3e43dcc88$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $694b1cc3e43dcc88$export$49bb65c2ea163039 = function(F) {
    return $694b1cc3e43dcc88$export$955fdc0d24efa249(F)((0, $195a10ed7200bcca$export$5f584391ee0d99b4));
};
var $694b1cc3e43dcc88$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $694b1cc3e43dcc88$export$5fd5031fecdacec3(as)), $694b1cc3e43dcc88$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $195a10ed7200bcca$export$a4627e546088548d)(bs, $694b1cc3e43dcc88$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $694b1cc3e43dcc88$export$f9380c9a627682d3 = $f506e8da188a4a28$export$5fd5031fecdacec3;
var $694b1cc3e43dcc88$export$9156e739aa33e19f = 'ReadonlyNonEmptyArray';
var $694b1cc3e43dcc88$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $694b1cc3e43dcc88$export$e759a9a7f8d04692 = function() {
    return {
        concat: $694b1cc3e43dcc88$export$ee1b3e54f0441b22
    };
};
var $694b1cc3e43dcc88$export$804fed467fde44e4 = function(E) {
    return (0, $621782213ab3b52c$export$fec6acd8d60e8568)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $694b1cc3e43dcc88$export$baca17b4aff42f82 = function(E) {
    var unionE = $694b1cc3e43dcc88$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $694b1cc3e43dcc88$export$bd5b6bfc5fa2ee61 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map
};
var $694b1cc3e43dcc88$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($694b1cc3e43dcc88$export$bd5b6bfc5fa2ee61);
var $694b1cc3e43dcc88$export$59a71046037e6c20 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    of: $694b1cc3e43dcc88$export$ba255e9e49e00608
};
var $694b1cc3e43dcc88$export$9fdffe0fe1e91cad = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    mapWithIndex: $694b1cc3e43dcc88$var$_mapWithIndex
};
var $694b1cc3e43dcc88$export$efc21ddc6aeb363d = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    ap: $694b1cc3e43dcc88$var$_ap
};
var $694b1cc3e43dcc88$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $9465861535336ff3$export$5f28d9feedcfd46e)($694b1cc3e43dcc88$export$efc21ddc6aeb363d);
var $694b1cc3e43dcc88$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $9465861535336ff3$export$ed01bc59c3d06bf3)($694b1cc3e43dcc88$export$efc21ddc6aeb363d);
var $694b1cc3e43dcc88$export$1279d2b7807629fd = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    ap: $694b1cc3e43dcc88$var$_ap,
    of: $694b1cc3e43dcc88$export$ba255e9e49e00608
};
var $694b1cc3e43dcc88$export$f18d5acc27d70423 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    ap: $694b1cc3e43dcc88$var$_ap,
    chain: $694b1cc3e43dcc88$export$5b8affa63fc6df16
};
var $694b1cc3e43dcc88$export$e3821ef4970c339c = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$e3821ef4970c339c)($694b1cc3e43dcc88$export$f18d5acc27d70423);
var $694b1cc3e43dcc88$export$fb641926d034ac7d = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    ap: $694b1cc3e43dcc88$var$_ap,
    of: $694b1cc3e43dcc88$export$ba255e9e49e00608,
    chain: $694b1cc3e43dcc88$export$5b8affa63fc6df16
};
var $694b1cc3e43dcc88$export$41404b31838667c9 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    reduce: $694b1cc3e43dcc88$var$_reduce,
    foldMap: $694b1cc3e43dcc88$var$_foldMap,
    reduceRight: $694b1cc3e43dcc88$var$_reduceRight
};
var $694b1cc3e43dcc88$export$e8f7d17aaff345cb = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    reduce: $694b1cc3e43dcc88$var$_reduce,
    foldMap: $694b1cc3e43dcc88$var$_foldMap,
    reduceRight: $694b1cc3e43dcc88$var$_reduceRight,
    reduceWithIndex: $694b1cc3e43dcc88$var$_reduceWithIndex,
    foldMapWithIndex: $694b1cc3e43dcc88$var$_foldMapWithIndex,
    reduceRightWithIndex: $694b1cc3e43dcc88$var$_reduceRightWithIndex
};
var $694b1cc3e43dcc88$export$a0202666c3bda011 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    reduce: $694b1cc3e43dcc88$var$_reduce,
    foldMap: $694b1cc3e43dcc88$var$_foldMap,
    reduceRight: $694b1cc3e43dcc88$var$_reduceRight,
    traverse: $694b1cc3e43dcc88$var$_traverse,
    sequence: $694b1cc3e43dcc88$export$49bb65c2ea163039
};
var $694b1cc3e43dcc88$export$bd7b528d8c36ec41 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    mapWithIndex: $694b1cc3e43dcc88$var$_mapWithIndex,
    reduce: $694b1cc3e43dcc88$var$_reduce,
    foldMap: $694b1cc3e43dcc88$var$_foldMap,
    reduceRight: $694b1cc3e43dcc88$var$_reduceRight,
    traverse: $694b1cc3e43dcc88$var$_traverse,
    sequence: $694b1cc3e43dcc88$export$49bb65c2ea163039,
    reduceWithIndex: $694b1cc3e43dcc88$var$_reduceWithIndex,
    foldMapWithIndex: $694b1cc3e43dcc88$var$_foldMapWithIndex,
    reduceRightWithIndex: $694b1cc3e43dcc88$var$_reduceRightWithIndex,
    traverseWithIndex: $694b1cc3e43dcc88$var$_traverseWithIndex
};
var $694b1cc3e43dcc88$export$25ba4469a069167 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    alt: $694b1cc3e43dcc88$var$_alt
};
var $694b1cc3e43dcc88$export$fdd73124b9f1de36 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    map: $694b1cc3e43dcc88$var$_map,
    extend: $694b1cc3e43dcc88$var$_extend,
    extract: $694b1cc3e43dcc88$export$f9380c9a627682d3
};
var $694b1cc3e43dcc88$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $694b1cc3e43dcc88$export$ba255e9e49e00608($f506e8da188a4a28$export$4de80339753b012b);
var $694b1cc3e43dcc88$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $b90291f3b522edda$export$7c052ae73f8acff0)($694b1cc3e43dcc88$export$bd5b6bfc5fa2ee61);
var $694b1cc3e43dcc88$export$5d537b797c421217 = /*#__PURE__*/ (0, $b90291f3b522edda$export$5d537b797c421217)($694b1cc3e43dcc88$export$bd5b6bfc5fa2ee61);
var $694b1cc3e43dcc88$export$2385a24977818dd0 = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$2385a24977818dd0)($694b1cc3e43dcc88$export$f18d5acc27d70423);
var $694b1cc3e43dcc88$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $9465861535336ff3$export$8cbfc0239f42bb49)($694b1cc3e43dcc88$export$efc21ddc6aeb363d);
var $694b1cc3e43dcc88$export$5fd5031fecdacec3 = $694b1cc3e43dcc88$export$f9380c9a627682d3;
var $694b1cc3e43dcc88$export$c01875f616615628 = $f506e8da188a4a28$export$c01875f616615628;
var $694b1cc3e43dcc88$export$4c7897fafd92b108 = function(as) {
    return as[as.length - 1];
};
var $694b1cc3e43dcc88$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $694b1cc3e43dcc88$export$96ec731ed4dcb222 = function(O) {
    var S = $3b02c86b535b1f01$export$96ec731ed4dcb222(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $694b1cc3e43dcc88$export$8960430cfd85939f = function(O) {
    var S = $3b02c86b535b1f01$export$8960430cfd85939f(O);
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $694b1cc3e43dcc88$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $694b1cc3e43dcc88$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($694b1cc3e43dcc88$export$5fd5031fecdacec3(as), $694b1cc3e43dcc88$export$c01875f616615628(as));
    };
};
var $694b1cc3e43dcc88$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($694b1cc3e43dcc88$export$2cd8252107eb640b(as), $694b1cc3e43dcc88$export$4c7897fafd92b108(as));
    };
};
var $694b1cc3e43dcc88$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $694b1cc3e43dcc88$var$__spreadArray([
            f($694b1cc3e43dcc88$export$5fd5031fecdacec3(as))
        ], $694b1cc3e43dcc88$export$c01875f616615628(as), true);
    };
};
var $694b1cc3e43dcc88$export$20ca6ad9f7762931 = function(a) {
    return $694b1cc3e43dcc88$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $694b1cc3e43dcc88$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)($694b1cc3e43dcc88$export$2cd8252107eb640b(as), $694b1cc3e43dcc88$export$10d8903dec122b9d(f($694b1cc3e43dcc88$export$4c7897fafd92b108(as))));
    };
};
var $694b1cc3e43dcc88$export$d3affa0a0a83d946 = function(a) {
    return $694b1cc3e43dcc88$export$302ad361c463800a(function() {
        return a;
    });
};
var $694b1cc3e43dcc88$export$739ec22334c44788 = function(S) {
    var concatAllS = $694b1cc3e43dcc88$export$b314777ae20abca9(S);
    return function(middle) {
        return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($694b1cc3e43dcc88$export$af200dcf8b7cb5de(middle), concatAllS);
    };
};
var $694b1cc3e43dcc88$export$e08e3b67e392101e = $694b1cc3e43dcc88$export$5b8affa63fc6df16;
function $694b1cc3e43dcc88$export$103ce2c0a67e4e61(O) {
    var sortO = $694b1cc3e43dcc88$export$97db5808d8f88186(O);
    var groupO = $694b1cc3e43dcc88$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $694b1cc3e43dcc88$export$a978c53b4062a525(as) ? groupO(sortO(as)) : $694b1cc3e43dcc88$export$6e22c362a0406a2c;
    };
}
function $694b1cc3e43dcc88$export$3dea766d36a8935f(predicate) {
    return $694b1cc3e43dcc88$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $694b1cc3e43dcc88$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $694b1cc3e43dcc88$export$9288e031f1846591(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $694b1cc3e43dcc88$export$b446f6baa3bb1430 = $694b1cc3e43dcc88$export$c04edabe9c8d994f;
var $694b1cc3e43dcc88$export$712962e076096ed4 = $694b1cc3e43dcc88$export$89a97afc72a83708;
function $694b1cc3e43dcc88$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $694b1cc3e43dcc88$export$68159836694e22c1(head) : (0, $195a10ed7200bcca$export$a4627e546088548d)(tail, $694b1cc3e43dcc88$export$68159836694e22c1(head));
}
var $694b1cc3e43dcc88$export$c40cf5aab899f397 = function(init, end) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(init, $694b1cc3e43dcc88$export$ee1b3e54f0441b22([
        end
    ]));
};
var $694b1cc3e43dcc88$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$f4863e1822a1860c(i, a, as));
    };
};
var $694b1cc3e43dcc88$export$baeb00bf1e27e233 = $694b1cc3e43dcc88$export$849c7567cbd62acc;
var $694b1cc3e43dcc88$export$93e2b83da34ff82a = $694b1cc3e43dcc88$export$b314777ae20abca9;
var $694b1cc3e43dcc88$export$3c6c57333e3dca24 = {
    URI: $694b1cc3e43dcc88$export$9156e739aa33e19f,
    of: $694b1cc3e43dcc88$export$ba255e9e49e00608,
    map: $694b1cc3e43dcc88$var$_map,
    mapWithIndex: $694b1cc3e43dcc88$var$_mapWithIndex,
    ap: $694b1cc3e43dcc88$var$_ap,
    chain: $694b1cc3e43dcc88$export$5b8affa63fc6df16,
    extend: $694b1cc3e43dcc88$var$_extend,
    extract: $694b1cc3e43dcc88$export$f9380c9a627682d3,
    reduce: $694b1cc3e43dcc88$var$_reduce,
    foldMap: $694b1cc3e43dcc88$var$_foldMap,
    reduceRight: $694b1cc3e43dcc88$var$_reduceRight,
    traverse: $694b1cc3e43dcc88$var$_traverse,
    sequence: $694b1cc3e43dcc88$export$49bb65c2ea163039,
    reduceWithIndex: $694b1cc3e43dcc88$var$_reduceWithIndex,
    foldMapWithIndex: $694b1cc3e43dcc88$var$_foldMapWithIndex,
    reduceRightWithIndex: $694b1cc3e43dcc88$var$_reduceRightWithIndex,
    traverseWithIndex: $694b1cc3e43dcc88$var$_traverseWithIndex,
    alt: $694b1cc3e43dcc88$var$_alt
};


var $40add6d007f2bbe9$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $40add6d007f2bbe9$export$a978c53b4062a525 = function(as) {
    return as.length > 0;
};
var $40add6d007f2bbe9$export$2fde0b1c54fc39b9 = function(i, as) {
    return i < 0 || i >= as.length;
};
var $40add6d007f2bbe9$export$c4c4d41eab625797 = function(head) {
    return function(tail) {
        return $40add6d007f2bbe9$var$__spreadArray([
            head
        ], tail, true);
    };
};
var $40add6d007f2bbe9$export$68159836694e22c1 = $40add6d007f2bbe9$export$c4c4d41eab625797;
var $40add6d007f2bbe9$export$19903a1bf1942f6 = function(end) {
    return function(init) {
        return $40add6d007f2bbe9$var$__spreadArray($40add6d007f2bbe9$var$__spreadArray([], init, true), [
            end
        ], false);
    };
};
var $40add6d007f2bbe9$export$10d8903dec122b9d = $40add6d007f2bbe9$export$19903a1bf1942f6;
var $40add6d007f2bbe9$export$f4863e1822a1860c = function(i, a, as) {
    if ($40add6d007f2bbe9$export$a978c53b4062a525(as)) {
        var xs = $40add6d007f2bbe9$export$7e77326b0f0e268c(as);
        xs.splice(i, 0, a);
        return xs;
    }
    return [
        a
    ];
};
var $40add6d007f2bbe9$export$9c0c6889b1fa9bfc = function(i, a, as) {
    var xs = $40add6d007f2bbe9$export$7e77326b0f0e268c(as);
    xs[i] = a;
    return xs;
};
var $40add6d007f2bbe9$export$f70730c3d1fc524e = function(E) {
    return function(as) {
        if (as.length === 1) return $40add6d007f2bbe9$export$784d13d8ee351f07(as);
        var out = [
            $40add6d007f2bbe9$export$5fd5031fecdacec3(as)
        ];
        var rest = $40add6d007f2bbe9$export$c01875f616615628(as);
        var _loop_1 = function(a) {
            if (out.every(function(o) {
                return !E.equals(o, a);
            })) out.push(a);
        };
        for(var _i = 0, rest_1 = rest; _i < rest_1.length; _i++){
            var a = rest_1[_i];
            _loop_1(a);
        }
        return out;
    };
};
var $40add6d007f2bbe9$export$b035e44d7bb4278f = function(ords) {
    if ($40add6d007f2bbe9$export$a978c53b4062a525(ords)) {
        var M = (0, $def12e545a21c13b$export$c2a7ef2cc9b32b31)();
        return $40add6d007f2bbe9$export$97db5808d8f88186(ords.reduce(M.concat, M.empty));
    }
    return $40add6d007f2bbe9$export$784d13d8ee351f07;
};
var $40add6d007f2bbe9$export$971dd5b0dfd021b6 = function(E) {
    var uniqE = $40add6d007f2bbe9$export$f70730c3d1fc524e(E);
    return function(second) {
        return function(first) {
            return uniqE((0, $195a10ed7200bcca$export$a4627e546088548d)(first, $40add6d007f2bbe9$export$ee1b3e54f0441b22(second)));
        };
    };
};
var $40add6d007f2bbe9$export$bb628a54ab399bc9 = function(n) {
    return function(as) {
        var len = as.length;
        var m = Math.round(n) % len;
        if ($40add6d007f2bbe9$export$2fde0b1c54fc39b9(Math.abs(m), as) || m === 0) return $40add6d007f2bbe9$export$784d13d8ee351f07(as);
        if (m < 0) {
            var _a = $40add6d007f2bbe9$export$b0d75975ac0be0e1(-m)(as), f = _a[0], s = _a[1];
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(s, $40add6d007f2bbe9$export$ee1b3e54f0441b22(f));
        } else return $40add6d007f2bbe9$export$bb628a54ab399bc9(m - len)(as);
    };
};
var $40add6d007f2bbe9$export$7e77326b0f0e268c = $f506e8da188a4a28$export$7e77326b0f0e268c;
var $40add6d007f2bbe9$export$571d59b505e6bb4e = function(as) {
    return $40add6d007f2bbe9$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd(as) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $40add6d007f2bbe9$export$849fbdcc2211fcde = function(f) {
    return function(n) {
        var j = Math.max(0, Math.floor(n));
        var out = [
            f(0)
        ];
        for(var i = 1; i < j; i++)out.push(f(i));
        return out;
    };
};
var $40add6d007f2bbe9$export$606959e7ccb797f0 = function(a) {
    return $40add6d007f2bbe9$export$849fbdcc2211fcde(function() {
        return a;
    });
};
var $40add6d007f2bbe9$export$d02631cccf789723 = function(start, end) {
    return start <= end ? $40add6d007f2bbe9$export$849fbdcc2211fcde(function(i) {
        return start + i;
    })(end - start + 1) : [
        start
    ];
};
var $40add6d007f2bbe9$export$c04edabe9c8d994f = function(as) {
    return [
        $40add6d007f2bbe9$export$5fd5031fecdacec3(as),
        $40add6d007f2bbe9$export$c01875f616615628(as)
    ];
};
var $40add6d007f2bbe9$export$89a97afc72a83708 = function(as) {
    return [
        $40add6d007f2bbe9$export$2cd8252107eb640b(as),
        $40add6d007f2bbe9$export$4c7897fafd92b108(as)
    ];
};
function $40add6d007f2bbe9$export$c8c959650bbe80e2(second) {
    return function(first) {
        return first.concat(second);
    };
}
function $40add6d007f2bbe9$export$ee1b3e54f0441b22(x, y) {
    return y ? x.concat(y) : function(y) {
        return y.concat(x);
    };
}
var $40add6d007f2bbe9$export$66c1ae025e96b4bc = function(as) {
    return $40add6d007f2bbe9$var$__spreadArray([
        $40add6d007f2bbe9$export$4c7897fafd92b108(as)
    ], as.slice(0, -1).reverse(), true);
};
function $40add6d007f2bbe9$export$e5e25fbcc1f7affe(E) {
    return function(as) {
        var len = as.length;
        if (len === 0) return [];
        var out = [];
        var head = as[0];
        var nea = [
            head
        ];
        for(var i = 1; i < len; i++){
            var a = as[i];
            if (E.equals(a, head)) nea.push(a);
            else {
                out.push(nea);
                head = a;
                nea = [
                    head
                ];
            }
        }
        out.push(nea);
        return out;
    };
}
var $40add6d007f2bbe9$export$3f063810d7bf01bd = function(f) {
    return function(as) {
        var out = {};
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            var k = f(a);
            if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(out, k)) out[k].push(a);
            else out[k] = [
                a
            ];
        }
        return out;
    };
};
var $40add6d007f2bbe9$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.slice().sort(O.compare);
    };
};
var $40add6d007f2bbe9$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($40add6d007f2bbe9$export$f4863e1822a1860c(i, a, as));
    };
};
var $40add6d007f2bbe9$export$b6d8713d53419d4c = function(i, a) {
    return $40add6d007f2bbe9$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $40add6d007f2bbe9$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $40add6d007f2bbe9$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($40add6d007f2bbe9$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $40add6d007f2bbe9$export$784d13d8ee351f07 = $40add6d007f2bbe9$export$7e77326b0f0e268c;
var $40add6d007f2bbe9$export$ba255e9e49e00608 = function(a) {
    return [
        a
    ];
};
var $40add6d007f2bbe9$export$b634740ce272acb5 = function(as, bs, f) {
    var cs = [
        f(as[0], bs[0])
    ];
    var len = Math.min(as.length, bs.length);
    for(var i = 1; i < len; i++)cs[i] = f(as[i], bs[i]);
    return cs;
};
function $40add6d007f2bbe9$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $40add6d007f2bbe9$export$8901015135f2fb22(bs, as);
    };
    return $40add6d007f2bbe9$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $40add6d007f2bbe9$export$23c8d3f8757cab88 = function(abs) {
    var fa = [
        abs[0][0]
    ];
    var fb = [
        abs[0][1]
    ];
    for(var i = 1; i < abs.length; i++){
        fa[i] = abs[i][0];
        fb[i] = abs[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $40add6d007f2bbe9$export$849c7567cbd62acc = function(middle) {
    return function(as) {
        var out = [
            middle,
            as[0]
        ];
        for(var i = 1; i < as.length; i++)out.push(middle, as[i]);
        return out;
    };
};
var $40add6d007f2bbe9$export$af200dcf8b7cb5de = function(middle) {
    return function(as) {
        var rest = $40add6d007f2bbe9$export$c01875f616615628(as);
        return $40add6d007f2bbe9$export$a978c53b4062a525(rest) ? (0, $195a10ed7200bcca$export$a4627e546088548d)(rest, $40add6d007f2bbe9$export$849c7567cbd62acc(middle), $40add6d007f2bbe9$export$68159836694e22c1($40add6d007f2bbe9$export$5fd5031fecdacec3(as))) : $40add6d007f2bbe9$export$784d13d8ee351f07(as);
    };
};
var $40add6d007f2bbe9$export$18153bb1181268e5 = $694b1cc3e43dcc88$export$18153bb1181268e5;
var $40add6d007f2bbe9$export$b66cdc0497d8a99a = $694b1cc3e43dcc88$export$b66cdc0497d8a99a;
var $40add6d007f2bbe9$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = $40add6d007f2bbe9$export$7e77326b0f0e268c(f(0, $40add6d007f2bbe9$export$5fd5031fecdacec3(as)));
        for(var i = 1; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $40add6d007f2bbe9$export$433fe05b12ba833f = function(f) {
    return function(as) {
        var _a = f(as), b = _a[0], rest = _a[1];
        var out = [
            b
        ];
        var next = rest;
        while($40add6d007f2bbe9$export$a978c53b4062a525(next)){
            var _b = f(next), b_1 = _b[0], rest_2 = _b[1];
            out.push(b_1);
            next = rest_2;
        }
        return out;
    };
};
var $40add6d007f2bbe9$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        var m = Math.max(1, n);
        return m >= as.length ? [
            $40add6d007f2bbe9$export$784d13d8ee351f07(as),
            []
        ] : [
            (0, $195a10ed7200bcca$export$a4627e546088548d)(as.slice(1, m), $40add6d007f2bbe9$export$68159836694e22c1($40add6d007f2bbe9$export$5fd5031fecdacec3(as))),
            as.slice(m)
        ];
    };
};
var $40add6d007f2bbe9$export$2f0184d5df52135f = function(n) {
    return $40add6d007f2bbe9$export$433fe05b12ba833f($40add6d007f2bbe9$export$b0d75975ac0be0e1(n));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_mapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$8f07ddce13659f50(f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_ap = function(fab, fa) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fab, $40add6d007f2bbe9$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_extend = function(wa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(wa, $40add6d007f2bbe9$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_reduce = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_foldMap = function(M) {
    var foldMapM = $40add6d007f2bbe9$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_reduceRight = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_traverse = function(F) {
    var traverseF = $40add6d007f2bbe9$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_alt = function(fa, that) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $40add6d007f2bbe9$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $40add6d007f2bbe9$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $40add6d007f2bbe9$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $40add6d007f2bbe9$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $40add6d007f2bbe9$export$1517cca7889d6aaa = function(that) {
    return function(as) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(as, $40add6d007f2bbe9$export$c8c959650bbe80e2(that()));
    };
};
var $40add6d007f2bbe9$export$228be17d80722ab = $40add6d007f2bbe9$export$1517cca7889d6aaa;
var $40add6d007f2bbe9$export$2f6ca3d3b1f80bf5 = function(as) {
    return $40add6d007f2bbe9$export$5b8affa63fc6df16(function(f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(as, $40add6d007f2bbe9$export$871de8747c9eaa88(f));
    });
};
var $40add6d007f2bbe9$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(ma, $40add6d007f2bbe9$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $40add6d007f2bbe9$export$8b58be045bf06082 = function(f) {
    return function(as) {
        var next = $40add6d007f2bbe9$export$c01875f616615628(as);
        var out = [
            f(as)
        ];
        while($40add6d007f2bbe9$export$a978c53b4062a525(next)){
            out.push(f(next));
            next = $40add6d007f2bbe9$export$c01875f616615628(next);
        }
        return out;
    };
};
var $40add6d007f2bbe9$export$ecd5e8ace626722c = /*#__PURE__*/ $40add6d007f2bbe9$export$8b58be045bf06082((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $40add6d007f2bbe9$export$bffa455ba8c619a6 = /*#__PURE__*/ $40add6d007f2bbe9$export$5b8affa63fc6df16((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $40add6d007f2bbe9$export$871de8747c9eaa88 = function(f) {
    return $40add6d007f2bbe9$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
};
var $40add6d007f2bbe9$export$8f07ddce13659f50 = function(f) {
    return function(as) {
        var out = [
            f(0, $40add6d007f2bbe9$export$5fd5031fecdacec3(as))
        ];
        for(var i = 1; i < as.length; i++)out.push(f(i, as[i]));
        return out;
    };
};
var $40add6d007f2bbe9$export$533b26079ad0b4b = $694b1cc3e43dcc88$export$533b26079ad0b4b;
var $40add6d007f2bbe9$export$bbd3ef8720e22369 = $694b1cc3e43dcc88$export$bbd3ef8720e22369;
var $40add6d007f2bbe9$export$7fef8bcdbb34f435 = $694b1cc3e43dcc88$export$7fef8bcdbb34f435;
var $40add6d007f2bbe9$export$ce2b2fe0b88ccd0a = $694b1cc3e43dcc88$export$ce2b2fe0b88ccd0a;
var $40add6d007f2bbe9$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $40add6d007f2bbe9$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $40add6d007f2bbe9$export$49bb65c2ea163039 = function(F) {
    return $40add6d007f2bbe9$export$955fdc0d24efa249(F)(function(_, a) {
        return a;
    });
};
var $40add6d007f2bbe9$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return function(as) {
            var out = F.map(f(0, $40add6d007f2bbe9$export$5fd5031fecdacec3(as)), $40add6d007f2bbe9$export$ba255e9e49e00608);
            for(var i = 1; i < as.length; i++)out = F.ap(F.map(out, function(bs) {
                return function(b) {
                    return (0, $195a10ed7200bcca$export$a4627e546088548d)(bs, $40add6d007f2bbe9$export$10d8903dec122b9d(b));
                };
            }), f(i, as[i]));
            return out;
        };
    };
};
var $40add6d007f2bbe9$export$f9380c9a627682d3 = $694b1cc3e43dcc88$export$5fd5031fecdacec3;
var $40add6d007f2bbe9$export$9156e739aa33e19f = 'NonEmptyArray';
var $40add6d007f2bbe9$export$3cb5cd7f7776c81 = $694b1cc3e43dcc88$export$3cb5cd7f7776c81;
var $40add6d007f2bbe9$export$e759a9a7f8d04692 = function() {
    return {
        concat: $40add6d007f2bbe9$export$ee1b3e54f0441b22
    };
};
var $40add6d007f2bbe9$export$804fed467fde44e4 = $694b1cc3e43dcc88$export$804fed467fde44e4;
var $40add6d007f2bbe9$export$baca17b4aff42f82 = function(E) {
    var unionE = $40add6d007f2bbe9$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $40add6d007f2bbe9$export$bd5b6bfc5fa2ee61 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map
};
var $40add6d007f2bbe9$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($40add6d007f2bbe9$export$bd5b6bfc5fa2ee61);
var $40add6d007f2bbe9$export$59a71046037e6c20 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    of: $40add6d007f2bbe9$export$ba255e9e49e00608
};
var $40add6d007f2bbe9$export$9fdffe0fe1e91cad = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    mapWithIndex: $40add6d007f2bbe9$var$_mapWithIndex
};
var $40add6d007f2bbe9$export$efc21ddc6aeb363d = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    ap: $40add6d007f2bbe9$var$_ap
};
var $40add6d007f2bbe9$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $9465861535336ff3$export$5f28d9feedcfd46e)($40add6d007f2bbe9$export$efc21ddc6aeb363d);
var $40add6d007f2bbe9$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $9465861535336ff3$export$ed01bc59c3d06bf3)($40add6d007f2bbe9$export$efc21ddc6aeb363d);
var $40add6d007f2bbe9$export$1279d2b7807629fd = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    ap: $40add6d007f2bbe9$var$_ap,
    of: $40add6d007f2bbe9$export$ba255e9e49e00608
};
var $40add6d007f2bbe9$export$f18d5acc27d70423 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    ap: $40add6d007f2bbe9$var$_ap,
    chain: $40add6d007f2bbe9$export$5b8affa63fc6df16
};
var $40add6d007f2bbe9$export$e3821ef4970c339c = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$e3821ef4970c339c)($40add6d007f2bbe9$export$f18d5acc27d70423);
var $40add6d007f2bbe9$export$fb641926d034ac7d = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    ap: $40add6d007f2bbe9$var$_ap,
    of: $40add6d007f2bbe9$export$ba255e9e49e00608,
    chain: $40add6d007f2bbe9$export$5b8affa63fc6df16
};
var $40add6d007f2bbe9$export$41404b31838667c9 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    reduce: $40add6d007f2bbe9$var$_reduce,
    foldMap: $40add6d007f2bbe9$var$_foldMap,
    reduceRight: $40add6d007f2bbe9$var$_reduceRight
};
var $40add6d007f2bbe9$export$e8f7d17aaff345cb = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    reduce: $40add6d007f2bbe9$var$_reduce,
    foldMap: $40add6d007f2bbe9$var$_foldMap,
    reduceRight: $40add6d007f2bbe9$var$_reduceRight,
    reduceWithIndex: $40add6d007f2bbe9$var$_reduceWithIndex,
    foldMapWithIndex: $40add6d007f2bbe9$var$_foldMapWithIndex,
    reduceRightWithIndex: $40add6d007f2bbe9$var$_reduceRightWithIndex
};
var $40add6d007f2bbe9$export$a0202666c3bda011 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    reduce: $40add6d007f2bbe9$var$_reduce,
    foldMap: $40add6d007f2bbe9$var$_foldMap,
    reduceRight: $40add6d007f2bbe9$var$_reduceRight,
    traverse: $40add6d007f2bbe9$var$_traverse,
    sequence: $40add6d007f2bbe9$export$49bb65c2ea163039
};
var $40add6d007f2bbe9$export$bd7b528d8c36ec41 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    mapWithIndex: $40add6d007f2bbe9$var$_mapWithIndex,
    reduce: $40add6d007f2bbe9$var$_reduce,
    foldMap: $40add6d007f2bbe9$var$_foldMap,
    reduceRight: $40add6d007f2bbe9$var$_reduceRight,
    traverse: $40add6d007f2bbe9$var$_traverse,
    sequence: $40add6d007f2bbe9$export$49bb65c2ea163039,
    reduceWithIndex: $40add6d007f2bbe9$var$_reduceWithIndex,
    foldMapWithIndex: $40add6d007f2bbe9$var$_foldMapWithIndex,
    reduceRightWithIndex: $40add6d007f2bbe9$var$_reduceRightWithIndex,
    traverseWithIndex: $40add6d007f2bbe9$var$_traverseWithIndex
};
var $40add6d007f2bbe9$export$25ba4469a069167 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    alt: $40add6d007f2bbe9$var$_alt
};
var $40add6d007f2bbe9$export$fdd73124b9f1de36 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    map: $40add6d007f2bbe9$var$_map,
    extend: $40add6d007f2bbe9$var$_extend,
    extract: $40add6d007f2bbe9$export$f9380c9a627682d3
};
var $40add6d007f2bbe9$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $40add6d007f2bbe9$export$ba255e9e49e00608($f506e8da188a4a28$export$4de80339753b012b);
var $40add6d007f2bbe9$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $b90291f3b522edda$export$7c052ae73f8acff0)($40add6d007f2bbe9$export$bd5b6bfc5fa2ee61);
var $40add6d007f2bbe9$export$5d537b797c421217 = /*#__PURE__*/ (0, $b90291f3b522edda$export$5d537b797c421217)($40add6d007f2bbe9$export$bd5b6bfc5fa2ee61);
var $40add6d007f2bbe9$export$2385a24977818dd0 = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$2385a24977818dd0)($40add6d007f2bbe9$export$f18d5acc27d70423);
var $40add6d007f2bbe9$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $9465861535336ff3$export$8cbfc0239f42bb49)($40add6d007f2bbe9$export$efc21ddc6aeb363d);
var $40add6d007f2bbe9$export$5fd5031fecdacec3 = $694b1cc3e43dcc88$export$5fd5031fecdacec3;
var $40add6d007f2bbe9$export$c01875f616615628 = function(as) {
    return as.slice(1);
};
var $40add6d007f2bbe9$export$4c7897fafd92b108 = $694b1cc3e43dcc88$export$4c7897fafd92b108;
var $40add6d007f2bbe9$export$2cd8252107eb640b = function(as) {
    return as.slice(0, -1);
};
var $40add6d007f2bbe9$export$96ec731ed4dcb222 = $694b1cc3e43dcc88$export$96ec731ed4dcb222;
var $40add6d007f2bbe9$export$8960430cfd85939f = $694b1cc3e43dcc88$export$8960430cfd85939f;
var $40add6d007f2bbe9$export$b314777ae20abca9 = function(S) {
    return function(as) {
        return as.reduce(S.concat);
    };
};
var $40add6d007f2bbe9$export$6280271dfaec4919 = function(f) {
    return function(as) {
        return f($40add6d007f2bbe9$export$5fd5031fecdacec3(as), $40add6d007f2bbe9$export$c01875f616615628(as));
    };
};
var $40add6d007f2bbe9$export$b1cacb83a5c6bd02 = function(f) {
    return function(as) {
        return f($40add6d007f2bbe9$export$2cd8252107eb640b(as), $40add6d007f2bbe9$export$4c7897fafd92b108(as));
    };
};
var $40add6d007f2bbe9$export$5c7327d4e64ef2aa = function(f) {
    return function(as) {
        return $40add6d007f2bbe9$var$__spreadArray([
            f($40add6d007f2bbe9$export$5fd5031fecdacec3(as))
        ], $40add6d007f2bbe9$export$c01875f616615628(as), true);
    };
};
var $40add6d007f2bbe9$export$20ca6ad9f7762931 = function(a) {
    return $40add6d007f2bbe9$export$5c7327d4e64ef2aa(function() {
        return a;
    });
};
var $40add6d007f2bbe9$export$302ad361c463800a = function(f) {
    return function(as) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)($40add6d007f2bbe9$export$2cd8252107eb640b(as), $40add6d007f2bbe9$export$10d8903dec122b9d(f($40add6d007f2bbe9$export$4c7897fafd92b108(as))));
    };
};
var $40add6d007f2bbe9$export$d3affa0a0a83d946 = function(a) {
    return $40add6d007f2bbe9$export$302ad361c463800a(function() {
        return a;
    });
};
var $40add6d007f2bbe9$export$739ec22334c44788 = $694b1cc3e43dcc88$export$739ec22334c44788;
var $40add6d007f2bbe9$export$e08e3b67e392101e = $40add6d007f2bbe9$export$5b8affa63fc6df16;
function $40add6d007f2bbe9$export$103ce2c0a67e4e61(O) {
    var sortO = $40add6d007f2bbe9$export$97db5808d8f88186(O);
    var groupO = $40add6d007f2bbe9$export$e5e25fbcc1f7affe(O);
    return function(as) {
        return $40add6d007f2bbe9$export$a978c53b4062a525(as) ? groupO(sortO(as)) : [];
    };
}
function $40add6d007f2bbe9$export$3dea766d36a8935f(predicate) {
    return $40add6d007f2bbe9$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
}
var $40add6d007f2bbe9$export$36e42aef19fc7171 = function(predicate) {
    return function(as) {
        return $40add6d007f2bbe9$export$571d59b505e6bb4e(as.filter(function(a, i) {
            return predicate(i, a);
        }));
    };
};
var $40add6d007f2bbe9$export$b446f6baa3bb1430 = $40add6d007f2bbe9$export$c04edabe9c8d994f;
var $40add6d007f2bbe9$export$712962e076096ed4 = $40add6d007f2bbe9$export$89a97afc72a83708;
function $40add6d007f2bbe9$export$8327ebbef2a0ba76(head, tail) {
    return tail === undefined ? $40add6d007f2bbe9$export$68159836694e22c1(head) : (0, $195a10ed7200bcca$export$a4627e546088548d)(tail, $40add6d007f2bbe9$export$68159836694e22c1(head));
}
var $40add6d007f2bbe9$export$c40cf5aab899f397 = function(init, end) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(init, $40add6d007f2bbe9$export$10d8903dec122b9d(end));
};
var $40add6d007f2bbe9$export$baeb00bf1e27e233 = $40add6d007f2bbe9$export$849c7567cbd62acc;
var $40add6d007f2bbe9$export$93e2b83da34ff82a = $694b1cc3e43dcc88$export$b314777ae20abca9;
var $40add6d007f2bbe9$export$a5383a53b408af94 = {
    URI: $40add6d007f2bbe9$export$9156e739aa33e19f,
    of: $40add6d007f2bbe9$export$ba255e9e49e00608,
    map: $40add6d007f2bbe9$var$_map,
    mapWithIndex: $40add6d007f2bbe9$var$_mapWithIndex,
    ap: $40add6d007f2bbe9$var$_ap,
    chain: $40add6d007f2bbe9$export$5b8affa63fc6df16,
    extend: $40add6d007f2bbe9$var$_extend,
    extract: $40add6d007f2bbe9$export$f9380c9a627682d3,
    reduce: $40add6d007f2bbe9$var$_reduce,
    foldMap: $40add6d007f2bbe9$var$_foldMap,
    reduceRight: $40add6d007f2bbe9$var$_reduceRight,
    traverse: $40add6d007f2bbe9$var$_traverse,
    sequence: $40add6d007f2bbe9$export$49bb65c2ea163039,
    reduceWithIndex: $40add6d007f2bbe9$var$_reduceWithIndex,
    foldMapWithIndex: $40add6d007f2bbe9$var$_foldMapWithIndex,
    reduceRightWithIndex: $40add6d007f2bbe9$var$_reduceRightWithIndex,
    traverseWithIndex: $40add6d007f2bbe9$var$_traverseWithIndex,
    alt: $40add6d007f2bbe9$var$_alt
};









// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * @category refinements
 * @since 2.11.0
 */ var $a37ad571de293d44$export$7e4aa119212bc614 = function(u) {
    return typeof u === 'number';
};
var $a37ad571de293d44$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $a37ad571de293d44$export$ee8aa95bfab51c5 = {
    equals: $a37ad571de293d44$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $a37ad571de293d44$export$88f31472ebc405c8 = {
    equals: $a37ad571de293d44$export$a2050e5b0c4dcf10.equals,
    compare: $a37ad571de293d44$export$ee8aa95bfab51c5.compare,
    top: Infinity,
    bottom: -Infinity
};
var $a37ad571de293d44$export$f6a3d19be20f5819 = {
    show: function(n) {
        return JSON.stringify(n);
    }
};
var $a37ad571de293d44$export$d423c79a04b3ae25 = {
    concat: function(first, second) {
        return first - second;
    }
};
var $a37ad571de293d44$export$e5fae4f686b09c06 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $a37ad571de293d44$export$5b0bccec79556292 = {
    concat: function(first, second) {
        return first * second;
    }
};
var $a37ad571de293d44$export$2517c0450e71e789 = {
    concat: $a37ad571de293d44$export$e5fae4f686b09c06.concat,
    empty: 0
};
var $a37ad571de293d44$export$ee1a63590489b690 = {
    concat: $a37ad571de293d44$export$5b0bccec79556292.concat,
    empty: 1
};
var $a37ad571de293d44$export$a455218a85c89869 = {
    add: $a37ad571de293d44$export$e5fae4f686b09c06.concat,
    zero: 0,
    mul: $a37ad571de293d44$export$5b0bccec79556292.concat,
    one: 1,
    sub: $a37ad571de293d44$export$d423c79a04b3ae25.concat,
    degree: function(_) {
        return 1;
    },
    div: function(first, second) {
        return first / second;
    },
    mod: function(first, second) {
        return first % second;
    }
};




/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ 

var $58dc45d60525231a$export$beaabdf62f4a639d = function(left, right) {
    return {
        left: left,
        right: right
    };
};
var $58dc45d60525231a$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $58dc45d60525231a$export$871de8747c9eaa88(f));
};
var $58dc45d60525231a$var$_mapLeft = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $58dc45d60525231a$export$472de43a55e4aa49(f));
};
var $58dc45d60525231a$var$_bimap = function(fa, g, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $58dc45d60525231a$export$eb54baf0b342cb1d(g, f));
};
var $58dc45d60525231a$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $58dc45d60525231a$export$beaabdf62f4a639d($58dc45d60525231a$export$eabcd2c8791e7bf4(fa), f($58dc45d60525231a$export$79ffe56a765070d2(fa)));
    };
};
var $58dc45d60525231a$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $58dc45d60525231a$export$beaabdf62f4a639d(f($58dc45d60525231a$export$eabcd2c8791e7bf4(fa)), $58dc45d60525231a$export$79ffe56a765070d2(fa));
    };
};
var $58dc45d60525231a$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $58dc45d60525231a$export$beaabdf62f4a639d(f($58dc45d60525231a$export$eabcd2c8791e7bf4(fa)), g($58dc45d60525231a$export$79ffe56a765070d2(fa)));
    };
};
var $58dc45d60525231a$export$9156e739aa33e19f = 'Separated';
var $58dc45d60525231a$export$fd0fe42029639505 = {
    URI: $58dc45d60525231a$export$9156e739aa33e19f,
    mapLeft: $58dc45d60525231a$var$_mapLeft,
    bimap: $58dc45d60525231a$var$_bimap
};
var $58dc45d60525231a$export$bd5b6bfc5fa2ee61 = {
    URI: $58dc45d60525231a$export$9156e739aa33e19f,
    map: $58dc45d60525231a$var$_map
};
var $58dc45d60525231a$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($58dc45d60525231a$export$bd5b6bfc5fa2ee61);
var $58dc45d60525231a$export$eabcd2c8791e7bf4 = function(s) {
    return s.left;
};
var $58dc45d60525231a$export$79ffe56a765070d2 = function(s) {
    return s.right;
};



function $1209966343b7d06c$export$f4cb42390e44d1d2(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function $1209966343b7d06c$export$1f5c6f948d11a182(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function $1209966343b7d06c$export$c40604f35db61519(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? $f506e8da188a4a28$export$ad14ef4001db2bcd(a) : $f506e8da188a4a28$export$f883a24d5edde77c;
                    });
                });
            };
        };
    };
}


function $7f5e139b9ab3f0d5$export$864d727b48066337(F, P) {
    return function(b) {
        return b ? P.of(undefined) : F.zero();
    };
}


var $aa0d0a09044b87d4$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $aa0d0a09044b87d4$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $aa0d0a09044b87d4$export$a978c53b4062a525 = $694b1cc3e43dcc88$export$a978c53b4062a525;
var $aa0d0a09044b87d4$export$68159836694e22c1 = $694b1cc3e43dcc88$export$68159836694e22c1;
var $aa0d0a09044b87d4$export$c4c4d41eab625797 = $694b1cc3e43dcc88$export$c4c4d41eab625797;
var $aa0d0a09044b87d4$export$10d8903dec122b9d = $694b1cc3e43dcc88$export$10d8903dec122b9d;
var $aa0d0a09044b87d4$export$19903a1bf1942f6 = $694b1cc3e43dcc88$export$19903a1bf1942f6;
var $aa0d0a09044b87d4$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : $694b1cc3e43dcc88$export$849fbdcc2211fcde(f)(n);
};
var $aa0d0a09044b87d4$export$606959e7ccb797f0 = function(n, a) {
    return $aa0d0a09044b87d4$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $aa0d0a09044b87d4$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : $aa0d0a09044b87d4$export$6e22c362a0406a2c;
    };
}
var $aa0d0a09044b87d4$export$172ec0a6ebfeb6fa = function(ma) {
    return $f506e8da188a4a28$export$e56af863d5645d5f(ma) ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : [
        ma.value
    ];
};
var $aa0d0a09044b87d4$export$80c878c9b1d77917 = function(e) {
    return $f506e8da188a4a28$export$d649b6842e09f2b(e) ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : [
        e.right
    ];
};
var $aa0d0a09044b87d4$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $aa0d0a09044b87d4$export$4659b591c19bdf3d = $aa0d0a09044b87d4$export$2d55ea551c238330;
var $aa0d0a09044b87d4$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? onNonEmpty($694b1cc3e43dcc88$export$5fd5031fecdacec3(as), $694b1cc3e43dcc88$export$c01875f616615628(as)) : onEmpty();
    };
};
var $aa0d0a09044b87d4$export$6280271dfaec4919 = $aa0d0a09044b87d4$export$ebbe93aa91e3abdc;
var $aa0d0a09044b87d4$export$f3163a37d0ef5927 = $aa0d0a09044b87d4$export$6280271dfaec4919;
var $aa0d0a09044b87d4$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? onNonEmpty($694b1cc3e43dcc88$export$2cd8252107eb640b(as), $694b1cc3e43dcc88$export$4c7897fafd92b108(as)) : onEmpty();
    };
};
var $aa0d0a09044b87d4$export$b1cacb83a5c6bd02 = $aa0d0a09044b87d4$export$364f7f2cc8473008;
var $aa0d0a09044b87d4$export$77fa89c00b331c4c = $aa0d0a09044b87d4$export$b1cacb83a5c6bd02;
var $aa0d0a09044b87d4$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        if ($aa0d0a09044b87d4$export$dd1bc94b04021eeb(as)) return $aa0d0a09044b87d4$export$6e22c362a0406a2c;
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $aa0d0a09044b87d4$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $aa0d0a09044b87d4$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $aa0d0a09044b87d4$export$346677f925de839c = function(as) {
    return as.length;
};
var $aa0d0a09044b87d4$export$2fde0b1c54fc39b9 = $694b1cc3e43dcc88$export$2fde0b1c54fc39b9;
function $aa0d0a09044b87d4$export$dfc7155ac0343b8(i, as) {
    return as === undefined ? function(as) {
        return $aa0d0a09044b87d4$export$dfc7155ac0343b8(i, as);
    } : $aa0d0a09044b87d4$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd(as[i]);
}
var $aa0d0a09044b87d4$export$5fd5031fecdacec3 = function(as) {
    return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$5fd5031fecdacec3(as)) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $aa0d0a09044b87d4$export$4c7897fafd92b108 = function(as) {
    return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$4c7897fafd92b108(as)) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $aa0d0a09044b87d4$export$c01875f616615628 = function(as) {
    return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$c01875f616615628(as)) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $aa0d0a09044b87d4$export$2cd8252107eb640b = function(as) {
    return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$2cd8252107eb640b(as)) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $aa0d0a09044b87d4$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $aa0d0a09044b87d4$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : as.slice(0, n);
    };
};
var $aa0d0a09044b87d4$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $aa0d0a09044b87d4$export$2fde0b1c54fc39b9(n, as) ? as : n === 0 ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : as.slice(-n);
    };
};
function $aa0d0a09044b87d4$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        var len = out.length;
        return len === as.length ? as : len === 0 ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : out;
    };
}
var $aa0d0a09044b87d4$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $aa0d0a09044b87d4$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $aa0d0a09044b87d4$export$b0d75975ac0be0e1($aa0d0a09044b87d4$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $aa0d0a09044b87d4$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $aa0d0a09044b87d4$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : as.slice(n, as.length);
    };
};
var $aa0d0a09044b87d4$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $aa0d0a09044b87d4$export$dd1bc94b04021eeb(as) ? as : n >= as.length ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : as.slice(0, as.length - n);
    };
};
function $aa0d0a09044b87d4$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        var i = $aa0d0a09044b87d4$var$spanLeftIndex(as, predicate);
        return i === 0 ? as : i === as.length ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : as.slice(i);
    };
}
var $aa0d0a09044b87d4$export$de3a4d4a0d731119 = function(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $f506e8da188a4a28$export$ad14ef4001db2bcd(i);
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
};
function $aa0d0a09044b87d4$export$9a2f228bed5035c2(predicate) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            if (predicate(as[i])) return $f506e8da188a4a28$export$ad14ef4001db2bcd(as[i]);
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
}
var $aa0d0a09044b87d4$export$a86c11c94d794a95 = function(f) {
    return function(as) {
        for(var i = 0; i < as.length; i++){
            var out = f(as[i]);
            if ($f506e8da188a4a28$export$5d7e502287836e58(out)) return out;
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
};
function $aa0d0a09044b87d4$export$296de88ccac4bedb(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $f506e8da188a4a28$export$ad14ef4001db2bcd(as[i]);
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
}
var $aa0d0a09044b87d4$export$8b5e6d6ad82284fa = function(f) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            var out = f(as[i]);
            if ($f506e8da188a4a28$export$5d7e502287836e58(out)) return out;
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
};
var $aa0d0a09044b87d4$export$8855a8be7bd3e9f8 = function(predicate) {
    return function(as) {
        for(var i = as.length - 1; i >= 0; i--){
            if (predicate(as[i])) return $f506e8da188a4a28$export$ad14ef4001db2bcd(i);
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
};
var $aa0d0a09044b87d4$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($694b1cc3e43dcc88$export$f4863e1822a1860c(i, a, as));
    };
};
var $aa0d0a09044b87d4$export$b6d8713d53419d4c = function(i, a) {
    return $aa0d0a09044b87d4$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $aa0d0a09044b87d4$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $aa0d0a09044b87d4$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($aa0d0a09044b87d4$export$4937fde8dfc38dbd(i, as));
    };
};
var $aa0d0a09044b87d4$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $aa0d0a09044b87d4$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($aa0d0a09044b87d4$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $aa0d0a09044b87d4$export$66c1ae025e96b4bc = function(as) {
    return as.length <= 1 ? as : as.slice().reverse();
};
var $aa0d0a09044b87d4$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $aa0d0a09044b87d4$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $aa0d0a09044b87d4$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? as : as.slice().sort(O.compare);
    };
};
var $aa0d0a09044b87d4$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $aa0d0a09044b87d4$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $aa0d0a09044b87d4$export$8901015135f2fb22(bs, as);
    };
    return $aa0d0a09044b87d4$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $aa0d0a09044b87d4$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $aa0d0a09044b87d4$export$849c7567cbd62acc = function(middle) {
    var f = $694b1cc3e43dcc88$export$849c7567cbd62acc(middle);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aa0d0a09044b87d4$export$af200dcf8b7cb5de = function(middle) {
    var f = $694b1cc3e43dcc88$export$af200dcf8b7cb5de(middle);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aa0d0a09044b87d4$export$bb628a54ab399bc9 = function(n) {
    var f = $694b1cc3e43dcc88$export$bb628a54ab399bc9(n);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
function $aa0d0a09044b87d4$export$5bf96401662340b7(E) {
    return function(a, as) {
        if (as === undefined) {
            var elemE_1 = $aa0d0a09044b87d4$export$5bf96401662340b7(E);
            return function(as) {
                return elemE_1(a, as);
            };
        }
        var predicate = function(element) {
            return E.equals(element, a);
        };
        var i = 0;
        for(; i < as.length; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
}
var $aa0d0a09044b87d4$export$f70730c3d1fc524e = function(E) {
    var f = $694b1cc3e43dcc88$export$f70730c3d1fc524e(E);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aa0d0a09044b87d4$export$b035e44d7bb4278f = function(ords) {
    var f = $694b1cc3e43dcc88$export$b035e44d7bb4278f(ords);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? f(as) : as;
    };
};
var $aa0d0a09044b87d4$export$433fe05b12ba833f = function(f) {
    var g = $694b1cc3e43dcc88$export$433fe05b12ba833f(f);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? g(as) : $aa0d0a09044b87d4$export$6e22c362a0406a2c;
    };
};
var $aa0d0a09044b87d4$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? $694b1cc3e43dcc88$export$b0d75975ac0be0e1(n)(as) : $aa0d0a09044b87d4$export$dd1bc94b04021eeb(as) ? [
            as,
            $aa0d0a09044b87d4$export$6e22c362a0406a2c
        ] : [
            $aa0d0a09044b87d4$export$6e22c362a0406a2c,
            as
        ];
    };
};
var $aa0d0a09044b87d4$export$2f0184d5df52135f = function(n) {
    var f = $694b1cc3e43dcc88$export$2f0184d5df52135f(n);
    return function(as) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? f(as) : $aa0d0a09044b87d4$export$6e22c362a0406a2c;
    };
};
var $aa0d0a09044b87d4$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $aa0d0a09044b87d4$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $aa0d0a09044b87d4$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $aa0d0a09044b87d4$export$a978c53b4062a525(input) ? $aa0d0a09044b87d4$export$5b8affa63fc6df16($694b1cc3e43dcc88$export$5fd5031fecdacec3(input), function(a) {
            return go((0, $195a10ed7200bcca$export$a4627e546088548d)(scope, $aa0d0a09044b87d4$export$10d8903dec122b9d(a)), $694b1cc3e43dcc88$export$c01875f616615628(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : $aa0d0a09044b87d4$export$6e22c362a0406a2c;
    };
    return go($aa0d0a09044b87d4$export$6e22c362a0406a2c, input);
}
var $aa0d0a09044b87d4$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $aa0d0a09044b87d4$export$dd1bc94b04021eeb(first) ? second : $aa0d0a09044b87d4$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
    };
};
var $aa0d0a09044b87d4$export$ee1b3e54f0441b22 = $aa0d0a09044b87d4$export$c8c959650bbe80e2;
function $aa0d0a09044b87d4$export$971dd5b0dfd021b6(E) {
    var unionE = $694b1cc3e43dcc88$export$971dd5b0dfd021b6(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $aa0d0a09044b87d4$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $aa0d0a09044b87d4$export$a978c53b4062a525(first) && $aa0d0a09044b87d4$export$a978c53b4062a525(second) ? unionE(second)(first) : $aa0d0a09044b87d4$export$a978c53b4062a525(first) ? first : second;
    };
}
function $aa0d0a09044b87d4$export$bc86dfbf7795668c(E) {
    var elemE = $aa0d0a09044b87d4$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $aa0d0a09044b87d4$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $aa0d0a09044b87d4$export$acaf96a27438246b(E) {
    var elemE = $aa0d0a09044b87d4$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $aa0d0a09044b87d4$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $aa0d0a09044b87d4$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$871de8747c9eaa88(f));
};
var $aa0d0a09044b87d4$var$_mapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$8f07ddce13659f50(f));
};
var $aa0d0a09044b87d4$var$_ap = function(fab, fa) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fab, $aa0d0a09044b87d4$export$2f6ca3d3b1f80bf5(fa));
};
var $aa0d0a09044b87d4$var$_filter = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$3dea766d36a8935f(predicate));
};
var $aa0d0a09044b87d4$var$_filterMap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$a04c6c6965dd4709(f));
};
var $aa0d0a09044b87d4$var$_partition = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$b29f828819edca8d(predicate));
};
var $aa0d0a09044b87d4$var$_partitionMap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$3117e3f9ececb6bc(f));
};
var $aa0d0a09044b87d4$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $aa0d0a09044b87d4$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$bc7c0794b9c6f3ba(f));
};
var $aa0d0a09044b87d4$var$_alt = function(fa, that) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$228be17d80722ab(that));
};
var $aa0d0a09044b87d4$var$_reduce = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$533b26079ad0b4b(b, f));
};
var $aa0d0a09044b87d4$var$_foldMap = function(M) {
    var foldMapM = $aa0d0a09044b87d4$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
var $aa0d0a09044b87d4$var$_reduceRight = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$7fef8bcdbb34f435(b, f));
};
var $aa0d0a09044b87d4$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$bbd3ef8720e22369(b, f));
};
var $aa0d0a09044b87d4$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $aa0d0a09044b87d4$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
var $aa0d0a09044b87d4$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$ce2b2fe0b88ccd0a(b, f));
};
var $aa0d0a09044b87d4$var$_filterMapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$30c5cbe848021e97(f));
};
var $aa0d0a09044b87d4$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$36e42aef19fc7171(predicateWithIndex));
};
var $aa0d0a09044b87d4$var$_extend = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$8b58be045bf06082(f));
};
var $aa0d0a09044b87d4$var$_traverse = function(F) {
    var traverseF = $aa0d0a09044b87d4$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $aa0d0a09044b87d4$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $aa0d0a09044b87d4$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $aa0d0a09044b87d4$export$c5c44f872d8af73 = function(a, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(a, $aa0d0a09044b87d4$export$f855115a79f70c1a(f));
};
var $aa0d0a09044b87d4$export$b9909b62ceeab991 = function(a, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(a, $aa0d0a09044b87d4$export$bffee57bb00a6859(f));
};
var $aa0d0a09044b87d4$export$ba255e9e49e00608 = $694b1cc3e43dcc88$export$ba255e9e49e00608;
var $aa0d0a09044b87d4$export$7f9972325ebfd559 = function() {
    return $aa0d0a09044b87d4$export$6e22c362a0406a2c;
};
var $aa0d0a09044b87d4$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $aa0d0a09044b87d4$export$228be17d80722ab = $aa0d0a09044b87d4$export$1517cca7889d6aaa;
var $aa0d0a09044b87d4$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $aa0d0a09044b87d4$export$5b8affa63fc6df16(function(f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $aa0d0a09044b87d4$export$871de8747c9eaa88(f));
    });
};
var $aa0d0a09044b87d4$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(ma, $aa0d0a09044b87d4$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $aa0d0a09044b87d4$export$bffa455ba8c619a6 = /*#__PURE__*/ $aa0d0a09044b87d4$export$5b8affa63fc6df16((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $aa0d0a09044b87d4$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $aa0d0a09044b87d4$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $aa0d0a09044b87d4$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
};
var $aa0d0a09044b87d4$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $aa0d0a09044b87d4$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($f506e8da188a4a28$export$5d7e502287836e58(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $aa0d0a09044b87d4$export$a04c6c6965dd4709 = function(f) {
    return $aa0d0a09044b87d4$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $aa0d0a09044b87d4$export$8e16b83750b44988 = /*#__PURE__*/ $aa0d0a09044b87d4$export$a04c6c6965dd4709((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $aa0d0a09044b87d4$export$b29f828819edca8d = function(predicate) {
    return $aa0d0a09044b87d4$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $aa0d0a09044b87d4$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var a = as[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
};
var $aa0d0a09044b87d4$export$3117e3f9ececb6bc = function(f) {
    return $aa0d0a09044b87d4$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $aa0d0a09044b87d4$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
};
var $aa0d0a09044b87d4$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    };
};
var $aa0d0a09044b87d4$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $aa0d0a09044b87d4$export$ecd5e8ace626722c = /*#__PURE__*/ $aa0d0a09044b87d4$export$8b58be045bf06082((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $aa0d0a09044b87d4$export$18153bb1181268e5 = function(M) {
    return function(f) {
        return function(fa) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    };
};
var $aa0d0a09044b87d4$export$533b26079ad0b4b = function(b, f) {
    return $aa0d0a09044b87d4$export$bbd3ef8720e22369(b, function(_, b, a) {
        return f(b, a);
    });
};
var $aa0d0a09044b87d4$export$b66cdc0497d8a99a = function(M) {
    var foldMapWithIndexM = $aa0d0a09044b87d4$export$18153bb1181268e5(M);
    return function(f) {
        return foldMapWithIndexM(function(_, a) {
            return f(a);
        });
    };
};
var $aa0d0a09044b87d4$export$bbd3ef8720e22369 = function(b, f) {
    return function(fa) {
        var len = fa.length;
        var out = b;
        for(var i = 0; i < len; i++)out = f(i, out, fa[i]);
        return out;
    };
};
var $aa0d0a09044b87d4$export$7fef8bcdbb34f435 = function(b, f) {
    return $aa0d0a09044b87d4$export$ce2b2fe0b88ccd0a(b, function(_, a, b) {
        return f(a, b);
    });
};
var $aa0d0a09044b87d4$export$ce2b2fe0b88ccd0a = function(b, f) {
    return function(fa) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    };
};
var $aa0d0a09044b87d4$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $aa0d0a09044b87d4$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $aa0d0a09044b87d4$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $aa0d0a09044b87d4$var$_reduce(ta, F.of($aa0d0a09044b87d4$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $195a10ed7200bcca$export$a4627e546088548d)(as, $aa0d0a09044b87d4$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $aa0d0a09044b87d4$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $aa0d0a09044b87d4$export$bbd3ef8720e22369(F.of($aa0d0a09044b87d4$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $195a10ed7200bcca$export$a4627e546088548d)(bs, $aa0d0a09044b87d4$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $aa0d0a09044b87d4$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $aa0d0a09044b87d4$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $aa0d0a09044b87d4$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $aa0d0a09044b87d4$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $aa0d0a09044b87d4$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($f506e8da188a4a28$export$5d7e502287836e58(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $aa0d0a09044b87d4$export$9156e739aa33e19f = 'ReadonlyArray';
var $aa0d0a09044b87d4$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(as) {
            return "[".concat(as.map(S.show).join(', '), "]");
        }
    };
};
var $aa0d0a09044b87d4$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return $aa0d0a09044b87d4$export$dd1bc94b04021eeb(first) ? second : $aa0d0a09044b87d4$export$dd1bc94b04021eeb(second) ? first : first.concat(second);
        }
    };
};
var $aa0d0a09044b87d4$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $aa0d0a09044b87d4$export$e759a9a7f8d04692().concat,
        empty: $aa0d0a09044b87d4$export$6e22c362a0406a2c
    };
};
var $aa0d0a09044b87d4$export$804fed467fde44e4 = function(E) {
    return (0, $621782213ab3b52c$export$fec6acd8d60e8568)(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return E.equals(x, ys[i]);
        });
    });
};
var $aa0d0a09044b87d4$export$1af51209b1b91d07 = function(O) {
    return (0, $def12e545a21c13b$export$aa9e0de96ff2f1fd)(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var ordering = O.compare(a[i], b[i]);
            if (ordering !== 0) return ordering;
        }
        return $a37ad571de293d44$export$ee8aa95bfab51c5.compare(aLen, bLen);
    });
};
var $aa0d0a09044b87d4$export$baca17b4aff42f82 = function(E) {
    var unionE = $aa0d0a09044b87d4$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $aa0d0a09044b87d4$export$c487aac9f4157837 = function(E) {
    return {
        concat: $aa0d0a09044b87d4$export$baca17b4aff42f82(E).concat,
        empty: $aa0d0a09044b87d4$export$6e22c362a0406a2c
    };
};
var $aa0d0a09044b87d4$export$d379a869a72e4055 = function(E) {
    var intersectionE = $aa0d0a09044b87d4$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $aa0d0a09044b87d4$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $aa0d0a09044b87d4$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $aa0d0a09044b87d4$export$bd5b6bfc5fa2ee61 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map
};
var $aa0d0a09044b87d4$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($aa0d0a09044b87d4$export$bd5b6bfc5fa2ee61);
var $aa0d0a09044b87d4$export$59a71046037e6c20 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    of: $aa0d0a09044b87d4$export$ba255e9e49e00608
};
var $aa0d0a09044b87d4$export$9fdffe0fe1e91cad = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    mapWithIndex: $aa0d0a09044b87d4$var$_mapWithIndex
};
var $aa0d0a09044b87d4$export$efc21ddc6aeb363d = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap
};
var $aa0d0a09044b87d4$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $9465861535336ff3$export$5f28d9feedcfd46e)($aa0d0a09044b87d4$export$efc21ddc6aeb363d);
var $aa0d0a09044b87d4$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $9465861535336ff3$export$ed01bc59c3d06bf3)($aa0d0a09044b87d4$export$efc21ddc6aeb363d);
var $aa0d0a09044b87d4$export$1279d2b7807629fd = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    of: $aa0d0a09044b87d4$export$ba255e9e49e00608
};
var $aa0d0a09044b87d4$export$f18d5acc27d70423 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    chain: $aa0d0a09044b87d4$export$5b8affa63fc6df16
};
var $aa0d0a09044b87d4$export$fb641926d034ac7d = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    of: $aa0d0a09044b87d4$export$ba255e9e49e00608,
    chain: $aa0d0a09044b87d4$export$5b8affa63fc6df16
};
var $aa0d0a09044b87d4$export$e3821ef4970c339c = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$e3821ef4970c339c)($aa0d0a09044b87d4$export$f18d5acc27d70423);
var $aa0d0a09044b87d4$export$8fa953f00d3b093 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    unfold: $aa0d0a09044b87d4$export$c48e357c1a89b78d
};
var $aa0d0a09044b87d4$export$25ba4469a069167 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    alt: $aa0d0a09044b87d4$var$_alt
};
var $aa0d0a09044b87d4$export$aaef8a3eae948f03 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    zero: $aa0d0a09044b87d4$export$7f9972325ebfd559
};
var $aa0d0a09044b87d4$export$864d727b48066337 = /*#__PURE__*/ (0, $7f5e139b9ab3f0d5$export$864d727b48066337)($aa0d0a09044b87d4$export$aaef8a3eae948f03, $aa0d0a09044b87d4$export$59a71046037e6c20);
var $aa0d0a09044b87d4$export$4acb47accde578d2 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    of: $aa0d0a09044b87d4$export$ba255e9e49e00608,
    alt: $aa0d0a09044b87d4$var$_alt,
    zero: $aa0d0a09044b87d4$export$7f9972325ebfd559
};
var $aa0d0a09044b87d4$export$5b5dd0e212d2a5bc = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    extend: $aa0d0a09044b87d4$var$_extend
};
var $aa0d0a09044b87d4$export$4a21ac48141ac3c9 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    compact: $aa0d0a09044b87d4$export$8e16b83750b44988,
    separate: $aa0d0a09044b87d4$export$709f6946f4e97408
};
var $aa0d0a09044b87d4$export$d00e1c48fb621173 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    compact: $aa0d0a09044b87d4$export$8e16b83750b44988,
    separate: $aa0d0a09044b87d4$export$709f6946f4e97408,
    filter: $aa0d0a09044b87d4$var$_filter,
    filterMap: $aa0d0a09044b87d4$var$_filterMap,
    partition: $aa0d0a09044b87d4$var$_partition,
    partitionMap: $aa0d0a09044b87d4$var$_partitionMap
};
var $aa0d0a09044b87d4$export$c29a647071e542ec = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    mapWithIndex: $aa0d0a09044b87d4$var$_mapWithIndex,
    compact: $aa0d0a09044b87d4$export$8e16b83750b44988,
    separate: $aa0d0a09044b87d4$export$709f6946f4e97408,
    filter: $aa0d0a09044b87d4$var$_filter,
    filterMap: $aa0d0a09044b87d4$var$_filterMap,
    partition: $aa0d0a09044b87d4$var$_partition,
    partitionMap: $aa0d0a09044b87d4$var$_partitionMap,
    partitionMapWithIndex: $aa0d0a09044b87d4$var$_partitionMapWithIndex,
    partitionWithIndex: $aa0d0a09044b87d4$var$_partitionWithIndex,
    filterMapWithIndex: $aa0d0a09044b87d4$var$_filterMapWithIndex,
    filterWithIndex: $aa0d0a09044b87d4$var$_filterWithIndex
};
var $aa0d0a09044b87d4$export$41404b31838667c9 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    reduce: $aa0d0a09044b87d4$var$_reduce,
    foldMap: $aa0d0a09044b87d4$var$_foldMap,
    reduceRight: $aa0d0a09044b87d4$var$_reduceRight
};
var $aa0d0a09044b87d4$export$e8f7d17aaff345cb = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    reduce: $aa0d0a09044b87d4$var$_reduce,
    foldMap: $aa0d0a09044b87d4$var$_foldMap,
    reduceRight: $aa0d0a09044b87d4$var$_reduceRight,
    reduceWithIndex: $aa0d0a09044b87d4$var$_reduceWithIndex,
    foldMapWithIndex: $aa0d0a09044b87d4$var$_foldMapWithIndex,
    reduceRightWithIndex: $aa0d0a09044b87d4$var$_reduceRightWithIndex
};
var $aa0d0a09044b87d4$export$a0202666c3bda011 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    reduce: $aa0d0a09044b87d4$var$_reduce,
    foldMap: $aa0d0a09044b87d4$var$_foldMap,
    reduceRight: $aa0d0a09044b87d4$var$_reduceRight,
    traverse: $aa0d0a09044b87d4$var$_traverse,
    sequence: $aa0d0a09044b87d4$export$49bb65c2ea163039
};
var $aa0d0a09044b87d4$export$bd7b528d8c36ec41 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    mapWithIndex: $aa0d0a09044b87d4$var$_mapWithIndex,
    reduce: $aa0d0a09044b87d4$var$_reduce,
    foldMap: $aa0d0a09044b87d4$var$_foldMap,
    reduceRight: $aa0d0a09044b87d4$var$_reduceRight,
    reduceWithIndex: $aa0d0a09044b87d4$var$_reduceWithIndex,
    foldMapWithIndex: $aa0d0a09044b87d4$var$_foldMapWithIndex,
    reduceRightWithIndex: $aa0d0a09044b87d4$var$_reduceRightWithIndex,
    traverse: $aa0d0a09044b87d4$var$_traverse,
    sequence: $aa0d0a09044b87d4$export$49bb65c2ea163039,
    traverseWithIndex: $aa0d0a09044b87d4$var$_traverseWithIndex
};
var $aa0d0a09044b87d4$export$f855115a79f70c1a = function(f) {
    return function(a) {
        var todo = $aa0d0a09044b87d4$var$__spreadArray([], f(a), true);
        var out = [];
        while(todo.length > 0){
            var e = todo.shift();
            if ($f506e8da188a4a28$export$d649b6842e09f2b(e)) todo.unshift.apply(todo, f(e.left));
            else out.push(e.right);
        }
        return out;
    };
};
var $aa0d0a09044b87d4$export$7d808dfaa6d54634 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    chain: $aa0d0a09044b87d4$export$5b8affa63fc6df16,
    chainRec: $aa0d0a09044b87d4$export$c5c44f872d8af73
};
var $aa0d0a09044b87d4$export$bffee57bb00a6859 = function(f) {
    return function(a) {
        var initial = f(a);
        var todo = [];
        var out = [];
        function go(e) {
            if ($f506e8da188a4a28$export$d649b6842e09f2b(e)) f(e.left).forEach(function(v) {
                return todo.push(v);
            });
            else out.push(e.right);
        }
        for(var _i = 0, initial_1 = initial; _i < initial_1.length; _i++){
            var e = initial_1[_i];
            go(e);
        }
        while(todo.length > 0)go(todo.shift());
        return out;
    };
};
var $aa0d0a09044b87d4$export$57f3a385c7e59628 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    chain: $aa0d0a09044b87d4$export$5b8affa63fc6df16,
    chainRec: $aa0d0a09044b87d4$export$b9909b62ceeab991
};
var $aa0d0a09044b87d4$var$_wither = /*#__PURE__*/ (0, $1209966343b7d06c$export$1f5c6f948d11a182)($aa0d0a09044b87d4$export$a0202666c3bda011, $aa0d0a09044b87d4$export$4a21ac48141ac3c9);
var $aa0d0a09044b87d4$var$_wilt = /*#__PURE__*/ (0, $1209966343b7d06c$export$f4cb42390e44d1d2)($aa0d0a09044b87d4$export$a0202666c3bda011, $aa0d0a09044b87d4$export$4a21ac48141ac3c9);
var $aa0d0a09044b87d4$export$748d317b4c426f96 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    map: $aa0d0a09044b87d4$var$_map,
    compact: $aa0d0a09044b87d4$export$8e16b83750b44988,
    separate: $aa0d0a09044b87d4$export$709f6946f4e97408,
    filter: $aa0d0a09044b87d4$var$_filter,
    filterMap: $aa0d0a09044b87d4$var$_filterMap,
    partition: $aa0d0a09044b87d4$var$_partition,
    partitionMap: $aa0d0a09044b87d4$var$_partitionMap,
    reduce: $aa0d0a09044b87d4$var$_reduce,
    foldMap: $aa0d0a09044b87d4$var$_foldMap,
    reduceRight: $aa0d0a09044b87d4$var$_reduceRight,
    traverse: $aa0d0a09044b87d4$var$_traverse,
    sequence: $aa0d0a09044b87d4$export$49bb65c2ea163039,
    wither: $aa0d0a09044b87d4$var$_wither,
    wilt: $aa0d0a09044b87d4$var$_wilt
};
var $aa0d0a09044b87d4$export$c40604f35db61519 = /*#__PURE__*/ (0, $1209966343b7d06c$export$c40604f35db61519)($aa0d0a09044b87d4$export$748d317b4c426f96);
var $aa0d0a09044b87d4$export$825ea6cb6fc48d49 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    fromEither: $aa0d0a09044b87d4$export$80c878c9b1d77917
};
var $aa0d0a09044b87d4$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $e877117324731de7$export$8138b0ae92c9b5d8)($aa0d0a09044b87d4$export$825ea6cb6fc48d49);
var $aa0d0a09044b87d4$export$f4863e1822a1860c = $694b1cc3e43dcc88$export$f4863e1822a1860c;
var $aa0d0a09044b87d4$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $aa0d0a09044b87d4$export$a978c53b4062a525(as) ? $694b1cc3e43dcc88$export$9c0c6889b1fa9bfc(i, a, as) : as;
};
var $aa0d0a09044b87d4$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $aa0d0a09044b87d4$export$45b10814cc054894 = function(as) {
    return as.slice();
};
var $aa0d0a09044b87d4$export$571d59b505e6bb4e = function(as) {
    return $aa0d0a09044b87d4$export$dd1bc94b04021eeb(as) ? $aa0d0a09044b87d4$export$6e22c362a0406a2c : as.slice();
};
var $aa0d0a09044b87d4$export$6e22c362a0406a2c = $694b1cc3e43dcc88$export$6e22c362a0406a2c;
function $aa0d0a09044b87d4$export$7ecc1a3b11b57dab(predicate) {
    return function(as) {
        return as.every(predicate);
    };
}
var $aa0d0a09044b87d4$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $aa0d0a09044b87d4$export$f7e9f41ea797a17 = $aa0d0a09044b87d4$export$ad14ef4001db2bcd;
var $aa0d0a09044b87d4$export$739ec22334c44788 = function(M) {
    var intercalateM = $694b1cc3e43dcc88$export$739ec22334c44788(M);
    return function(middle) {
        return $aa0d0a09044b87d4$export$4659b591c19bdf3d(function() {
            return M.empty;
        }, intercalateM(middle));
    };
};
var $aa0d0a09044b87d4$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $aa0d0a09044b87d4$export$ba255e9e49e00608($f506e8da188a4a28$export$4de80339753b012b);
var $aa0d0a09044b87d4$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $b90291f3b522edda$export$7c052ae73f8acff0)($aa0d0a09044b87d4$export$bd5b6bfc5fa2ee61);
var $aa0d0a09044b87d4$export$5d537b797c421217 = /*#__PURE__*/ (0, $b90291f3b522edda$export$5d537b797c421217)($aa0d0a09044b87d4$export$bd5b6bfc5fa2ee61);
var $aa0d0a09044b87d4$export$2385a24977818dd0 = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$2385a24977818dd0)($aa0d0a09044b87d4$export$f18d5acc27d70423);
var $aa0d0a09044b87d4$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $9465861535336ff3$export$8cbfc0239f42bb49)($aa0d0a09044b87d4$export$efc21ddc6aeb363d);
var $aa0d0a09044b87d4$export$e08e3b67e392101e = $aa0d0a09044b87d4$export$5b8affa63fc6df16;
var $aa0d0a09044b87d4$export$d02631cccf789723 = $694b1cc3e43dcc88$export$d02631cccf789723;
var $aa0d0a09044b87d4$export$8327ebbef2a0ba76 = $694b1cc3e43dcc88$export$8327ebbef2a0ba76;
var $aa0d0a09044b87d4$export$c40cf5aab899f397 = $694b1cc3e43dcc88$export$c40cf5aab899f397;
var $aa0d0a09044b87d4$export$baeb00bf1e27e233 = $aa0d0a09044b87d4$export$849c7567cbd62acc;
var $aa0d0a09044b87d4$export$95ca155af9fd5713 = {
    URI: $aa0d0a09044b87d4$export$9156e739aa33e19f,
    compact: $aa0d0a09044b87d4$export$8e16b83750b44988,
    separate: $aa0d0a09044b87d4$export$709f6946f4e97408,
    map: $aa0d0a09044b87d4$var$_map,
    ap: $aa0d0a09044b87d4$var$_ap,
    of: $aa0d0a09044b87d4$export$ba255e9e49e00608,
    chain: $aa0d0a09044b87d4$export$5b8affa63fc6df16,
    filter: $aa0d0a09044b87d4$var$_filter,
    filterMap: $aa0d0a09044b87d4$var$_filterMap,
    partition: $aa0d0a09044b87d4$var$_partition,
    partitionMap: $aa0d0a09044b87d4$var$_partitionMap,
    mapWithIndex: $aa0d0a09044b87d4$var$_mapWithIndex,
    partitionMapWithIndex: $aa0d0a09044b87d4$var$_partitionMapWithIndex,
    partitionWithIndex: $aa0d0a09044b87d4$var$_partitionWithIndex,
    filterMapWithIndex: $aa0d0a09044b87d4$var$_filterMapWithIndex,
    filterWithIndex: $aa0d0a09044b87d4$var$_filterWithIndex,
    alt: $aa0d0a09044b87d4$var$_alt,
    zero: $aa0d0a09044b87d4$export$7f9972325ebfd559,
    unfold: $aa0d0a09044b87d4$export$c48e357c1a89b78d,
    reduce: $aa0d0a09044b87d4$var$_reduce,
    foldMap: $aa0d0a09044b87d4$var$_foldMap,
    reduceRight: $aa0d0a09044b87d4$var$_reduceRight,
    traverse: $aa0d0a09044b87d4$var$_traverse,
    sequence: $aa0d0a09044b87d4$export$49bb65c2ea163039,
    reduceWithIndex: $aa0d0a09044b87d4$var$_reduceWithIndex,
    foldMapWithIndex: $aa0d0a09044b87d4$var$_foldMapWithIndex,
    reduceRightWithIndex: $aa0d0a09044b87d4$var$_reduceRightWithIndex,
    traverseWithIndex: $aa0d0a09044b87d4$var$_traverseWithIndex,
    extend: $aa0d0a09044b87d4$var$_extend,
    wither: $aa0d0a09044b87d4$var$_wither,
    wilt: $aa0d0a09044b87d4$var$_wilt
};





var $80651cc7cbc1f14e$export$dd1bc94b04021eeb = function(as) {
    return as.length === 0;
};
var $80651cc7cbc1f14e$export$a978c53b4062a525 = $40add6d007f2bbe9$export$a978c53b4062a525;
var $80651cc7cbc1f14e$export$68159836694e22c1 = $40add6d007f2bbe9$export$68159836694e22c1;
var $80651cc7cbc1f14e$export$c4c4d41eab625797 = $40add6d007f2bbe9$export$c4c4d41eab625797;
var $80651cc7cbc1f14e$export$10d8903dec122b9d = $40add6d007f2bbe9$export$10d8903dec122b9d;
var $80651cc7cbc1f14e$export$19903a1bf1942f6 = $40add6d007f2bbe9$export$19903a1bf1942f6;
var $80651cc7cbc1f14e$export$849fbdcc2211fcde = function(n, f) {
    return n <= 0 ? [] : $40add6d007f2bbe9$export$849fbdcc2211fcde(f)(n);
};
var $80651cc7cbc1f14e$export$606959e7ccb797f0 = function(n, a) {
    return $80651cc7cbc1f14e$export$849fbdcc2211fcde(n, function() {
        return a;
    });
};
function $80651cc7cbc1f14e$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? [
            a
        ] : [];
    };
}
var $80651cc7cbc1f14e$export$172ec0a6ebfeb6fa = function(ma) {
    return $f506e8da188a4a28$export$e56af863d5645d5f(ma) ? [] : [
        ma.value
    ];
};
var $80651cc7cbc1f14e$export$80c878c9b1d77917 = function(e) {
    return $f506e8da188a4a28$export$d649b6842e09f2b(e) ? [] : [
        e.right
    ];
};
var $80651cc7cbc1f14e$export$2d55ea551c238330 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? onNonEmpty(as) : onEmpty();
    };
};
var $80651cc7cbc1f14e$export$4659b591c19bdf3d = $80651cc7cbc1f14e$export$2d55ea551c238330;
var $80651cc7cbc1f14e$export$ebbe93aa91e3abdc = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? onNonEmpty($40add6d007f2bbe9$export$5fd5031fecdacec3(as), $40add6d007f2bbe9$export$c01875f616615628(as)) : onEmpty();
    };
};
var $80651cc7cbc1f14e$export$6280271dfaec4919 = $80651cc7cbc1f14e$export$ebbe93aa91e3abdc;
var $80651cc7cbc1f14e$export$f3163a37d0ef5927 = $80651cc7cbc1f14e$export$6280271dfaec4919;
var $80651cc7cbc1f14e$export$364f7f2cc8473008 = function(onEmpty, onNonEmpty) {
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? onNonEmpty($40add6d007f2bbe9$export$2cd8252107eb640b(as), $40add6d007f2bbe9$export$4c7897fafd92b108(as)) : onEmpty();
    };
};
var $80651cc7cbc1f14e$export$b1cacb83a5c6bd02 = $80651cc7cbc1f14e$export$364f7f2cc8473008;
var $80651cc7cbc1f14e$export$77fa89c00b331c4c = $80651cc7cbc1f14e$export$b1cacb83a5c6bd02;
var $80651cc7cbc1f14e$export$852cd95c2dfc239 = function(f) {
    return function(as) {
        var out = [];
        for(var i = 0; i < as.length; i++){
            var bs = f(i, as[i]);
            for(var j = 0; j < bs.length; j++)out.push(bs[j]);
        }
        return out;
    };
};
var $80651cc7cbc1f14e$export$555ac70de528b074 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[0] = b;
        for(var i = 0; i < len; i++)out[i + 1] = f(out[i], as[i]);
        return out;
    };
};
var $80651cc7cbc1f14e$export$d799959bdf780177 = function(b, f) {
    return function(as) {
        var len = as.length;
        var out = new Array(len + 1);
        out[len] = b;
        for(var i = len - 1; i >= 0; i--)out[i] = f(as[i], out[i + 1]);
        return out;
    };
};
var $80651cc7cbc1f14e$export$346677f925de839c = function(as) {
    return as.length;
};
var $80651cc7cbc1f14e$export$2fde0b1c54fc39b9 = $40add6d007f2bbe9$export$2fde0b1c54fc39b9;
var $80651cc7cbc1f14e$export$dfc7155ac0343b8 = $aa0d0a09044b87d4$export$dfc7155ac0343b8;
var $80651cc7cbc1f14e$export$5fd5031fecdacec3 = $aa0d0a09044b87d4$export$5fd5031fecdacec3;
var $80651cc7cbc1f14e$export$4c7897fafd92b108 = $aa0d0a09044b87d4$export$4c7897fafd92b108;
var $80651cc7cbc1f14e$export$c01875f616615628 = function(as) {
    return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd($40add6d007f2bbe9$export$c01875f616615628(as)) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $80651cc7cbc1f14e$export$2cd8252107eb640b = function(as) {
    return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? $f506e8da188a4a28$export$ad14ef4001db2bcd($40add6d007f2bbe9$export$2cd8252107eb640b(as)) : $f506e8da188a4a28$export$f883a24d5edde77c;
};
var $80651cc7cbc1f14e$export$8ea13dbc737d576b = function(n) {
    return function(as) {
        return $80651cc7cbc1f14e$export$2fde0b1c54fc39b9(n, as) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(as) : as.slice(0, n);
    };
};
var $80651cc7cbc1f14e$export$1bbc425ddca7f2c6 = function(n) {
    return function(as) {
        return $80651cc7cbc1f14e$export$2fde0b1c54fc39b9(n, as) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(as) : n === 0 ? [] : as.slice(-n);
    };
};
function $80651cc7cbc1f14e$export$5b0b82239a6f6d94(predicate) {
    return function(as) {
        var out = [];
        for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
            var a = as_1[_i];
            if (!predicate(a)) break;
            out.push(a);
        }
        return out;
    };
}
var $80651cc7cbc1f14e$var$spanLeftIndex = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $80651cc7cbc1f14e$export$104948d9b1d3fb14(predicate) {
    return function(as) {
        var _a = $80651cc7cbc1f14e$export$b0d75975ac0be0e1($80651cc7cbc1f14e$var$spanLeftIndex(as, predicate))(as), init = _a[0], rest = _a[1];
        return {
            init: init,
            rest: rest
        };
    };
}
var $80651cc7cbc1f14e$export$738250583454396 = function(n) {
    return function(as) {
        return n <= 0 || $80651cc7cbc1f14e$export$dd1bc94b04021eeb(as) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(n, as.length);
    };
};
var $80651cc7cbc1f14e$export$6ba801e3e123536e = function(n) {
    return function(as) {
        return n <= 0 || $80651cc7cbc1f14e$export$dd1bc94b04021eeb(as) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(as) : n >= as.length ? [] : as.slice(0, as.length - n);
    };
};
function $80651cc7cbc1f14e$export$d265ccd398ee49c9(predicate) {
    return function(as) {
        return as.slice($80651cc7cbc1f14e$var$spanLeftIndex(as, predicate));
    };
}
var $80651cc7cbc1f14e$export$de3a4d4a0d731119 = $aa0d0a09044b87d4$export$de3a4d4a0d731119;
function $80651cc7cbc1f14e$export$9a2f228bed5035c2(predicate) {
    return $aa0d0a09044b87d4$export$9a2f228bed5035c2(predicate);
}
var $80651cc7cbc1f14e$export$a86c11c94d794a95 = $aa0d0a09044b87d4$export$a86c11c94d794a95;
function $80651cc7cbc1f14e$export$296de88ccac4bedb(predicate) {
    return $aa0d0a09044b87d4$export$296de88ccac4bedb(predicate);
}
var $80651cc7cbc1f14e$export$8b5e6d6ad82284fa = $aa0d0a09044b87d4$export$8b5e6d6ad82284fa;
var $80651cc7cbc1f14e$export$8855a8be7bd3e9f8 = $aa0d0a09044b87d4$export$8855a8be7bd3e9f8;
var $80651cc7cbc1f14e$export$784d13d8ee351f07 = function(as) {
    return as.slice();
};
var $80651cc7cbc1f14e$export$9f200c4466975173 = function(i, a) {
    return function(as) {
        return i < 0 || i > as.length ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($80651cc7cbc1f14e$export$f4863e1822a1860c(i, a, as));
    };
};
var $80651cc7cbc1f14e$export$b6d8713d53419d4c = function(i, a) {
    return $80651cc7cbc1f14e$export$cba09f9e3d3e58eb(i, function() {
        return a;
    });
};
var $80651cc7cbc1f14e$export$90f9093465da3136 = function(i) {
    return function(as) {
        return $80651cc7cbc1f14e$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($80651cc7cbc1f14e$export$4937fde8dfc38dbd(i, as));
    };
};
var $80651cc7cbc1f14e$export$cba09f9e3d3e58eb = function(i, f) {
    return function(as) {
        return $80651cc7cbc1f14e$export$2fde0b1c54fc39b9(i, as) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd($80651cc7cbc1f14e$export$9c0c6889b1fa9bfc(i, f(as[i]), as));
    };
};
var $80651cc7cbc1f14e$export$66c1ae025e96b4bc = function(as) {
    return $80651cc7cbc1f14e$export$dd1bc94b04021eeb(as) ? [] : as.slice().reverse();
};
var $80651cc7cbc1f14e$export$cae945d60b6cbe50 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Right') r.push(a.right);
    }
    return r;
};
var $80651cc7cbc1f14e$export$837c95301ebad184 = function(as) {
    var r = [];
    for(var i = 0; i < as.length; i++){
        var a = as[i];
        if (a._tag === 'Left') r.push(a.left);
    }
    return r;
};
var $80651cc7cbc1f14e$export$97db5808d8f88186 = function(O) {
    return function(as) {
        return as.length <= 1 ? $80651cc7cbc1f14e$export$784d13d8ee351f07(as) : as.slice().sort(O.compare);
    };
};
var $80651cc7cbc1f14e$export$b634740ce272acb5 = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
function $80651cc7cbc1f14e$export$8901015135f2fb22(as, bs) {
    if (bs === undefined) return function(bs) {
        return $80651cc7cbc1f14e$export$8901015135f2fb22(bs, as);
    };
    return $80651cc7cbc1f14e$export$b634740ce272acb5(as, bs, function(a, b) {
        return [
            a,
            b
        ];
    });
}
var $80651cc7cbc1f14e$export$23c8d3f8757cab88 = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
var $80651cc7cbc1f14e$export$849c7567cbd62acc = function(middle) {
    var f = $40add6d007f2bbe9$export$849c7567cbd62acc(middle);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $80651cc7cbc1f14e$export$af200dcf8b7cb5de = function(middle) {
    var f = $40add6d007f2bbe9$export$af200dcf8b7cb5de(middle);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? f(as) : $80651cc7cbc1f14e$export$784d13d8ee351f07(as);
    };
};
var $80651cc7cbc1f14e$export$bb628a54ab399bc9 = function(n) {
    var f = $40add6d007f2bbe9$export$bb628a54ab399bc9(n);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? f(as) : $80651cc7cbc1f14e$export$784d13d8ee351f07(as);
    };
};
var $80651cc7cbc1f14e$export$5bf96401662340b7 = $aa0d0a09044b87d4$export$5bf96401662340b7;
var $80651cc7cbc1f14e$export$f70730c3d1fc524e = function(E) {
    var f = $40add6d007f2bbe9$export$f70730c3d1fc524e(E);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? f(as) : $80651cc7cbc1f14e$export$784d13d8ee351f07(as);
    };
};
var $80651cc7cbc1f14e$export$b035e44d7bb4278f = function(ords) {
    var f = $40add6d007f2bbe9$export$b035e44d7bb4278f(ords);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? f(as) : $80651cc7cbc1f14e$export$784d13d8ee351f07(as);
    };
};
var $80651cc7cbc1f14e$export$433fe05b12ba833f = function(f) {
    var g = $40add6d007f2bbe9$export$433fe05b12ba833f(f);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? g(as) : [];
    };
};
var $80651cc7cbc1f14e$export$b0d75975ac0be0e1 = function(n) {
    return function(as) {
        return n >= 1 && $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? $40add6d007f2bbe9$export$b0d75975ac0be0e1(n)(as) : $80651cc7cbc1f14e$export$dd1bc94b04021eeb(as) ? [
            $80651cc7cbc1f14e$export$784d13d8ee351f07(as),
            []
        ] : [
            [],
            $80651cc7cbc1f14e$export$784d13d8ee351f07(as)
        ];
    };
};
var $80651cc7cbc1f14e$export$2f0184d5df52135f = function(n) {
    var f = $40add6d007f2bbe9$export$2f0184d5df52135f(n);
    return function(as) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? f(as) : [];
    };
};
var $80651cc7cbc1f14e$export$a907462f448b49f8 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $80651cc7cbc1f14e$export$172ec0a6ebfeb6fa(f.apply(void 0, a));
    };
};
function $80651cc7cbc1f14e$export$105c199d42fdf965(input, f, g) {
    if (g === void 0) g = function() {
        return true;
    };
    var go = function(scope, input) {
        return $80651cc7cbc1f14e$export$a978c53b4062a525(input) ? $80651cc7cbc1f14e$export$5b8affa63fc6df16($40add6d007f2bbe9$export$5fd5031fecdacec3(input), function(a) {
            return go((0, $195a10ed7200bcca$export$a4627e546088548d)(scope, $80651cc7cbc1f14e$export$10d8903dec122b9d(a)), $40add6d007f2bbe9$export$c01875f616615628(input));
        }) : g.apply(void 0, scope) ? [
            f.apply(void 0, scope)
        ] : [];
    };
    return go([], input);
}
var $80651cc7cbc1f14e$export$c8c959650bbe80e2 = function(second) {
    return function(first) {
        return $80651cc7cbc1f14e$export$dd1bc94b04021eeb(first) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(second) : $80651cc7cbc1f14e$export$dd1bc94b04021eeb(second) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(first) : first.concat(second);
    };
};
var $80651cc7cbc1f14e$export$ee1b3e54f0441b22 = $80651cc7cbc1f14e$export$c8c959650bbe80e2;
function $80651cc7cbc1f14e$export$971dd5b0dfd021b6(E) {
    var unionE = $40add6d007f2bbe9$export$971dd5b0dfd021b6(E);
    return function(first, second) {
        if (second === undefined) {
            var unionE_1 = $80651cc7cbc1f14e$export$971dd5b0dfd021b6(E);
            return function(second) {
                return unionE_1(second, first);
            };
        }
        return $80651cc7cbc1f14e$export$a978c53b4062a525(first) && $80651cc7cbc1f14e$export$a978c53b4062a525(second) ? unionE(second)(first) : $80651cc7cbc1f14e$export$a978c53b4062a525(first) ? $80651cc7cbc1f14e$export$784d13d8ee351f07(first) : $80651cc7cbc1f14e$export$784d13d8ee351f07(second);
    };
}
function $80651cc7cbc1f14e$export$bc86dfbf7795668c(E) {
    var elemE = $80651cc7cbc1f14e$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var intersectionE_1 = $80651cc7cbc1f14e$export$bc86dfbf7795668c(E);
            return function(ys) {
                return intersectionE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
}
function $80651cc7cbc1f14e$export$acaf96a27438246b(E) {
    var elemE = $80651cc7cbc1f14e$export$5bf96401662340b7(E);
    return function(xs, ys) {
        if (ys === undefined) {
            var differenceE_1 = $80651cc7cbc1f14e$export$acaf96a27438246b(E);
            return function(ys) {
                return differenceE_1(ys, xs);
            };
        }
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
}
var $80651cc7cbc1f14e$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_mapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$8f07ddce13659f50(f));
};
var $80651cc7cbc1f14e$var$_ap = function(fab, fa) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fab, $80651cc7cbc1f14e$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_filter = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_filterMap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_partition = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_partitionMap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$3117e3f9ececb6bc(f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_partitionWithIndex = function(fa, predicateWithIndex) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$dad5e500f2bab9bc(predicateWithIndex));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$bc7c0794b9c6f3ba(f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_alt = function(fa, that) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$228be17d80722ab(that));
};
var $80651cc7cbc1f14e$var$_reduce = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_foldMap = function(M) {
    var foldMapM = $80651cc7cbc1f14e$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_reduceRight = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$7fef8bcdbb34f435(b, f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_reduceWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$bbd3ef8720e22369(b, f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_foldMapWithIndex = function(M) {
    var foldMapWithIndexM = $80651cc7cbc1f14e$export$18153bb1181268e5(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
    };
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_reduceRightWithIndex = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$ce2b2fe0b88ccd0a(b, f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_filterMapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$30c5cbe848021e97(f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_filterWithIndex = function(fa, predicateWithIndex) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$36e42aef19fc7171(predicateWithIndex));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_extend = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_traverse = function(F) {
    var traverseF = $80651cc7cbc1f14e$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $80651cc7cbc1f14e$var$_traverseWithIndex = function(F) {
    var traverseWithIndexF = $80651cc7cbc1f14e$export$955fdc0d24efa249(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseWithIndexF(f));
    };
};
var $80651cc7cbc1f14e$var$_chainRecDepthFirst = $aa0d0a09044b87d4$export$c5c44f872d8af73;
var $80651cc7cbc1f14e$var$_chainRecBreadthFirst = $aa0d0a09044b87d4$export$b9909b62ceeab991;
var $80651cc7cbc1f14e$export$ba255e9e49e00608 = $40add6d007f2bbe9$export$ba255e9e49e00608;
var $80651cc7cbc1f14e$export$7f9972325ebfd559 = function() {
    return [];
};
var $80651cc7cbc1f14e$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return fa.map(function(a) {
            return f(a);
        });
    };
};
var $80651cc7cbc1f14e$export$2f6ca3d3b1f80bf5 = function(fa) {
    return $80651cc7cbc1f14e$export$5b8affa63fc6df16(function(f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $80651cc7cbc1f14e$export$871de8747c9eaa88(f));
    });
};
var $80651cc7cbc1f14e$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(ma, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(ma, $80651cc7cbc1f14e$export$852cd95c2dfc239(function(i, a) {
        return f(a, i);
    }));
});
var $80651cc7cbc1f14e$export$bffa455ba8c619a6 = /*#__PURE__*/ $80651cc7cbc1f14e$export$5b8affa63fc6df16((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $80651cc7cbc1f14e$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    };
};
var $80651cc7cbc1f14e$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var out = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($f506e8da188a4a28$export$5d7e502287836e58(optionB)) out.push(optionB.value);
        }
        return out;
    };
};
var $80651cc7cbc1f14e$export$a04c6c6965dd4709 = function(f) {
    return $80651cc7cbc1f14e$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $80651cc7cbc1f14e$export$8e16b83750b44988 = /*#__PURE__*/ $80651cc7cbc1f14e$export$a04c6c6965dd4709((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $80651cc7cbc1f14e$export$709f6946f4e97408 = function(fa) {
    var left = [];
    var right = [];
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var e = fa_1[_i];
        if (e._tag === 'Left') left.push(e.left);
        else right.push(e.right);
    }
    return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
};
var $80651cc7cbc1f14e$export$3dea766d36a8935f = function(predicate) {
    return function(as) {
        return as.filter(predicate);
    };
};
var $80651cc7cbc1f14e$export$b29f828819edca8d = function(predicate) {
    return $80651cc7cbc1f14e$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $80651cc7cbc1f14e$export$dad5e500f2bab9bc = function(predicateWithIndex) {
    return function(as) {
        var left = [];
        var right = [];
        for(var i = 0; i < as.length; i++){
            var b = as[i];
            if (predicateWithIndex(i, b)) right.push(b);
            else left.push(b);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
};
var $80651cc7cbc1f14e$export$3117e3f9ececb6bc = function(f) {
    return $80651cc7cbc1f14e$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
var $80651cc7cbc1f14e$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === 'Left') left.push(e.left);
            else right.push(e.right);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
};
var $80651cc7cbc1f14e$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return fa.concat(that());
    };
};
var $80651cc7cbc1f14e$export$228be17d80722ab = $80651cc7cbc1f14e$export$1517cca7889d6aaa;
var $80651cc7cbc1f14e$export$36e42aef19fc7171 = function(predicateWithIndex) {
    return function(as) {
        return as.filter(function(b, i) {
            return predicateWithIndex(i, b);
        });
    };
};
var $80651cc7cbc1f14e$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return wa.map(function(_, i) {
            return f(wa.slice(i));
        });
    };
};
var $80651cc7cbc1f14e$export$ecd5e8ace626722c = /*#__PURE__*/ $80651cc7cbc1f14e$export$8b58be045bf06082((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $80651cc7cbc1f14e$export$b66cdc0497d8a99a = $aa0d0a09044b87d4$export$b66cdc0497d8a99a;
var $80651cc7cbc1f14e$export$18153bb1181268e5 = $aa0d0a09044b87d4$export$18153bb1181268e5;
var $80651cc7cbc1f14e$export$533b26079ad0b4b = $aa0d0a09044b87d4$export$533b26079ad0b4b;
var $80651cc7cbc1f14e$export$bbd3ef8720e22369 = $aa0d0a09044b87d4$export$bbd3ef8720e22369;
var $80651cc7cbc1f14e$export$7fef8bcdbb34f435 = $aa0d0a09044b87d4$export$7fef8bcdbb34f435;
var $80651cc7cbc1f14e$export$ce2b2fe0b88ccd0a = $aa0d0a09044b87d4$export$ce2b2fe0b88ccd0a;
var $80651cc7cbc1f14e$export$df3f009e3d155b20 = function(F) {
    var traverseWithIndexF = $80651cc7cbc1f14e$export$955fdc0d24efa249(F);
    return function(f) {
        return traverseWithIndexF(function(_, a) {
            return f(a);
        });
    };
};
var $80651cc7cbc1f14e$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $80651cc7cbc1f14e$var$_reduce(ta, F.of($80651cc7cbc1f14e$export$7f9972325ebfd559()), function(fas, fa) {
            return F.ap(F.map(fas, function(as) {
                return function(a) {
                    return (0, $195a10ed7200bcca$export$a4627e546088548d)(as, $80651cc7cbc1f14e$export$10d8903dec122b9d(a));
                };
            }), fa);
        });
    };
};
var $80651cc7cbc1f14e$export$955fdc0d24efa249 = function(F) {
    return function(f) {
        return $80651cc7cbc1f14e$export$bbd3ef8720e22369(F.of($80651cc7cbc1f14e$export$7f9972325ebfd559()), function(i, fbs, a) {
            return F.ap(F.map(fbs, function(bs) {
                return function(b) {
                    return (0, $195a10ed7200bcca$export$a4627e546088548d)(bs, $80651cc7cbc1f14e$export$10d8903dec122b9d(b));
                };
            }), f(i, a));
        });
    };
};
var $80651cc7cbc1f14e$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $80651cc7cbc1f14e$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $80651cc7cbc1f14e$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $80651cc7cbc1f14e$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $80651cc7cbc1f14e$export$c48e357c1a89b78d = function(b, f) {
    var out = [];
    var bb = b;
    // eslint-disable-next-line no-constant-condition
    while(true){
        var mt = f(bb);
        if ($f506e8da188a4a28$export$5d7e502287836e58(mt)) {
            var _a = mt.value, a = _a[0], b_1 = _a[1];
            out.push(a);
            bb = b_1;
        } else break;
    }
    return out;
};
var $80651cc7cbc1f14e$export$9156e739aa33e19f = 'Array';
var $80651cc7cbc1f14e$export$3cb5cd7f7776c81 = $aa0d0a09044b87d4$export$3cb5cd7f7776c81;
var $80651cc7cbc1f14e$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return first.concat(second);
        }
    };
};
var $80651cc7cbc1f14e$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $80651cc7cbc1f14e$export$e759a9a7f8d04692().concat,
        empty: []
    };
};
var $80651cc7cbc1f14e$export$804fed467fde44e4 = $aa0d0a09044b87d4$export$804fed467fde44e4;
var $80651cc7cbc1f14e$export$1af51209b1b91d07 = $aa0d0a09044b87d4$export$1af51209b1b91d07;
var $80651cc7cbc1f14e$export$baca17b4aff42f82 = function(E) {
    var unionE = $80651cc7cbc1f14e$export$971dd5b0dfd021b6(E);
    return {
        concat: function(first, second) {
            return unionE(second)(first);
        }
    };
};
var $80651cc7cbc1f14e$export$c487aac9f4157837 = function(E) {
    return {
        concat: $80651cc7cbc1f14e$export$baca17b4aff42f82(E).concat,
        empty: []
    };
};
var $80651cc7cbc1f14e$export$d379a869a72e4055 = function(E) {
    var intersectionE = $80651cc7cbc1f14e$export$bc86dfbf7795668c(E);
    return {
        concat: function(first, second) {
            return intersectionE(second)(first);
        }
    };
};
var $80651cc7cbc1f14e$export$fdb3296ca0a124e3 = function(E) {
    var differenceE = $80651cc7cbc1f14e$export$acaf96a27438246b(E);
    return {
        concat: function(first, second) {
            return differenceE(second)(first);
        }
    };
};
var $80651cc7cbc1f14e$export$bd5b6bfc5fa2ee61 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map
};
var $80651cc7cbc1f14e$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($80651cc7cbc1f14e$export$bd5b6bfc5fa2ee61);
var $80651cc7cbc1f14e$export$59a71046037e6c20 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    of: $80651cc7cbc1f14e$export$ba255e9e49e00608
};
var $80651cc7cbc1f14e$export$9fdffe0fe1e91cad = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    mapWithIndex: $80651cc7cbc1f14e$var$_mapWithIndex
};
var $80651cc7cbc1f14e$export$efc21ddc6aeb363d = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap
};
var $80651cc7cbc1f14e$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $9465861535336ff3$export$5f28d9feedcfd46e)($80651cc7cbc1f14e$export$efc21ddc6aeb363d);
var $80651cc7cbc1f14e$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $9465861535336ff3$export$ed01bc59c3d06bf3)($80651cc7cbc1f14e$export$efc21ddc6aeb363d);
var $80651cc7cbc1f14e$export$1279d2b7807629fd = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    of: $80651cc7cbc1f14e$export$ba255e9e49e00608
};
var $80651cc7cbc1f14e$export$f18d5acc27d70423 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    chain: $80651cc7cbc1f14e$export$5b8affa63fc6df16
};
var $80651cc7cbc1f14e$export$e3821ef4970c339c = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$e3821ef4970c339c)($80651cc7cbc1f14e$export$f18d5acc27d70423);
var $80651cc7cbc1f14e$export$fb641926d034ac7d = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    of: $80651cc7cbc1f14e$export$ba255e9e49e00608,
    chain: $80651cc7cbc1f14e$export$5b8affa63fc6df16
};
var $80651cc7cbc1f14e$export$8fa953f00d3b093 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    unfold: $80651cc7cbc1f14e$export$c48e357c1a89b78d
};
var $80651cc7cbc1f14e$export$25ba4469a069167 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    alt: $80651cc7cbc1f14e$var$_alt
};
var $80651cc7cbc1f14e$export$aaef8a3eae948f03 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    zero: $80651cc7cbc1f14e$export$7f9972325ebfd559
};
var $80651cc7cbc1f14e$export$864d727b48066337 = /*#__PURE__*/ (0, $7f5e139b9ab3f0d5$export$864d727b48066337)($80651cc7cbc1f14e$export$aaef8a3eae948f03, $80651cc7cbc1f14e$export$59a71046037e6c20);
var $80651cc7cbc1f14e$export$4acb47accde578d2 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    of: $80651cc7cbc1f14e$export$ba255e9e49e00608,
    alt: $80651cc7cbc1f14e$var$_alt,
    zero: $80651cc7cbc1f14e$export$7f9972325ebfd559
};
var $80651cc7cbc1f14e$export$5b5dd0e212d2a5bc = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    extend: $80651cc7cbc1f14e$var$_extend
};
var $80651cc7cbc1f14e$export$4a21ac48141ac3c9 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    compact: $80651cc7cbc1f14e$export$8e16b83750b44988,
    separate: $80651cc7cbc1f14e$export$709f6946f4e97408
};
var $80651cc7cbc1f14e$export$d00e1c48fb621173 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    compact: $80651cc7cbc1f14e$export$8e16b83750b44988,
    separate: $80651cc7cbc1f14e$export$709f6946f4e97408,
    filter: $80651cc7cbc1f14e$var$_filter,
    filterMap: $80651cc7cbc1f14e$var$_filterMap,
    partition: $80651cc7cbc1f14e$var$_partition,
    partitionMap: $80651cc7cbc1f14e$var$_partitionMap
};
var $80651cc7cbc1f14e$export$c29a647071e542ec = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    mapWithIndex: $80651cc7cbc1f14e$var$_mapWithIndex,
    compact: $80651cc7cbc1f14e$export$8e16b83750b44988,
    separate: $80651cc7cbc1f14e$export$709f6946f4e97408,
    filter: $80651cc7cbc1f14e$var$_filter,
    filterMap: $80651cc7cbc1f14e$var$_filterMap,
    partition: $80651cc7cbc1f14e$var$_partition,
    partitionMap: $80651cc7cbc1f14e$var$_partitionMap,
    partitionMapWithIndex: $80651cc7cbc1f14e$var$_partitionMapWithIndex,
    partitionWithIndex: $80651cc7cbc1f14e$var$_partitionWithIndex,
    filterMapWithIndex: $80651cc7cbc1f14e$var$_filterMapWithIndex,
    filterWithIndex: $80651cc7cbc1f14e$var$_filterWithIndex
};
var $80651cc7cbc1f14e$export$41404b31838667c9 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    reduce: $80651cc7cbc1f14e$var$_reduce,
    foldMap: $80651cc7cbc1f14e$var$_foldMap,
    reduceRight: $80651cc7cbc1f14e$var$_reduceRight
};
var $80651cc7cbc1f14e$export$e8f7d17aaff345cb = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    reduce: $80651cc7cbc1f14e$var$_reduce,
    foldMap: $80651cc7cbc1f14e$var$_foldMap,
    reduceRight: $80651cc7cbc1f14e$var$_reduceRight,
    reduceWithIndex: $80651cc7cbc1f14e$var$_reduceWithIndex,
    foldMapWithIndex: $80651cc7cbc1f14e$var$_foldMapWithIndex,
    reduceRightWithIndex: $80651cc7cbc1f14e$var$_reduceRightWithIndex
};
var $80651cc7cbc1f14e$export$a0202666c3bda011 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    reduce: $80651cc7cbc1f14e$var$_reduce,
    foldMap: $80651cc7cbc1f14e$var$_foldMap,
    reduceRight: $80651cc7cbc1f14e$var$_reduceRight,
    traverse: $80651cc7cbc1f14e$var$_traverse,
    sequence: $80651cc7cbc1f14e$export$49bb65c2ea163039
};
var $80651cc7cbc1f14e$export$bd7b528d8c36ec41 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    mapWithIndex: $80651cc7cbc1f14e$var$_mapWithIndex,
    reduce: $80651cc7cbc1f14e$var$_reduce,
    foldMap: $80651cc7cbc1f14e$var$_foldMap,
    reduceRight: $80651cc7cbc1f14e$var$_reduceRight,
    reduceWithIndex: $80651cc7cbc1f14e$var$_reduceWithIndex,
    foldMapWithIndex: $80651cc7cbc1f14e$var$_foldMapWithIndex,
    reduceRightWithIndex: $80651cc7cbc1f14e$var$_reduceRightWithIndex,
    traverse: $80651cc7cbc1f14e$var$_traverse,
    sequence: $80651cc7cbc1f14e$export$49bb65c2ea163039,
    traverseWithIndex: $80651cc7cbc1f14e$var$_traverseWithIndex
};
var $80651cc7cbc1f14e$var$_wither = /*#__PURE__*/ (0, $1209966343b7d06c$export$1f5c6f948d11a182)($80651cc7cbc1f14e$export$a0202666c3bda011, $80651cc7cbc1f14e$export$4a21ac48141ac3c9);
var $80651cc7cbc1f14e$var$_wilt = /*#__PURE__*/ (0, $1209966343b7d06c$export$f4cb42390e44d1d2)($80651cc7cbc1f14e$export$a0202666c3bda011, $80651cc7cbc1f14e$export$4a21ac48141ac3c9);
var $80651cc7cbc1f14e$export$748d317b4c426f96 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    compact: $80651cc7cbc1f14e$export$8e16b83750b44988,
    separate: $80651cc7cbc1f14e$export$709f6946f4e97408,
    filter: $80651cc7cbc1f14e$var$_filter,
    filterMap: $80651cc7cbc1f14e$var$_filterMap,
    partition: $80651cc7cbc1f14e$var$_partition,
    partitionMap: $80651cc7cbc1f14e$var$_partitionMap,
    reduce: $80651cc7cbc1f14e$var$_reduce,
    foldMap: $80651cc7cbc1f14e$var$_foldMap,
    reduceRight: $80651cc7cbc1f14e$var$_reduceRight,
    traverse: $80651cc7cbc1f14e$var$_traverse,
    sequence: $80651cc7cbc1f14e$export$49bb65c2ea163039,
    wither: $80651cc7cbc1f14e$var$_wither,
    wilt: $80651cc7cbc1f14e$var$_wilt
};
var $80651cc7cbc1f14e$export$f855115a79f70c1a = $aa0d0a09044b87d4$export$f855115a79f70c1a;
var $80651cc7cbc1f14e$export$7d808dfaa6d54634 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    chain: $80651cc7cbc1f14e$export$5b8affa63fc6df16,
    chainRec: $80651cc7cbc1f14e$var$_chainRecDepthFirst
};
var $80651cc7cbc1f14e$export$bffee57bb00a6859 = $aa0d0a09044b87d4$export$bffee57bb00a6859;
var $80651cc7cbc1f14e$export$57f3a385c7e59628 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    chain: $80651cc7cbc1f14e$export$5b8affa63fc6df16,
    chainRec: $80651cc7cbc1f14e$var$_chainRecBreadthFirst
};
var $80651cc7cbc1f14e$export$c40604f35db61519 = /*#__PURE__*/ (0, $1209966343b7d06c$export$c40604f35db61519)($80651cc7cbc1f14e$export$748d317b4c426f96);
var $80651cc7cbc1f14e$export$825ea6cb6fc48d49 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    fromEither: $80651cc7cbc1f14e$export$80c878c9b1d77917
};
var $80651cc7cbc1f14e$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $e877117324731de7$export$8138b0ae92c9b5d8)($80651cc7cbc1f14e$export$825ea6cb6fc48d49);
var $80651cc7cbc1f14e$export$f4863e1822a1860c = $40add6d007f2bbe9$export$f4863e1822a1860c;
var $80651cc7cbc1f14e$export$9c0c6889b1fa9bfc = function(i, a, as) {
    return $80651cc7cbc1f14e$export$a978c53b4062a525(as) ? $40add6d007f2bbe9$export$9c0c6889b1fa9bfc(i, a, as) : [];
};
var $80651cc7cbc1f14e$export$4937fde8dfc38dbd = function(i, as) {
    var xs = as.slice();
    xs.splice(i, 1);
    return xs;
};
var $80651cc7cbc1f14e$export$7ecc1a3b11b57dab = $aa0d0a09044b87d4$export$7ecc1a3b11b57dab;
var $80651cc7cbc1f14e$export$ad14ef4001db2bcd = function(predicate) {
    return function(as) {
        return as.some(predicate);
    };
};
var $80651cc7cbc1f14e$export$f7e9f41ea797a17 = $80651cc7cbc1f14e$export$ad14ef4001db2bcd;
var $80651cc7cbc1f14e$export$739ec22334c44788 = $aa0d0a09044b87d4$export$739ec22334c44788;
var $80651cc7cbc1f14e$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $80651cc7cbc1f14e$export$ba255e9e49e00608($f506e8da188a4a28$export$4de80339753b012b);
var $80651cc7cbc1f14e$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $b90291f3b522edda$export$7c052ae73f8acff0)($80651cc7cbc1f14e$export$bd5b6bfc5fa2ee61);
var $80651cc7cbc1f14e$export$5d537b797c421217 = /*#__PURE__*/ (0, $b90291f3b522edda$export$5d537b797c421217)($80651cc7cbc1f14e$export$bd5b6bfc5fa2ee61);
var $80651cc7cbc1f14e$export$2385a24977818dd0 = /*#__PURE__*/ (0, $a048b5cdbfcd6533$export$2385a24977818dd0)($80651cc7cbc1f14e$export$f18d5acc27d70423);
var $80651cc7cbc1f14e$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $9465861535336ff3$export$8cbfc0239f42bb49)($80651cc7cbc1f14e$export$efc21ddc6aeb363d);
var $80651cc7cbc1f14e$export$e08e3b67e392101e = $80651cc7cbc1f14e$export$5b8affa63fc6df16;
var $80651cc7cbc1f14e$export$d02631cccf789723 = $40add6d007f2bbe9$export$d02631cccf789723;
var $80651cc7cbc1f14e$export$6e22c362a0406a2c = [];
var $80651cc7cbc1f14e$export$8327ebbef2a0ba76 = $40add6d007f2bbe9$export$8327ebbef2a0ba76;
var $80651cc7cbc1f14e$export$c40cf5aab899f397 = $40add6d007f2bbe9$export$c40cf5aab899f397;
var $80651cc7cbc1f14e$export$baeb00bf1e27e233 = $80651cc7cbc1f14e$export$849c7567cbd62acc;
var $80651cc7cbc1f14e$export$2f23118c22fb2630 = {
    URI: $80651cc7cbc1f14e$export$9156e739aa33e19f,
    compact: $80651cc7cbc1f14e$export$8e16b83750b44988,
    separate: $80651cc7cbc1f14e$export$709f6946f4e97408,
    map: $80651cc7cbc1f14e$var$_map,
    ap: $80651cc7cbc1f14e$var$_ap,
    of: $80651cc7cbc1f14e$export$ba255e9e49e00608,
    chain: $80651cc7cbc1f14e$export$5b8affa63fc6df16,
    filter: $80651cc7cbc1f14e$var$_filter,
    filterMap: $80651cc7cbc1f14e$var$_filterMap,
    partition: $80651cc7cbc1f14e$var$_partition,
    partitionMap: $80651cc7cbc1f14e$var$_partitionMap,
    mapWithIndex: $80651cc7cbc1f14e$var$_mapWithIndex,
    partitionMapWithIndex: $80651cc7cbc1f14e$var$_partitionMapWithIndex,
    partitionWithIndex: $80651cc7cbc1f14e$var$_partitionWithIndex,
    filterMapWithIndex: $80651cc7cbc1f14e$var$_filterMapWithIndex,
    filterWithIndex: $80651cc7cbc1f14e$var$_filterWithIndex,
    alt: $80651cc7cbc1f14e$var$_alt,
    zero: $80651cc7cbc1f14e$export$7f9972325ebfd559,
    unfold: $80651cc7cbc1f14e$export$c48e357c1a89b78d,
    reduce: $80651cc7cbc1f14e$var$_reduce,
    foldMap: $80651cc7cbc1f14e$var$_foldMap,
    reduceRight: $80651cc7cbc1f14e$var$_reduceRight,
    traverse: $80651cc7cbc1f14e$var$_traverse,
    sequence: $80651cc7cbc1f14e$export$49bb65c2ea163039,
    reduceWithIndex: $80651cc7cbc1f14e$var$_reduceWithIndex,
    foldMapWithIndex: $80651cc7cbc1f14e$var$_foldMapWithIndex,
    reduceRightWithIndex: $80651cc7cbc1f14e$var$_reduceRightWithIndex,
    traverseWithIndex: $80651cc7cbc1f14e$var$_traverseWithIndex,
    extend: $80651cc7cbc1f14e$var$_extend,
    wither: $80651cc7cbc1f14e$var$_wither,
    wilt: $80651cc7cbc1f14e$var$_wilt
};




var $1625efb126506723$export$dd44f18ab656f3bb = (0, $195a10ed7200bcca$export$401372c57776dc);
function $1625efb126506723$export$3cb5cd7f7776c81(S) {
    return {
        show: function(c) {
            return "make(".concat(S.show(c), ")");
        }
    };
}
var $1625efb126506723$export$804fed467fde44e4 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$1af51209b1b91d07 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$c55397fc301c5a = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$e759a9a7f8d04692 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$c2a7ef2cc9b32b31 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$3d48c7fefc7b8ec2 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$575097c1c561f76f = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$2e73cb3f0f25ed55 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
var $1625efb126506723$export$f37f1abb2c955577 = (0, $195a10ed7200bcca$export$f0954fd7d5368655);
function $1625efb126506723$export$81090df2aa47ff12(S) {
    return {
        URI: $1625efb126506723$export$9156e739aa33e19f,
        _E: undefined,
        map: $1625efb126506723$var$_map,
        ap: function(fab, fa) {
            return $1625efb126506723$export$dd44f18ab656f3bb(S.concat(fab, fa));
        }
    };
}
function $1625efb126506723$export$1402880adb2295a7(M) {
    var A = $1625efb126506723$export$81090df2aa47ff12(M);
    return {
        URI: $1625efb126506723$export$9156e739aa33e19f,
        _E: undefined,
        map: A.map,
        ap: A.ap,
        of: function() {
            return $1625efb126506723$export$dd44f18ab656f3bb(M.empty);
        }
    };
}
var $1625efb126506723$var$_contramap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $1625efb126506723$export$53b696d27ecb7ba7(f));
};
/* istanbul ignore next */ var $1625efb126506723$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $1625efb126506723$export$871de8747c9eaa88(f));
};
/* istanbul ignore next */ var $1625efb126506723$var$_bimap = function(fa, f, g) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $1625efb126506723$export$eb54baf0b342cb1d(f, g));
};
/* istanbul ignore next */ var $1625efb126506723$var$_mapLeft = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $1625efb126506723$export$472de43a55e4aa49(f));
};
var $1625efb126506723$export$53b696d27ecb7ba7 = function() {
    return 0, $195a10ed7200bcca$export$401372c57776dc;
};
var $1625efb126506723$export$871de8747c9eaa88 = function() {
    return 0, $195a10ed7200bcca$export$401372c57776dc;
};
var $1625efb126506723$export$eb54baf0b342cb1d = function(f) {
    return function(fa) {
        return $1625efb126506723$export$dd44f18ab656f3bb(f(fa));
    };
};
var $1625efb126506723$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $1625efb126506723$export$dd44f18ab656f3bb(f(fa));
    };
};
var $1625efb126506723$export$9156e739aa33e19f = 'Const';
var $1625efb126506723$export$bd5b6bfc5fa2ee61 = {
    URI: $1625efb126506723$export$9156e739aa33e19f,
    map: $1625efb126506723$var$_map
};
var $1625efb126506723$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($1625efb126506723$export$bd5b6bfc5fa2ee61);
var $1625efb126506723$export$def901a57d5539c3 = {
    URI: $1625efb126506723$export$9156e739aa33e19f,
    contramap: $1625efb126506723$var$_contramap
};
var $1625efb126506723$export$fd0fe42029639505 = {
    URI: $1625efb126506723$export$9156e739aa33e19f,
    bimap: $1625efb126506723$var$_bimap,
    mapLeft: $1625efb126506723$var$_mapLeft
};
var $1625efb126506723$export$dfdd8a9a12668b21 = {
    URI: $1625efb126506723$export$9156e739aa33e19f,
    map: $1625efb126506723$var$_map,
    contramap: $1625efb126506723$var$_contramap,
    bimap: $1625efb126506723$var$_bimap,
    mapLeft: $1625efb126506723$var$_mapLeft
};



/**
 * @since 2.11.0
 */ 
var $5e8337e8a678e26a$export$9156e739aa33e19f = 'Endomorphism';
var $5e8337e8a678e26a$export$e759a9a7f8d04692 = function() {
    return {
        concat: function(first, second) {
            return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(first, second);
        }
    };
};
var $5e8337e8a678e26a$export$c2a7ef2cc9b32b31 = function() {
    return {
        concat: $5e8337e8a678e26a$export$e759a9a7f8d04692().concat,
        empty: (0, $195a10ed7200bcca$export$f0954fd7d5368655)
    };
};





var $cc297423db0e9671$export$96ec731ed4dcb222 = function(B) {
    return {
        concat: $3b02c86b535b1f01$exports.min(B).concat,
        empty: B.top
    };
};
var $cc297423db0e9671$export$8960430cfd85939f = function(B) {
    return {
        concat: $3b02c86b535b1f01$exports.max(B).concat,
        empty: B.bottom
    };
};
var $cc297423db0e9671$export$66c1ae025e96b4bc = function(M) {
    return {
        concat: $3b02c86b535b1f01$exports.reverse(M).concat,
        empty: M.empty
    };
};
var $cc297423db0e9671$export$8cf3da7c1c9174ea = function(monoids) {
    var empty = {};
    for(var k in monoids)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(monoids, k)) empty[k] = monoids[k].empty;
    return {
        concat: $3b02c86b535b1f01$exports.struct(monoids).concat,
        empty: empty
    };
};
var $cc297423db0e9671$export$65e3907585753458 = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return {
        concat: $3b02c86b535b1f01$exports.tuple.apply($3b02c86b535b1f01$exports, monoids).concat,
        empty: monoids.map(function(m) {
            return m.empty;
        })
    };
};
var $cc297423db0e9671$export$b314777ae20abca9 = function(M) {
    return $3b02c86b535b1f01$exports.concatAll(M)(M.empty);
};
var $cc297423db0e9671$export$50d82750fd26461d = {
    concat: $3b02c86b535b1f01$exports.semigroupVoid.concat,
    empty: undefined
};
var $cc297423db0e9671$export$4ab04e39033ac22a = $cc297423db0e9671$export$65e3907585753458;
var $cc297423db0e9671$export$dfc91d1e5b77420b = $cc297423db0e9671$export$8cf3da7c1c9174ea;
var $cc297423db0e9671$export$5ca84f9b29f1c1a2 = $cc297423db0e9671$export$66c1ae025e96b4bc;
var $cc297423db0e9671$export$9cc0388793460b00 = $cc297423db0e9671$export$8960430cfd85939f;
var $cc297423db0e9671$export$6d1c667712a51996 = $cc297423db0e9671$export$96ec731ed4dcb222;
var $cc297423db0e9671$export$93e2b83da34ff82a = $cc297423db0e9671$export$b314777ae20abca9;
var $cc297423db0e9671$export$ea84ccdc68daa647 = {
    concat: $3b02c86b535b1f01$exports.semigroupAll.concat,
    empty: true
};
var $cc297423db0e9671$export$c147905ca5134122 = {
    concat: $3b02c86b535b1f01$exports.semigroupAny.concat,
    empty: false
};
var $cc297423db0e9671$export$616ba591d6210ed8 = (0, $195a10ed7200bcca$export$c2a7ef2cc9b32b31);
var $cc297423db0e9671$export$5c6d2e402d334f37 = function() {
    return $cc297423db0e9671$export$66c1ae025e96b4bc((0, $5e8337e8a678e26a$export$c2a7ef2cc9b32b31)());
};
var $cc297423db0e9671$export$fc39f3d77fa2e58a = {
    concat: $3b02c86b535b1f01$exports.semigroupString.concat,
    empty: ''
};
var $cc297423db0e9671$export$8f9c64d4a92a9eb6 = {
    concat: $3b02c86b535b1f01$exports.semigroupSum.concat,
    empty: 0
};
var $cc297423db0e9671$export$cb362f92c995f3b8 = {
    concat: $3b02c86b535b1f01$exports.semigroupProduct.concat,
    empty: 1
};


/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ 


function $9c908bfa9fcd6259$export$c8e1a8ea383fd0ff(F) {
    var f = (0, $9465861535336ff3$export$18979a515d2a828e)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function $9c908bfa9fcd6259$export$9833a940afed18f3(F, G) {
    var map = (0, $b90291f3b522edda$export$7b0f6fce42e2b480)(F, G).map;
    var _ap = (0, $9465861535336ff3$export$2f6ca3d3b1f80bf5)(F, G);
    return {
        map: map,
        of: function(a) {
            return F.of(G.of(a));
        },
        ap: function(fgab, fga) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fgab, _ap(fga));
        }
    };
}









var $71dce11dc017701c$var$contramap_ = function(predicate, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(predicate, $71dce11dc017701c$export$53b696d27ecb7ba7(f));
};
var $71dce11dc017701c$export$53b696d27ecb7ba7 = function(f) {
    return function(predicate) {
        return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(f, predicate);
    };
};
var $71dce11dc017701c$export$9156e739aa33e19f = 'Predicate';
var $71dce11dc017701c$export$45c71cec3a7e90aa = function() {
    return {
        concat: function(first, second) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(first, $71dce11dc017701c$export$252bb8b3bbdf6749(second));
        }
    };
};
var $71dce11dc017701c$export$d795ff673668f564 = function() {
    return {
        concat: $71dce11dc017701c$export$45c71cec3a7e90aa().concat,
        empty: (0, $195a10ed7200bcca$export$7349232f2648ca80)
    };
};
var $71dce11dc017701c$export$d900a29579818780 = function() {
    return {
        concat: function(first, second) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(first, $71dce11dc017701c$export$21c0ac7fe1cef1b8(second));
        }
    };
};
var $71dce11dc017701c$export$4c43b04d78b174fa = function() {
    return {
        concat: $71dce11dc017701c$export$d900a29579818780().concat,
        empty: (0, $195a10ed7200bcca$export$a68382d9631f6c53)
    };
};
var $71dce11dc017701c$export$def901a57d5539c3 = {
    URI: $71dce11dc017701c$export$9156e739aa33e19f,
    contramap: $71dce11dc017701c$var$contramap_
};
var $71dce11dc017701c$export$6003a5f097c73977 = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
var $71dce11dc017701c$export$252bb8b3bbdf6749 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) || second(a);
        };
    };
};
var $71dce11dc017701c$export$21c0ac7fe1cef1b8 = function(second) {
    return function(first) {
        return function(a) {
            return first(a) && second(a);
        };
    };
};






var $52d3945e22e86057$export$f883a24d5edde77c = $f506e8da188a4a28$export$f883a24d5edde77c;
var $52d3945e22e86057$export$ad14ef4001db2bcd = $f506e8da188a4a28$export$ad14ef4001db2bcd;
function $52d3945e22e86057$export$23f31c55d7162b91(predicate) {
    return function(a) {
        return predicate(a) ? $52d3945e22e86057$export$ad14ef4001db2bcd(a) : $52d3945e22e86057$export$f883a24d5edde77c;
    };
}
var $52d3945e22e86057$export$da405662c16fca8e = function(ma) {
    return ma._tag === 'Right' ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$ad14ef4001db2bcd(ma.left);
};
var $52d3945e22e86057$export$482f3615ecf01dc6 = function(ma) {
    return ma._tag === 'Left' ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$ad14ef4001db2bcd(ma.right);
};
var $52d3945e22e86057$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$871de8747c9eaa88(f));
};
var $52d3945e22e86057$var$_ap = function(fab, fa) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fab, $52d3945e22e86057$export$2f6ca3d3b1f80bf5(fa));
};
var $52d3945e22e86057$var$_reduce = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$533b26079ad0b4b(b, f));
};
var $52d3945e22e86057$var$_foldMap = function(M) {
    var foldMapM = $52d3945e22e86057$export$b66cdc0497d8a99a(M);
    return function(fa, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
var $52d3945e22e86057$var$_reduceRight = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$7fef8bcdbb34f435(b, f));
};
var $52d3945e22e86057$var$_traverse = function(F) {
    var traverseF = $52d3945e22e86057$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseF(f));
    };
};
/* istanbul ignore next */ var $52d3945e22e86057$var$_alt = function(fa, that) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$228be17d80722ab(that));
};
var $52d3945e22e86057$var$_filter = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$3dea766d36a8935f(predicate));
};
/* istanbul ignore next */ var $52d3945e22e86057$var$_filterMap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$a04c6c6965dd4709(f));
};
/* istanbul ignore next */ var $52d3945e22e86057$var$_extend = function(wa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(wa, $52d3945e22e86057$export$8b58be045bf06082(f));
};
/* istanbul ignore next */ var $52d3945e22e86057$var$_partition = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$b29f828819edca8d(predicate));
};
/* istanbul ignore next */ var $52d3945e22e86057$var$_partitionMap = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $52d3945e22e86057$export$3117e3f9ececb6bc(f));
};
var $52d3945e22e86057$export$9156e739aa33e19f = 'Option';
var $52d3945e22e86057$export$3cb5cd7f7776c81 = function(S) {
    return {
        show: function(ma) {
            return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? 'none' : "some(".concat(S.show(ma.value), ")");
        }
    };
};
var $52d3945e22e86057$export$804fed467fde44e4 = function(E) {
    return {
        equals: function(x, y) {
            return x === y || ($52d3945e22e86057$export$e56af863d5645d5f(x) ? $52d3945e22e86057$export$e56af863d5645d5f(y) : $52d3945e22e86057$export$e56af863d5645d5f(y) ? false : E.equals(x.value, y.value));
        }
    };
};
var $52d3945e22e86057$export$1af51209b1b91d07 = function(O) {
    return {
        equals: $52d3945e22e86057$export$804fed467fde44e4(O).equals,
        compare: function(x, y) {
            return x === y ? 0 : $52d3945e22e86057$export$5d7e502287836e58(x) ? $52d3945e22e86057$export$5d7e502287836e58(y) ? O.compare(x.value, y.value) : 1 : $52d3945e22e86057$export$5d7e502287836e58(y) ? -1 : 0;
        }
    };
};
var $52d3945e22e86057$export$c2a7ef2cc9b32b31 = function(S) {
    return {
        concat: function(x, y) {
            return $52d3945e22e86057$export$e56af863d5645d5f(x) ? y : $52d3945e22e86057$export$e56af863d5645d5f(y) ? x : $52d3945e22e86057$export$ad14ef4001db2bcd(S.concat(x.value, y.value));
        },
        empty: $52d3945e22e86057$export$f883a24d5edde77c
    };
};
var $52d3945e22e86057$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $52d3945e22e86057$export$e56af863d5645d5f(fa) ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$ad14ef4001db2bcd(f(fa.value));
    };
};
var $52d3945e22e86057$export$bd5b6bfc5fa2ee61 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map
};
var $52d3945e22e86057$export$6554612db691658e = (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, (0, $b90291f3b522edda$export$6554612db691658e)($52d3945e22e86057$export$bd5b6bfc5fa2ee61));
var $52d3945e22e86057$export$9284b360ca18a0fd = (0, $b90291f3b522edda$export$9284b360ca18a0fd)($52d3945e22e86057$export$bd5b6bfc5fa2ee61);
var $52d3945e22e86057$export$ba255e9e49e00608 = $52d3945e22e86057$export$ad14ef4001db2bcd;
var $52d3945e22e86057$export$59a71046037e6c20 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    of: $52d3945e22e86057$export$ba255e9e49e00608
};
var $52d3945e22e86057$export$2f6ca3d3b1f80bf5 = function(fa) {
    return function(fab) {
        return $52d3945e22e86057$export$e56af863d5645d5f(fab) ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$e56af863d5645d5f(fa) ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$ad14ef4001db2bcd(fab.value(fa.value));
    };
};
var $52d3945e22e86057$export$efc21ddc6aeb363d = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    ap: $52d3945e22e86057$var$_ap
};
var $52d3945e22e86057$export$1279d2b7807629fd = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    ap: $52d3945e22e86057$var$_ap,
    of: $52d3945e22e86057$export$ba255e9e49e00608
};
var $52d3945e22e86057$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(ma, f) {
    return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? $52d3945e22e86057$export$f883a24d5edde77c : f(ma.value);
});
var $52d3945e22e86057$export$f18d5acc27d70423 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    ap: $52d3945e22e86057$var$_ap,
    chain: $52d3945e22e86057$export$5b8affa63fc6df16
};
var $52d3945e22e86057$export$fb641926d034ac7d = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    ap: $52d3945e22e86057$var$_ap,
    of: $52d3945e22e86057$export$ba255e9e49e00608,
    chain: $52d3945e22e86057$export$5b8affa63fc6df16
};
var $52d3945e22e86057$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $52d3945e22e86057$export$e56af863d5645d5f(fa) ? b : f(b, fa.value);
    };
};
var $52d3945e22e86057$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $52d3945e22e86057$export$e56af863d5645d5f(fa) ? M.empty : f(fa.value);
        };
    };
};
var $52d3945e22e86057$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $52d3945e22e86057$export$e56af863d5645d5f(fa) ? b : f(fa.value, b);
    };
};
var $52d3945e22e86057$export$41404b31838667c9 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    reduce: $52d3945e22e86057$var$_reduce,
    foldMap: $52d3945e22e86057$var$_foldMap,
    reduceRight: $52d3945e22e86057$var$_reduceRight
};
var $52d3945e22e86057$export$41d1a04d78e7b141 = (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(self, that) {
    return $52d3945e22e86057$export$e56af863d5645d5f(self) ? that() : self;
});
var $52d3945e22e86057$export$1517cca7889d6aaa = $52d3945e22e86057$export$41d1a04d78e7b141;
var $52d3945e22e86057$export$228be17d80722ab = $52d3945e22e86057$export$41d1a04d78e7b141;
var $52d3945e22e86057$export$25ba4469a069167 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    alt: $52d3945e22e86057$var$_alt
};
var $52d3945e22e86057$export$7f9972325ebfd559 = function() {
    return $52d3945e22e86057$export$f883a24d5edde77c;
};
var $52d3945e22e86057$export$aaef8a3eae948f03 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    zero: $52d3945e22e86057$export$7f9972325ebfd559
};
var $52d3945e22e86057$export$864d727b48066337 = /*#__PURE__*/ (0, $7f5e139b9ab3f0d5$export$864d727b48066337)($52d3945e22e86057$export$aaef8a3eae948f03, $52d3945e22e86057$export$59a71046037e6c20);
var $52d3945e22e86057$export$4acb47accde578d2 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    ap: $52d3945e22e86057$var$_ap,
    of: $52d3945e22e86057$export$ba255e9e49e00608,
    alt: $52d3945e22e86057$var$_alt,
    zero: $52d3945e22e86057$export$7f9972325ebfd559
};
var $52d3945e22e86057$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $52d3945e22e86057$export$e56af863d5645d5f(wa) ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$ad14ef4001db2bcd(f(wa));
    };
};
var $52d3945e22e86057$export$5b5dd0e212d2a5bc = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    extend: $52d3945e22e86057$var$_extend
};
var $52d3945e22e86057$export$8e16b83750b44988 = /*#__PURE__*/ $52d3945e22e86057$export$5b8affa63fc6df16((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $52d3945e22e86057$var$defaultSeparated = /*#__PURE__*/ (0, $58dc45d60525231a$export$beaabdf62f4a639d)($52d3945e22e86057$export$f883a24d5edde77c, $52d3945e22e86057$export$f883a24d5edde77c);
var $52d3945e22e86057$export$709f6946f4e97408 = function(ma) {
    return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? $52d3945e22e86057$var$defaultSeparated : (0, $58dc45d60525231a$export$beaabdf62f4a639d)($52d3945e22e86057$export$da405662c16fca8e(ma.value), $52d3945e22e86057$export$482f3615ecf01dc6(ma.value));
};
var $52d3945e22e86057$export$4a21ac48141ac3c9 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    compact: $52d3945e22e86057$export$8e16b83750b44988,
    separate: $52d3945e22e86057$export$709f6946f4e97408
};
var $52d3945e22e86057$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $52d3945e22e86057$export$e56af863d5645d5f(fa) ? $52d3945e22e86057$export$f883a24d5edde77c : predicate(fa.value) ? fa : $52d3945e22e86057$export$f883a24d5edde77c;
    };
};
var $52d3945e22e86057$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $52d3945e22e86057$export$e56af863d5645d5f(fa) ? $52d3945e22e86057$export$f883a24d5edde77c : f(fa.value);
    };
};
var $52d3945e22e86057$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)($52d3945e22e86057$var$_filter(fa, (0, $71dce11dc017701c$export$6003a5f097c73977)(predicate)), $52d3945e22e86057$var$_filter(fa, predicate));
    };
};
var $52d3945e22e86057$export$3117e3f9ececb6bc = function(f) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($52d3945e22e86057$export$871de8747c9eaa88(f), $52d3945e22e86057$export$709f6946f4e97408);
};
var $52d3945e22e86057$export$d00e1c48fb621173 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    compact: $52d3945e22e86057$export$8e16b83750b44988,
    separate: $52d3945e22e86057$export$709f6946f4e97408,
    filter: $52d3945e22e86057$var$_filter,
    filterMap: $52d3945e22e86057$var$_filterMap,
    partition: $52d3945e22e86057$var$_partition,
    partitionMap: $52d3945e22e86057$var$_partitionMap
};
var $52d3945e22e86057$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $52d3945e22e86057$export$e56af863d5645d5f(ta) ? F.of($52d3945e22e86057$export$f883a24d5edde77c) : F.map(f(ta.value), $52d3945e22e86057$export$ad14ef4001db2bcd);
        };
    };
};
var $52d3945e22e86057$export$49bb65c2ea163039 = function(F) {
    return function(ta) {
        return $52d3945e22e86057$export$e56af863d5645d5f(ta) ? F.of($52d3945e22e86057$export$f883a24d5edde77c) : F.map(ta.value, $52d3945e22e86057$export$ad14ef4001db2bcd);
    };
};
var $52d3945e22e86057$export$a0202666c3bda011 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    reduce: $52d3945e22e86057$var$_reduce,
    foldMap: $52d3945e22e86057$var$_foldMap,
    reduceRight: $52d3945e22e86057$var$_reduceRight,
    traverse: $52d3945e22e86057$var$_traverse,
    sequence: $52d3945e22e86057$export$49bb65c2ea163039
};
var $52d3945e22e86057$var$_wither = /*#__PURE__*/ (0, $1209966343b7d06c$export$1f5c6f948d11a182)($52d3945e22e86057$export$a0202666c3bda011, $52d3945e22e86057$export$4a21ac48141ac3c9);
var $52d3945e22e86057$var$_wilt = /*#__PURE__*/ (0, $1209966343b7d06c$export$f4cb42390e44d1d2)($52d3945e22e86057$export$a0202666c3bda011, $52d3945e22e86057$export$4a21ac48141ac3c9);
var $52d3945e22e86057$export$6c36d01819ecdb31 = function(F) {
    var _witherF = $52d3945e22e86057$var$_wither(F);
    return function(f) {
        return function(fa) {
            return _witherF(fa, f);
        };
    };
};
var $52d3945e22e86057$export$2439a3bc02b13b03 = function(F) {
    var _wiltF = $52d3945e22e86057$var$_wilt(F);
    return function(f) {
        return function(fa) {
            return _wiltF(fa, f);
        };
    };
};
var $52d3945e22e86057$export$748d317b4c426f96 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    reduce: $52d3945e22e86057$var$_reduce,
    foldMap: $52d3945e22e86057$var$_foldMap,
    reduceRight: $52d3945e22e86057$var$_reduceRight,
    traverse: $52d3945e22e86057$var$_traverse,
    sequence: $52d3945e22e86057$export$49bb65c2ea163039,
    compact: $52d3945e22e86057$export$8e16b83750b44988,
    separate: $52d3945e22e86057$export$709f6946f4e97408,
    filter: $52d3945e22e86057$var$_filter,
    filterMap: $52d3945e22e86057$var$_filterMap,
    partition: $52d3945e22e86057$var$_partition,
    partitionMap: $52d3945e22e86057$var$_partitionMap,
    wither: $52d3945e22e86057$var$_wither,
    wilt: $52d3945e22e86057$var$_wilt
};
var $52d3945e22e86057$export$8bf7aba4a9e09055 = function() {
    return $52d3945e22e86057$export$f883a24d5edde77c;
};
var $52d3945e22e86057$export$5f956d47d0619c3a = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    ap: $52d3945e22e86057$var$_ap,
    of: $52d3945e22e86057$export$ba255e9e49e00608,
    chain: $52d3945e22e86057$export$5b8affa63fc6df16,
    throwError: $52d3945e22e86057$export$8bf7aba4a9e09055
};
var $52d3945e22e86057$export$80c878c9b1d77917 = $52d3945e22e86057$export$482f3615ecf01dc6;
var $52d3945e22e86057$export$825ea6cb6fc48d49 = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    fromEither: $52d3945e22e86057$export$80c878c9b1d77917
};
var $52d3945e22e86057$export$5d7e502287836e58 = $f506e8da188a4a28$export$5d7e502287836e58;
var $52d3945e22e86057$export$e56af863d5645d5f = function(fa) {
    return fa._tag === 'None';
};
var $52d3945e22e86057$export$2d55ea551c238330 = function(onNone, onSome) {
    return function(ma) {
        return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? onNone() : onSome(ma.value);
    };
};
var $52d3945e22e86057$export$ccb09033cefa61e8 = $52d3945e22e86057$export$2d55ea551c238330;
var $52d3945e22e86057$export$4659b591c19bdf3d = $52d3945e22e86057$export$2d55ea551c238330;
var $52d3945e22e86057$export$93e2b83da34ff82a = $52d3945e22e86057$export$4659b591c19bdf3d;
var $52d3945e22e86057$export$d8a997ff0e6436f3 = function(onNone) {
    return function(ma) {
        return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? onNone() : ma.value;
    };
};
var $52d3945e22e86057$export$8832081647a02ee7 = $52d3945e22e86057$export$d8a997ff0e6436f3;
var $52d3945e22e86057$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($52d3945e22e86057$export$bd5b6bfc5fa2ee61);
var $52d3945e22e86057$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $9465861535336ff3$export$5f28d9feedcfd46e)($52d3945e22e86057$export$efc21ddc6aeb363d);
var $52d3945e22e86057$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $9465861535336ff3$export$ed01bc59c3d06bf3)($52d3945e22e86057$export$efc21ddc6aeb363d);
var $52d3945e22e86057$export$bffa455ba8c619a6 = $52d3945e22e86057$export$8e16b83750b44988;
var $52d3945e22e86057$export$3f23594af5f37336 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, $a048b5cdbfcd6533$export$3f23594af5f37336($52d3945e22e86057$export$f18d5acc27d70423));
var $52d3945e22e86057$export$be3ff275bb5a8ac9 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, (0, $e877117324731de7$export$be3ff275bb5a8ac9)($52d3945e22e86057$export$825ea6cb6fc48d49, $52d3945e22e86057$export$f18d5acc27d70423));
var $52d3945e22e86057$export$ecd5e8ace626722c = /*#__PURE__*/ $52d3945e22e86057$export$8b58be045bf06082((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $52d3945e22e86057$export$8138b0ae92c9b5d8 = /*#__PURE__*/ (0, $e877117324731de7$export$8138b0ae92c9b5d8)($52d3945e22e86057$export$825ea6cb6fc48d49);
var $52d3945e22e86057$export$a3eef2eba9908c3e = /*#__PURE__*/ (0, $e877117324731de7$export$a3eef2eba9908c3e)($52d3945e22e86057$export$825ea6cb6fc48d49, $52d3945e22e86057$export$f18d5acc27d70423);
var $52d3945e22e86057$export$c5f2bdbf9b43f0c0 = $52d3945e22e86057$export$be3ff275bb5a8ac9;
var $52d3945e22e86057$export$b601f49376b4621a = function(a) {
    return a == null ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$ad14ef4001db2bcd(a);
};
var $52d3945e22e86057$export$d234c058d1d4e435 = function(f) {
    try {
        return $52d3945e22e86057$export$ad14ef4001db2bcd(f());
    } catch (e) {
        return $52d3945e22e86057$export$f883a24d5edde77c;
    }
};
var $52d3945e22e86057$export$7f3d23c4b0794e72 = function(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $52d3945e22e86057$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        });
    };
};
var $52d3945e22e86057$export$c69ca7b73fad45e1 = function(f) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(f, $52d3945e22e86057$export$b601f49376b4621a);
};
var $52d3945e22e86057$export$c81f992c08fd0bf3 = function(f) {
    return function(ma) {
        return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? $52d3945e22e86057$export$f883a24d5edde77c : $52d3945e22e86057$export$b601f49376b4621a(f(ma.value));
    };
};
var $52d3945e22e86057$export$b187f57ee1822bc5 = /*#__PURE__*/ $52d3945e22e86057$export$4659b591c19bdf3d((0, $195a10ed7200bcca$export$243c2ee5e7d8b05c), (0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $52d3945e22e86057$export$cb585b8513fa8577 = /*#__PURE__*/ $52d3945e22e86057$export$4659b591c19bdf3d((0, $195a10ed7200bcca$export$3d16a43570087548), (0, $195a10ed7200bcca$export$f0954fd7d5368655));
function $52d3945e22e86057$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $52d3945e22e86057$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? false : E.equals(a, ma.value);
    };
}
var $52d3945e22e86057$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $52d3945e22e86057$export$e56af863d5645d5f(ma) ? false : predicate(ma.value);
    };
};
var $52d3945e22e86057$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $52d3945e22e86057$export$ba255e9e49e00608($f506e8da188a4a28$export$4de80339753b012b);
var $52d3945e22e86057$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $b90291f3b522edda$export$7c052ae73f8acff0)($52d3945e22e86057$export$bd5b6bfc5fa2ee61);
var $52d3945e22e86057$export$5d537b797c421217 = /*#__PURE__*/ (0, $b90291f3b522edda$export$5d537b797c421217)($52d3945e22e86057$export$bd5b6bfc5fa2ee61);
var $52d3945e22e86057$export$2385a24977818dd0 = /*#__PURE__*/ $a048b5cdbfcd6533$export$2385a24977818dd0($52d3945e22e86057$export$f18d5acc27d70423);
var $52d3945e22e86057$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $9465861535336ff3$export$8cbfc0239f42bb49)($52d3945e22e86057$export$efc21ddc6aeb363d);
var $52d3945e22e86057$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $52d3945e22e86057$export$ba255e9e49e00608($f506e8da188a4a28$export$6ca726a2417e0f3f);
var $52d3945e22e86057$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var o = f(0, $f506e8da188a4a28$export$5fd5031fecdacec3(as));
        if ($52d3945e22e86057$export$e56af863d5645d5f(o)) return $52d3945e22e86057$export$f883a24d5edde77c;
        var out = [
            o.value
        ];
        for(var i = 1; i < as.length; i++){
            var o_1 = f(i, as[i]);
            if ($52d3945e22e86057$export$e56af863d5645d5f(o_1)) return $52d3945e22e86057$export$f883a24d5edde77c;
            out.push(o_1.value);
        }
        return $52d3945e22e86057$export$ad14ef4001db2bcd(out);
    };
};
var $52d3945e22e86057$export$d4e79db5dc14cc1 = function(f) {
    var g = $52d3945e22e86057$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $f506e8da188a4a28$export$a978c53b4062a525(as) ? g(as) : $52d3945e22e86057$export$c74b6e34b2b6efb0;
    };
};
var $52d3945e22e86057$export$104a2841e9cbad06 = $52d3945e22e86057$export$d4e79db5dc14cc1;
var $52d3945e22e86057$export$64f39b2a2b79e1b1 = function(f) {
    return $52d3945e22e86057$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $52d3945e22e86057$export$d330b60315c14cd1 = /*#__PURE__*/ $52d3945e22e86057$export$64f39b2a2b79e1b1((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $52d3945e22e86057$export$e08e3b67e392101e = $52d3945e22e86057$export$5b8affa63fc6df16;
var $52d3945e22e86057$export$e3821ef4970c339c = $52d3945e22e86057$export$3f23594af5f37336;
function $52d3945e22e86057$export$4a60bf88193d4686(getOption) {
    return function(a) {
        return $52d3945e22e86057$export$5d7e502287836e58(getOption(a));
    };
}
var $52d3945e22e86057$export$c2a8dfc107523e74 = $52d3945e22e86057$export$c81f992c08fd0bf3;
var $52d3945e22e86057$export$a75d1723e6bda2ec = {
    URI: $52d3945e22e86057$export$9156e739aa33e19f,
    map: $52d3945e22e86057$var$_map,
    of: $52d3945e22e86057$export$ba255e9e49e00608,
    ap: $52d3945e22e86057$var$_ap,
    chain: $52d3945e22e86057$export$5b8affa63fc6df16,
    reduce: $52d3945e22e86057$var$_reduce,
    foldMap: $52d3945e22e86057$var$_foldMap,
    reduceRight: $52d3945e22e86057$var$_reduceRight,
    traverse: $52d3945e22e86057$var$_traverse,
    sequence: $52d3945e22e86057$export$49bb65c2ea163039,
    zero: $52d3945e22e86057$export$7f9972325ebfd559,
    alt: $52d3945e22e86057$var$_alt,
    extend: $52d3945e22e86057$var$_extend,
    compact: $52d3945e22e86057$export$8e16b83750b44988,
    separate: $52d3945e22e86057$export$709f6946f4e97408,
    filter: $52d3945e22e86057$var$_filter,
    filterMap: $52d3945e22e86057$var$_filterMap,
    partition: $52d3945e22e86057$var$_partition,
    partitionMap: $52d3945e22e86057$var$_partitionMap,
    wither: $52d3945e22e86057$var$_wither,
    wilt: $52d3945e22e86057$var$_wilt,
    throwError: $52d3945e22e86057$export$8bf7aba4a9e09055
};
var $52d3945e22e86057$export$18979a515d2a828e = /*#__PURE__*/ (0, $9465861535336ff3$export$18979a515d2a828e)($52d3945e22e86057$export$efc21ddc6aeb363d);
var $52d3945e22e86057$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $9c908bfa9fcd6259$export$c8e1a8ea383fd0ff)($52d3945e22e86057$export$1279d2b7807629fd);
var $52d3945e22e86057$export$56cd0d85e73e688f = function() {
    return $52d3945e22e86057$export$c2a7ef2cc9b32b31((0, $3b02c86b535b1f01$export$43128fadae87b74a)());
};
var $52d3945e22e86057$export$ca391a563a1f3001 = function() {
    return $52d3945e22e86057$export$c2a7ef2cc9b32b31((0, $3b02c86b535b1f01$export$4c7897fafd92b108)());
};





function $943b7a1a0eab6ad7$export$871de8747c9eaa88(F) {
    return function(f) {
        return function(fa) {
            return F.map(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$53b696d27ecb7ba7(F) {
    return function(f) {
        return function(fa) {
            return F.contramap(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$8f07ddce13659f50(F) {
    return function(f) {
        return function(fa) {
            return F.mapWithIndex(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$2f6ca3d3b1f80bf5(F) {
    return function(fa) {
        return function(fab) {
            return F.ap(fab, fa);
        };
    };
}
function $943b7a1a0eab6ad7$export$e08e3b67e392101e(F) {
    return function(f) {
        return function(fa) {
            return F.chain(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$eb54baf0b342cb1d(F) {
    return function(f, g) {
        return function(fea) {
            return F.bimap(fea, f, g);
        };
    };
}
function $943b7a1a0eab6ad7$export$472de43a55e4aa49(F) {
    return function(f) {
        return function(fea) {
            return F.mapLeft(fea, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$8b58be045bf06082(F) {
    return function(f) {
        return function(wa) {
            return F.extend(wa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$533b26079ad0b4b(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduce(fa, b, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$b66cdc0497d8a99a(F) {
    return function(M) {
        var foldMapM = F.foldMap(M);
        return function(f) {
            return function(fa) {
                return foldMapM(fa, f);
            };
        };
    };
}
function $943b7a1a0eab6ad7$export$7fef8bcdbb34f435(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRight(fa, b, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$bbd3ef8720e22369(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceWithIndex(fa, b, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$18153bb1181268e5(F) {
    return function(M) {
        var foldMapWithIndexM = F.foldMapWithIndex(M);
        return function(f) {
            return function(fa) {
                return foldMapWithIndexM(fa, f);
            };
        };
    };
}
function $943b7a1a0eab6ad7$export$ce2b2fe0b88ccd0a(F) {
    return function(b, f) {
        return function(fa) {
            return F.reduceRightWithIndex(fa, b, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$228be17d80722ab(F) {
    return function(that) {
        return function(fa) {
            return F.alt(fa, that);
        };
    };
}
function $943b7a1a0eab6ad7$export$3dea766d36a8935f(F) {
    return function(predicate) {
        return function(fa) {
            return F.filter(fa, predicate);
        };
    };
}
function $943b7a1a0eab6ad7$export$a04c6c6965dd4709(F) {
    return function(f) {
        return function(fa) {
            return F.filterMap(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$b29f828819edca8d(F) {
    return function(f) {
        return function(fa) {
            return F.partition(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$3117e3f9ececb6bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMap(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$36e42aef19fc7171(F) {
    return function(predicate) {
        return function(fa) {
            return F.filterWithIndex(fa, predicate);
        };
    };
}
function $943b7a1a0eab6ad7$export$30c5cbe848021e97(F) {
    return function(f) {
        return function(fa) {
            return F.filterMapWithIndex(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$dad5e500f2bab9bc(F) {
    return function(f) {
        return function(fa) {
            return F.partitionWithIndex(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$bc7c0794b9c6f3ba(F) {
    return function(f) {
        return function(fa) {
            return F.partitionMapWithIndex(fa, f);
        };
    };
}
function $943b7a1a0eab6ad7$export$6684e88861ab74ec(F) {
    return function(f, g) {
        return function(fbc) {
            return F.promap(fbc, f, g);
        };
    };
}
function $943b7a1a0eab6ad7$export$f672e0b6f7222cd7(F) {
    return function(ea) {
        return function(ab) {
            return F.compose(ab, ea);
        };
    };
}
var $943b7a1a0eab6ad7$var$isFunctor = function(I) {
    return typeof I.map === 'function';
};
var $943b7a1a0eab6ad7$var$isContravariant = function(I) {
    return typeof I.contramap === 'function';
};
var $943b7a1a0eab6ad7$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === 'function';
};
var $943b7a1a0eab6ad7$var$isApply = function(I) {
    return typeof I.ap === 'function';
};
var $943b7a1a0eab6ad7$var$isChain = function(I) {
    return typeof I.chain === 'function';
};
var $943b7a1a0eab6ad7$var$isBifunctor = function(I) {
    return typeof I.bimap === 'function';
};
var $943b7a1a0eab6ad7$var$isExtend = function(I) {
    return typeof I.extend === 'function';
};
var $943b7a1a0eab6ad7$var$isFoldable = function(I) {
    return typeof I.reduce === 'function';
};
var $943b7a1a0eab6ad7$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === 'function';
};
var $943b7a1a0eab6ad7$var$isAlt = function(I) {
    return typeof I.alt === 'function';
};
var $943b7a1a0eab6ad7$var$isCompactable = function(I) {
    return typeof I.compact === 'function';
};
var $943b7a1a0eab6ad7$var$isFilterable = function(I) {
    return typeof I.filter === 'function';
};
var $943b7a1a0eab6ad7$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === 'function';
};
var $943b7a1a0eab6ad7$var$isProfunctor = function(I) {
    return typeof I.promap === 'function';
};
var $943b7a1a0eab6ad7$var$isSemigroupoid = function(I) {
    return typeof I.compose === 'function';
};
var $943b7a1a0eab6ad7$var$isMonadThrow = function(I) {
    return typeof I.throwError === 'function';
};
function $943b7a1a0eab6ad7$export$1124ffa357d27237(I) {
    var r = {};
    if ($943b7a1a0eab6ad7$var$isFunctor(I)) r.map = $943b7a1a0eab6ad7$export$871de8747c9eaa88(I);
    if ($943b7a1a0eab6ad7$var$isContravariant(I)) r.contramap = $943b7a1a0eab6ad7$export$53b696d27ecb7ba7(I);
    if ($943b7a1a0eab6ad7$var$isFunctorWithIndex(I)) r.mapWithIndex = $943b7a1a0eab6ad7$export$8f07ddce13659f50(I);
    if ($943b7a1a0eab6ad7$var$isApply(I)) {
        r.ap = $943b7a1a0eab6ad7$export$2f6ca3d3b1f80bf5(I);
        r.apFirst = (0, $9465861535336ff3$export$5f28d9feedcfd46e)(I);
        r.apSecond = (0, $9465861535336ff3$export$ed01bc59c3d06bf3)(I);
    }
    if ($943b7a1a0eab6ad7$var$isChain(I)) {
        r.chain = $943b7a1a0eab6ad7$export$e08e3b67e392101e(I);
        r.chainFirst = (0, $a048b5cdbfcd6533$export$e3821ef4970c339c)(I);
        r.flatten = r.chain((0, $195a10ed7200bcca$export$f0954fd7d5368655));
    }
    if ($943b7a1a0eab6ad7$var$isBifunctor(I)) {
        r.bimap = $943b7a1a0eab6ad7$export$eb54baf0b342cb1d(I);
        r.mapLeft = $943b7a1a0eab6ad7$export$472de43a55e4aa49(I);
    }
    if ($943b7a1a0eab6ad7$var$isExtend(I)) {
        r.extend = $943b7a1a0eab6ad7$export$8b58be045bf06082(I);
        r.duplicate = r.extend((0, $195a10ed7200bcca$export$f0954fd7d5368655));
    }
    if ($943b7a1a0eab6ad7$var$isFoldable(I)) {
        r.reduce = $943b7a1a0eab6ad7$export$533b26079ad0b4b(I);
        r.foldMap = $943b7a1a0eab6ad7$export$b66cdc0497d8a99a(I);
        r.reduceRight = $943b7a1a0eab6ad7$export$7fef8bcdbb34f435(I);
    }
    if ($943b7a1a0eab6ad7$var$isFoldableWithIndex(I)) {
        r.reduceWithIndex = $943b7a1a0eab6ad7$export$bbd3ef8720e22369(I);
        r.foldMapWithIndex = $943b7a1a0eab6ad7$export$18153bb1181268e5(I);
        r.reduceRightWithIndex = $943b7a1a0eab6ad7$export$ce2b2fe0b88ccd0a(I);
    }
    if ($943b7a1a0eab6ad7$var$isAlt(I)) r.alt = $943b7a1a0eab6ad7$export$228be17d80722ab(I);
    if ($943b7a1a0eab6ad7$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($943b7a1a0eab6ad7$var$isFilterable(I)) {
        r.filter = $943b7a1a0eab6ad7$export$3dea766d36a8935f(I);
        r.filterMap = $943b7a1a0eab6ad7$export$a04c6c6965dd4709(I);
        r.partition = $943b7a1a0eab6ad7$export$b29f828819edca8d(I);
        r.partitionMap = $943b7a1a0eab6ad7$export$3117e3f9ececb6bc(I);
    }
    if ($943b7a1a0eab6ad7$var$isFilterableWithIndex(I)) {
        r.filterWithIndex = $943b7a1a0eab6ad7$export$36e42aef19fc7171(I);
        r.filterMapWithIndex = $943b7a1a0eab6ad7$export$30c5cbe848021e97(I);
        r.partitionWithIndex = $943b7a1a0eab6ad7$export$dad5e500f2bab9bc(I);
        r.partitionMapWithIndex = $943b7a1a0eab6ad7$export$bc7c0794b9c6f3ba(I);
    }
    if ($943b7a1a0eab6ad7$var$isProfunctor(I)) r.promap = $943b7a1a0eab6ad7$export$6684e88861ab74ec(I);
    if ($943b7a1a0eab6ad7$var$isSemigroupoid(I)) r.compose = $943b7a1a0eab6ad7$export$f672e0b6f7222cd7(I);
    if ($943b7a1a0eab6ad7$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === 'None' ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === 'Left' ? I.throwError(ma.left) : I.of(ma.right);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
var $943b7a1a0eab6ad7$export$a4627e546088548d = (0, $195a10ed7200bcca$export$a4627e546088548d);











var $c6a8e3db2bad0039$export$d81aa96f14f987cc = function(m) {
    return new Map(m);
};
function $c6a8e3db2bad0039$export$e98af36a72b77685(m) {
    return new Map(m);
}
function $c6a8e3db2bad0039$export$3cb5cd7f7776c81(SK, SA) {
    return {
        show: function(m) {
            var entries = [];
            m.forEach(function(a, k) {
                entries.push("[".concat(SK.show(k), ", ").concat(SA.show(a), "]"));
            });
            return "new Map([".concat(entries.sort().join(', '), "])");
        }
    };
}
var $c6a8e3db2bad0039$export$346677f925de839c = function(m) {
    return m.size;
};
var $c6a8e3db2bad0039$export$dd1bc94b04021eeb = function(m) {
    return m.size === 0;
};
function $c6a8e3db2bad0039$export$6a0d13241802fe80(E) {
    var lookupE = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
    return function(k, m) {
        if (m === undefined) {
            var memberE_1 = $c6a8e3db2bad0039$export$6a0d13241802fe80(E);
            return function(m) {
                return memberE_1(k, m);
            };
        }
        return $f506e8da188a4a28$export$5d7e502287836e58(lookupE(k, m));
    };
}
function $c6a8e3db2bad0039$export$5bf96401662340b7(E) {
    return function(a, m) {
        if (m === undefined) {
            var elemE_1 = $c6a8e3db2bad0039$export$5bf96401662340b7(E);
            return function(m) {
                return elemE_1(a, m);
            };
        }
        var values = m.values();
        var e;
        while(!(e = values.next()).done){
            var v = e.value;
            if (E.equals(a, v)) return true;
        }
        return false;
    };
}
var $c6a8e3db2bad0039$export$ed97f33186d4b816 = function(O) {
    return function(m) {
        return Array.from(m.keys()).sort(O.compare);
    };
};
var $c6a8e3db2bad0039$export$68c286be0e7e55b7 = function(O) {
    return function(m) {
        return Array.from(m.values()).sort(O.compare);
    };
};
function $c6a8e3db2bad0039$export$bb44f104e3c54dae(O) {
    var keysO = $c6a8e3db2bad0039$export$ed97f33186d4b816(O);
    return function(f) {
        return function(m) {
            var out = [];
            var ks = keysO(m);
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                out.push(f(key, m.get(key)));
            }
            return out;
        };
    };
}
var $c6a8e3db2bad0039$export$4aaa3912a3956cb7 = function(O) {
    return $c6a8e3db2bad0039$export$bb44f104e3c54dae(O)(function(k, a) {
        return [
            k,
            a
        ];
    });
};
function $c6a8e3db2bad0039$export$823be24f8766da23(ord, U) {
    var toReadonlyArrayO = $c6a8e3db2bad0039$export$4aaa3912a3956cb7(ord);
    return function(d) {
        var kas = toReadonlyArrayO(d);
        var len = kas.length;
        return U.unfold(0, function(b) {
            return b < len ? $f506e8da188a4a28$export$ad14ef4001db2bcd([
                kas[b],
                b + 1
            ]) : $f506e8da188a4a28$export$f883a24d5edde77c;
        });
    };
}
var $c6a8e3db2bad0039$export$ff82449ce381c54a = function(E) {
    var lookupWithKeyE = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E);
    return function(k, a) {
        var lookupWithKeyEk = lookupWithKeyE(k);
        return function(m) {
            var found = lookupWithKeyEk(m);
            if ($f506e8da188a4a28$export$e56af863d5645d5f(found)) {
                var out = new Map(m);
                out.set(k, a);
                return out;
            } else if (found.value[1] !== a) {
                var out = new Map(m);
                out.set(found.value[0], a);
                return out;
            }
            return m;
        };
    };
};
var $c6a8e3db2bad0039$export$90f9093465da3136 = function(E) {
    var lookupWithKeyE = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E);
    return function(k) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($f506e8da188a4a28$export$5d7e502287836e58(found)) {
                var r = new Map(m);
                r.delete(found.value[0]);
                return r;
            }
            return m;
        };
    };
};
var $c6a8e3db2bad0039$export$b6d8713d53419d4c = function(E) {
    var modifyAtE = $c6a8e3db2bad0039$export$cba09f9e3d3e58eb(E);
    return function(k, a) {
        return modifyAtE(k, function() {
            return a;
        });
    };
};
var $c6a8e3db2bad0039$export$cba09f9e3d3e58eb = function(E) {
    var lookupWithKeyE = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E);
    return function(k, f) {
        return function(m) {
            var found = lookupWithKeyE(k, m);
            if ($f506e8da188a4a28$export$e56af863d5645d5f(found)) return $f506e8da188a4a28$export$f883a24d5edde77c;
            var _a = found.value, fk = _a[0], fv = _a[1];
            var next = f(fv);
            if (next === fv) return $f506e8da188a4a28$export$ad14ef4001db2bcd(m);
            var r = new Map(m);
            r.set(fk, next);
            return $f506e8da188a4a28$export$ad14ef4001db2bcd(r);
        };
    };
};
function $c6a8e3db2bad0039$export$3e41007ebfff0e64(E) {
    var lookupE = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
    var deleteAtE = $c6a8e3db2bad0039$export$90f9093465da3136(E);
    return function(k) {
        var deleteAtEk = deleteAtE(k);
        return function(m) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(lookupE(k, m), $52d3945e22e86057$export$871de8747c9eaa88(function(a) {
                return [
                    a,
                    deleteAtEk(m)
                ];
            }));
        };
    };
}
function $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E) {
    return function(k, m) {
        if (m === undefined) {
            var lookupWithKeyE_1 = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E);
            return function(m) {
                return lookupWithKeyE_1(k, m);
            };
        }
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, ka = _a[0], a = _a[1];
            if (E.equals(ka, k)) return $f506e8da188a4a28$export$ad14ef4001db2bcd([
                ka,
                a
            ]);
        }
        return $f506e8da188a4a28$export$f883a24d5edde77c;
    };
}
function $c6a8e3db2bad0039$export$dfc7155ac0343b8(E) {
    var lookupWithKeyE = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E);
    return function(k, m) {
        if (m === undefined) {
            var lookupE_1 = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
            return function(m) {
                return lookupE_1(k, m);
            };
        }
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(lookupWithKeyE(k, m), $52d3945e22e86057$export$871de8747c9eaa88(function(_a) {
            var _ = _a[0], a = _a[1];
            return a;
        }));
    };
}
function $c6a8e3db2bad0039$export$35d0420a84c5d3ae(SK, SA) {
    var lookupWithKeyS = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(SK);
    return function(me, that) {
        if (that === undefined) {
            var isSubmapSKSA_1 = $c6a8e3db2bad0039$export$35d0420a84c5d3ae(SK, SA);
            return function(that) {
                return isSubmapSKSA_1(that, me);
            };
        }
        var entries = me.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var d2OptA = lookupWithKeyS(k, that);
            if ($f506e8da188a4a28$export$e56af863d5645d5f(d2OptA) || !SK.equals(k, d2OptA.value[0]) || !SA.equals(a, d2OptA.value[1])) return false;
        }
        return true;
    };
}
var $c6a8e3db2bad0039$export$6e22c362a0406a2c = // the type annotation here is intended (otherwise it doesn't type-check)
new Map();
function $c6a8e3db2bad0039$export$804fed467fde44e4(SK, SA) {
    var isSubmapSKSA = $c6a8e3db2bad0039$export$35d0420a84c5d3ae(SK, SA);
    return (0, $621782213ab3b52c$export$fec6acd8d60e8568)(function(x, y) {
        return isSubmapSKSA(x, y) && isSubmapSKSA(y, x);
    });
}
function $c6a8e3db2bad0039$export$c2a7ef2cc9b32b31(SK, SA) {
    var lookupWithKeyS = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(SK);
    return {
        concat: function(mx, my) {
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(mx)) return my;
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(my)) return mx;
            var r = new Map(mx);
            var entries = my.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var mxOptA = lookupWithKeyS(k, mx);
                if ($f506e8da188a4a28$export$5d7e502287836e58(mxOptA)) r.set(mxOptA.value[0], SA.concat(mxOptA.value[1], a));
                else r.set(k, a);
            }
            return r;
        },
        empty: $c6a8e3db2bad0039$export$6e22c362a0406a2c
    };
}
var $c6a8e3db2bad0039$export$439306a4dcaafbb9 = function(k, a) {
    return new Map([
        [
            k,
            a
        ]
    ]);
};
function $c6a8e3db2bad0039$export$b7d5d9bb9ff52072(E, M, F) {
    return function(fka) {
        var lookupWithKeyE = $c6a8e3db2bad0039$export$40b8019a6fc8a5ae(E);
        return F.reduce(fka, new Map(), function(b, _a) {
            var k = _a[0], a = _a[1];
            var bOpt = lookupWithKeyE(k, b);
            if ($f506e8da188a4a28$export$5d7e502287836e58(bOpt)) b.set(bOpt.value[0], M.concat(bOpt.value[1], a));
            else b.set(k, a);
            return b;
        });
    };
}
var $c6a8e3db2bad0039$var$_mapWithIndex = function(fa, f) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, key = _a[0], a = _a[1];
        m.set(key, f(key, a));
    }
    return m;
};
var $c6a8e3db2bad0039$export$bc7c0794b9c6f3ba = function(f) {
    return function(fa) {
        var left = new Map();
        var right = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var ei = f(k, a);
            if ($f506e8da188a4a28$export$d649b6842e09f2b(ei)) left.set(k, ei.left);
            else right.set(k, ei.right);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
};
function $c6a8e3db2bad0039$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(m) {
        var left = new Map();
        var right = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) right.set(k, a);
            else left.set(k, a);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
}
var $c6a8e3db2bad0039$export$30c5cbe848021e97 = function(f) {
    return function(fa) {
        var m = new Map();
        var entries = fa.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            var o = f(k, a);
            if ($f506e8da188a4a28$export$5d7e502287836e58(o)) m.set(k, o.value);
        }
        return m;
    };
};
function $c6a8e3db2bad0039$export$36e42aef19fc7171(predicateWithIndex) {
    return function(m) {
        var out = new Map();
        var entries = m.entries();
        var e;
        while(!(e = entries.next()).done){
            var _a = e.value, k = _a[0], a = _a[1];
            if (predicateWithIndex(k, a)) out.set(k, a);
        }
        return out;
    };
}
var $c6a8e3db2bad0039$var$_map = function(fa, f) {
    return $c6a8e3db2bad0039$var$_mapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $c6a8e3db2bad0039$var$_filter = function(fa, p) {
    return $c6a8e3db2bad0039$var$_filterWithIndex(fa, function(_, a) {
        return p(a);
    });
};
var $c6a8e3db2bad0039$var$_filterMap = function(fa, f) {
    return $c6a8e3db2bad0039$var$_filterMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $c6a8e3db2bad0039$var$_partition = function(fa, predicate) {
    return $c6a8e3db2bad0039$var$_partitionWithIndex(fa, function(_, a) {
        return predicate(a);
    });
};
var $c6a8e3db2bad0039$var$_partitionMap = function(fa, f) {
    return $c6a8e3db2bad0039$var$_partitionMapWithIndex(fa, function(_, a) {
        return f(a);
    });
};
var $c6a8e3db2bad0039$var$_filterWithIndex = function(fa, p) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c6a8e3db2bad0039$export$36e42aef19fc7171(p));
};
var $c6a8e3db2bad0039$var$_filterMapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c6a8e3db2bad0039$export$30c5cbe848021e97(f));
};
var $c6a8e3db2bad0039$var$_partitionWithIndex = function(fa, p) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c6a8e3db2bad0039$export$dad5e500f2bab9bc(p));
};
var $c6a8e3db2bad0039$var$_partitionMapWithIndex = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c6a8e3db2bad0039$export$bc7c0794b9c6f3ba(f));
};
var $c6a8e3db2bad0039$export$8e16b83750b44988 = function(fa) {
    var m = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], oa = _a[1];
        if ($f506e8da188a4a28$export$5d7e502287836e58(oa)) m.set(k, oa.value);
    }
    return m;
};
var $c6a8e3db2bad0039$export$3dea766d36a8935f = function(predicate) {
    return function(fa) {
        return $c6a8e3db2bad0039$var$_filter(fa, predicate);
    };
};
var $c6a8e3db2bad0039$export$a04c6c6965dd4709 = function(f) {
    return function(fa) {
        return $c6a8e3db2bad0039$var$_filterMap(fa, f);
    };
};
var $c6a8e3db2bad0039$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $c6a8e3db2bad0039$var$_map(fa, f);
    };
};
var $c6a8e3db2bad0039$export$8f07ddce13659f50 = function(f) {
    return function(fa) {
        return $c6a8e3db2bad0039$var$_mapWithIndex(fa, f);
    };
};
var $c6a8e3db2bad0039$export$b29f828819edca8d = function(predicate) {
    return function(fa) {
        return $c6a8e3db2bad0039$var$_partition(fa, predicate);
    };
};
var $c6a8e3db2bad0039$export$3117e3f9ececb6bc = function(f) {
    return function(fa) {
        return $c6a8e3db2bad0039$var$_partitionMap(fa, f);
    };
};
var $c6a8e3db2bad0039$export$709f6946f4e97408 = function(fa) {
    var left = new Map();
    var right = new Map();
    var entries = fa.entries();
    var e;
    while(!(e = entries.next()).done){
        var _a = e.value, k = _a[0], ei = _a[1];
        if ($f506e8da188a4a28$export$d649b6842e09f2b(ei)) left.set(k, ei.left);
        else right.set(k, ei.right);
    }
    return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
};
var $c6a8e3db2bad0039$export$9156e739aa33e19f = 'ReadonlyMap';
var $c6a8e3db2bad0039$export$baca17b4aff42f82 = function(E, S) {
    var unionES = $c6a8e3db2bad0039$export$971dd5b0dfd021b6(E, S);
    return {
        concat: function(first, second) {
            return unionES(second)(first);
        }
    };
};
var $c6a8e3db2bad0039$export$c487aac9f4157837 = function(E, S) {
    return {
        concat: $c6a8e3db2bad0039$export$baca17b4aff42f82(E, S).concat,
        empty: $c6a8e3db2bad0039$export$6e22c362a0406a2c
    };
};
var $c6a8e3db2bad0039$export$d379a869a72e4055 = function(E, S) {
    var intersectionES = $c6a8e3db2bad0039$export$bc86dfbf7795668c(E, S);
    return {
        concat: function(first, second) {
            return intersectionES(second)(first);
        }
    };
};
var $c6a8e3db2bad0039$export$fdb3296ca0a124e3 = function(E) {
    return function() {
        var differenceE = $c6a8e3db2bad0039$export$acaf96a27438246b(E);
        return {
            concat: function(first, second) {
                return differenceE(second)(first);
            }
        };
    };
};
function $c6a8e3db2bad0039$export$d600270efcad85ac() {
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        map: $c6a8e3db2bad0039$var$_map,
        mapWithIndex: $c6a8e3db2bad0039$var$_mapWithIndex,
        compact: $c6a8e3db2bad0039$export$8e16b83750b44988,
        separate: $c6a8e3db2bad0039$export$709f6946f4e97408,
        filter: $c6a8e3db2bad0039$var$_filter,
        filterMap: $c6a8e3db2bad0039$var$_filterMap,
        partition: $c6a8e3db2bad0039$var$_partition,
        partitionMap: $c6a8e3db2bad0039$var$_partitionMap,
        partitionMapWithIndex: $c6a8e3db2bad0039$var$_partitionMapWithIndex,
        partitionWithIndex: $c6a8e3db2bad0039$var$_partitionWithIndex,
        filterMapWithIndex: $c6a8e3db2bad0039$var$_filterMapWithIndex,
        filterWithIndex: $c6a8e3db2bad0039$var$_filterWithIndex
    };
}
var $c6a8e3db2bad0039$export$bd5b6bfc5fa2ee61 = {
    URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
    map: $c6a8e3db2bad0039$var$_map
};
var $c6a8e3db2bad0039$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($c6a8e3db2bad0039$export$bd5b6bfc5fa2ee61);
var $c6a8e3db2bad0039$export$7c7748da5f3db60f = function() {
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        map: $c6a8e3db2bad0039$var$_map,
        mapWithIndex: $c6a8e3db2bad0039$var$_mapWithIndex
    };
};
var $c6a8e3db2bad0039$export$4a21ac48141ac3c9 = {
    URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
    compact: $c6a8e3db2bad0039$export$8e16b83750b44988,
    separate: $c6a8e3db2bad0039$export$709f6946f4e97408
};
var $c6a8e3db2bad0039$export$d00e1c48fb621173 = {
    URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
    map: $c6a8e3db2bad0039$var$_map,
    compact: $c6a8e3db2bad0039$export$8e16b83750b44988,
    separate: $c6a8e3db2bad0039$export$709f6946f4e97408,
    filter: $c6a8e3db2bad0039$var$_filter,
    filterMap: $c6a8e3db2bad0039$var$_filterMap,
    partition: $c6a8e3db2bad0039$var$_partition,
    partitionMap: $c6a8e3db2bad0039$var$_partitionMap
};
var $c6a8e3db2bad0039$export$533b26079ad0b4b = function(O) {
    var reduceWithIndexO = $c6a8e3db2bad0039$export$bbd3ef8720e22369(O);
    return function(b, f) {
        return reduceWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $c6a8e3db2bad0039$export$b66cdc0497d8a99a = function(O) {
    var foldMapWithIndexO = $c6a8e3db2bad0039$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexOM = foldMapWithIndexO(M);
        return function(f) {
            return foldMapWithIndexOM(function(_, a) {
                return f(a);
            });
        };
    };
};
var $c6a8e3db2bad0039$export$7fef8bcdbb34f435 = function(O) {
    var reduceRightWithIndexO = $c6a8e3db2bad0039$export$ce2b2fe0b88ccd0a(O);
    return function(b, f) {
        return reduceRightWithIndexO(b, function(_, b, a) {
            return f(b, a);
        });
    };
};
var $c6a8e3db2bad0039$export$d544f02c7cebdaed = function(O) {
    var reduceO = $c6a8e3db2bad0039$export$533b26079ad0b4b(O);
    var foldMapO = $c6a8e3db2bad0039$export$b66cdc0497d8a99a(O);
    var reduceRightO = $c6a8e3db2bad0039$export$7fef8bcdbb34f435(O);
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        reduce: function(fa, b, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceO(b, f));
        },
        foldMap: function(M) {
            var foldMapOM = foldMapO(M);
            return function(fa, f) {
                return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapOM(f));
            };
        },
        reduceRight: function(fa, b, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceRightO(b, f));
        }
    };
};
var $c6a8e3db2bad0039$export$bbd3ef8720e22369 = function(O) {
    var keysO = $c6a8e3db2bad0039$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                var k = _a[_i];
                out = f(k, out, m.get(k));
            }
            return out;
        };
    };
};
var $c6a8e3db2bad0039$export$18153bb1181268e5 = function(O) {
    var keysO = $c6a8e3db2bad0039$export$ed97f33186d4b816(O);
    return function(M) {
        return function(f) {
            return function(m) {
                var out = M.empty;
                for(var _i = 0, _a = keysO(m); _i < _a.length; _i++){
                    var k = _a[_i];
                    out = M.concat(out, f(k, m.get(k)));
                }
                return out;
            };
        };
    };
};
var $c6a8e3db2bad0039$export$ce2b2fe0b88ccd0a = function(O) {
    var keysO = $c6a8e3db2bad0039$export$ed97f33186d4b816(O);
    return function(b, f) {
        return function(m) {
            var out = b;
            var ks = keysO(m);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, m.get(k), out);
            }
            return out;
        };
    };
};
var $c6a8e3db2bad0039$export$6c59d75f118e7bc9 = function(O) {
    var F = $c6a8e3db2bad0039$export$d544f02c7cebdaed(O);
    var reduceWithIndexO = $c6a8e3db2bad0039$export$bbd3ef8720e22369(O);
    var foldMapWithIndexO = $c6a8e3db2bad0039$export$18153bb1181268e5(O);
    var reduceRightWithIndexO = $c6a8e3db2bad0039$export$ce2b2fe0b88ccd0a(O);
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        reduceWithIndex: function(fa, b, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceWithIndexO(b, f));
        },
        foldMapWithIndex: function(M) {
            var foldMapWithIndexOM = foldMapWithIndexO(M);
            return function(fa, f) {
                return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapWithIndexOM(f));
            };
        },
        reduceRightWithIndex: function(fa, b, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceRightWithIndexO(b, f));
        }
    };
};
var $c6a8e3db2bad0039$export$4e0ffba11065d2c1 = function(O) {
    var TWI = $c6a8e3db2bad0039$export$46b81797a3375b8c(O);
    var F = $c6a8e3db2bad0039$export$d544f02c7cebdaed(O);
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        map: $c6a8e3db2bad0039$var$_map,
        reduce: F.reduce,
        foldMap: F.foldMap,
        reduceRight: F.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence
    };
};
var $c6a8e3db2bad0039$export$46b81797a3375b8c = function(O) {
    var FWI = $c6a8e3db2bad0039$export$6c59d75f118e7bc9(O);
    var keysO = $c6a8e3db2bad0039$export$ed97f33186d4b816(O);
    var traverseWithIndex = function(F) {
        return function(ta, f) {
            var fm = F.of(new Map());
            var ks = keysO(ta);
            var len = ks.length;
            var _loop_1 = function(i) {
                var key = ks[i];
                var a = ta.get(key);
                fm = F.ap(F.map(fm, function(m) {
                    return function(b) {
                        return m.set(key, b);
                    };
                }), f(key, a));
            };
            for(var i = 0; i < len; i++)_loop_1(i);
            return fm;
        };
    };
    var traverse = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    };
    var sequence = function(F) {
        var traverseWithIndexF = traverseWithIndex(F);
        return function(ta) {
            return traverseWithIndexF(ta, (0, $195a10ed7200bcca$export$5f584391ee0d99b4));
        };
    };
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        map: $c6a8e3db2bad0039$var$_map,
        mapWithIndex: $c6a8e3db2bad0039$var$_mapWithIndex,
        reduce: FWI.reduce,
        foldMap: FWI.foldMap,
        reduceRight: FWI.reduceRight,
        reduceWithIndex: FWI.reduceWithIndex,
        foldMapWithIndex: FWI.foldMapWithIndex,
        reduceRightWithIndex: FWI.reduceRightWithIndex,
        traverse: traverse,
        sequence: sequence,
        traverseWithIndex: traverseWithIndex
    };
};
function $c6a8e3db2bad0039$export$bb8ef26a634cac7b(O) {
    var TWI = $c6a8e3db2bad0039$export$46b81797a3375b8c(O);
    return {
        URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
        _E: undefined,
        map: $c6a8e3db2bad0039$var$_map,
        compact: $c6a8e3db2bad0039$export$8e16b83750b44988,
        separate: $c6a8e3db2bad0039$export$709f6946f4e97408,
        filter: $c6a8e3db2bad0039$var$_filter,
        filterMap: $c6a8e3db2bad0039$var$_filterMap,
        partition: $c6a8e3db2bad0039$var$_partition,
        partitionMap: $c6a8e3db2bad0039$var$_partitionMap,
        reduce: TWI.reduce,
        foldMap: TWI.foldMap,
        reduceRight: TWI.reduceRight,
        traverse: TWI.traverse,
        sequence: TWI.sequence,
        mapWithIndex: $c6a8e3db2bad0039$var$_mapWithIndex,
        reduceWithIndex: TWI.reduceWithIndex,
        foldMapWithIndex: TWI.foldMapWithIndex,
        reduceRightWithIndex: TWI.reduceRightWithIndex,
        traverseWithIndex: TWI.traverseWithIndex,
        wilt: (0, $1209966343b7d06c$export$f4cb42390e44d1d2)(TWI, $c6a8e3db2bad0039$export$4a21ac48141ac3c9),
        wither: (0, $1209966343b7d06c$export$1f5c6f948d11a182)(TWI, $c6a8e3db2bad0039$export$4a21ac48141ac3c9)
    };
}
var $c6a8e3db2bad0039$export$971dd5b0dfd021b6 = function(E, M) {
    var lookupE = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(first)) return second;
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($f506e8da188a4a28$export$5d7e502287836e58(oka)) out.set(k, M.concat(a, oka.value));
                else out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                var oka = lookupE(k)(out);
                if ($f506e8da188a4a28$export$e56af863d5645d5f(oka)) out.set(k, a);
            }
            return out;
        };
    };
};
var $c6a8e3db2bad0039$export$bc86dfbf7795668c = function(E, M) {
    var lookupE = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
    return function(second) {
        return function(first) {
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(first) || $c6a8e3db2bad0039$export$dd1bc94b04021eeb(second)) return $c6a8e3db2bad0039$export$6e22c362a0406a2c;
            var out = new Map();
            var entries = first.entries();
            var e;
            while(!(e = entries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                var oka = lookupE(k)(second);
                if ($f506e8da188a4a28$export$5d7e502287836e58(oka)) out.set(k, M.concat(a, oka.value));
            }
            return out;
        };
    };
};
var $c6a8e3db2bad0039$export$acaf96a27438246b = function(E) {
    var memberE = $c6a8e3db2bad0039$export$6a0d13241802fe80(E);
    return function(second) {
        return function(first) {
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(first)) return second;
            if ($c6a8e3db2bad0039$export$dd1bc94b04021eeb(second)) return first;
            var out = new Map();
            var firstEntries = first.entries();
            var e;
            while(!(e = firstEntries.next()).done){
                var _a = e.value, k = _a[0], a = _a[1];
                if (!memberE(k)(second)) out.set(k, a);
            }
            var secondEntries = second.entries();
            while(!(e = secondEntries.next()).done){
                var _b = e.value, k = _b[0], a = _b[1];
                if (!memberE(k)(first)) out.set(k, a);
            }
            return out;
        };
    };
};
var $c6a8e3db2bad0039$export$9f200c4466975173 = $c6a8e3db2bad0039$export$ff82449ce381c54a;
var $c6a8e3db2bad0039$export$28562fb56044e6b5 = {
    URI: $c6a8e3db2bad0039$export$9156e739aa33e19f,
    map: $c6a8e3db2bad0039$var$_map,
    compact: $c6a8e3db2bad0039$export$8e16b83750b44988,
    separate: $c6a8e3db2bad0039$export$709f6946f4e97408,
    filter: $c6a8e3db2bad0039$var$_filter,
    filterMap: $c6a8e3db2bad0039$var$_filterMap,
    partition: $c6a8e3db2bad0039$var$_partition,
    partitionMap: $c6a8e3db2bad0039$var$_partitionMap
};






var $ce91c0a3783db19e$export$7d98477f9d1e986f = function(s) {
    return new Set(s);
};
var $ce91c0a3783db19e$export$439306a4dcaafbb9 = function(a) {
    return new Set([
        a
    ]);
};
var $ce91c0a3783db19e$export$9288e031f1846591 = function(E) {
    return function(as) {
        var len = as.length;
        var out = new Set();
        var has = $ce91c0a3783db19e$export$5bf96401662340b7(E);
        for(var i = 0; i < len; i++){
            var a = as[i];
            if (!has(a, out)) out.add(a);
        }
        return out;
    };
};
function $ce91c0a3783db19e$export$f416efe173c6901c(s) {
    return new Set(s);
}
function $ce91c0a3783db19e$export$871de8747c9eaa88(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                var v = f(e);
                if (!elemE(v, r)) r.add(v);
            });
            return r;
        };
    };
}
function $ce91c0a3783db19e$export$e08e3b67e392101e(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(f) {
        return function(set) {
            var r = new Set();
            set.forEach(function(e) {
                f(e).forEach(function(e) {
                    if (!elemE(e, r)) r.add(e);
                });
            });
            return r;
        };
    };
}
function $ce91c0a3783db19e$export$3dea766d36a8935f(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var r = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) r.add(a);
        }
        return r;
    };
}
function $ce91c0a3783db19e$export$b29f828819edca8d(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var right = new Set();
        var left = new Set();
        while(!(e = values.next()).done){
            var a = e.value;
            if (predicate(a)) right.add(a);
            else left.add(a);
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
}
function $ce91c0a3783db19e$export$971dd5b0dfd021b6(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var unionE_1 = $ce91c0a3783db19e$export$971dd5b0dfd021b6(E);
            return function(that) {
                return unionE_1(me, that);
            };
        }
        if ($ce91c0a3783db19e$export$dd1bc94b04021eeb(me)) return that;
        if ($ce91c0a3783db19e$export$dd1bc94b04021eeb(that)) return me;
        var r = new Set(me);
        that.forEach(function(e) {
            if (!elemE(e, r)) r.add(e);
        });
        return r;
    };
}
function $ce91c0a3783db19e$export$bc86dfbf7795668c(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var intersectionE_1 = $ce91c0a3783db19e$export$bc86dfbf7795668c(E);
            return function(that) {
                return intersectionE_1(that, me);
            };
        }
        if ($ce91c0a3783db19e$export$dd1bc94b04021eeb(me) || $ce91c0a3783db19e$export$dd1bc94b04021eeb(that)) return $ce91c0a3783db19e$export$6e22c362a0406a2c;
        var r = new Set();
        me.forEach(function(e) {
            if (elemE(e, that)) r.add(e);
        });
        return r;
    };
}
function $ce91c0a3783db19e$export$3117e3f9ececb6bc(EB, EC) {
    return function(f) {
        return function(set) {
            var values = set.values();
            var e;
            var left = new Set();
            var right = new Set();
            var hasB = $ce91c0a3783db19e$export$5bf96401662340b7(EB);
            var hasC = $ce91c0a3783db19e$export$5bf96401662340b7(EC);
            while(!(e = values.next()).done){
                var v = f(e.value);
                switch(v._tag){
                    case 'Left':
                        if (!hasB(v.left, left)) left.add(v.left);
                        break;
                    case 'Right':
                        if (!hasC(v.right, right)) right.add(v.right);
                        break;
                }
            }
            return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
        };
    };
}
function $ce91c0a3783db19e$export$acaf96a27438246b(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var differenceE_1 = $ce91c0a3783db19e$export$acaf96a27438246b(E);
            return function(that) {
                return differenceE_1(that, me);
            };
        }
        return $ce91c0a3783db19e$export$3dea766d36a8935f(function(a) {
            return !elemE(a, that);
        })(me);
    };
}
function $ce91c0a3783db19e$export$533b26079ad0b4b(O) {
    var toReadonlyArrayO = $ce91c0a3783db19e$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(f, b);
        };
    };
}
function $ce91c0a3783db19e$export$b66cdc0497d8a99a(O, M) {
    var toReadonlyArrayO = $ce91c0a3783db19e$export$4aaa3912a3956cb7(O);
    return function(f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduce(function(b, a) {
                return M.concat(b, f(a));
            }, M.empty);
        };
    };
}
var $ce91c0a3783db19e$export$7fef8bcdbb34f435 = function(O) {
    var toReadonlyArrayO = $ce91c0a3783db19e$export$4aaa3912a3956cb7(O);
    return function(b, f) {
        return function(fa) {
            return toReadonlyArrayO(fa).reduceRight(function(b, a) {
                return f(a, b);
            }, b);
        };
    };
};
function $ce91c0a3783db19e$export$21a5ca8aa77d35ff(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(a) {
        return function(set) {
            if (!elemE(a)(set)) {
                var r = new Set(set);
                r.add(a);
                return r;
            } else return set;
        };
    };
}
var $ce91c0a3783db19e$export$cd7f480d6b8286c3 = function(E) {
    return function(a) {
        return function(set) {
            return $ce91c0a3783db19e$export$3dea766d36a8935f(function(ax) {
                return !E.equals(a, ax);
            })(set);
        };
    };
};
var $ce91c0a3783db19e$export$e03c1c3201ee8bb7 = function(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    var removeE = $ce91c0a3783db19e$export$cd7f480d6b8286c3(E);
    var insertE = $ce91c0a3783db19e$export$21a5ca8aa77d35ff(E);
    return function(a) {
        return function(set) {
            return (elemE(a, set) ? removeE : insertE)(a)(set);
        };
    };
};
var $ce91c0a3783db19e$export$8e16b83750b44988 = function(E) {
    return $ce91c0a3783db19e$export$a04c6c6965dd4709(E)((0, $195a10ed7200bcca$export$f0954fd7d5368655));
};
function $ce91c0a3783db19e$export$709f6946f4e97408(EE, EA) {
    return function(fa) {
        var elemEE = $ce91c0a3783db19e$export$5bf96401662340b7(EE);
        var elemEA = $ce91c0a3783db19e$export$5bf96401662340b7(EA);
        var left = new Set();
        var right = new Set();
        fa.forEach(function(e) {
            switch(e._tag){
                case 'Left':
                    if (!elemEE(e.left, left)) left.add(e.left);
                    break;
                case 'Right':
                    if (!elemEA(e.right, right)) right.add(e.right);
                    break;
            }
        });
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
}
function $ce91c0a3783db19e$export$a04c6c6965dd4709(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(f) {
        return function(fa) {
            var r = new Set();
            fa.forEach(function(a) {
                var ob = f(a);
                if (ob._tag === 'Some' && !elemE(ob.value, r)) r.add(ob.value);
            });
            return r;
        };
    };
}
var $ce91c0a3783db19e$export$6e22c362a0406a2c = new Set();
var $ce91c0a3783db19e$export$dd1bc94b04021eeb = function(set) {
    return set.size === 0;
};
var $ce91c0a3783db19e$export$346677f925de839c = function(set) {
    return set.size;
};
var $ce91c0a3783db19e$export$ad14ef4001db2bcd = function(predicate) {
    return function(set) {
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = predicate(e.value);
        return found;
    };
};
function $ce91c0a3783db19e$export$7ecc1a3b11b57dab(predicate) {
    return (0, $71dce11dc017701c$export$6003a5f097c73977)($ce91c0a3783db19e$export$ad14ef4001db2bcd((0, $71dce11dc017701c$export$6003a5f097c73977)(predicate)));
}
function $ce91c0a3783db19e$export$af04532ec9ff13d2(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    return function(me, that) {
        if (that === undefined) {
            var isSubsetE_1 = $ce91c0a3783db19e$export$af04532ec9ff13d2(E);
            return function(that) {
                return isSubsetE_1(that, me);
            };
        }
        return $ce91c0a3783db19e$export$7ecc1a3b11b57dab(function(a) {
            return elemE(a, that);
        })(me);
    };
}
function $ce91c0a3783db19e$export$5bf96401662340b7(E) {
    return function(a, set) {
        if (set === undefined) {
            var elemE_1 = $ce91c0a3783db19e$export$5bf96401662340b7(E);
            return function(set) {
                return elemE_1(a, set);
            };
        }
        var values = set.values();
        var e;
        var found = false;
        while(!found && !(e = values.next()).done)found = E.equals(a, e.value);
        return found;
    };
}
var $ce91c0a3783db19e$export$4aaa3912a3956cb7 = function(O) {
    return function(set) {
        var out = [];
        set.forEach(function(e) {
            return out.push(e);
        });
        return out.sort(O.compare);
    };
};
var $ce91c0a3783db19e$export$9156e739aa33e19f = 'ReadonlySet';
function $ce91c0a3783db19e$export$3cb5cd7f7776c81(S) {
    return {
        show: function(s) {
            var entries = [];
            s.forEach(function(a) {
                entries.push(S.show(a));
            });
            return "new Set([".concat(entries.sort().join(', '), "])");
        }
    };
}
function $ce91c0a3783db19e$export$804fed467fde44e4(E) {
    var subsetE = $ce91c0a3783db19e$export$af04532ec9ff13d2(E);
    return (0, $621782213ab3b52c$export$fec6acd8d60e8568)(function(x, y) {
        return subsetE(x, y) && subsetE(y, x);
    });
}
var $ce91c0a3783db19e$export$baca17b4aff42f82 = function(E) {
    return {
        concat: $ce91c0a3783db19e$export$971dd5b0dfd021b6(E)
    };
};
var $ce91c0a3783db19e$export$c487aac9f4157837 = function(E) {
    return {
        concat: $ce91c0a3783db19e$export$baca17b4aff42f82(E).concat,
        empty: $ce91c0a3783db19e$export$6e22c362a0406a2c
    };
};
var $ce91c0a3783db19e$export$d379a869a72e4055 = function(E) {
    return {
        concat: $ce91c0a3783db19e$export$bc86dfbf7795668c(E)
    };
};
var $ce91c0a3783db19e$export$fdb3296ca0a124e3 = function(E) {
    return {
        concat: $ce91c0a3783db19e$export$acaf96a27438246b(E)
    };
};
var $ce91c0a3783db19e$export$571d59b505e6bb4e = $ce91c0a3783db19e$export$9288e031f1846591;


var $4d6af78a1b90130a$exports = {};







var $d663fd790ff22335$export$a2050e5b0c4dcf10 = {
    equals: function(first, second) {
        return first === second;
    }
};
var $d663fd790ff22335$export$c16b1dbe8a4166b6 = {
    concat: function(first, second) {
        return first + second;
    }
};
var $d663fd790ff22335$export$6e22c362a0406a2c = '';
var $d663fd790ff22335$export$8f55868b713abdc3 = {
    concat: $d663fd790ff22335$export$c16b1dbe8a4166b6.concat,
    empty: $d663fd790ff22335$export$6e22c362a0406a2c
};
var $d663fd790ff22335$export$ee8aa95bfab51c5 = {
    equals: $d663fd790ff22335$export$a2050e5b0c4dcf10.equals,
    compare: function(first, second) {
        return first < second ? -1 : first > second ? 1 : 0;
    }
};
var $d663fd790ff22335$export$f6a3d19be20f5819 = {
    show: function(s) {
        return JSON.stringify(s);
    }
};
var $d663fd790ff22335$export$844ec244b1367d54 = function(u) {
    return typeof u === 'string';
};
var $d663fd790ff22335$export$d80c591a9e16646 = function(s) {
    return s.toUpperCase();
};
var $d663fd790ff22335$export$84b9399c77df0edf = function(s) {
    return s.toLowerCase();
};
var $d663fd790ff22335$export$77ad94ebf1c2b9ed = function(searchValue, replaceValue) {
    return function(s) {
        return s.replace(searchValue, replaceValue);
    };
};
var $d663fd790ff22335$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
var $d663fd790ff22335$export$c5557f40488c48ec = function(s) {
    return s.trimLeft();
};
var $d663fd790ff22335$export$da8e5da96e287379 = function(s) {
    return s.trimRight();
};
var $d663fd790ff22335$export$58adb3bec8346d0f = function(start, end) {
    return function(s) {
        return s.slice(start, end);
    };
};
var $d663fd790ff22335$export$dd1bc94b04021eeb = function(s) {
    return s.length === 0;
};
var $d663fd790ff22335$export$346677f925de839c = function(s) {
    return s.length;
};
var $d663fd790ff22335$export$65980d18b75784e2 = function(separator) {
    return function(s) {
        var out = s.split(separator);
        return (0, $694b1cc3e43dcc88$export$a978c53b4062a525)(out) ? out : [
            s
        ];
    };
};
var $d663fd790ff22335$export$ee2e0f811dca1807 = function(searchString, position) {
    return function(s) {
        return s.includes(searchString, position);
    };
};
var $d663fd790ff22335$export$68326237475e9a7d = function(searchString, position) {
    return function(s) {
        return s.startsWith(searchString, position);
    };
};
var $d663fd790ff22335$export$10fdab3683b55b22 = function(searchString, position) {
    return function(s) {
        return s.endsWith(searchString, position);
    };
};



var $0af7b080d1ec098a$export$6c8271f68d66a228 = function(r) {
    return Object.assign({}, r);
};
var $0af7b080d1ec098a$export$1a8926de16677683 = function(r) {
    return Object.assign({}, r);
};
var $0af7b080d1ec098a$export$346677f925de839c = function(r) {
    return Object.keys(r).length;
};
var $0af7b080d1ec098a$export$dd1bc94b04021eeb = function(r) {
    for(var k in r){
        if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) return false;
    }
    return true;
};
var $0af7b080d1ec098a$var$keys_ = function(O) {
    return function(r) {
        return Object.keys(r).sort(O.compare);
    };
};
var $0af7b080d1ec098a$export$ed97f33186d4b816 = /*#__PURE__*/ $0af7b080d1ec098a$var$keys_($d663fd790ff22335$export$ee8aa95bfab51c5);
function $0af7b080d1ec098a$export$bb44f104e3c54dae(O) {
    if (typeof O === 'function') return $0af7b080d1ec098a$export$bb44f104e3c54dae($d663fd790ff22335$export$ee8aa95bfab51c5)(O);
    var keysO = $0af7b080d1ec098a$var$keys_(O);
    return function(f) {
        return function(r) {
            var out = [];
            for(var _i = 0, _a = keysO(r); _i < _a.length; _i++){
                var key = _a[_i];
                out.push(f(key, r[key]));
            }
            return out;
        };
    };
}
var $0af7b080d1ec098a$export$4aaa3912a3956cb7 = /*#__PURE__*/ $0af7b080d1ec098a$export$bb44f104e3c54dae($d663fd790ff22335$export$ee8aa95bfab51c5)(function(k, a) {
    return [
        k,
        a
    ];
});
function $0af7b080d1ec098a$export$823be24f8766da23(U) {
    return function(r) {
        var sas = $0af7b080d1ec098a$export$4aaa3912a3956cb7(r);
        var len = sas.length;
        return U.unfold(0, function(b) {
            return b < len ? $f506e8da188a4a28$export$ad14ef4001db2bcd([
                sas[b],
                b + 1
            ]) : $f506e8da188a4a28$export$f883a24d5edde77c;
        });
    };
}
var $0af7b080d1ec098a$export$ff82449ce381c54a = function(k, a) {
    return function(r) {
        if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k) && r[k] === a) return r;
        var out = Object.assign({}, r);
        out[k] = a;
        return out;
    };
};
var $0af7b080d1ec098a$export$a4f4bb6b1453fff5 = function(k, r) {
    return $f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k);
};
function $0af7b080d1ec098a$export$90f9093465da3136(k) {
    return function(r) {
        if (!$f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) return r;
        var out = Object.assign({}, r);
        delete out[k];
        return out;
    };
}
var $0af7b080d1ec098a$export$b6d8713d53419d4c = function(k, a) {
    return function(r) {
        if (!$0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, r)) return $f506e8da188a4a28$export$f883a24d5edde77c;
        if (r[k] === a) return $f506e8da188a4a28$export$ad14ef4001db2bcd(r);
        var out = Object.assign({}, r);
        out[k] = a;
        return $f506e8da188a4a28$export$ad14ef4001db2bcd(out);
    };
};
var $0af7b080d1ec098a$export$cba09f9e3d3e58eb = function(k, f) {
    return function(r) {
        if (!$0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, r)) return $f506e8da188a4a28$export$f883a24d5edde77c;
        var next = f(r[k]);
        if (next === r[k]) return $f506e8da188a4a28$export$ad14ef4001db2bcd(r);
        var out = Object.assign({}, r);
        out[k] = next;
        return $f506e8da188a4a28$export$ad14ef4001db2bcd(out);
    };
};
function $0af7b080d1ec098a$export$3e41007ebfff0e64(k) {
    var deleteAtk = $0af7b080d1ec098a$export$90f9093465da3136(k);
    return function(r) {
        var oa = $0af7b080d1ec098a$export$dfc7155ac0343b8(k, r);
        return $f506e8da188a4a28$export$e56af863d5645d5f(oa) ? $f506e8da188a4a28$export$f883a24d5edde77c : $f506e8da188a4a28$export$ad14ef4001db2bcd([
            oa.value,
            deleteAtk(r)
        ]);
    };
}
function $0af7b080d1ec098a$export$36e6f76a1d117b8a(E) {
    return function(me, that) {
        if (that === undefined) {
            var isSubrecordE_1 = $0af7b080d1ec098a$export$36e6f76a1d117b8a(E);
            return function(that) {
                return isSubrecordE_1(that, me);
            };
        }
        for(var k in me){
            if (!$f506e8da188a4a28$export$a4f4bb6b1453fff5.call(that, k) || !E.equals(me[k], that[k])) return false;
        }
        return true;
    };
}
function $0af7b080d1ec098a$export$dfc7155ac0343b8(k, r) {
    if (r === undefined) return function(r) {
        return $0af7b080d1ec098a$export$dfc7155ac0343b8(k, r);
    };
    return $f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k) ? $f506e8da188a4a28$export$ad14ef4001db2bcd(r[k]) : $f506e8da188a4a28$export$f883a24d5edde77c;
}
var $0af7b080d1ec098a$export$6e22c362a0406a2c = {};
function $0af7b080d1ec098a$export$8f07ddce13659f50(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) out[k] = f(k, r[k]);
        return out;
    };
}
function $0af7b080d1ec098a$export$871de8747c9eaa88(f) {
    return $0af7b080d1ec098a$export$8f07ddce13659f50(function(_, a) {
        return f(a);
    });
}
function $0af7b080d1ec098a$export$bbd3ef8720e22369() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $0af7b080d1ec098a$export$bbd3ef8720e22369($d663fd790ff22335$export$ee8aa95bfab51c5).apply(void 0, args);
    var keysO = $0af7b080d1ec098a$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = 0; i < len; i++){
                var k = ks[i];
                out = f(k, out, fa[k]);
            }
            return out;
        };
    };
}
function $0af7b080d1ec098a$export$18153bb1181268e5(O) {
    if ('compare' in O) {
        var keysO_1 = $0af7b080d1ec098a$var$keys_(O);
        return function(M) {
            return function(f) {
                return function(fa) {
                    var out = M.empty;
                    var ks = keysO_1(fa);
                    var len = ks.length;
                    for(var i = 0; i < len; i++){
                        var k = ks[i];
                        out = M.concat(out, f(k, fa[k]));
                    }
                    return out;
                };
            };
        };
    }
    return $0af7b080d1ec098a$export$18153bb1181268e5($d663fd790ff22335$export$ee8aa95bfab51c5)(O);
}
function $0af7b080d1ec098a$export$ce2b2fe0b88ccd0a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 2) return $0af7b080d1ec098a$export$ce2b2fe0b88ccd0a($d663fd790ff22335$export$ee8aa95bfab51c5).apply(void 0, args);
    var keysO = $0af7b080d1ec098a$var$keys_(args[0]);
    return function(b, f) {
        return function(fa) {
            var out = b;
            var ks = keysO(fa);
            var len = ks.length;
            for(var i = len - 1; i >= 0; i--){
                var k = ks[i];
                out = f(k, fa[k], out);
            }
            return out;
        };
    };
}
var $0af7b080d1ec098a$export$439306a4dcaafbb9 = function(k, a) {
    var _a;
    return _a = {}, _a[k] = a, _a;
};
function $0af7b080d1ec098a$export$955fdc0d24efa249(F) {
    var traverseWithIndexOF = $0af7b080d1ec098a$var$_traverseWithIndex($d663fd790ff22335$export$ee8aa95bfab51c5)(F);
    return function(f) {
        return function(ta) {
            return traverseWithIndexOF(ta, f);
        };
    };
}
function $0af7b080d1ec098a$export$df3f009e3d155b20(F) {
    var traverseOF = $0af7b080d1ec098a$export$b3c6f3d9661cffba($d663fd790ff22335$export$ee8aa95bfab51c5)(F);
    return function(f) {
        return function(ta) {
            return traverseOF(ta, f);
        };
    };
}
function $0af7b080d1ec098a$export$49bb65c2ea163039(F) {
    return $0af7b080d1ec098a$export$5d141086b2c0bc6($d663fd790ff22335$export$ee8aa95bfab51c5)(F);
}
var $0af7b080d1ec098a$export$6c36d01819ecdb31 = function(F) {
    var traverseF = $0af7b080d1ec098a$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $195a10ed7200bcca$export$a4627e546088548d)(fa, traverseF(f)), $0af7b080d1ec098a$export$8e16b83750b44988);
        };
    };
};
var $0af7b080d1ec098a$export$2439a3bc02b13b03 = function(F) {
    var traverseF = $0af7b080d1ec098a$export$df3f009e3d155b20(F);
    return function(f) {
        return function(fa) {
            return F.map((0, $195a10ed7200bcca$export$a4627e546088548d)(fa, traverseF(f)), $0af7b080d1ec098a$export$709f6946f4e97408);
        };
    };
};
function $0af7b080d1ec098a$export$bc7c0794b9c6f3ba(f) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) {
            var e = f(k, r[k]);
            switch(e._tag){
                case 'Left':
                    left[k] = e.left;
                    break;
                case 'Right':
                    right[k] = e.right;
                    break;
            }
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
}
function $0af7b080d1ec098a$export$dad5e500f2bab9bc(predicateWithIndex) {
    return function(r) {
        var left = {};
        var right = {};
        for(var k in r)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) {
            var a = r[k];
            if (predicateWithIndex(k, a)) right[k] = a;
            else left[k] = a;
        }
        return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
    };
}
function $0af7b080d1ec098a$export$30c5cbe848021e97(f) {
    return function(r) {
        var out = {};
        for(var k in r)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) {
            var ob = f(k, r[k]);
            if ($f506e8da188a4a28$export$5d7e502287836e58(ob)) out[k] = ob.value;
        }
        return out;
    };
}
function $0af7b080d1ec098a$export$36e42aef19fc7171(predicateWithIndex) {
    return function(fa) {
        var out = {};
        var changed = false;
        for(var key in fa)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(fa, key)) {
            var a = fa[key];
            if (predicateWithIndex(key, a)) out[key] = a;
            else changed = true;
        }
        return changed ? out : fa;
    };
}
function $0af7b080d1ec098a$export$b7d5d9bb9ff52072(M, F) {
    var fromFoldableMapM = $0af7b080d1ec098a$export$f658682c0065ad25(M, F);
    return function(fka) {
        return fromFoldableMapM(fka, (0, $195a10ed7200bcca$export$f0954fd7d5368655));
    };
}
function $0af7b080d1ec098a$export$f658682c0065ad25(M, F) {
    return function(ta, f) {
        return F.reduce(ta, {}, function(r, a) {
            var _a = f(a), k = _a[0], b = _a[1];
            r[k] = $f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k) ? M.concat(r[k], b) : b;
            return r;
        });
    };
}
var $0af7b080d1ec098a$export$9f69d28786a8399c = $0af7b080d1ec098a$export$4aaa3912a3956cb7;
var $0af7b080d1ec098a$export$5150077fc2e7c662 = function(fa) {
    var out = {};
    for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
        var a = fa_1[_i];
        out[a[0]] = a[1];
    }
    return out;
};
function $0af7b080d1ec098a$export$7ecc1a3b11b57dab(predicate) {
    return function(r) {
        for(var k in r){
            if (!predicate(r[k])) return false;
        }
        return true;
    };
}
function $0af7b080d1ec098a$export$ad14ef4001db2bcd(predicate) {
    return function(r) {
        for(var k in r){
            if (predicate(r[k])) return true;
        }
        return false;
    };
}
function $0af7b080d1ec098a$export$5bf96401662340b7(E) {
    return function(a, fa) {
        if (fa === undefined) {
            var elemE_1 = $0af7b080d1ec098a$export$5bf96401662340b7(E);
            return function(fa) {
                return elemE_1(a, fa);
            };
        }
        for(var k in fa){
            if (E.equals(fa[k], a)) return true;
        }
        return false;
    };
}
var $0af7b080d1ec098a$export$971dd5b0dfd021b6 = function(M) {
    return function(second) {
        return function(first) {
            if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(first)) return second;
            if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(second)) return first;
            var out = {};
            for(var k in first)if ($0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            else out[k] = first[k];
            for(var k in second)if (!$0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, out)) out[k] = second[k];
            return out;
        };
    };
};
var $0af7b080d1ec098a$export$bc86dfbf7795668c = function(M) {
    return function(second) {
        return function(first) {
            if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(first) || $0af7b080d1ec098a$export$dd1bc94b04021eeb(second)) return $0af7b080d1ec098a$export$6e22c362a0406a2c;
            var out = {};
            for(var k in first)if ($0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, second)) out[k] = M.concat(first[k], second[k]);
            return out;
        };
    };
};
var $0af7b080d1ec098a$export$acaf96a27438246b = function(second) {
    return function(first) {
        if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(first)) return second;
        if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(second)) return first;
        var out = {};
        for(var k in first)if (!$0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, second)) out[k] = first[k];
        for(var k in second)if (!$0af7b080d1ec098a$export$a4f4bb6b1453fff5(k, first)) out[k] = second[k];
        return out;
    };
};
var $0af7b080d1ec098a$export$a0135aecf4a782ab = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$871de8747c9eaa88(f));
};
var $0af7b080d1ec098a$export$45e3e46323e6d66c = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$8f07ddce13659f50(f));
};
var $0af7b080d1ec098a$export$8eef5fdba9512999 = function(O) {
    var reduceO = $0af7b080d1ec098a$export$533b26079ad0b4b(O);
    return function(fa, b, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceO(b, f));
    };
};
var $0af7b080d1ec098a$export$11b0d0e0b70641d9 = function(O) {
    return function(M) {
        var foldMapM = $0af7b080d1ec098a$export$b66cdc0497d8a99a(O)(M);
        return function(fa, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
        };
    };
};
var $0af7b080d1ec098a$export$ec882fc9def9e5db = function(O) {
    var reduceRightO = $0af7b080d1ec098a$export$7fef8bcdbb34f435(O);
    return function(fa, b, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceRightO(b, f));
    };
};
var $0af7b080d1ec098a$export$ec7439dc64f73058 = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$3dea766d36a8935f(predicate));
};
var $0af7b080d1ec098a$export$e8609d6e184911e6 = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$a04c6c6965dd4709(f));
};
var $0af7b080d1ec098a$export$8d112ad5a197e16a = function(fa, predicate) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$b29f828819edca8d(predicate));
};
var $0af7b080d1ec098a$export$f721fb25a1c72a8d = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$3117e3f9ececb6bc(f));
};
var $0af7b080d1ec098a$export$dd5ca3bcbad0b6af = function(O) {
    var reduceWithIndexO = $0af7b080d1ec098a$export$bbd3ef8720e22369(O);
    return function(fa, b, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceWithIndexO(b, f));
    };
};
var $0af7b080d1ec098a$export$e08bbf939bdc3250 = function(O) {
    var foldMapWithIndexO = $0af7b080d1ec098a$export$18153bb1181268e5(O);
    return function(M) {
        var foldMapWithIndexM = foldMapWithIndexO(M);
        return function(fa, f) {
            return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapWithIndexM(f));
        };
    };
};
var $0af7b080d1ec098a$export$3b7618311030b1af = function(O) {
    var reduceRightWithIndexO = $0af7b080d1ec098a$export$ce2b2fe0b88ccd0a(O);
    return function(fa, b, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, reduceRightWithIndexO(b, f));
    };
};
var $0af7b080d1ec098a$export$18034ec93490e9d2 = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$bc7c0794b9c6f3ba(f));
};
var $0af7b080d1ec098a$export$31601036bfbf1c76 = function(fa, predicateWithIndex) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$dad5e500f2bab9bc(predicateWithIndex));
};
var $0af7b080d1ec098a$export$ac207938ecd8ddc4 = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$30c5cbe848021e97(f));
};
var $0af7b080d1ec098a$export$560430393fed15de = function(fa, predicateWithIndex) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $0af7b080d1ec098a$export$36e42aef19fc7171(predicateWithIndex));
};
var $0af7b080d1ec098a$export$b3c6f3d9661cffba = function(O) {
    var traverseWithIndexO = $0af7b080d1ec098a$var$_traverseWithIndex(O);
    return function(F) {
        var traverseWithIndexOF = traverseWithIndexO(F);
        return function(ta, f) {
            return traverseWithIndexOF(ta, (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)((0, $195a10ed7200bcca$export$5f584391ee0d99b4), f));
        };
    };
};
var $0af7b080d1ec098a$export$5d141086b2c0bc6 = function(O) {
    var traverseO = $0af7b080d1ec098a$export$b3c6f3d9661cffba(O);
    return function(F) {
        var traverseOF = traverseO(F);
        return function(ta) {
            return traverseOF(ta, (0, $195a10ed7200bcca$export$f0954fd7d5368655));
        };
    };
};
var $0af7b080d1ec098a$var$_traverseWithIndex = function(O) {
    return function(F) {
        var keysO = $0af7b080d1ec098a$var$keys_(O);
        return function(ta, f) {
            var ks = keysO(ta);
            if (ks.length === 0) return F.of($0af7b080d1ec098a$export$6e22c362a0406a2c);
            var fr = F.of({});
            var _loop_1 = function(key) {
                fr = F.ap(F.map(fr, function(r) {
                    return function(b) {
                        var _a;
                        return Object.assign({}, r, (_a = {}, _a[key] = b, _a));
                    };
                }), f(key, ta[key]));
            };
            for(var _i = 0, ks_1 = ks; _i < ks_1.length; _i++){
                var key = ks_1[_i];
                _loop_1(key);
            }
            return fr;
        };
    };
};
var $0af7b080d1ec098a$export$3dea766d36a8935f = function(predicate) {
    return $0af7b080d1ec098a$export$36e42aef19fc7171(function(_, a) {
        return predicate(a);
    });
};
var $0af7b080d1ec098a$export$a04c6c6965dd4709 = function(f) {
    return $0af7b080d1ec098a$export$30c5cbe848021e97(function(_, a) {
        return f(a);
    });
};
var $0af7b080d1ec098a$export$b29f828819edca8d = function(predicate) {
    return $0af7b080d1ec098a$export$dad5e500f2bab9bc(function(_, a) {
        return predicate(a);
    });
};
var $0af7b080d1ec098a$export$3117e3f9ececb6bc = function(f) {
    return $0af7b080d1ec098a$export$bc7c0794b9c6f3ba(function(_, a) {
        return f(a);
    });
};
function $0af7b080d1ec098a$export$533b26079ad0b4b() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceWithIndexO_1 = $0af7b080d1ec098a$export$bbd3ef8720e22369(args[0]);
        return function(b, f) {
            return reduceWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $0af7b080d1ec098a$export$533b26079ad0b4b($d663fd790ff22335$export$ee8aa95bfab51c5).apply(void 0, args);
}
function $0af7b080d1ec098a$export$b66cdc0497d8a99a(O) {
    if ('compare' in O) {
        var foldMapWithIndexO_1 = $0af7b080d1ec098a$export$18153bb1181268e5(O);
        return function(M) {
            var foldMapWithIndexM = foldMapWithIndexO_1(M);
            return function(f) {
                return foldMapWithIndexM(function(_, a) {
                    return f(a);
                });
            };
        };
    }
    return $0af7b080d1ec098a$export$b66cdc0497d8a99a($d663fd790ff22335$export$ee8aa95bfab51c5)(O);
}
function $0af7b080d1ec098a$export$7fef8bcdbb34f435() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args.length === 1) {
        var reduceRightWithIndexO_1 = $0af7b080d1ec098a$export$ce2b2fe0b88ccd0a(args[0]);
        return function(b, f) {
            return reduceRightWithIndexO_1(b, function(_, b, a) {
                return f(b, a);
            });
        };
    }
    return $0af7b080d1ec098a$export$7fef8bcdbb34f435($d663fd790ff22335$export$ee8aa95bfab51c5).apply(void 0, args);
}
var $0af7b080d1ec098a$export$8e16b83750b44988 = function(r) {
    var out = {};
    for(var k in r)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) {
        var oa = r[k];
        if ($f506e8da188a4a28$export$5d7e502287836e58(oa)) out[k] = oa.value;
    }
    return out;
};
var $0af7b080d1ec098a$export$709f6946f4e97408 = function(r) {
    var left = {};
    var right = {};
    for(var k in r)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r, k)) {
        var e = r[k];
        if ($f506e8da188a4a28$export$d649b6842e09f2b(e)) left[k] = e.left;
        else right[k] = e.right;
    }
    return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(left, right);
};
var $0af7b080d1ec098a$export$9156e739aa33e19f = 'ReadonlyRecord';
function $0af7b080d1ec098a$export$3cb5cd7f7776c81(O) {
    if ('compare' in O) return function(S) {
        return {
            show: function(r) {
                var elements = $0af7b080d1ec098a$export$bb44f104e3c54dae(O)(function(k, a) {
                    return "".concat(JSON.stringify(k), ": ").concat(S.show(a));
                })(r).join(', ');
                return elements === '' ? '{}' : "{ ".concat(elements, " }");
            }
        };
    };
    return $0af7b080d1ec098a$export$3cb5cd7f7776c81($d663fd790ff22335$export$ee8aa95bfab51c5)(O);
}
function $0af7b080d1ec098a$export$804fed467fde44e4(E) {
    var isSubrecordE = $0af7b080d1ec098a$export$36e6f76a1d117b8a(E);
    return (0, $621782213ab3b52c$export$fec6acd8d60e8568)(function(x, y) {
        return isSubrecordE(x)(y) && isSubrecordE(y)(x);
    });
}
function $0af7b080d1ec098a$export$c2a7ef2cc9b32b31(S) {
    return {
        concat: function(first, second) {
            if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(first)) return second;
            if ($0af7b080d1ec098a$export$dd1bc94b04021eeb(second)) return first;
            var r = Object.assign({}, first);
            for(var k in second)if ($f506e8da188a4a28$export$a4f4bb6b1453fff5.call(second, k)) r[k] = $f506e8da188a4a28$export$a4f4bb6b1453fff5.call(first, k) ? S.concat(first[k], second[k]) : second[k];
            return r;
        },
        empty: $0af7b080d1ec098a$export$6e22c362a0406a2c
    };
}
var $0af7b080d1ec098a$export$bd5b6bfc5fa2ee61 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab
};
var $0af7b080d1ec098a$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($0af7b080d1ec098a$export$bd5b6bfc5fa2ee61);
var $0af7b080d1ec098a$export$9fdffe0fe1e91cad = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    mapWithIndex: $0af7b080d1ec098a$export$45e3e46323e6d66c
};
var $0af7b080d1ec098a$export$d544f02c7cebdaed = function(O) {
    return {
        URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
        reduce: $0af7b080d1ec098a$export$8eef5fdba9512999(O),
        foldMap: $0af7b080d1ec098a$export$11b0d0e0b70641d9(O),
        reduceRight: $0af7b080d1ec098a$export$ec882fc9def9e5db(O)
    };
};
var $0af7b080d1ec098a$export$6c59d75f118e7bc9 = function(O) {
    return {
        URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
        reduce: $0af7b080d1ec098a$export$8eef5fdba9512999(O),
        foldMap: $0af7b080d1ec098a$export$11b0d0e0b70641d9(O),
        reduceRight: $0af7b080d1ec098a$export$ec882fc9def9e5db(O),
        reduceWithIndex: $0af7b080d1ec098a$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $0af7b080d1ec098a$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $0af7b080d1ec098a$export$3b7618311030b1af(O)
    };
};
var $0af7b080d1ec098a$export$4a21ac48141ac3c9 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    compact: $0af7b080d1ec098a$export$8e16b83750b44988,
    separate: $0af7b080d1ec098a$export$709f6946f4e97408
};
var $0af7b080d1ec098a$export$d00e1c48fb621173 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    compact: $0af7b080d1ec098a$export$8e16b83750b44988,
    separate: $0af7b080d1ec098a$export$709f6946f4e97408,
    filter: $0af7b080d1ec098a$export$ec7439dc64f73058,
    filterMap: $0af7b080d1ec098a$export$e8609d6e184911e6,
    partition: $0af7b080d1ec098a$export$8d112ad5a197e16a,
    partitionMap: $0af7b080d1ec098a$export$f721fb25a1c72a8d
};
var $0af7b080d1ec098a$export$c29a647071e542ec = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    mapWithIndex: $0af7b080d1ec098a$export$45e3e46323e6d66c,
    compact: $0af7b080d1ec098a$export$8e16b83750b44988,
    separate: $0af7b080d1ec098a$export$709f6946f4e97408,
    filter: $0af7b080d1ec098a$export$ec7439dc64f73058,
    filterMap: $0af7b080d1ec098a$export$e8609d6e184911e6,
    partition: $0af7b080d1ec098a$export$8d112ad5a197e16a,
    partitionMap: $0af7b080d1ec098a$export$f721fb25a1c72a8d,
    filterMapWithIndex: $0af7b080d1ec098a$export$ac207938ecd8ddc4,
    filterWithIndex: $0af7b080d1ec098a$export$560430393fed15de,
    partitionMapWithIndex: $0af7b080d1ec098a$export$18034ec93490e9d2,
    partitionWithIndex: $0af7b080d1ec098a$export$31601036bfbf1c76
};
var $0af7b080d1ec098a$export$4e0ffba11065d2c1 = function(O) {
    return {
        URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
        map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
        reduce: $0af7b080d1ec098a$export$8eef5fdba9512999(O),
        foldMap: $0af7b080d1ec098a$export$11b0d0e0b70641d9(O),
        reduceRight: $0af7b080d1ec098a$export$ec882fc9def9e5db(O),
        traverse: $0af7b080d1ec098a$export$b3c6f3d9661cffba(O),
        sequence: $0af7b080d1ec098a$export$5d141086b2c0bc6(O)
    };
};
var $0af7b080d1ec098a$export$46b81797a3375b8c = function(O) {
    return {
        URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
        map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
        mapWithIndex: $0af7b080d1ec098a$export$45e3e46323e6d66c,
        reduce: $0af7b080d1ec098a$export$8eef5fdba9512999(O),
        foldMap: $0af7b080d1ec098a$export$11b0d0e0b70641d9(O),
        reduceRight: $0af7b080d1ec098a$export$ec882fc9def9e5db(O),
        reduceWithIndex: $0af7b080d1ec098a$export$dd5ca3bcbad0b6af(O),
        foldMapWithIndex: $0af7b080d1ec098a$export$e08bbf939bdc3250(O),
        reduceRightWithIndex: $0af7b080d1ec098a$export$3b7618311030b1af(O),
        traverse: $0af7b080d1ec098a$export$b3c6f3d9661cffba(O),
        sequence: $0af7b080d1ec098a$export$5d141086b2c0bc6(O),
        traverseWithIndex: $0af7b080d1ec098a$var$_traverseWithIndex(O)
    };
};
var $0af7b080d1ec098a$export$bb8ef26a634cac7b = function(O) {
    var T = $0af7b080d1ec098a$export$4e0ffba11065d2c1(O);
    return {
        URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
        map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
        reduce: $0af7b080d1ec098a$export$8eef5fdba9512999(O),
        foldMap: $0af7b080d1ec098a$export$11b0d0e0b70641d9(O),
        reduceRight: $0af7b080d1ec098a$export$ec882fc9def9e5db(O),
        traverse: T.traverse,
        sequence: T.sequence,
        compact: $0af7b080d1ec098a$export$8e16b83750b44988,
        separate: $0af7b080d1ec098a$export$709f6946f4e97408,
        filter: $0af7b080d1ec098a$export$ec7439dc64f73058,
        filterMap: $0af7b080d1ec098a$export$e8609d6e184911e6,
        partition: $0af7b080d1ec098a$export$8d112ad5a197e16a,
        partitionMap: $0af7b080d1ec098a$export$f721fb25a1c72a8d,
        wither: (0, $1209966343b7d06c$export$1f5c6f948d11a182)(T, $0af7b080d1ec098a$export$4a21ac48141ac3c9),
        wilt: (0, $1209966343b7d06c$export$f4cb42390e44d1d2)(T, $0af7b080d1ec098a$export$4a21ac48141ac3c9)
    };
};
var $0af7b080d1ec098a$export$baca17b4aff42f82 = function(S) {
    var unionS = $0af7b080d1ec098a$export$971dd5b0dfd021b6(S);
    return {
        concat: function(first, second) {
            return unionS(second)(first);
        }
    };
};
var $0af7b080d1ec098a$export$c487aac9f4157837 = function(S) {
    return {
        concat: $0af7b080d1ec098a$export$baca17b4aff42f82(S).concat,
        empty: $0af7b080d1ec098a$export$6e22c362a0406a2c
    };
};
var $0af7b080d1ec098a$export$d379a869a72e4055 = function(S) {
    var intersectionS = $0af7b080d1ec098a$export$bc86dfbf7795668c(S);
    return {
        concat: function(first, second) {
            return intersectionS(second)(first);
        }
    };
};
var $0af7b080d1ec098a$export$fdb3296ca0a124e3 = function() {
    return {
        concat: function(first, second) {
            return $0af7b080d1ec098a$export$acaf96a27438246b(second)(first);
        }
    };
};
var $0af7b080d1ec098a$export$41404b31838667c9 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $0af7b080d1ec098a$export$8eef5fdba9512999($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $0af7b080d1ec098a$export$11b0d0e0b70641d9($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $0af7b080d1ec098a$export$ec882fc9def9e5db($d663fd790ff22335$export$ee8aa95bfab51c5)
};
var $0af7b080d1ec098a$export$e8f7d17aaff345cb = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    reduce: /*#__PURE__*/ $0af7b080d1ec098a$export$8eef5fdba9512999($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $0af7b080d1ec098a$export$11b0d0e0b70641d9($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $0af7b080d1ec098a$export$ec882fc9def9e5db($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$dd5ca3bcbad0b6af($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMapWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$e08bbf939bdc3250($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRightWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$3b7618311030b1af($d663fd790ff22335$export$ee8aa95bfab51c5)
};
var $0af7b080d1ec098a$export$a0202666c3bda011 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $0af7b080d1ec098a$export$8eef5fdba9512999($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $0af7b080d1ec098a$export$11b0d0e0b70641d9($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $0af7b080d1ec098a$export$ec882fc9def9e5db($d663fd790ff22335$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $0af7b080d1ec098a$export$b3c6f3d9661cffba($d663fd790ff22335$export$ee8aa95bfab51c5),
    sequence: $0af7b080d1ec098a$export$49bb65c2ea163039
};
var $0af7b080d1ec098a$export$bd7b528d8c36ec41 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    mapWithIndex: $0af7b080d1ec098a$export$45e3e46323e6d66c,
    reduce: /*#__PURE__*/ $0af7b080d1ec098a$export$8eef5fdba9512999($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $0af7b080d1ec098a$export$11b0d0e0b70641d9($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $0af7b080d1ec098a$export$ec882fc9def9e5db($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$dd5ca3bcbad0b6af($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMapWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$e08bbf939bdc3250($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRightWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$3b7618311030b1af($d663fd790ff22335$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $0af7b080d1ec098a$export$b3c6f3d9661cffba($d663fd790ff22335$export$ee8aa95bfab51c5),
    sequence: $0af7b080d1ec098a$export$49bb65c2ea163039,
    traverseWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$var$_traverseWithIndex($d663fd790ff22335$export$ee8aa95bfab51c5)
};
var $0af7b080d1ec098a$var$_wither = /*#__PURE__*/ (0, $1209966343b7d06c$export$1f5c6f948d11a182)($0af7b080d1ec098a$export$a0202666c3bda011, $0af7b080d1ec098a$export$4a21ac48141ac3c9);
var $0af7b080d1ec098a$var$_wilt = /*#__PURE__*/ (0, $1209966343b7d06c$export$f4cb42390e44d1d2)($0af7b080d1ec098a$export$a0202666c3bda011, $0af7b080d1ec098a$export$4a21ac48141ac3c9);
var $0af7b080d1ec098a$export$748d317b4c426f96 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $0af7b080d1ec098a$export$8eef5fdba9512999($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $0af7b080d1ec098a$export$11b0d0e0b70641d9($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $0af7b080d1ec098a$export$ec882fc9def9e5db($d663fd790ff22335$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $0af7b080d1ec098a$export$b3c6f3d9661cffba($d663fd790ff22335$export$ee8aa95bfab51c5),
    sequence: $0af7b080d1ec098a$export$49bb65c2ea163039,
    compact: $0af7b080d1ec098a$export$8e16b83750b44988,
    separate: $0af7b080d1ec098a$export$709f6946f4e97408,
    filter: $0af7b080d1ec098a$export$ec7439dc64f73058,
    filterMap: $0af7b080d1ec098a$export$e8609d6e184911e6,
    partition: $0af7b080d1ec098a$export$8d112ad5a197e16a,
    partitionMap: $0af7b080d1ec098a$export$f721fb25a1c72a8d,
    wither: $0af7b080d1ec098a$var$_wither,
    wilt: $0af7b080d1ec098a$var$_wilt
};
var $0af7b080d1ec098a$export$9f200c4466975173 = $0af7b080d1ec098a$export$ff82449ce381c54a;
function $0af7b080d1ec098a$export$5a15a386532a5ea4(k, r) {
    return $f506e8da188a4a28$export$a4f4bb6b1453fff5.call(r === undefined ? this : r, k);
}
var $0af7b080d1ec098a$export$74b9182b22de2bc1 = {
    URI: $0af7b080d1ec098a$export$9156e739aa33e19f,
    map: $0af7b080d1ec098a$export$a0135aecf4a782ab,
    reduce: /*#__PURE__*/ $0af7b080d1ec098a$export$8eef5fdba9512999($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMap: /*#__PURE__*/ $0af7b080d1ec098a$export$11b0d0e0b70641d9($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRight: /*#__PURE__*/ $0af7b080d1ec098a$export$ec882fc9def9e5db($d663fd790ff22335$export$ee8aa95bfab51c5),
    traverse: /*#__PURE__*/ $0af7b080d1ec098a$export$b3c6f3d9661cffba($d663fd790ff22335$export$ee8aa95bfab51c5),
    sequence: $0af7b080d1ec098a$export$49bb65c2ea163039,
    compact: $0af7b080d1ec098a$export$8e16b83750b44988,
    separate: $0af7b080d1ec098a$export$709f6946f4e97408,
    filter: $0af7b080d1ec098a$export$ec7439dc64f73058,
    filterMap: $0af7b080d1ec098a$export$e8609d6e184911e6,
    partition: $0af7b080d1ec098a$export$8d112ad5a197e16a,
    partitionMap: $0af7b080d1ec098a$export$f721fb25a1c72a8d,
    mapWithIndex: $0af7b080d1ec098a$export$45e3e46323e6d66c,
    reduceWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$dd5ca3bcbad0b6af($d663fd790ff22335$export$ee8aa95bfab51c5),
    foldMapWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$e08bbf939bdc3250($d663fd790ff22335$export$ee8aa95bfab51c5),
    reduceRightWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$export$3b7618311030b1af($d663fd790ff22335$export$ee8aa95bfab51c5),
    filterMapWithIndex: $0af7b080d1ec098a$export$ac207938ecd8ddc4,
    filterWithIndex: $0af7b080d1ec098a$export$560430393fed15de,
    partitionMapWithIndex: $0af7b080d1ec098a$export$18034ec93490e9d2,
    partitionWithIndex: $0af7b080d1ec098a$export$31601036bfbf1c76,
    traverseWithIndex: /*#__PURE__*/ $0af7b080d1ec098a$var$_traverseWithIndex($d663fd790ff22335$export$ee8aa95bfab51c5),
    wither: $0af7b080d1ec098a$var$_wither,
    wilt: $0af7b080d1ec098a$var$_wilt
};







/**
 * @since 2.0.0
 */ var $743290cdc79d1e8a$export$2e586eaa876dd2fd = function(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};








var $c024626970c514e1$export$eabcd2c8791e7bf4 = $f506e8da188a4a28$export$eabcd2c8791e7bf4;
var $c024626970c514e1$export$79ffe56a765070d2 = $f506e8da188a4a28$export$79ffe56a765070d2;
var $c024626970c514e1$export$5b8affa63fc6df16 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, function(ma, f) {
    return $c024626970c514e1$export$d649b6842e09f2b(ma) ? ma : f(ma.right);
});
var $c024626970c514e1$var$_map = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c024626970c514e1$export$871de8747c9eaa88(f));
};
var $c024626970c514e1$var$_ap = function(fab, fa) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fab, $c024626970c514e1$export$2f6ca3d3b1f80bf5(fa));
};
/* istanbul ignore next */ var $c024626970c514e1$var$_reduce = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c024626970c514e1$export$533b26079ad0b4b(b, f));
};
/* istanbul ignore next */ var $c024626970c514e1$var$_foldMap = function(M) {
    return function(fa, f) {
        var foldMapM = $c024626970c514e1$export$b66cdc0497d8a99a(M);
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var $c024626970c514e1$var$_reduceRight = function(fa, b, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c024626970c514e1$export$7fef8bcdbb34f435(b, f));
};
var $c024626970c514e1$var$_traverse = function(F) {
    var traverseF = $c024626970c514e1$export$df3f009e3d155b20(F);
    return function(ta, f) {
        return (0, $195a10ed7200bcca$export$a4627e546088548d)(ta, traverseF(f));
    };
};
var $c024626970c514e1$var$_bimap = function(fa, f, g) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c024626970c514e1$export$eb54baf0b342cb1d(f, g));
};
var $c024626970c514e1$var$_mapLeft = function(fa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c024626970c514e1$export$472de43a55e4aa49(f));
};
/* istanbul ignore next */ var $c024626970c514e1$var$_alt = function(fa, that) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(fa, $c024626970c514e1$export$228be17d80722ab(that));
};
/* istanbul ignore next */ var $c024626970c514e1$var$_extend = function(wa, f) {
    return (0, $195a10ed7200bcca$export$a4627e546088548d)(wa, $c024626970c514e1$export$8b58be045bf06082(f));
};
var $c024626970c514e1$var$_chainRec = function(a, f) {
    return (0, $743290cdc79d1e8a$export$2e586eaa876dd2fd)(f(a), function(e) {
        return $c024626970c514e1$export$d649b6842e09f2b(e) ? $c024626970c514e1$export$79ffe56a765070d2($c024626970c514e1$export$eabcd2c8791e7bf4(e.left)) : $c024626970c514e1$export$d649b6842e09f2b(e.right) ? $c024626970c514e1$export$eabcd2c8791e7bf4(f(e.right.left)) : $c024626970c514e1$export$79ffe56a765070d2($c024626970c514e1$export$79ffe56a765070d2(e.right.right));
    });
};
var $c024626970c514e1$export$9156e739aa33e19f = 'Either';
var $c024626970c514e1$export$3cb5cd7f7776c81 = function(SE, SA) {
    return {
        show: function(ma) {
            return $c024626970c514e1$export$d649b6842e09f2b(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var $c024626970c514e1$export$804fed467fde44e4 = function(EL, EA) {
    return {
        equals: function(x, y) {
            return x === y || ($c024626970c514e1$export$d649b6842e09f2b(x) ? $c024626970c514e1$export$d649b6842e09f2b(y) && EL.equals(x.left, y.left) : $c024626970c514e1$export$a9d71693f0c1a85d(y) && EA.equals(x.right, y.right));
        }
    };
};
var $c024626970c514e1$export$e759a9a7f8d04692 = function(S) {
    return {
        concat: function(x, y) {
            return $c024626970c514e1$export$d649b6842e09f2b(y) ? x : $c024626970c514e1$export$d649b6842e09f2b(x) ? y : $c024626970c514e1$export$79ffe56a765070d2(S.concat(x.right, y.right));
        }
    };
};
var $c024626970c514e1$export$cfae3069ac05ff4c = function(M) {
    var empty = $c024626970c514e1$export$eabcd2c8791e7bf4(M.empty);
    return {
        URI: $c024626970c514e1$export$9156e739aa33e19f,
        _E: undefined,
        compact: function(ma) {
            return $c024626970c514e1$export$d649b6842e09f2b(ma) ? ma : ma.right._tag === 'None' ? empty : $c024626970c514e1$export$79ffe56a765070d2(ma.right.value);
        },
        separate: function(ma) {
            return $c024626970c514e1$export$d649b6842e09f2b(ma) ? (0, $58dc45d60525231a$export$beaabdf62f4a639d)(ma, ma) : $c024626970c514e1$export$d649b6842e09f2b(ma.right) ? (0, $58dc45d60525231a$export$beaabdf62f4a639d)($c024626970c514e1$export$79ffe56a765070d2(ma.right.left), empty) : (0, $58dc45d60525231a$export$beaabdf62f4a639d)(empty, $c024626970c514e1$export$79ffe56a765070d2(ma.right.right));
        }
    };
};
var $c024626970c514e1$export$a4e870b0a57ec14e = function(M) {
    var empty = $c024626970c514e1$export$eabcd2c8791e7bf4(M.empty);
    var _a = $c024626970c514e1$export$cfae3069ac05ff4c(M), compact = _a.compact, separate = _a.separate;
    var filter = function(ma, predicate) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function(ma, p) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? (0, $58dc45d60525231a$export$beaabdf62f4a639d)(ma, ma) : p(ma.right) ? (0, $58dc45d60525231a$export$beaabdf62f4a639d)(empty, $c024626970c514e1$export$79ffe56a765070d2(ma.right)) : (0, $58dc45d60525231a$export$beaabdf62f4a639d)($c024626970c514e1$export$79ffe56a765070d2(ma.right), empty);
    };
    return {
        URI: $c024626970c514e1$export$9156e739aa33e19f,
        _E: undefined,
        map: $c024626970c514e1$var$_map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function(ma, f) {
            if ($c024626970c514e1$export$d649b6842e09f2b(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : $c024626970c514e1$export$79ffe56a765070d2(ob.value);
        },
        partition: partition,
        partitionMap: function(ma, f) {
            if ($c024626970c514e1$export$d649b6842e09f2b(ma)) return (0, $58dc45d60525231a$export$beaabdf62f4a639d)(ma, ma);
            var e = f(ma.right);
            return $c024626970c514e1$export$d649b6842e09f2b(e) ? (0, $58dc45d60525231a$export$beaabdf62f4a639d)($c024626970c514e1$export$79ffe56a765070d2(e.left), empty) : (0, $58dc45d60525231a$export$beaabdf62f4a639d)(empty, $c024626970c514e1$export$79ffe56a765070d2(e.right));
        }
    };
};
var $c024626970c514e1$export$bb8ef26a634cac7b = function(M) {
    var F_ = $c024626970c514e1$export$a4e870b0a57ec14e(M);
    var C = $c024626970c514e1$export$cfae3069ac05ff4c(M);
    return {
        URI: $c024626970c514e1$export$9156e739aa33e19f,
        _E: undefined,
        map: $c024626970c514e1$var$_map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: $c024626970c514e1$var$_traverse,
        sequence: $c024626970c514e1$export$49bb65c2ea163039,
        reduce: $c024626970c514e1$var$_reduce,
        foldMap: $c024626970c514e1$var$_foldMap,
        reduceRight: $c024626970c514e1$var$_reduceRight,
        wither: (0, $1209966343b7d06c$export$1f5c6f948d11a182)($c024626970c514e1$export$a0202666c3bda011, C),
        wilt: (0, $1209966343b7d06c$export$f4cb42390e44d1d2)($c024626970c514e1$export$a0202666c3bda011, C)
    };
};
var $c024626970c514e1$export$d9540e18497e6036 = function(SE) {
    return {
        URI: $c024626970c514e1$export$9156e739aa33e19f,
        _E: undefined,
        map: $c024626970c514e1$var$_map,
        ap: function(fab, fa) {
            return $c024626970c514e1$export$d649b6842e09f2b(fab) ? $c024626970c514e1$export$d649b6842e09f2b(fa) ? $c024626970c514e1$export$eabcd2c8791e7bf4(SE.concat(fab.left, fa.left)) : fab : $c024626970c514e1$export$d649b6842e09f2b(fa) ? fa : $c024626970c514e1$export$79ffe56a765070d2(fab.right(fa.right));
        },
        of: $c024626970c514e1$export$ba255e9e49e00608
    };
};
var $c024626970c514e1$export$a81dd5ed716f5f73 = function(SE) {
    return {
        URI: $c024626970c514e1$export$9156e739aa33e19f,
        _E: undefined,
        map: $c024626970c514e1$var$_map,
        alt: function(me, that) {
            if ($c024626970c514e1$export$a9d71693f0c1a85d(me)) return me;
            var ea = that();
            return $c024626970c514e1$export$d649b6842e09f2b(ea) ? $c024626970c514e1$export$eabcd2c8791e7bf4(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var $c024626970c514e1$export$871de8747c9eaa88 = function(f) {
    return function(fa) {
        return $c024626970c514e1$export$d649b6842e09f2b(fa) ? fa : $c024626970c514e1$export$79ffe56a765070d2(f(fa.right));
    };
};
var $c024626970c514e1$export$bd5b6bfc5fa2ee61 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map
};
var $c024626970c514e1$export$6554612db691658e = (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, (0, $b90291f3b522edda$export$6554612db691658e)($c024626970c514e1$export$bd5b6bfc5fa2ee61));
var $c024626970c514e1$export$9284b360ca18a0fd = (0, $b90291f3b522edda$export$9284b360ca18a0fd)($c024626970c514e1$export$bd5b6bfc5fa2ee61);
var $c024626970c514e1$export$ba255e9e49e00608 = $c024626970c514e1$export$79ffe56a765070d2;
var $c024626970c514e1$export$59a71046037e6c20 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    of: $c024626970c514e1$export$ba255e9e49e00608
};
var $c024626970c514e1$export$321be6e231de8eac = function(fa) {
    return function(fab) {
        return $c024626970c514e1$export$d649b6842e09f2b(fab) ? fab : $c024626970c514e1$export$d649b6842e09f2b(fa) ? fa : $c024626970c514e1$export$79ffe56a765070d2(fab.right(fa.right));
    };
};
var $c024626970c514e1$export$2f6ca3d3b1f80bf5 = $c024626970c514e1$export$321be6e231de8eac;
var $c024626970c514e1$export$efc21ddc6aeb363d = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    ap: $c024626970c514e1$var$_ap
};
var $c024626970c514e1$export$1279d2b7807629fd = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    ap: $c024626970c514e1$var$_ap,
    of: $c024626970c514e1$export$ba255e9e49e00608
};
var $c024626970c514e1$export$f18d5acc27d70423 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    ap: $c024626970c514e1$var$_ap,
    chain: $c024626970c514e1$export$5b8affa63fc6df16
};
var $c024626970c514e1$export$fb641926d034ac7d = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    ap: $c024626970c514e1$var$_ap,
    of: $c024626970c514e1$export$ba255e9e49e00608,
    chain: $c024626970c514e1$export$5b8affa63fc6df16
};
var $c024626970c514e1$export$533b26079ad0b4b = function(b, f) {
    return function(fa) {
        return $c024626970c514e1$export$d649b6842e09f2b(fa) ? b : f(b, fa.right);
    };
};
var $c024626970c514e1$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(fa) {
            return $c024626970c514e1$export$d649b6842e09f2b(fa) ? M.empty : f(fa.right);
        };
    };
};
var $c024626970c514e1$export$7fef8bcdbb34f435 = function(b, f) {
    return function(fa) {
        return $c024626970c514e1$export$d649b6842e09f2b(fa) ? b : f(fa.right, b);
    };
};
var $c024626970c514e1$export$41404b31838667c9 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    reduce: $c024626970c514e1$var$_reduce,
    foldMap: $c024626970c514e1$var$_foldMap,
    reduceRight: $c024626970c514e1$var$_reduceRight
};
var $c024626970c514e1$export$df3f009e3d155b20 = function(F) {
    return function(f) {
        return function(ta) {
            return $c024626970c514e1$export$d649b6842e09f2b(ta) ? F.of($c024626970c514e1$export$eabcd2c8791e7bf4(ta.left)) : F.map(f(ta.right), $c024626970c514e1$export$79ffe56a765070d2);
        };
    };
};
var $c024626970c514e1$export$49bb65c2ea163039 = function(F) {
    return function(ma) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? F.of($c024626970c514e1$export$eabcd2c8791e7bf4(ma.left)) : F.map(ma.right, $c024626970c514e1$export$79ffe56a765070d2);
    };
};
var $c024626970c514e1$export$a0202666c3bda011 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    reduce: $c024626970c514e1$var$_reduce,
    foldMap: $c024626970c514e1$var$_foldMap,
    reduceRight: $c024626970c514e1$var$_reduceRight,
    traverse: $c024626970c514e1$var$_traverse,
    sequence: $c024626970c514e1$export$49bb65c2ea163039
};
var $c024626970c514e1$export$eb54baf0b342cb1d = function(f, g) {
    return function(fa) {
        return $c024626970c514e1$export$d649b6842e09f2b(fa) ? $c024626970c514e1$export$eabcd2c8791e7bf4(f(fa.left)) : $c024626970c514e1$export$79ffe56a765070d2(g(fa.right));
    };
};
var $c024626970c514e1$export$472de43a55e4aa49 = function(f) {
    return function(fa) {
        return $c024626970c514e1$export$d649b6842e09f2b(fa) ? $c024626970c514e1$export$eabcd2c8791e7bf4(f(fa.left)) : fa;
    };
};
var $c024626970c514e1$export$fd0fe42029639505 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    bimap: $c024626970c514e1$var$_bimap,
    mapLeft: $c024626970c514e1$var$_mapLeft
};
var $c024626970c514e1$export$1517cca7889d6aaa = function(that) {
    return function(fa) {
        return $c024626970c514e1$export$d649b6842e09f2b(fa) ? that() : fa;
    };
};
var $c024626970c514e1$export$228be17d80722ab = $c024626970c514e1$export$1517cca7889d6aaa;
var $c024626970c514e1$export$25ba4469a069167 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    alt: $c024626970c514e1$var$_alt
};
var $c024626970c514e1$export$8b58be045bf06082 = function(f) {
    return function(wa) {
        return $c024626970c514e1$export$d649b6842e09f2b(wa) ? wa : $c024626970c514e1$export$79ffe56a765070d2(f(wa));
    };
};
var $c024626970c514e1$export$5b5dd0e212d2a5bc = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    extend: $c024626970c514e1$var$_extend
};
var $c024626970c514e1$export$be58f7327716329d = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    ap: $c024626970c514e1$var$_ap,
    chain: $c024626970c514e1$export$5b8affa63fc6df16,
    chainRec: $c024626970c514e1$var$_chainRec
};
var $c024626970c514e1$export$8bf7aba4a9e09055 = $c024626970c514e1$export$eabcd2c8791e7bf4;
var $c024626970c514e1$export$5f956d47d0619c3a = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    ap: $c024626970c514e1$var$_ap,
    of: $c024626970c514e1$export$ba255e9e49e00608,
    chain: $c024626970c514e1$export$5b8affa63fc6df16,
    throwError: $c024626970c514e1$export$8bf7aba4a9e09055
};
var $c024626970c514e1$export$825ea6cb6fc48d49 = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    fromEither: (0, $195a10ed7200bcca$export$f0954fd7d5368655)
};
var $c024626970c514e1$export$23f31c55d7162b91 = /*#__PURE__*/ (0, $e877117324731de7$export$23f31c55d7162b91)($c024626970c514e1$export$825ea6cb6fc48d49);
var $c024626970c514e1$export$172ec0a6ebfeb6fa = /*#__PURE__*/ (0, $e877117324731de7$export$172ec0a6ebfeb6fa)($c024626970c514e1$export$825ea6cb6fc48d49);
var $c024626970c514e1$export$d649b6842e09f2b = $f506e8da188a4a28$export$d649b6842e09f2b;
var $c024626970c514e1$export$a9d71693f0c1a85d = $f506e8da188a4a28$export$a9d71693f0c1a85d;
var $c024626970c514e1$export$2d55ea551c238330 = function(onLeft, onRight) {
    return function(ma) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var $c024626970c514e1$export$ccb09033cefa61e8 = $c024626970c514e1$export$2d55ea551c238330;
var $c024626970c514e1$export$4659b591c19bdf3d = $c024626970c514e1$export$2d55ea551c238330;
var $c024626970c514e1$export$93e2b83da34ff82a = $c024626970c514e1$export$4659b591c19bdf3d;
var $c024626970c514e1$export$d8a997ff0e6436f3 = function(onLeft) {
    return function(ma) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma.right;
    };
};
var $c024626970c514e1$export$8832081647a02ee7 = $c024626970c514e1$export$d8a997ff0e6436f3;
var $c024626970c514e1$export$18c957606d8bdf09 = /*#__PURE__*/ (0, $b90291f3b522edda$export$18c957606d8bdf09)($c024626970c514e1$export$bd5b6bfc5fa2ee61);
var $c024626970c514e1$export$5f28d9feedcfd46e = /*#__PURE__*/ (0, $9465861535336ff3$export$5f28d9feedcfd46e)($c024626970c514e1$export$efc21ddc6aeb363d);
var $c024626970c514e1$export$ac044f4aa9961a4f = $c024626970c514e1$export$5f28d9feedcfd46e;
var $c024626970c514e1$export$ed01bc59c3d06bf3 = /*#__PURE__*/ (0, $9465861535336ff3$export$ed01bc59c3d06bf3)($c024626970c514e1$export$efc21ddc6aeb363d);
var $c024626970c514e1$export$8a00020751233172 = $c024626970c514e1$export$ed01bc59c3d06bf3;
var $c024626970c514e1$export$3f23594af5f37336 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$d1699a1bbdf17835)(2, $a048b5cdbfcd6533$export$3f23594af5f37336($c024626970c514e1$export$f18d5acc27d70423));
var $c024626970c514e1$export$2409099f1fc434fb = /*#__PURE__*/ $c024626970c514e1$export$5b8affa63fc6df16((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $c024626970c514e1$export$bffa455ba8c619a6 = $c024626970c514e1$export$2409099f1fc434fb;
var $c024626970c514e1$export$ecd5e8ace626722c = /*#__PURE__*/ $c024626970c514e1$export$8b58be045bf06082((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $c024626970c514e1$export$a907462f448b49f8 = /*#__PURE__*/ (0, $e877117324731de7$export$a907462f448b49f8)($c024626970c514e1$export$825ea6cb6fc48d49);
var $c024626970c514e1$export$12d26179deb6a68a = /*#__PURE__*/ (0, $e877117324731de7$export$12d26179deb6a68a)($c024626970c514e1$export$825ea6cb6fc48d49, $c024626970c514e1$export$f18d5acc27d70423);
var $c024626970c514e1$export$377cc334277e5c3c = $c024626970c514e1$export$12d26179deb6a68a;
/** @internal */ var $c024626970c514e1$var$_FromEither = {
    fromEither: $c024626970c514e1$export$825ea6cb6fc48d49.fromEither
};
var $c024626970c514e1$export$cd139e14432f317b = /*#__PURE__*/ $f506e8da188a4a28$export$cd139e14432f317b($c024626970c514e1$var$_FromEither);
var $c024626970c514e1$export$ea4a22f93200df79 = /*#__PURE__*/ $f506e8da188a4a28$export$ea4a22f93200df79($c024626970c514e1$var$_FromEither);
/** @internal */ var $c024626970c514e1$var$_FlatMap = {
    flatMap: $c024626970c514e1$export$5b8affa63fc6df16
};
var $c024626970c514e1$export$1a0515933c5c84fe = /*#__PURE__*/ $f506e8da188a4a28$export$1a0515933c5c84fe($c024626970c514e1$var$_FromEither, $c024626970c514e1$var$_FlatMap);
var $c024626970c514e1$export$b5f02b7beb8ed7d8 = /*#__PURE__*/ $f506e8da188a4a28$export$b5f02b7beb8ed7d8($c024626970c514e1$var$_FromEither, $c024626970c514e1$var$_FlatMap);
var $c024626970c514e1$export$30af8ca9498ddf5b = /*#__PURE__*/ (0, $e877117324731de7$export$30af8ca9498ddf5b)($c024626970c514e1$export$825ea6cb6fc48d49, $c024626970c514e1$export$f18d5acc27d70423);
var $c024626970c514e1$export$84511cf4503ec9dd = $c024626970c514e1$export$30af8ca9498ddf5b;
var $c024626970c514e1$export$b0e76d9850c64156 = function(ma) {
    return $c024626970c514e1$export$d649b6842e09f2b(ma) ? $c024626970c514e1$export$79ffe56a765070d2(ma.left) : $c024626970c514e1$export$eabcd2c8791e7bf4(ma.right);
};
var $c024626970c514e1$export$efd845e0c87089a6 = function(onLeft) {
    return function(ma) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? onLeft(ma.left) : ma;
    };
};
var $c024626970c514e1$export$41d1a04d78e7b141 = $c024626970c514e1$export$efd845e0c87089a6;
var $c024626970c514e1$export$b601f49376b4621a = function(e) {
    return function(a) {
        return a == null ? $c024626970c514e1$export$eabcd2c8791e7bf4(e) : $c024626970c514e1$export$79ffe56a765070d2(a);
    };
};
var $c024626970c514e1$export$d234c058d1d4e435 = function(f, onThrow) {
    try {
        return $c024626970c514e1$export$79ffe56a765070d2(f());
    } catch (e) {
        return $c024626970c514e1$export$eabcd2c8791e7bf4(onThrow(e));
    }
};
var $c024626970c514e1$export$7f3d23c4b0794e72 = function(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return $c024626970c514e1$export$d234c058d1d4e435(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var $c024626970c514e1$export$c69ca7b73fad45e1 = function(e) {
    var from = $c024626970c514e1$export$b601f49376b4621a(e);
    return function(f) {
        return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(f, from);
    };
};
var $c024626970c514e1$export$c81f992c08fd0bf3 = function(e) {
    var from = $c024626970c514e1$export$c69ca7b73fad45e1(e);
    return function(f) {
        return $c024626970c514e1$export$5b8affa63fc6df16(from(f));
    };
};
var $c024626970c514e1$export$a0886ed3a572729f = /*#__PURE__*/ $c024626970c514e1$export$ccb09033cefa61e8((0, $195a10ed7200bcca$export$f0954fd7d5368655), (0, $195a10ed7200bcca$export$f0954fd7d5368655));
function $c024626970c514e1$export$cc3b967c039ed3e7(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function $c024626970c514e1$export$5bf96401662340b7(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = $c024626970c514e1$export$5bf96401662340b7(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? false : E.equals(a, ma.right);
    };
}
var $c024626970c514e1$export$f7e9f41ea797a17 = function(predicate) {
    return function(ma) {
        return $c024626970c514e1$export$d649b6842e09f2b(ma) ? false : predicate(ma.right);
    };
};
var $c024626970c514e1$export$dfcca0b9d3f9c8f1 = /*#__PURE__*/ $c024626970c514e1$export$ba255e9e49e00608($f506e8da188a4a28$export$4de80339753b012b);
var $c024626970c514e1$export$7c052ae73f8acff0 = /*#__PURE__*/ (0, $b90291f3b522edda$export$7c052ae73f8acff0)($c024626970c514e1$export$bd5b6bfc5fa2ee61);
var $c024626970c514e1$export$5d537b797c421217 = /*#__PURE__*/ (0, $b90291f3b522edda$export$5d537b797c421217)($c024626970c514e1$export$bd5b6bfc5fa2ee61);
var $c024626970c514e1$export$2385a24977818dd0 = /*#__PURE__*/ $a048b5cdbfcd6533$export$2385a24977818dd0($c024626970c514e1$export$f18d5acc27d70423);
var $c024626970c514e1$export$e0d5b1cbe98976d9 = $c024626970c514e1$export$2385a24977818dd0;
var $c024626970c514e1$export$8cbfc0239f42bb49 = /*#__PURE__*/ (0, $9465861535336ff3$export$8cbfc0239f42bb49)($c024626970c514e1$export$efc21ddc6aeb363d);
var $c024626970c514e1$export$5c01f27714264b3d = $c024626970c514e1$export$8cbfc0239f42bb49;
var $c024626970c514e1$export$c74b6e34b2b6efb0 = /*#__PURE__*/ $c024626970c514e1$export$ba255e9e49e00608($f506e8da188a4a28$export$6ca726a2417e0f3f);
var $c024626970c514e1$export$817de7d5ba7e6fab = function(f) {
    return function(as) {
        var e = f(0, $f506e8da188a4a28$export$5fd5031fecdacec3(as));
        if ($c024626970c514e1$export$d649b6842e09f2b(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if ($c024626970c514e1$export$d649b6842e09f2b(e_1)) return e_1;
            out.push(e_1.right);
        }
        return $c024626970c514e1$export$79ffe56a765070d2(out);
    };
};
var $c024626970c514e1$export$d4e79db5dc14cc1 = function(f) {
    var g = $c024626970c514e1$export$817de7d5ba7e6fab(f);
    return function(as) {
        return $f506e8da188a4a28$export$a978c53b4062a525(as) ? g(as) : $c024626970c514e1$export$c74b6e34b2b6efb0;
    };
};
var $c024626970c514e1$export$104a2841e9cbad06 = $c024626970c514e1$export$d4e79db5dc14cc1;
var $c024626970c514e1$export$64f39b2a2b79e1b1 = function(f) {
    return $c024626970c514e1$export$d4e79db5dc14cc1(function(_, a) {
        return f(a);
    });
};
var $c024626970c514e1$export$d330b60315c14cd1 = /*#__PURE__*/ $c024626970c514e1$export$64f39b2a2b79e1b1((0, $195a10ed7200bcca$export$f0954fd7d5368655));
var $c024626970c514e1$export$8e5885f0163d737a = $c024626970c514e1$export$5b8affa63fc6df16;
var $c024626970c514e1$export$e08e3b67e392101e = $c024626970c514e1$export$5b8affa63fc6df16;
var $c024626970c514e1$export$e3821ef4970c339c = $c024626970c514e1$export$3f23594af5f37336;
var $c024626970c514e1$export$5de78197fc44b933 = $c024626970c514e1$export$3f23594af5f37336;
function $c024626970c514e1$export$27924e57e9afff7f(s, onError) {
    return $c024626970c514e1$export$d234c058d1d4e435(function() {
        return JSON.parse(s);
    }, onError);
}
var $c024626970c514e1$export$702e019c6853c7a = function(u, onError) {
    return $c024626970c514e1$export$d234c058d1d4e435(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var $c024626970c514e1$export$5f5be1bb6cd1fded = {
    URI: $c024626970c514e1$export$9156e739aa33e19f,
    map: $c024626970c514e1$var$_map,
    of: $c024626970c514e1$export$ba255e9e49e00608,
    ap: $c024626970c514e1$var$_ap,
    chain: $c024626970c514e1$export$5b8affa63fc6df16,
    reduce: $c024626970c514e1$var$_reduce,
    foldMap: $c024626970c514e1$var$_foldMap,
    reduceRight: $c024626970c514e1$var$_reduceRight,
    traverse: $c024626970c514e1$var$_traverse,
    sequence: $c024626970c514e1$export$49bb65c2ea163039,
    bimap: $c024626970c514e1$var$_bimap,
    mapLeft: $c024626970c514e1$var$_mapLeft,
    alt: $c024626970c514e1$var$_alt,
    extend: $c024626970c514e1$var$_extend,
    chainRec: $c024626970c514e1$var$_chainRec,
    throwError: $c024626970c514e1$export$8bf7aba4a9e09055
};
var $c024626970c514e1$export$18979a515d2a828e = /*#__PURE__*/ (0, $9465861535336ff3$export$18979a515d2a828e)($c024626970c514e1$export$efc21ddc6aeb363d);
var $c024626970c514e1$export$1b097547f7ec9bb3 = /*#__PURE__*/ (0, $9c908bfa9fcd6259$export$c8e1a8ea383fd0ff)($c024626970c514e1$export$1279d2b7807629fd);
var $c024626970c514e1$export$5c6835227ac7f658 = function(SE, SA) {
    return (0, $9465861535336ff3$export$18979a515d2a828e)($c024626970c514e1$export$d9540e18497e6036(SE))(SA);
};
var $c024626970c514e1$export$c6554235dd19af66 = function(SE, MA) {
    return (0, $9c908bfa9fcd6259$export$c8e1a8ea383fd0ff)($c024626970c514e1$export$d9540e18497e6036(SE))(MA);
};
function $c024626970c514e1$export$6843f928420ce3e4(SE) {
    var ap = $c024626970c514e1$export$d9540e18497e6036(SE).ap;
    var alt = $c024626970c514e1$export$a81dd5ed716f5f73(SE).alt;
    return {
        URI: $c024626970c514e1$export$9156e739aa33e19f,
        _E: undefined,
        map: $c024626970c514e1$var$_map,
        of: $c024626970c514e1$export$ba255e9e49e00608,
        chain: $c024626970c514e1$export$5b8affa63fc6df16,
        bimap: $c024626970c514e1$var$_bimap,
        mapLeft: $c024626970c514e1$var$_mapLeft,
        reduce: $c024626970c514e1$var$_reduce,
        foldMap: $c024626970c514e1$var$_foldMap,
        reduceRight: $c024626970c514e1$var$_reduceRight,
        extend: $c024626970c514e1$var$_extend,
        traverse: $c024626970c514e1$var$_traverse,
        sequence: $c024626970c514e1$export$49bb65c2ea163039,
        chainRec: $c024626970c514e1$var$_chainRec,
        throwError: $c024626970c514e1$export$8bf7aba4a9e09055,
        ap: ap,
        alt: alt
    };
}



var $4d6af78a1b90130a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4d6af78a1b90130a$export$1aba8f741a0eae06 = function(get, reverseGet) {
    return {
        get: get,
        reverseGet: reverseGet
    };
};
var $4d6af78a1b90130a$export$d001ee9513dee7c1 = function(sa) {
    return $4d6af78a1b90130a$export$21cde5187c2605a3(sa.get, (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.reverseGet, (0, $195a10ed7200bcca$export$c983f826f44ff86)));
};
var $4d6af78a1b90130a$export$fde8c5b9dff57abc = function(sa) {
    return $4d6af78a1b90130a$export$e469dcfea9910464((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.get, $52d3945e22e86057$export$ad14ef4001db2bcd), sa.reverseGet);
};
var $4d6af78a1b90130a$export$4d3db894cf45abd5 = function(sa) {
    return $4d6af78a1b90130a$export$516e28dec6a4b6d4((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.get, $52d3945e22e86057$export$ad14ef4001db2bcd), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.reverseGet, (0, $195a10ed7200bcca$export$c983f826f44ff86)));
};
var $4d6af78a1b90130a$export$e55a826b3ba968d2 = function(sa) {
    return $4d6af78a1b90130a$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.reverseGet(a);
                });
            };
        };
    });
};
var $4d6af78a1b90130a$export$21cde5187c2605a3 = function(get, set) {
    return {
        get: get,
        set: set
    };
};
var $4d6af78a1b90130a$export$bae94c671b4dc75d = function(sa) {
    return $4d6af78a1b90130a$export$516e28dec6a4b6d4((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.get, $52d3945e22e86057$export$ad14ef4001db2bcd), sa.set);
};
var $4d6af78a1b90130a$export$e5de01c31c85830c = function(sa) {
    return $4d6af78a1b90130a$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return F.map(f(sa.get(s)), function(a) {
                    return sa.set(a)(s);
                });
            };
        };
    });
};
var $4d6af78a1b90130a$export$62d1b5266563d2b6 = function(ab) {
    return function(sa) {
        return $4d6af78a1b90130a$export$21cde5187c2605a3(function(s) {
            return ab.get(sa.get(s));
        }, function(b) {
            return function(s) {
                return sa.set(ab.set(b)(sa.get(s)))(s);
            };
        });
    };
};
var $4d6af78a1b90130a$export$af9c087537c23eb1 = function(ab) {
    return function(sa) {
        return $4d6af78a1b90130a$export$e469dcfea9910464((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.getOption, $52d3945e22e86057$export$e08e3b67e392101e(ab.getOption)), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ab.reverseGet, sa.reverseGet));
    };
};
var $4d6af78a1b90130a$export$ffffe1ca21811d93 = function(ab) {
    return function(sa) {
        return $4d6af78a1b90130a$export$8e08893559c32e38($4d6af78a1b90130a$export$70f4d204f3bdc8bd(ab))($4d6af78a1b90130a$export$bae94c671b4dc75d(sa));
    };
};
var $4d6af78a1b90130a$export$a4b03755c6673298 = function() {
    return $4d6af78a1b90130a$export$21cde5187c2605a3((0, $195a10ed7200bcca$export$f0954fd7d5368655), (0, $195a10ed7200bcca$export$c983f826f44ff86));
};
var $4d6af78a1b90130a$export$a6ba95b157529836 = function(prop) {
    return function(sa) {
        return $4d6af78a1b90130a$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var _a;
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                return sa.set(Object.assign({}, oa, (_a = {}, _a[prop] = ap, _a)))(s);
            };
        });
    };
};
var $4d6af78a1b90130a$export$c19575454e66bf5f = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return function(sa) {
        return $4d6af78a1b90130a$export$21cde5187c2605a3(function(s) {
            var a = sa.get(s);
            var r = {};
            for(var _i = 0, props_1 = props; _i < props_1.length; _i++){
                var k = props_1[_i];
                r[k] = a[k];
            }
            return r;
        }, function(a) {
            return function(s) {
                var oa = sa.get(s);
                for(var _i = 0, props_2 = props; _i < props_2.length; _i++){
                    var k = props_2[_i];
                    if (a[k] !== oa[k]) return sa.set(Object.assign({}, oa, a))(s);
                }
                return s;
            };
        });
    };
};
var $4d6af78a1b90130a$export$103f2a6258fae742 = function(prop) {
    return function(sa) {
        return $4d6af78a1b90130a$export$21cde5187c2605a3(function(s) {
            return sa.get(s)[prop];
        }, function(ap) {
            return function(s) {
                var oa = sa.get(s);
                if (ap === oa[prop]) return s;
                var copy = oa.slice();
                copy[prop] = ap;
                return sa.set(copy)(s);
            };
        });
    };
};
var $4d6af78a1b90130a$export$fc68a3bfc89f0b98 = function(key) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $4d6af78a1b90130a$export$62d1b5266563d2b6($4d6af78a1b90130a$export$ba8573d258bae607().at(key)));
    };
};
var $4d6af78a1b90130a$export$e469dcfea9910464 = function(getOption, reverseGet) {
    return {
        getOption: getOption,
        reverseGet: reverseGet
    };
};
var $4d6af78a1b90130a$export$70f4d204f3bdc8bd = function(sa) {
    return $4d6af78a1b90130a$export$516e28dec6a4b6d4(sa.getOption, function(a) {
        return $4d6af78a1b90130a$export$97725fa315d6412c(a)(sa);
    });
};
var $4d6af78a1b90130a$export$18564f4597667b6a = function(sa) {
    return $4d6af78a1b90130a$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.getOption(s), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return $4d6af78a1b90130a$export$97725fa315d6412c(a)(sa)(s);
                    });
                }));
            };
        };
    });
};
var $4d6af78a1b90130a$export$ddb3ff54eaa1c530 = function(f) {
    return function(sa) {
        return function(s) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.getOption(s), $52d3945e22e86057$export$871de8747c9eaa88(function(o) {
                var n = f(o);
                return n === o ? s : sa.reverseGet(n);
            }));
        };
    };
};
var $4d6af78a1b90130a$export$f545e0bcbe4b5ea7 = function(f) {
    return function(sa) {
        var g = $4d6af78a1b90130a$export$ddb3ff54eaa1c530(f)(sa);
        return function(s) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(g(s), $52d3945e22e86057$export$8832081647a02ee7(function() {
                return s;
            }));
        };
    };
};
var $4d6af78a1b90130a$export$97725fa315d6412c = function(a) {
    return $4d6af78a1b90130a$export$f545e0bcbe4b5ea7(function() {
        return a;
    });
};
var $4d6af78a1b90130a$export$dad01448ef670850 = function(ab) {
    return function(sa) {
        return $4d6af78a1b90130a$export$8e08893559c32e38($4d6af78a1b90130a$export$bae94c671b4dc75d(ab))($4d6af78a1b90130a$export$70f4d204f3bdc8bd(sa));
    };
};
var $4d6af78a1b90130a$export$258cc98aa6d7d21b = function() {
    return $4d6af78a1b90130a$export$e469dcfea9910464($52d3945e22e86057$export$b601f49376b4621a, (0, $195a10ed7200bcca$export$f0954fd7d5368655));
};
var $4d6af78a1b90130a$export$8f316a2f03469694 = function(predicate) {
    return $4d6af78a1b90130a$export$e469dcfea9910464($52d3945e22e86057$export$23f31c55d7162b91(predicate), (0, $195a10ed7200bcca$export$f0954fd7d5368655));
};
var $4d6af78a1b90130a$export$782e8b2fe031f968 = function() {
    return $4d6af78a1b90130a$export$e469dcfea9910464((0, $195a10ed7200bcca$export$f0954fd7d5368655), $52d3945e22e86057$export$ad14ef4001db2bcd);
};
var $4d6af78a1b90130a$export$929e170fdd93186c = function() {
    return $4d6af78a1b90130a$export$e469dcfea9910464($52d3945e22e86057$export$80c878c9b1d77917, $c024626970c514e1$export$79ffe56a765070d2);
};
var $4d6af78a1b90130a$export$97ae81cf28b21f26 = function() {
    return $4d6af78a1b90130a$export$e469dcfea9910464(function(s) {
        return $c024626970c514e1$export$d649b6842e09f2b(s) ? $52d3945e22e86057$export$ad14ef4001db2bcd(s.left) : $52d3945e22e86057$export$f883a24d5edde77c;
    }, $c024626970c514e1$export$eabcd2c8791e7bf4);
};
var $4d6af78a1b90130a$export$516e28dec6a4b6d4 = function(getOption, set) {
    return {
        getOption: getOption,
        set: set
    };
};
var $4d6af78a1b90130a$export$a595a5197cc37264 = function(sa) {
    return $4d6af78a1b90130a$export$8666ce7a134c2314(function(F) {
        return function(f) {
            return function(s) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.getOption(s), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    });
};
var $4d6af78a1b90130a$export$48aae8aebe6d3ee9 = function(f) {
    return function(optional) {
        return function(s) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(optional.getOption(s), $52d3945e22e86057$export$871de8747c9eaa88(function(a) {
                var n = f(a);
                return n === a ? s : optional.set(n)(s);
            }));
        };
    };
};
var $4d6af78a1b90130a$export$6d575f282c3c1d48 = function(f) {
    return function(optional) {
        var g = $4d6af78a1b90130a$export$48aae8aebe6d3ee9(f)(optional);
        return function(s) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(g(s), $52d3945e22e86057$export$8832081647a02ee7(function() {
                return s;
            }));
        };
    };
};
var $4d6af78a1b90130a$export$8e08893559c32e38 = function(ab) {
    return function(sa) {
        return $4d6af78a1b90130a$export$516e28dec6a4b6d4((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.getOption, $52d3945e22e86057$export$e08e3b67e392101e(ab.getOption)), function(b) {
            return $4d6af78a1b90130a$export$6d575f282c3c1d48(ab.set(b))(sa);
        });
    };
};
var $4d6af78a1b90130a$export$47ac94aa95300c6f = function(i) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $4d6af78a1b90130a$export$8e08893559c32e38($4d6af78a1b90130a$export$bb0c054375ca4b0().index(i)));
    };
};
var $4d6af78a1b90130a$export$83e62439a4d30c4c = function(i) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $4d6af78a1b90130a$export$8e08893559c32e38($4d6af78a1b90130a$export$165af7b747e6b1f1().index(i)));
    };
};
var $4d6af78a1b90130a$export$a6c26e1663200bf4 = function(key) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $4d6af78a1b90130a$export$8e08893559c32e38($4d6af78a1b90130a$export$3c3468aec3b83bbf().index(key)));
    };
};
var $4d6af78a1b90130a$export$220673392b48821b = function(predicate) {
    return $4d6af78a1b90130a$export$516e28dec6a4b6d4($aa0d0a09044b87d4$export$9a2f228bed5035c2(predicate), function(a) {
        return function(s) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)($aa0d0a09044b87d4$export$de3a4d4a0d731119(predicate)(s), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                return s;
            }, function(i) {
                return $aa0d0a09044b87d4$export$9c0c6889b1fa9bfc(i, a, s);
            }));
        };
    });
};
var $4d6af78a1b90130a$var$unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $4d6af78a1b90130a$var$__spreadArray([
            as[0]
        ], as.slice(1), true);
        xs[i] = a;
        return xs;
    }
};
var $4d6af78a1b90130a$export$cf29cfc68de9a659 = function(predicate) {
    return $4d6af78a1b90130a$export$516e28dec6a4b6d4($aa0d0a09044b87d4$export$9a2f228bed5035c2(predicate), function(a) {
        return function(as) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)($aa0d0a09044b87d4$export$de3a4d4a0d731119(predicate)(as), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                return as;
            }, function(i) {
                return $4d6af78a1b90130a$var$unsafeUpdateAt(i, a, as);
            }));
        };
    });
};
var $4d6af78a1b90130a$export$8666ce7a134c2314 = function(modifyF) {
    return {
        modifyF: modifyF
    };
};
function $4d6af78a1b90130a$export$2c68ab81171b083f(ab) {
    return function(sa) {
        return $4d6af78a1b90130a$export$8666ce7a134c2314(function(F) {
            return function(f) {
                return sa.modifyF(F)(ab.modifyF(F)(f));
            };
        });
    };
}
var $4d6af78a1b90130a$export$7c4912ca011fa00e = {
    URI: 'Identity',
    map: function(fa, f) {
        return f(fa);
    },
    of: (0, $195a10ed7200bcca$export$f0954fd7d5368655),
    ap: /* istanbul ignore next */ function(fab, fa) {
        return fab(fa);
    }
};
var $4d6af78a1b90130a$var$isIdentity = function(F) {
    return F.URI === 'Identity';
};
function $4d6af78a1b90130a$export$126b5a87c58d3f9c(T) {
    return function() {
        return $4d6af78a1b90130a$export$8666ce7a134c2314(function(F) {
            // if `F` is `Identity` then `traverseF = map`
            var traverseF = $4d6af78a1b90130a$var$isIdentity(F) ? T.map : T.traverse(F);
            return function(f) {
                return function(s) {
                    return traverseF(s, f);
                };
            };
        });
    };
}
function $4d6af78a1b90130a$export$35db6fcbd934c57(T) {
    return $4d6af78a1b90130a$export$2c68ab81171b083f($4d6af78a1b90130a$export$126b5a87c58d3f9c(T)());
}
var $4d6af78a1b90130a$export$b610b8812bbcded9 = function(index) {
    return {
        index: index
    };
};
var $4d6af78a1b90130a$export$bb0c054375ca4b0 = function() {
    return $4d6af78a1b90130a$export$b610b8812bbcded9(function(i) {
        return $4d6af78a1b90130a$export$516e28dec6a4b6d4(function(as) {
            return $aa0d0a09044b87d4$export$dfc7155ac0343b8(i, as);
        }, function(a) {
            return function(as) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)($aa0d0a09044b87d4$export$dfc7155ac0343b8(i, as), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                    return as;
                }, function() {
                    return $aa0d0a09044b87d4$export$9c0c6889b1fa9bfc(i, a, as);
                }));
            };
        });
    });
};
var $4d6af78a1b90130a$export$165af7b747e6b1f1 = function() {
    return $4d6af78a1b90130a$export$b610b8812bbcded9(function(i) {
        return $4d6af78a1b90130a$export$516e28dec6a4b6d4(function(as) {
            return $aa0d0a09044b87d4$export$dfc7155ac0343b8(i, as);
        }, function(a) {
            return function(as) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)($aa0d0a09044b87d4$export$dfc7155ac0343b8(i, as), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                    return as;
                }, function() {
                    return $4d6af78a1b90130a$var$unsafeUpdateAt(i, a, as);
                }));
            };
        });
    });
};
var $4d6af78a1b90130a$export$3c3468aec3b83bbf = function() {
    return $4d6af78a1b90130a$export$b610b8812bbcded9(function(k) {
        return $4d6af78a1b90130a$export$516e28dec6a4b6d4(function(r) {
            return $0af7b080d1ec098a$export$dfc7155ac0343b8(k, r);
        }, function(a) {
            return function(r) {
                if (r[k] === a || $52d3945e22e86057$export$e56af863d5645d5f($0af7b080d1ec098a$export$dfc7155ac0343b8(k, r))) return r;
                return $0af7b080d1ec098a$export$9f200c4466975173(k, a)(r);
            };
        });
    });
};
var $4d6af78a1b90130a$export$493d36ec626b6698 = function(at) {
    return {
        at: at
    };
};
function $4d6af78a1b90130a$export$ba8573d258bae607() {
    return $4d6af78a1b90130a$export$493d36ec626b6698(function(key) {
        return $4d6af78a1b90130a$export$21cde5187c2605a3(function(r) {
            return $0af7b080d1ec098a$export$dfc7155ac0343b8(key, r);
        }, $52d3945e22e86057$export$93e2b83da34ff82a(function() {
            return $0af7b080d1ec098a$export$90f9093465da3136(key);
        }, function(a) {
            return $0af7b080d1ec098a$export$9f200c4466975173(key, a);
        }));
    });
}
$4d6af78a1b90130a$exports["iso"] = $4d6af78a1b90130a$export$1aba8f741a0eae06;
$4d6af78a1b90130a$exports["isoAsLens"] = $4d6af78a1b90130a$export$d001ee9513dee7c1;
$4d6af78a1b90130a$exports["lens"] = $4d6af78a1b90130a$export$21cde5187c2605a3;
$4d6af78a1b90130a$exports["isoAsPrism"] = $4d6af78a1b90130a$export$fde8c5b9dff57abc;
$4d6af78a1b90130a$exports["prism"] = $4d6af78a1b90130a$export$e469dcfea9910464;
$4d6af78a1b90130a$exports["isoAsOptional"] = $4d6af78a1b90130a$export$4d3db894cf45abd5;
$4d6af78a1b90130a$exports["optional"] = $4d6af78a1b90130a$export$516e28dec6a4b6d4;
$4d6af78a1b90130a$exports["isoAsTraversal"] = $4d6af78a1b90130a$export$e55a826b3ba968d2;
$4d6af78a1b90130a$exports["traversal"] = $4d6af78a1b90130a$export$8666ce7a134c2314;
$4d6af78a1b90130a$exports["lensAsOptional"] = $4d6af78a1b90130a$export$bae94c671b4dc75d;
$4d6af78a1b90130a$exports["lensAsTraversal"] = $4d6af78a1b90130a$export$e5de01c31c85830c;
$4d6af78a1b90130a$exports["lensComposeLens"] = $4d6af78a1b90130a$export$62d1b5266563d2b6;
$4d6af78a1b90130a$exports["prismComposePrism"] = $4d6af78a1b90130a$export$af9c087537c23eb1;
$4d6af78a1b90130a$exports["lensComposePrism"] = $4d6af78a1b90130a$export$ffffe1ca21811d93;
$4d6af78a1b90130a$exports["optionalComposeOptional"] = $4d6af78a1b90130a$export$8e08893559c32e38;
$4d6af78a1b90130a$exports["prismAsOptional"] = $4d6af78a1b90130a$export$70f4d204f3bdc8bd;
$4d6af78a1b90130a$exports["lensId"] = $4d6af78a1b90130a$export$a4b03755c6673298;
$4d6af78a1b90130a$exports["lensProp"] = $4d6af78a1b90130a$export$a6ba95b157529836;
$4d6af78a1b90130a$exports["lensProps"] = $4d6af78a1b90130a$export$c19575454e66bf5f;
$4d6af78a1b90130a$exports["lensComponent"] = $4d6af78a1b90130a$export$103f2a6258fae742;
$4d6af78a1b90130a$exports["lensAtKey"] = $4d6af78a1b90130a$export$fc68a3bfc89f0b98;
$4d6af78a1b90130a$exports["atReadonlyRecord"] = $4d6af78a1b90130a$export$ba8573d258bae607;
$4d6af78a1b90130a$exports["prismSet"] = $4d6af78a1b90130a$export$97725fa315d6412c;
$4d6af78a1b90130a$exports["prismAsTraversal"] = $4d6af78a1b90130a$export$18564f4597667b6a;
$4d6af78a1b90130a$exports["prismModifyOption"] = $4d6af78a1b90130a$export$ddb3ff54eaa1c530;
$4d6af78a1b90130a$exports["prismModify"] = $4d6af78a1b90130a$export$f545e0bcbe4b5ea7;
$4d6af78a1b90130a$exports["prismComposeLens"] = $4d6af78a1b90130a$export$dad01448ef670850;
$4d6af78a1b90130a$exports["prismFromNullable"] = $4d6af78a1b90130a$export$258cc98aa6d7d21b;
$4d6af78a1b90130a$exports["prismFromPredicate"] = $4d6af78a1b90130a$export$8f316a2f03469694;
$4d6af78a1b90130a$exports["prismSome"] = $4d6af78a1b90130a$export$782e8b2fe031f968;
$4d6af78a1b90130a$exports["prismRight"] = $4d6af78a1b90130a$export$929e170fdd93186c;
$4d6af78a1b90130a$exports["prismLeft"] = $4d6af78a1b90130a$export$97ae81cf28b21f26;
$4d6af78a1b90130a$exports["optionalAsTraversal"] = $4d6af78a1b90130a$export$a595a5197cc37264;
$4d6af78a1b90130a$exports["optionalModifyOption"] = $4d6af78a1b90130a$export$48aae8aebe6d3ee9;
$4d6af78a1b90130a$exports["optionalModify"] = $4d6af78a1b90130a$export$6d575f282c3c1d48;
$4d6af78a1b90130a$exports["optionalIndex"] = $4d6af78a1b90130a$export$47ac94aa95300c6f;
$4d6af78a1b90130a$exports["indexReadonlyArray"] = $4d6af78a1b90130a$export$bb0c054375ca4b0;
$4d6af78a1b90130a$exports["optionalIndexNonEmpty"] = $4d6af78a1b90130a$export$83e62439a4d30c4c;
$4d6af78a1b90130a$exports["indexReadonlyNonEmptyArray"] = $4d6af78a1b90130a$export$165af7b747e6b1f1;
$4d6af78a1b90130a$exports["optionalKey"] = $4d6af78a1b90130a$export$a6c26e1663200bf4;
$4d6af78a1b90130a$exports["indexReadonlyRecord"] = $4d6af78a1b90130a$export$3c3468aec3b83bbf;
$4d6af78a1b90130a$exports["optionalFindFirst"] = $4d6af78a1b90130a$export$220673392b48821b;
$4d6af78a1b90130a$exports["optionalFindFirstNonEmpty"] = $4d6af78a1b90130a$export$cf29cfc68de9a659;
$4d6af78a1b90130a$exports["traversalComposeTraversal"] = $4d6af78a1b90130a$export$2c68ab81171b083f;
$4d6af78a1b90130a$exports["ApplicativeIdentity"] = $4d6af78a1b90130a$export$7c4912ca011fa00e;
$4d6af78a1b90130a$exports["fromTraversable"] = $4d6af78a1b90130a$export$126b5a87c58d3f9c;
$4d6af78a1b90130a$exports["traversalTraverse"] = $4d6af78a1b90130a$export$35db6fcbd934c57;
$4d6af78a1b90130a$exports["index"] = $4d6af78a1b90130a$export$b610b8812bbcded9;
$4d6af78a1b90130a$exports["at"] = $4d6af78a1b90130a$export$493d36ec626b6698;


var $d64c9e8784d5648b$export$493d36ec626b6698 = $4d6af78a1b90130a$export$493d36ec626b6698;
var $d64c9e8784d5648b$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $d64c9e8784d5648b$export$493d36ec626b6698(function(i) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(iso, $4d6af78a1b90130a$export$d001ee9513dee7c1, $4d6af78a1b90130a$export$62d1b5266563d2b6(sia.at(i)));
        });
    };
};
var $d64c9e8784d5648b$export$ba8573d258bae607 = $4d6af78a1b90130a$export$ba8573d258bae607;
var $d64c9e8784d5648b$export$3d6583cb45ca961e = function(E) {
    var lookupE = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
    var deleteAtE = $c6a8e3db2bad0039$export$90f9093465da3136(E);
    var insertAtE = $c6a8e3db2bad0039$export$9f200c4466975173(E);
    return function() {
        return $d64c9e8784d5648b$export$493d36ec626b6698(function(key) {
            return $4d6af78a1b90130a$export$21cde5187c2605a3(function(s) {
                return lookupE(key, s);
            }, $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                return deleteAtE(key);
            }, function(a) {
                return insertAtE(key, a);
            }));
        });
    };
};
var $d64c9e8784d5648b$export$388a7d8e51ea972f = function(E) {
    var elemE = $ce91c0a3783db19e$export$5bf96401662340b7(E);
    var insertE = $ce91c0a3783db19e$export$21a5ca8aa77d35ff(E);
    var removeE = $ce91c0a3783db19e$export$cd7f480d6b8286c3(E);
    return $d64c9e8784d5648b$export$493d36ec626b6698(function(a) {
        var insert = insertE(a);
        var remove = removeE(a);
        return $4d6af78a1b90130a$export$21cde5187c2605a3(function(s) {
            return elemE(a, s);
        }, function(b) {
            return function(s) {
                return b ? insert(s) : remove(s);
            };
        });
    });
};
var $d64c9e8784d5648b$export$1cfc761eca4929a9 = $4d6af78a1b90130a$export$ba8573d258bae607;





var $a97fa24f64672e8e$export$1aba8f741a0eae06 = $4d6af78a1b90130a$exports.iso;
var $a97fa24f64672e8e$export$d560c7e4a29451c2 = function() {
    return $a97fa24f64672e8e$export$1aba8f741a0eae06((0, $195a10ed7200bcca$export$f0954fd7d5368655), (0, $195a10ed7200bcca$export$f0954fd7d5368655));
};
var $a97fa24f64672e8e$export$ba6dbfc52e933ec = $4d6af78a1b90130a$exports.isoAsLens;
var $a97fa24f64672e8e$export$6963d4cf5712e556 = $4d6af78a1b90130a$exports.isoAsPrism;
var $a97fa24f64672e8e$export$81a625dd455a09de = $4d6af78a1b90130a$exports.isoAsOptional;
var $a97fa24f64672e8e$export$ef38eac73d6f828f = $4d6af78a1b90130a$exports.isoAsTraversal;
var $a97fa24f64672e8e$export$f672e0b6f7222cd7 = function(ab) {
    return function(sa) {
        return $a97fa24f64672e8e$export$1aba8f741a0eae06((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(sa.get, ab.get), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ab.reverseGet, sa.reverseGet));
    };
};
var $a97fa24f64672e8e$export$220ad92d18dabdd7 = $a97fa24f64672e8e$export$f672e0b6f7222cd7;
var $a97fa24f64672e8e$export$f5c3e419c6a355ce = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ba6dbfc52e933ec, $4d6af78a1b90130a$exports.lensComposeLens(ab));
};
var $a97fa24f64672e8e$export$c1dc05e399870f6 = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$6963d4cf5712e556, $4d6af78a1b90130a$exports.prismComposePrism(ab));
};
var $a97fa24f64672e8e$export$323f76c400675c8b = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalComposeOptional(ab));
};
var $a97fa24f64672e8e$export$aa978f69e007229f = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ef38eac73d6f828f, $4d6af78a1b90130a$exports.traversalComposeTraversal(ab));
};
var $a97fa24f64672e8e$export$66c1ae025e96b4bc = function(sa) {
    return $a97fa24f64672e8e$export$1aba8f741a0eae06(sa.reverseGet, sa.get);
};
var $a97fa24f64672e8e$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            return sa.reverseGet(f(sa.get(s)));
        };
    };
};
function $a97fa24f64672e8e$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.get(s), f, function(fa) {
                    return F.map(fa, sa.reverseGet);
                });
            };
        };
    };
}
var $a97fa24f64672e8e$export$b601f49376b4621a = function(sa) {
    return $a97fa24f64672e8e$export$c1dc05e399870f6($4d6af78a1b90130a$exports.prismFromNullable())(sa);
};
function $a97fa24f64672e8e$export$3dea766d36a8935f(predicate) {
    return $a97fa24f64672e8e$export$c1dc05e399870f6($4d6af78a1b90130a$exports.prismFromPredicate(predicate));
}
var $a97fa24f64672e8e$export$977f3f6a9323c0f6 = function(prop) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ba6dbfc52e933ec, $4d6af78a1b90130a$exports.lensProp(prop));
};
var $a97fa24f64672e8e$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ba6dbfc52e933ec, $4d6af78a1b90130a$exports.lensProps.apply($4d6af78a1b90130a$exports, props));
};
var $a97fa24f64672e8e$export$d8556a2a8f973135 = function(prop) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ba6dbfc52e933ec, $4d6af78a1b90130a$exports.lensComponent(prop));
};
var $a97fa24f64672e8e$export$b610b8812bbcded9 = function(i) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalIndex(i));
};
var $a97fa24f64672e8e$export$84162b00c25b711c = function(i) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalIndexNonEmpty(i));
};
var $a97fa24f64672e8e$export$df61b30b684217c0 = function(key) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalKey(key));
};
var $a97fa24f64672e8e$export$976574c443b9185b = function(key) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ba6dbfc52e933ec, $4d6af78a1b90130a$exports.lensAtKey(key));
};
var $a97fa24f64672e8e$export$ad14ef4001db2bcd = /*#__PURE__*/ $a97fa24f64672e8e$export$c1dc05e399870f6(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismSome());
var $a97fa24f64672e8e$export$79ffe56a765070d2 = /*#__PURE__*/ $a97fa24f64672e8e$export$c1dc05e399870f6(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismRight());
var $a97fa24f64672e8e$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $a97fa24f64672e8e$export$c1dc05e399870f6(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismLeft());
function $a97fa24f64672e8e$export$df3f009e3d155b20(T) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($a97fa24f64672e8e$export$ef38eac73d6f828f, $4d6af78a1b90130a$exports.traversalTraverse(T));
}
function $a97fa24f64672e8e$export$9a2f228bed5035c2(predicate) {
    return $a97fa24f64672e8e$export$323f76c400675c8b($4d6af78a1b90130a$exports.optionalFindFirst(predicate));
}
function $a97fa24f64672e8e$export$28e1f787311e0a21(predicate) {
    return $a97fa24f64672e8e$export$323f76c400675c8b($4d6af78a1b90130a$exports.optionalFindFirstNonEmpty(predicate));
}
var $a97fa24f64672e8e$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $a97fa24f64672e8e$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $a97fa24f64672e8e$var$imap_ = function(ea, ab, ba) {
    return $a97fa24f64672e8e$export$1aba8f741a0eae06((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ea.get, ab), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ba, ea.reverseGet));
};
var $a97fa24f64672e8e$export$9156e739aa33e19f = 'monocle-ts/Iso';
var $a97fa24f64672e8e$export$dbdf692cc5737cfd = {
    URI: $a97fa24f64672e8e$export$9156e739aa33e19f,
    imap: $a97fa24f64672e8e$var$imap_
};
var $a97fa24f64672e8e$export$67666a3fb7d250d8 = {
    URI: $a97fa24f64672e8e$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $a97fa24f64672e8e$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $a97fa24f64672e8e$export$3a8840c5b2ecf003 = {
    URI: $a97fa24f64672e8e$export$9156e739aa33e19f,
    compose: $a97fa24f64672e8e$export$67666a3fb7d250d8.compose,
    id: $a97fa24f64672e8e$export$d560c7e4a29451c2
};


/**
 * **This module is experimental**
 *
 * Experimental features are published in order to get early feedback from the community.
 *
 * A feature tagged as _Experimental_ is in a high state of flux, you're at risk of it changing without notice.
 *
 * @since 2.3.0
 */ 



var $6e81345a850ee8a7$export$b610b8812bbcded9 = $4d6af78a1b90130a$export$b610b8812bbcded9;
var $6e81345a850ee8a7$export$c4dd3e639c7af330 = function(at) {
    return $6e81345a850ee8a7$export$b610b8812bbcded9(function(i) {
        return $4d6af78a1b90130a$export$ffffe1ca21811d93($4d6af78a1b90130a$export$782e8b2fe031f968())(at.at(i));
    });
};
var $6e81345a850ee8a7$export$3160d47a1ad63980 = function(iso) {
    return function(sia) {
        return $6e81345a850ee8a7$export$b610b8812bbcded9(function(i) {
            return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(iso, $4d6af78a1b90130a$export$4d3db894cf45abd5, $4d6af78a1b90130a$export$8e08893559c32e38(sia.index(i)));
        });
    };
};
var $6e81345a850ee8a7$export$bb0c054375ca4b0 = $4d6af78a1b90130a$export$bb0c054375ca4b0;
var $6e81345a850ee8a7$export$165af7b747e6b1f1 = $4d6af78a1b90130a$export$165af7b747e6b1f1;
var $6e81345a850ee8a7$export$3c3468aec3b83bbf = $4d6af78a1b90130a$export$3c3468aec3b83bbf;
var $6e81345a850ee8a7$export$92da200d6ddb6846 = function(E) {
    var lookupE = $c6a8e3db2bad0039$export$dfc7155ac0343b8(E);
    var insertAtE = $c6a8e3db2bad0039$export$9f200c4466975173(E);
    return function() {
        return $6e81345a850ee8a7$export$b610b8812bbcded9(function(key) {
            return $4d6af78a1b90130a$export$516e28dec6a4b6d4(function(s) {
                return lookupE(key, s);
            }, function(next) {
                var insert = insertAtE(key, next);
                return function(s) {
                    return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(lookupE(key, s), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                        return s;
                    }, function(prev) {
                        return next === prev ? s : insert(s);
                    }));
                };
            });
        });
    };
};
var $6e81345a850ee8a7$export$2cd1c249765cd0a4 = $4d6af78a1b90130a$export$bb0c054375ca4b0;
var $6e81345a850ee8a7$export$720226bf1ef46cb2 = $4d6af78a1b90130a$export$3c3468aec3b83bbf;


var $9066168b32797695$exports = {};



var $9066168b32797695$export$21cde5187c2605a3 = $4d6af78a1b90130a$export$21cde5187c2605a3;
var $9066168b32797695$export$d560c7e4a29451c2 = $4d6af78a1b90130a$export$a4b03755c6673298;
var $9066168b32797695$export$81a625dd455a09de = $4d6af78a1b90130a$export$bae94c671b4dc75d;
var $9066168b32797695$export$ef38eac73d6f828f = $4d6af78a1b90130a$export$e5de01c31c85830c;
var $9066168b32797695$export$f672e0b6f7222cd7 = $4d6af78a1b90130a$export$62d1b5266563d2b6;
var $9066168b32797695$export$f5c3e419c6a355ce = $9066168b32797695$export$f672e0b6f7222cd7;
var $9066168b32797695$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$export$d001ee9513dee7c1, $9066168b32797695$export$f672e0b6f7222cd7);
var $9066168b32797695$export$c1dc05e399870f6 = $4d6af78a1b90130a$export$ffffe1ca21811d93;
var $9066168b32797695$export$323f76c400675c8b = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($9066168b32797695$export$81a625dd455a09de, $4d6af78a1b90130a$export$8e08893559c32e38(ab));
};
var $9066168b32797695$export$aa978f69e007229f = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($9066168b32797695$export$ef38eac73d6f828f, $4d6af78a1b90130a$export$2c68ab81171b083f(ab));
};
var $9066168b32797695$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return function(s) {
            var o = sa.get(s);
            var n = f(o);
            return o === n ? s : sa.set(n)(s);
        };
    };
};
function $9066168b32797695$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.get(s), f, function(fa) {
                    return F.map(fa, function(a) {
                        return sa.set(a)(s);
                    });
                });
            };
        };
    };
}
var $9066168b32797695$export$b601f49376b4621a = function(sa) {
    return $9066168b32797695$export$c1dc05e399870f6($4d6af78a1b90130a$export$258cc98aa6d7d21b())(sa);
};
function $9066168b32797695$export$3dea766d36a8935f(predicate) {
    return $9066168b32797695$export$c1dc05e399870f6($4d6af78a1b90130a$export$8f316a2f03469694(predicate));
}
var $9066168b32797695$export$977f3f6a9323c0f6 = $4d6af78a1b90130a$export$a6ba95b157529836;
var $9066168b32797695$export$8128bb6492cf3de7 = $4d6af78a1b90130a$export$c19575454e66bf5f;
var $9066168b32797695$export$d8556a2a8f973135 = $4d6af78a1b90130a$export$103f2a6258fae742;
var $9066168b32797695$export$b610b8812bbcded9 = function(i) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($9066168b32797695$export$81a625dd455a09de, $4d6af78a1b90130a$export$47ac94aa95300c6f(i));
};
var $9066168b32797695$export$84162b00c25b711c = function(i) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($9066168b32797695$export$81a625dd455a09de, $4d6af78a1b90130a$export$83e62439a4d30c4c(i));
};
var $9066168b32797695$export$df61b30b684217c0 = function(key) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($9066168b32797695$export$81a625dd455a09de, $4d6af78a1b90130a$export$a6c26e1663200bf4(key));
};
var $9066168b32797695$export$976574c443b9185b = $4d6af78a1b90130a$export$fc68a3bfc89f0b98;
var $9066168b32797695$export$ad14ef4001db2bcd = /*#__PURE__*/ $9066168b32797695$export$c1dc05e399870f6(/*#__PURE__*/ $4d6af78a1b90130a$export$782e8b2fe031f968());
var $9066168b32797695$export$79ffe56a765070d2 = /*#__PURE__*/ $9066168b32797695$export$c1dc05e399870f6(/*#__PURE__*/ $4d6af78a1b90130a$export$929e170fdd93186c());
var $9066168b32797695$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $9066168b32797695$export$c1dc05e399870f6(/*#__PURE__*/ $4d6af78a1b90130a$export$97ae81cf28b21f26());
function $9066168b32797695$export$df3f009e3d155b20(T) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($9066168b32797695$export$ef38eac73d6f828f, $4d6af78a1b90130a$export$35db6fcbd934c57(T));
}
function $9066168b32797695$export$9a2f228bed5035c2(predicate) {
    return $9066168b32797695$export$323f76c400675c8b($4d6af78a1b90130a$export$220673392b48821b(predicate));
}
function $9066168b32797695$export$28e1f787311e0a21(predicate) {
    return $9066168b32797695$export$323f76c400675c8b($4d6af78a1b90130a$export$cf29cfc68de9a659(predicate));
}
var $9066168b32797695$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $9066168b32797695$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $9066168b32797695$var$imap_ = function(ea, ab, ba) {
    return $9066168b32797695$export$21cde5187c2605a3((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ea.get, ab), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ba, ea.set));
};
var $9066168b32797695$export$9156e739aa33e19f = 'monocle-ts/Lens';
var $9066168b32797695$export$dbdf692cc5737cfd = {
    URI: $9066168b32797695$export$9156e739aa33e19f,
    imap: $9066168b32797695$var$imap_
};
var $9066168b32797695$export$67666a3fb7d250d8 = {
    URI: $9066168b32797695$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $9066168b32797695$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $9066168b32797695$export$3a8840c5b2ecf003 = {
    URI: $9066168b32797695$export$9156e739aa33e19f,
    compose: $9066168b32797695$export$67666a3fb7d250d8.compose,
    id: $9066168b32797695$export$d560c7e4a29451c2
};
$9066168b32797695$exports["lens"] = $9066168b32797695$export$21cde5187c2605a3;
$9066168b32797695$exports["id"] = $9066168b32797695$export$d560c7e4a29451c2;
$9066168b32797695$exports["asOptional"] = $9066168b32797695$export$81a625dd455a09de;
$9066168b32797695$exports["asTraversal"] = $9066168b32797695$export$ef38eac73d6f828f;
$9066168b32797695$exports["compose"] = $9066168b32797695$export$f672e0b6f7222cd7;
$9066168b32797695$exports["composeLens"] = $9066168b32797695$export$f5c3e419c6a355ce;
$9066168b32797695$exports["composeIso"] = $9066168b32797695$export$220ad92d18dabdd7;
$9066168b32797695$exports["composePrism"] = $9066168b32797695$export$c1dc05e399870f6;
$9066168b32797695$exports["composeOptional"] = $9066168b32797695$export$323f76c400675c8b;
$9066168b32797695$exports["composeTraversal"] = $9066168b32797695$export$aa978f69e007229f;
$9066168b32797695$exports["modify"] = $9066168b32797695$export$3ff57735a52b8713;
$9066168b32797695$exports["modifyF"] = $9066168b32797695$export$a28005d3e6beb9a6;
$9066168b32797695$exports["fromNullable"] = $9066168b32797695$export$b601f49376b4621a;
$9066168b32797695$exports["filter"] = $9066168b32797695$export$3dea766d36a8935f;
$9066168b32797695$exports["prop"] = $9066168b32797695$export$977f3f6a9323c0f6;
$9066168b32797695$exports["props"] = $9066168b32797695$export$8128bb6492cf3de7;
$9066168b32797695$exports["component"] = $9066168b32797695$export$d8556a2a8f973135;
$9066168b32797695$exports["index"] = $9066168b32797695$export$b610b8812bbcded9;
$9066168b32797695$exports["indexNonEmpty"] = $9066168b32797695$export$84162b00c25b711c;
$9066168b32797695$exports["key"] = $9066168b32797695$export$df61b30b684217c0;
$9066168b32797695$exports["atKey"] = $9066168b32797695$export$976574c443b9185b;
$9066168b32797695$exports["some"] = $9066168b32797695$export$ad14ef4001db2bcd;
$9066168b32797695$exports["right"] = $9066168b32797695$export$79ffe56a765070d2;
$9066168b32797695$exports["left"] = $9066168b32797695$export$eabcd2c8791e7bf4;
$9066168b32797695$exports["traverse"] = $9066168b32797695$export$df3f009e3d155b20;
$9066168b32797695$exports["findFirst"] = $9066168b32797695$export$9a2f228bed5035c2;
$9066168b32797695$exports["findFirstNonEmpty"] = $9066168b32797695$export$28e1f787311e0a21;
$9066168b32797695$exports["imap"] = $9066168b32797695$export$b2517b0ab3a58435;
$9066168b32797695$exports["URI"] = $9066168b32797695$export$9156e739aa33e19f;
$9066168b32797695$exports["Invariant"] = $9066168b32797695$export$dbdf692cc5737cfd;
$9066168b32797695$exports["Semigroupoid"] = $9066168b32797695$export$67666a3fb7d250d8;
$9066168b32797695$exports["Category"] = $9066168b32797695$export$3a8840c5b2ecf003;






var $6ee048ed19e5d55a$export$516e28dec6a4b6d4 = $4d6af78a1b90130a$exports.optional;
var $6ee048ed19e5d55a$export$d560c7e4a29451c2 = function() {
    return $6ee048ed19e5d55a$export$516e28dec6a4b6d4($52d3945e22e86057$export$ad14ef4001db2bcd, (0, $195a10ed7200bcca$export$c983f826f44ff86));
};
var $6ee048ed19e5d55a$export$ef38eac73d6f828f = $4d6af78a1b90130a$exports.optionalAsTraversal;
var $6ee048ed19e5d55a$export$f672e0b6f7222cd7 = $4d6af78a1b90130a$exports.optionalComposeOptional;
var $6ee048ed19e5d55a$export$323f76c400675c8b = $6ee048ed19e5d55a$export$f672e0b6f7222cd7;
var $6ee048ed19e5d55a$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.isoAsOptional, $6ee048ed19e5d55a$export$f672e0b6f7222cd7);
var $6ee048ed19e5d55a$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.lensAsOptional, $4d6af78a1b90130a$exports.optionalComposeOptional);
var $6ee048ed19e5d55a$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.prismAsOptional, $4d6af78a1b90130a$exports.optionalComposeOptional);
var $6ee048ed19e5d55a$export$aa978f69e007229f = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($6ee048ed19e5d55a$export$ef38eac73d6f828f, $4d6af78a1b90130a$exports.traversalComposeTraversal(ab));
};
var $6ee048ed19e5d55a$export$a2ef9d652875bdfa = $4d6af78a1b90130a$exports.optionalModifyOption;
var $6ee048ed19e5d55a$export$b2a7969df3fe0aa3 = function(a) {
    return $6ee048ed19e5d55a$export$a2ef9d652875bdfa(function() {
        return a;
    });
};
var $6ee048ed19e5d55a$export$3ff57735a52b8713 = $4d6af78a1b90130a$exports.optionalModify;
function $6ee048ed19e5d55a$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.getOption(s), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), function(a) {
                        return sa.set(a)(s);
                    });
                }));
            };
        };
    };
}
var $6ee048ed19e5d55a$export$b601f49376b4621a = /*#__PURE__*/ $6ee048ed19e5d55a$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsOptional(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismFromNullable()));
function $6ee048ed19e5d55a$export$3dea766d36a8935f(predicate) {
    return $6ee048ed19e5d55a$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.prismAsOptional($4d6af78a1b90130a$exports.prismFromPredicate(predicate)));
}
var $6ee048ed19e5d55a$export$977f3f6a9323c0f6 = function(prop) {
    return $6ee048ed19e5d55a$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensProp(prop), $4d6af78a1b90130a$exports.lensAsOptional));
};
var $6ee048ed19e5d55a$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $6ee048ed19e5d55a$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensProps.apply($4d6af78a1b90130a$exports, props), $4d6af78a1b90130a$exports.lensAsOptional));
};
var $6ee048ed19e5d55a$export$d8556a2a8f973135 = function(prop) {
    return $6ee048ed19e5d55a$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensComponent(prop), $4d6af78a1b90130a$exports.lensAsOptional));
};
var $6ee048ed19e5d55a$export$b610b8812bbcded9 = $4d6af78a1b90130a$exports.optionalIndex;
var $6ee048ed19e5d55a$export$84162b00c25b711c = $4d6af78a1b90130a$exports.optionalIndexNonEmpty;
var $6ee048ed19e5d55a$export$df61b30b684217c0 = $4d6af78a1b90130a$exports.optionalKey;
var $6ee048ed19e5d55a$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $6ee048ed19e5d55a$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.lensAsOptional($4d6af78a1b90130a$exports.atReadonlyRecord().at(key))));
    };
};
var $6ee048ed19e5d55a$export$ad14ef4001db2bcd = /*#__PURE__*/ $6ee048ed19e5d55a$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsOptional(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismSome()));
var $6ee048ed19e5d55a$export$79ffe56a765070d2 = /*#__PURE__*/ $6ee048ed19e5d55a$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsOptional(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismRight()));
var $6ee048ed19e5d55a$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $6ee048ed19e5d55a$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsOptional(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismLeft()));
function $6ee048ed19e5d55a$export$df3f009e3d155b20(T) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($6ee048ed19e5d55a$export$ef38eac73d6f828f, $4d6af78a1b90130a$exports.traversalTraverse(T));
}
function $6ee048ed19e5d55a$export$9a2f228bed5035c2(predicate) {
    return $6ee048ed19e5d55a$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.optionalFindFirst(predicate));
}
function $6ee048ed19e5d55a$export$28e1f787311e0a21(predicate) {
    return $6ee048ed19e5d55a$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.optionalFindFirstNonEmpty(predicate));
}
var $6ee048ed19e5d55a$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $6ee048ed19e5d55a$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $6ee048ed19e5d55a$var$imap_ = function(ea, ab, ba) {
    return $6ee048ed19e5d55a$export$516e28dec6a4b6d4((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ea.getOption, $52d3945e22e86057$export$871de8747c9eaa88(ab)), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ba, ea.set));
};
var $6ee048ed19e5d55a$export$9156e739aa33e19f = 'monocle-ts/Optional';
var $6ee048ed19e5d55a$export$dbdf692cc5737cfd = {
    URI: $6ee048ed19e5d55a$export$9156e739aa33e19f,
    imap: $6ee048ed19e5d55a$var$imap_
};
var $6ee048ed19e5d55a$export$67666a3fb7d250d8 = {
    URI: $6ee048ed19e5d55a$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $6ee048ed19e5d55a$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $6ee048ed19e5d55a$export$3a8840c5b2ecf003 = {
    URI: $6ee048ed19e5d55a$export$9156e739aa33e19f,
    compose: $6ee048ed19e5d55a$export$67666a3fb7d250d8.compose,
    id: $6ee048ed19e5d55a$export$d560c7e4a29451c2
};






var $19e144429a70bac9$export$e469dcfea9910464 = $4d6af78a1b90130a$exports.prism;
var $19e144429a70bac9$export$d560c7e4a29451c2 = function() {
    return $19e144429a70bac9$export$e469dcfea9910464($52d3945e22e86057$export$ad14ef4001db2bcd, (0, $195a10ed7200bcca$export$f0954fd7d5368655));
};
var $19e144429a70bac9$export$23f31c55d7162b91 = $4d6af78a1b90130a$exports.prismFromPredicate;
var $19e144429a70bac9$export$81a625dd455a09de = $4d6af78a1b90130a$exports.prismAsOptional;
var $19e144429a70bac9$export$ef38eac73d6f828f = $4d6af78a1b90130a$exports.prismAsTraversal;
var $19e144429a70bac9$export$f672e0b6f7222cd7 = $4d6af78a1b90130a$exports.prismComposePrism;
var $19e144429a70bac9$export$c1dc05e399870f6 = $19e144429a70bac9$export$f672e0b6f7222cd7;
var $19e144429a70bac9$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.isoAsPrism, $19e144429a70bac9$export$f672e0b6f7222cd7);
var $19e144429a70bac9$export$f5c3e419c6a355ce = $4d6af78a1b90130a$exports.prismComposeLens;
var $19e144429a70bac9$export$323f76c400675c8b = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($19e144429a70bac9$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalComposeOptional(ab));
};
var $19e144429a70bac9$export$aa978f69e007229f = function(ab) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($19e144429a70bac9$export$ef38eac73d6f828f, $4d6af78a1b90130a$exports.traversalComposeTraversal(ab));
};
var $19e144429a70bac9$export$adaa4cf7ef1b65be = $4d6af78a1b90130a$exports.prismSet;
var $19e144429a70bac9$export$a2ef9d652875bdfa = $4d6af78a1b90130a$exports.prismModifyOption;
var $19e144429a70bac9$export$3ff57735a52b8713 = $4d6af78a1b90130a$exports.prismModify;
function $19e144429a70bac9$export$a28005d3e6beb9a6(F) {
    return function(f) {
        return function(sa) {
            return function(s) {
                return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa.getOption(s), $52d3945e22e86057$export$93e2b83da34ff82a(function() {
                    return F.of(s);
                }, function(a) {
                    return F.map(f(a), sa.reverseGet);
                }));
            };
        };
    };
}
var $19e144429a70bac9$export$b601f49376b4621a = /*#__PURE__*/ $19e144429a70bac9$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismFromNullable());
function $19e144429a70bac9$export$3dea766d36a8935f(predicate) {
    return $19e144429a70bac9$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.prismFromPredicate(predicate));
}
var $19e144429a70bac9$export$977f3f6a9323c0f6 = function(prop) {
    return $19e144429a70bac9$export$f5c3e419c6a355ce((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensProp(prop)));
}; // TODO: simplify?
var $19e144429a70bac9$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $19e144429a70bac9$export$f5c3e419c6a355ce((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensProps.apply($4d6af78a1b90130a$exports, props)));
};
var $19e144429a70bac9$export$d8556a2a8f973135 = function(prop) {
    return $19e144429a70bac9$export$f5c3e419c6a355ce((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensComponent(prop)));
};
var $19e144429a70bac9$export$b610b8812bbcded9 = function(i) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($19e144429a70bac9$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalIndex(i));
};
var $19e144429a70bac9$export$84162b00c25b711c = function(i) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($19e144429a70bac9$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalIndexNonEmpty(i));
};
var $19e144429a70bac9$export$df61b30b684217c0 = function(key) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($19e144429a70bac9$export$81a625dd455a09de, $4d6af78a1b90130a$exports.optionalKey(key));
};
var $19e144429a70bac9$export$976574c443b9185b = function(key) {
    return function(sa) {
        return $4d6af78a1b90130a$exports.prismComposeLens($4d6af78a1b90130a$exports.atReadonlyRecord().at(key))(sa);
    };
};
var $19e144429a70bac9$export$ad14ef4001db2bcd = /*#__PURE__*/ $19e144429a70bac9$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismSome());
var $19e144429a70bac9$export$79ffe56a765070d2 = /*#__PURE__*/ $19e144429a70bac9$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismRight());
var $19e144429a70bac9$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $19e144429a70bac9$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismLeft());
function $19e144429a70bac9$export$df3f009e3d155b20(T) {
    return (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($19e144429a70bac9$export$ef38eac73d6f828f, $4d6af78a1b90130a$exports.traversalTraverse(T));
}
function $19e144429a70bac9$export$9a2f228bed5035c2(predicate) {
    return $19e144429a70bac9$export$323f76c400675c8b($4d6af78a1b90130a$exports.optionalFindFirst(predicate));
}
function $19e144429a70bac9$export$28e1f787311e0a21(predicate) {
    return $19e144429a70bac9$export$323f76c400675c8b($4d6af78a1b90130a$exports.optionalFindFirstNonEmpty(predicate));
}
var $19e144429a70bac9$export$b2517b0ab3a58435 = function(f, g) {
    return function(ea) {
        return $19e144429a70bac9$var$imap_(ea, f, g);
    };
};
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
var $19e144429a70bac9$var$imap_ = function(ea, ab, ba) {
    return $19e144429a70bac9$export$e469dcfea9910464((0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ea.getOption, $52d3945e22e86057$export$871de8747c9eaa88(ab)), (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)(ba, ea.reverseGet));
};
var $19e144429a70bac9$export$9156e739aa33e19f = 'monocle-ts/Prism';
var $19e144429a70bac9$export$dbdf692cc5737cfd = {
    URI: $19e144429a70bac9$export$9156e739aa33e19f,
    imap: $19e144429a70bac9$var$imap_
};
var $19e144429a70bac9$export$67666a3fb7d250d8 = {
    URI: $19e144429a70bac9$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $19e144429a70bac9$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $19e144429a70bac9$export$3a8840c5b2ecf003 = {
    URI: $19e144429a70bac9$export$9156e739aa33e19f,
    compose: $19e144429a70bac9$export$67666a3fb7d250d8.compose,
    id: $19e144429a70bac9$export$d560c7e4a29451c2
};







var $5b7de3caec026191$export$8666ce7a134c2314 = $4d6af78a1b90130a$exports.traversal;
var $5b7de3caec026191$export$d560c7e4a29451c2 = function() {
    return $5b7de3caec026191$export$8666ce7a134c2314(function(_) {
        return function(f) {
            return f;
        };
    });
};
var $5b7de3caec026191$export$126b5a87c58d3f9c = $4d6af78a1b90130a$exports.fromTraversable;
var $5b7de3caec026191$export$f672e0b6f7222cd7 = $4d6af78a1b90130a$exports.traversalComposeTraversal;
var $5b7de3caec026191$export$aa978f69e007229f = $5b7de3caec026191$export$f672e0b6f7222cd7;
var $5b7de3caec026191$export$220ad92d18dabdd7 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.isoAsTraversal, $5b7de3caec026191$export$f672e0b6f7222cd7);
var $5b7de3caec026191$export$f5c3e419c6a355ce = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.lensAsTraversal, $4d6af78a1b90130a$exports.traversalComposeTraversal);
var $5b7de3caec026191$export$c1dc05e399870f6 = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.prismAsTraversal, $4d6af78a1b90130a$exports.traversalComposeTraversal);
var $5b7de3caec026191$export$323f76c400675c8b = /*#__PURE__*/ (0, $195a10ed7200bcca$export$ccc7b0636abaffc3)($4d6af78a1b90130a$exports.optionalAsTraversal, $4d6af78a1b90130a$exports.traversalComposeTraversal);
var $5b7de3caec026191$export$3ff57735a52b8713 = function(f) {
    return function(sa) {
        return sa.modifyF($4d6af78a1b90130a$exports.ApplicativeIdentity)(f);
    };
};
var $5b7de3caec026191$export$adaa4cf7ef1b65be = function(a) {
    return $5b7de3caec026191$export$3ff57735a52b8713(function() {
        return a;
    });
};
var $5b7de3caec026191$export$b601f49376b4621a = function(sa) {
    return $5b7de3caec026191$export$c1dc05e399870f6($4d6af78a1b90130a$exports.prismFromNullable())(sa);
};
function $5b7de3caec026191$export$3dea766d36a8935f(predicate) {
    return $5b7de3caec026191$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.prismAsTraversal($4d6af78a1b90130a$exports.prismFromPredicate(predicate)));
}
var $5b7de3caec026191$export$977f3f6a9323c0f6 = function(prop) {
    return $5b7de3caec026191$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensProp(prop), $4d6af78a1b90130a$exports.lensAsTraversal));
};
var $5b7de3caec026191$export$8128bb6492cf3de7 = function() {
    var props = [];
    for(var _i = 0; _i < arguments.length; _i++)props[_i] = arguments[_i];
    return $5b7de3caec026191$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensProps.apply($4d6af78a1b90130a$exports, props), $4d6af78a1b90130a$exports.lensAsTraversal));
};
var $5b7de3caec026191$export$d8556a2a8f973135 = function(prop) {
    return $5b7de3caec026191$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($4d6af78a1b90130a$exports.lensId(), $4d6af78a1b90130a$exports.lensComponent(prop), $4d6af78a1b90130a$exports.lensAsTraversal));
};
var $5b7de3caec026191$export$b610b8812bbcded9 = function(i) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $5b7de3caec026191$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.optionalAsTraversal($4d6af78a1b90130a$exports.indexReadonlyArray().index(i))));
    };
};
var $5b7de3caec026191$export$84162b00c25b711c = function(i) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $5b7de3caec026191$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.optionalAsTraversal($4d6af78a1b90130a$exports.indexReadonlyNonEmptyArray().index(i))));
    };
};
var $5b7de3caec026191$export$df61b30b684217c0 = function(key) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $5b7de3caec026191$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.optionalAsTraversal($4d6af78a1b90130a$exports.indexReadonlyRecord().index(key))));
    };
};
var $5b7de3caec026191$export$976574c443b9185b = function(key) {
    return function(sa) {
        return (0, $943b7a1a0eab6ad7$export$a4627e546088548d)(sa, $5b7de3caec026191$export$f672e0b6f7222cd7($4d6af78a1b90130a$exports.lensAsTraversal($4d6af78a1b90130a$exports.atReadonlyRecord().at(key))));
    };
};
var $5b7de3caec026191$export$ad14ef4001db2bcd = /*#__PURE__*/ $5b7de3caec026191$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsTraversal(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismSome()));
var $5b7de3caec026191$export$79ffe56a765070d2 = /*#__PURE__*/ $5b7de3caec026191$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsTraversal(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismRight()));
var $5b7de3caec026191$export$eabcd2c8791e7bf4 = /*#__PURE__*/ $5b7de3caec026191$export$f672e0b6f7222cd7(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismAsTraversal(/*#__PURE__*/ $4d6af78a1b90130a$exports.prismLeft()));
var $5b7de3caec026191$export$df3f009e3d155b20 = $4d6af78a1b90130a$exports.traversalTraverse;
function $5b7de3caec026191$export$9a2f228bed5035c2(predicate) {
    return $5b7de3caec026191$export$323f76c400675c8b($4d6af78a1b90130a$exports.optionalFindFirst(predicate));
}
function $5b7de3caec026191$export$28e1f787311e0a21(predicate) {
    return $5b7de3caec026191$export$323f76c400675c8b($4d6af78a1b90130a$exports.optionalFindFirstNonEmpty(predicate));
}
var $5b7de3caec026191$export$b66cdc0497d8a99a = function(M) {
    return function(f) {
        return function(sa) {
            return sa.modifyF($1625efb126506723$export$1402880adb2295a7(M))(function(a) {
                return $1625efb126506723$export$dd44f18ab656f3bb(f(a));
            });
        };
    };
};
var $5b7de3caec026191$export$93e2b83da34ff82a = function(M) {
    return $5b7de3caec026191$export$b66cdc0497d8a99a(M)((0, $195a10ed7200bcca$export$f0954fd7d5368655));
};
var $5b7de3caec026191$export$2774c37398bee8b2 = function(s) {
    return function(sa) {
        return $5b7de3caec026191$export$b66cdc0497d8a99a($aa0d0a09044b87d4$export$c2a7ef2cc9b32b31())($aa0d0a09044b87d4$export$ba255e9e49e00608)(sa)(s);
    };
};
var $5b7de3caec026191$export$9156e739aa33e19f = 'monocle-ts/Traversal';
var $5b7de3caec026191$export$67666a3fb7d250d8 = {
    URI: $5b7de3caec026191$export$9156e739aa33e19f,
    compose: function(ab, ea) {
        return $5b7de3caec026191$export$f672e0b6f7222cd7(ab)(ea);
    }
};
var $5b7de3caec026191$export$3a8840c5b2ecf003 = {
    URI: $5b7de3caec026191$export$9156e739aa33e19f,
    compose: $5b7de3caec026191$export$67666a3fb7d250d8.compose,
    id: $5b7de3caec026191$export$d560c7e4a29451c2
};


//
// compat
//
var fromIso = function(iso) {
    return new Iso(iso.get, iso.reverseGet);
};
var fromLens = function(lens) {
    return new Lens(lens.get, lens.set);
};
var fromPrism = function(prism) {
    return new Prism(prism.getOption, prism.reverseGet);
};
var fromOptional = function(optional) {
    return new Optional(optional.getOption, optional.set);
};
var fromTraversal = function(traversal) {
    return new Traversal(traversal.modifyF);
};
var fromAt = function(at) {
    return new At(function(i) {
        return fromLens(at.at(i));
    });
};
var fromIndex = function(ix) {
    return new Index(function(i) {
        return fromOptional(ix.index(i));
    });
};
//
// old APIs
//
var update = function(o, k, a) {
    var _a;
    return a === o[k] ? o : Object.assign({}, o, (_a = {}, _a[k] = a, _a));
};
/**
 * Laws:
 * 1. `reverseGet(get(s)) = s`
 * 2. `get(reversetGet(a)) = a`
 *
 * @category constructor
 * @since 1.0.0
 */ var Iso = /** @class */ function() {
    function Iso(get, reverseGet) {
        this.get = get;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Iso';
        /**
         * @since 1.0.0
         */ this.unwrap = this.get;
        /**
         * @since 1.0.0
         */ this.to = this.get;
        /**
         * @since 1.0.0
         */ this.wrap = this.reverseGet;
        /**
         * @since 1.0.0
         */ this.from = this.reverseGet;
    }
    /**
     * reverse the `Iso`: the source becomes the target and the target becomes the source
     * @since 1.0.0
     */ Iso.prototype.reverse = function() {
        return fromIso($a97fa24f64672e8e$export$66c1ae025e96b4bc(this));
    };
    /**
     * @since 1.0.0
     */ Iso.prototype.modify = function(f) {
        return $a97fa24f64672e8e$export$3ff57735a52b8713(f)(this);
    };
    /**
     * view an `Iso` as a `Lens`
     *
     * @since 1.0.0
     */ Iso.prototype.asLens = function() {
        return fromLens($a97fa24f64672e8e$export$ba6dbfc52e933ec(this));
    };
    /**
     * view an `Iso` as a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.asPrism = function() {
        return fromPrism($a97fa24f64672e8e$export$6963d4cf5712e556(this));
    };
    /**
     * view an `Iso` as a `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.asOptional = function() {
        return fromOptional($a97fa24f64672e8e$export$81a625dd455a09de(this));
    };
    /**
     * view an `Iso` as a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.asTraversal = function() {
        return fromTraversal($a97fa24f64672e8e$export$ef38eac73d6f828f(this));
    };
    /**
     * view an `Iso` as a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * view an `Iso` as a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view an `Iso` as a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose an `Iso` with an `Iso`
     *
     * @since 1.0.0
     */ Iso.prototype.compose = function(ab) {
        return fromIso($a97fa24f64672e8e$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Iso.prototype.composeIso = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Iso` with a `Lens `
     *
     * @since 1.0.0
     */ Iso.prototype.composeLens = function(ab) {
        return fromLens((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $a97fa24f64672e8e$export$ba6dbfc52e933ec, $9066168b32797695$exports.compose(ab)));
    };
    /**
     * compose an `Iso` with a `Prism`
     *
     * @since 1.0.0
     */ Iso.prototype.composePrism = function(ab) {
        return fromPrism((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $a97fa24f64672e8e$export$6963d4cf5712e556, $19e144429a70bac9$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Iso` with an `Optional`
     *
     * @since 1.0.0
     */ Iso.prototype.composeOptional = function(ab) {
        return fromOptional((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $a97fa24f64672e8e$export$81a625dd455a09de, $6ee048ed19e5d55a$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Iso` with a `Traversal`
     *
     * @since 1.0.0
     */ Iso.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $a97fa24f64672e8e$export$ef38eac73d6f828f, $5b7de3caec026191$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Iso` with a `Fold`
     *
     * @since 1.0.0
     */ Iso.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Iso` with a `Getter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose an `Iso` with a `Setter`
     *
     * @since 1.0.0
     */ Iso.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    return Iso;
}();
/**
 * Laws:
 * 1. `get(set(a)(s)) = a`
 * 2. `set(get(s))(s) = s`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Lens = /** @class */ function() {
    function Lens(get, set) {
        this.get = get;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Lens';
    }
    /**
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     *   address: {
     *     city: string
     *   }
     * }
     *
     * const city = Lens.fromPath<Person>()(['address', 'city'])
     *
     * const person: Person = { name: 'Giulio', age: 43, address: { city: 'Milan' } }
     *
     * assert.strictEqual(city.get(person), 'Milan')
     * assert.deepStrictEqual(city.set('London')(person), { name: 'Giulio', age: 43, address: { city: 'London' } })
     *
     * @since 1.0.0
     */ Lens.fromPath = function() {
        var fromProp = Lens.fromProp();
        return function(path) {
            var lens = fromProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromProp(prop));
            }, lens);
        };
    };
    /**
     * Returns a `Lens` from a type and a prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * type Person = {
     *   name: string
     *   age: number
     * }
     *
     * const age = Lens.fromProp<Person>()('age')
     *
     * const person: Person = { name: 'Giulio', age: 43 }
     *
     * assert.strictEqual(age.get(person), 43)
     * assert.deepStrictEqual(age.set(44)(person), { name: 'Giulio', age: 44 })
     *
     * @since 1.0.0
     */ Lens.fromProp = function() {
        return function(prop) {
            return fromLens((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($9066168b32797695$exports.id(), $9066168b32797695$exports.prop(prop)));
        };
    };
    Lens.fromProps = function() {
        return function(props) {
            return fromLens((0, $943b7a1a0eab6ad7$export$a4627e546088548d)($9066168b32797695$exports.id(), $9066168b32797695$exports.props.apply($9066168b32797695$exports, props)));
        };
    };
    /**
     * Returns a `Lens` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Lens } from 'monocle-ts'
     *
     * interface Outer {
     *   inner?: Inner
     * }
     *
     * interface Inner {
     *   value: number
     *   foo: string
     * }
     *
     * const inner = Lens.fromNullableProp<Outer>()('inner', { value: 0, foo: 'foo' })
     * const value = Lens.fromProp<Inner>()('value')
     * const lens = inner.compose(value)
     *
     * assert.deepStrictEqual(lens.set(1)({}), { inner: { value: 1, foo: 'foo' } })
     * assert.strictEqual(lens.get({}), 0)
     * assert.deepStrictEqual(lens.set(1)({ inner: { value: 1, foo: 'bar' } }), { inner: { value: 1, foo: 'bar' } })
     * assert.strictEqual(lens.get({ inner: { value: 1, foo: 'bar' } }), 1)
     *
     * @since 1.0.0
     */ Lens.fromNullableProp = function() {
        return function(k, defaultValue) {
            return new Lens(function(s) {
                var osk = (0, $52d3945e22e86057$export$b601f49376b4621a)(s[k]);
                if ((0, $52d3945e22e86057$export$e56af863d5645d5f)(osk)) return defaultValue;
                else return osk.value;
            }, function(a) {
                return function(s) {
                    return update(s, k, a);
                };
            });
        };
    };
    /**
     * @since 1.0.0
     */ Lens.prototype.modify = function(f) {
        return $9066168b32797695$exports.modify(f)(this);
    };
    /**
     * view a `Lens` as a Optional
     *
     * @since 1.0.0
     */ Lens.prototype.asOptional = function() {
        return fromOptional($9066168b32797695$exports.asOptional(this));
    };
    /**
     * view a `Lens` as a `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.asTraversal = function() {
        return fromTraversal($9066168b32797695$exports.asTraversal(this));
    };
    /**
     * view a `Lens` as a `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Lens` as a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.asGetter = function() {
        var _this = this;
        return new Getter(function(s) {
            return _this.get(s);
        });
    };
    /**
     * view a `Lens` as a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Lens` with a `Lens`
     *
     * @since 1.0.0
     */ Lens.prototype.compose = function(ab) {
        return fromLens($9066168b32797695$exports.compose(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Lens.prototype.composeLens = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Lens` with a `Getter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeGetter = function(ab) {
        return this.asGetter().compose(ab);
    };
    /**
     * compose a `Lens` with a `Fold`
     *
     * @since 1.0.0
     */ Lens.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Lens` with an `Optional`
     *
     * @since 1.0.0
     */ Lens.prototype.composeOptional = function(ab) {
        return fromOptional((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $9066168b32797695$exports.asOptional, $6ee048ed19e5d55a$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Lens` with an `Traversal`
     *
     * @since 1.0.0
     */ Lens.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $9066168b32797695$exports.asTraversal, $5b7de3caec026191$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Lens` with an `Setter`
     *
     * @since 1.0.0
     */ Lens.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Lens` with an `Iso`
     *
     * @since 1.0.0
     */ Lens.prototype.composeIso = function(ab) {
        return fromLens((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $9066168b32797695$exports.compose((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $a97fa24f64672e8e$export$ba6dbfc52e933ec))));
    };
    /**
     * compose a `Lens` with a `Prism`
     *
     * @since 1.0.0
     */ Lens.prototype.composePrism = function(ab) {
        return fromOptional($9066168b32797695$exports.composePrism(ab)(this));
    };
    return Lens;
}();
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, reverseGet)) = s`
 * 2. `getOption(reverseGet(a)) = some(a)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Prism = /** @class */ function() {
    function Prism(getOption, reverseGet) {
        this.getOption = getOption;
        this.reverseGet = reverseGet;
        /**
         * @since 1.0.0
         */ this._tag = 'Prism';
    }
    Prism.fromPredicate = function(predicate) {
        return fromPrism($19e144429a70bac9$export$23f31c55d7162b91(predicate));
    };
    /**
     * @since 1.0.0
     */ Prism.some = function() {
        return somePrism;
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modify = function(f) {
        var _this = this;
        return function(s) {
            var os = _this.modifyOption(f)(s);
            if ((0, $52d3945e22e86057$export$e56af863d5645d5f)(os)) return s;
            else return os.value;
        };
    };
    /**
     * @since 1.0.0
     */ Prism.prototype.modifyOption = function(f) {
        var _this = this;
        return function(s) {
            return (0, $52d3945e22e86057$export$a75d1723e6bda2ec).map(_this.getOption(s), function(v) {
                var n = f(v);
                return n === v ? s : _this.reverseGet(n);
            });
        };
    };
    /**
     * set the target of a `Prism` with a value
     *
     * @since 1.0.0
     */ Prism.prototype.set = function(a) {
        return this.modify(function() {
            return a;
        });
    };
    /**
     * view a `Prism` as a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.asOptional = function() {
        return fromOptional($19e144429a70bac9$export$81a625dd455a09de(this));
    };
    /**
     * view a `Prism` as a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.asTraversal = function() {
        return fromTraversal($19e144429a70bac9$export$ef38eac73d6f828f(this));
    };
    /**
     * view a `Prism` as a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * view a `Prism` as a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $52d3945e22e86057$export$e56af863d5645d5f)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * compose a `Prism` with a `Prism`
     *
     * @since 1.0.0
     */ Prism.prototype.compose = function(ab) {
        return fromPrism($19e144429a70bac9$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Prism.prototype.composePrism = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Prism` with a `Optional`
     *
     * @since 1.0.0
     */ Prism.prototype.composeOptional = function(ab) {
        return fromOptional((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $19e144429a70bac9$export$81a625dd455a09de, $6ee048ed19e5d55a$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Prism` with a `Traversal`
     *
     * @since 1.0.0
     */ Prism.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $19e144429a70bac9$export$ef38eac73d6f828f, $5b7de3caec026191$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose a `Prism` with a `Fold`
     *
     * @since 1.0.0
     */ Prism.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Prism` with a `Setter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Prism` with a `Iso`
     *
     * @since 1.0.0
     */ Prism.prototype.composeIso = function(ab) {
        return fromPrism((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $19e144429a70bac9$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $a97fa24f64672e8e$export$6963d4cf5712e556))));
    };
    /**
     * compose a `Prism` with a `Lens`
     *
     * @since 1.0.0
     */ Prism.prototype.composeLens = function(ab) {
        return fromOptional($19e144429a70bac9$export$f5c3e419c6a355ce(ab)(this));
    };
    /**
     * compose a `Prism` with a `Getter`
     *
     * @since 1.0.0
     */ Prism.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Prism;
}();
var somePrism = /*#__PURE__*/ new Prism((0, $195a10ed7200bcca$export$f0954fd7d5368655), (0, $52d3945e22e86057$export$ad14ef4001db2bcd));
/**
 * Laws:
 * 1. `pipe(getOption(s), fold(() => s, a => set(a)(s))) = s`
 * 2. `getOption(set(a)(s)) = pipe(getOption(s), map(_ => a))`
 * 3. `set(a)(set(a)(s)) = set(a)(s)`
 *
 * @category constructor
 * @since 1.0.0
 */ var Optional = /** @class */ function() {
    function Optional(getOption, set) {
        this.getOption = getOption;
        this.set = set;
        /**
         * @since 1.0.0
         */ this._tag = 'Optional';
    }
    /**
     * Returns an `Optional` from a nullable (`A | null | undefined`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface Phone {
     *   number: string
     * }
     * interface Employment {
     *   phone?: Phone
     * }
     * interface Info {
     *   employment?: Employment
     * }
     * interface Response {
     *   info?: Info
     * }
     *
     * const numberFromResponse = Optional.fromPath<Response>()(['info', 'employment', 'phone', 'number'])
     *
     * const response1: Response = {
     *   info: {
     *     employment: {
     *       phone: {
     *         number: '555-1234'
     *       }
     *     }
     *   }
     * }
     * const response2: Response = {
     *   info: {
     *     employment: {}
     *   }
     * }
     *
     * numberFromResponse.getOption(response1) // some('555-1234')
     * numberFromResponse.getOption(response2) // none
     *
     * @since 2.1.0
     */ Optional.fromPath = function() {
        var fromNullableProp = Optional.fromNullableProp();
        return function(path) {
            var optional = fromNullableProp(path[0]);
            return path.slice(1).reduce(function(acc, prop) {
                return acc.compose(fromNullableProp(prop));
            }, optional);
        };
    };
    /**
     * @example
     * import { Optional } from 'monocle-ts'
     *
     * interface S {
     *   a: number | undefined | null
     * }
     *
     * const optional = Optional.fromNullableProp<S>()('a')
     *
     * const s1: S = { a: undefined }
     * const s2: S = { a: null }
     * const s3: S = { a: 1 }
     *
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), s2)
     * assert.deepStrictEqual(optional.set(2)(s3), { a: 2 })
     *
     * @since 1.0.0
     */ Optional.fromNullableProp = function() {
        return function(k) {
            return new Optional(function(s) {
                return (0, $52d3945e22e86057$export$b601f49376b4621a)(s[k]);
            }, function(a) {
                return function(s) {
                    return s[k] == null ? s : update(s, k, a);
                };
            });
        };
    };
    /**
     * Returns an `Optional` from an option (`Option<A>`) prop
     *
     * @example
     * import { Optional } from 'monocle-ts'
     * import * as O from 'fp-ts/Option'
     *
     * interface S {
     *   a: O.Option<number>
     * }
     *
     * const optional = Optional.fromOptionProp<S>()('a')
     * const s1: S = { a: O.none }
     * const s2: S = { a: O.some(1) }
     * assert.deepStrictEqual(optional.set(2)(s1), s1)
     * assert.deepStrictEqual(optional.set(2)(s2), { a: O.some(2) })
     *
     * @since 1.0.0
     */ Optional.fromOptionProp = function() {
        var formProp = Lens.fromProp();
        return function(prop) {
            return formProp(prop).composePrism(somePrism);
        };
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modify = function(f) {
        return $6ee048ed19e5d55a$export$3ff57735a52b8713(f)(this);
    };
    /**
     * @since 1.0.0
     */ Optional.prototype.modifyOption = function(f) {
        return $6ee048ed19e5d55a$export$a2ef9d652875bdfa(f)(this);
    };
    /**
     * view a `Optional` as a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.asTraversal = function() {
        return fromTraversal($6ee048ed19e5d55a$export$ef38eac73d6f828f(this));
    };
    /**
     * view an `Optional` as a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return function(s) {
                    var oa = _this.getOption(s);
                    return (0, $52d3945e22e86057$export$e56af863d5645d5f)(oa) ? M.empty : f(oa.value);
                };
            };
        });
    };
    /**
     * view an `Optional` as a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Optional` with a `Optional`
     *
     * @since 1.0.0
     */ Optional.prototype.compose = function(ab) {
        return fromOptional($6ee048ed19e5d55a$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Optional.prototype.composeOptional = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose an `Optional` with a `Traversal`
     *
     * @since 1.0.0
     */ Optional.prototype.composeTraversal = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $6ee048ed19e5d55a$export$ef38eac73d6f828f, $5b7de3caec026191$export$f672e0b6f7222cd7(ab)));
    };
    /**
     * compose an `Optional` with a `Fold`
     *
     * @since 1.0.0
     */ Optional.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose an `Optional` with a `Setter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose an `Optional` with a `Lens`
     *
     * @since 1.0.0
     */ Optional.prototype.composeLens = function(ab) {
        return fromOptional((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $6ee048ed19e5d55a$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $9066168b32797695$exports.asOptional))));
    };
    /**
     * compose an `Optional` with a `Prism`
     *
     * @since 1.0.0
     */ Optional.prototype.composePrism = function(ab) {
        return fromOptional((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $6ee048ed19e5d55a$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $19e144429a70bac9$export$81a625dd455a09de))));
    };
    /**
     * compose an `Optional` with a `Iso`
     *
     * @since 1.0.0
     */ Optional.prototype.composeIso = function(ab) {
        return fromOptional((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $6ee048ed19e5d55a$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $a97fa24f64672e8e$export$81a625dd455a09de))));
    };
    /**
     * compose an `Optional` with a `Getter`
     *
     * @since 1.0.0
     */ Optional.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Optional;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Traversal = /** @class */ function() {
    function Traversal(// Van Laarhoven representation
    modifyF) {
        this.modifyF = modifyF;
        /**
         * @since 1.0.0
         */ this._tag = 'Traversal';
    }
    /**
     * @since 1.0.0
     */ Traversal.prototype.modify = function(f) {
        return $5b7de3caec026191$export$3ff57735a52b8713(f)(this);
    };
    /**
     * @since 1.0.0
     */ Traversal.prototype.set = function(a) {
        return $5b7de3caec026191$export$adaa4cf7ef1b65be(a)(this);
    };
    Traversal.prototype.filter = function(predicate) {
        return fromTraversal($5b7de3caec026191$export$3dea766d36a8935f(predicate)(this));
    };
    /**
     * view a `Traversal` as a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.asFold = function() {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.modifyF((0, $1625efb126506723$export$1402880adb2295a7)(M))(function(a) {
                    return (0, $1625efb126506723$export$dd44f18ab656f3bb)(f(a));
                });
            };
        });
    };
    /**
     * view a `Traversal` as a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.asSetter = function() {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(f);
        });
    };
    /**
     * compose a `Traversal` with a `Traversal`
     *
     * @since 1.0.0
     */ Traversal.prototype.compose = function(ab) {
        return fromTraversal($5b7de3caec026191$export$f672e0b6f7222cd7(ab)(this));
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeTraversal = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Traversal` with a `Fold`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Setter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeSetter = function(ab) {
        return this.asSetter().compose(ab);
    };
    /**
     * compose a `Traversal` with a `Optional`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeOptional = function(ab) {
        return this.compose(ab.asTraversal());
    };
    /**
     * compose a `Traversal` with a `Lens`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeLens = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $5b7de3caec026191$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $9066168b32797695$exports.asTraversal))));
    };
    /**
     * compose a `Traversal` with a `Prism`
     *
     * @since 1.0.0
     */ Traversal.prototype.composePrism = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $5b7de3caec026191$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $19e144429a70bac9$export$ef38eac73d6f828f))));
    };
    /**
     * compose a `Traversal` with a `Iso`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeIso = function(ab) {
        return fromTraversal((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(this, $5b7de3caec026191$export$f672e0b6f7222cd7((0, $943b7a1a0eab6ad7$export$a4627e546088548d)(ab, $a97fa24f64672e8e$export$ef38eac73d6f828f))));
    };
    /**
     * compose a `Traversal` with a `Getter`
     *
     * @since 1.0.0
     */ Traversal.prototype.composeGetter = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Traversal;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var At = /** @class */ function() {
    function At(at) {
        this.at = at;
        /**
         * @since 1.0.0
         */ this._tag = 'At';
    }
    /**
     * lift an instance of `At` using an `Iso`
     *
     * @since 1.2.0
     */ At.prototype.fromIso = function(iso) {
        return fromAt($d64c9e8784d5648b$export$3160d47a1ad63980(iso)(this));
    };
    return At;
}();
/**
 * @category constructor
 * @since 1.2.0
 */ var Index = /** @class */ function() {
    function Index(index) {
        this.index = index;
        /**
         * @since 1.0.0
         */ this._tag = 'Index';
    }
    /**
     * @since 1.2.0
     */ Index.fromAt = function(at) {
        return fromIndex($6e81345a850ee8a7$export$c4dd3e639c7af330(at));
    };
    /**
     * lift an instance of `Index` using an `Iso`
     *
     * @since 1.2.0
     */ Index.prototype.fromIso = function(iso) {
        return fromIndex($6e81345a850ee8a7$export$3160d47a1ad63980(iso)(this));
    };
    return Index;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Getter = /** @class */ function() {
    function Getter(get) {
        this.get = get;
        /**
         * @since 1.0.0
         */ this._tag = 'Getter';
    }
    /**
     * view a `Getter` as a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.asFold = function() {
        var _this = this;
        return new Fold(function() {
            return function(f) {
                return function(s) {
                    return f(_this.get(s));
                };
            };
        });
    };
    /**
     * compose a `Getter` with a `Getter`
     *
     * @since 1.0.0
     */ Getter.prototype.compose = function(ab) {
        var _this = this;
        return new Getter(function(s) {
            return ab.get(_this.get(s));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Getter.prototype.composeGetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Getter` with a `Fold`
     *
     * @since 1.0.0
     */ Getter.prototype.composeFold = function(ab) {
        return this.asFold().compose(ab);
    };
    /**
     * compose a `Getter` with a `Lens`
     *
     * @since 1.0.0
     */ Getter.prototype.composeLens = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Iso`
     *
     * @since 1.0.0
     */ Getter.prototype.composeIso = function(ab) {
        return this.compose(ab.asGetter());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeTraversal = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Optional`
     *
     * @since 1.0.0
     */ Getter.prototype.composeOptional = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    /**
     * compose a `Getter` with a `Prism`
     *
     * @since 1.0.0
     */ Getter.prototype.composePrism = function(ab) {
        return this.asFold().compose(ab.asFold());
    };
    return Getter;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Fold = /** @class */ function() {
    function Fold(foldMap) {
        this.foldMap = foldMap;
        /**
         * @since 1.0.0
         */ this._tag = 'Fold';
        this.getAll = foldMap($80651cc7cbc1f14e$export$c2a7ef2cc9b32b31())($80651cc7cbc1f14e$export$ba255e9e49e00608);
        this.exist = foldMap((0, $cc297423db0e9671$export$c147905ca5134122));
        this.all = foldMap((0, $cc297423db0e9671$export$ea84ccdc68daa647));
        this.foldMapFirst = foldMap((0, $52d3945e22e86057$export$56cd0d85e73e688f)());
    }
    /**
     * compose a `Fold` with a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.compose = function(ab) {
        var _this = this;
        return new Fold(function(M) {
            return function(f) {
                return _this.foldMap(M)(ab.foldMap(M)(f));
            };
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Fold.prototype.composeFold = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Fold` with a `Getter`
     *
     * @since 1.0.0
     */ Fold.prototype.composeGetter = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Traversal`
     *
     * @since 1.0.0
     */ Fold.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Optional`
     *
     * @since 1.0.0
     */ Fold.prototype.composeOptional = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Lens`
     *
     * @since 1.0.0
     */ Fold.prototype.composeLens = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Prism`
     *
     * @since 1.0.0
     */ Fold.prototype.composePrism = function(ab) {
        return this.compose(ab.asFold());
    };
    /**
     * compose a `Fold` with a `Iso`
     *
     * @since 1.0.0
     */ Fold.prototype.composeIso = function(ab) {
        return this.compose(ab.asFold());
    };
    Fold.prototype.find = function(p) {
        return this.foldMapFirst((0, $52d3945e22e86057$export$23f31c55d7162b91)(p));
    };
    /**
     * get the first target of a `Fold`
     *
     * @since 1.0.0
     */ Fold.prototype.headOption = function(s) {
        return this.find(function() {
            return true;
        })(s);
    };
    return Fold;
}();
/**
 * @category constructor
 * @since 1.0.0
 */ var Setter = /** @class */ function() {
    function Setter(modify) {
        this.modify = modify;
        /**
         * @since 1.0.0
         */ this._tag = 'Setter';
    }
    /**
     * @since 1.0.0
     */ Setter.prototype.set = function(a) {
        return this.modify((0, $195a10ed7200bcca$export$c983f826f44ff86)(a));
    };
    /**
     * compose a `Setter` with a `Setter`
     *
     * @since 1.0.0
     */ Setter.prototype.compose = function(ab) {
        var _this = this;
        return new Setter(function(f) {
            return _this.modify(ab.modify(f));
        });
    };
    /**
     * Alias of `compose`
     *
     * @since 1.0.0
     */ Setter.prototype.composeSetter = function(ab) {
        return this.compose(ab);
    };
    /**
     * compose a `Setter` with a `Traversal`
     *
     * @since 1.0.0
     */ Setter.prototype.composeTraversal = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Optional`
     *
     * @since 1.0.0
     */ Setter.prototype.composeOptional = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Lens`
     *
     * @since 1.0.0
     */ Setter.prototype.composeLens = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Prism`
     *
     * @since 1.0.0
     */ Setter.prototype.composePrism = function(ab) {
        return this.compose(ab.asSetter());
    };
    /**
     * compose a `Setter` with a `Iso`
     *
     * @since 1.0.0
     */ Setter.prototype.composeIso = function(ab) {
        return this.compose(ab.asSetter());
    };
    return Setter;
}();
function fromTraversable(T) {
    var f = $5b7de3caec026191$export$126b5a87c58d3f9c(T);
    return function() {
        return fromTraversal(f());
    };
}
function fromFoldable(F) {
    return function() {
        return new Fold(function(M) {
            var foldMapFM = F.foldMap(M);
            return function(f) {
                return function(s) {
                    return foldMapFM(s, f);
                };
            };
        });
    };
}

});

parcelRegister("9HbQX", function(module, exports) {
"use strict";
/**
 * Sometimes you don't allow every type to be partially parsed.
 * For example, you may not want a partial number because it may increase its size gradually before it's complete.
 * In this case, you can use the `Allow` object to control what types you allow to be partially parsed.
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.ALL = module.exports.COLLECTION = module.exports.ATOM = module.exports.SPECIAL = module.exports.INF = module.exports._INFINITY = module.exports.INFINITY = module.exports.NAN = module.exports.BOOL = module.exports.NULL = module.exports.OBJ = module.exports.ARR = module.exports.NUM = module.exports.STR = void 0;
/**
 * allow partial strings like `"hello \u12` to be parsed as `"hello "`
 */ module.exports.STR = 1;
/**
 * allow partial numbers like `123.` to be parsed as `123`
 */ module.exports.NUM = 2;
/**
 * allow partial arrays like `[1, 2,` to be parsed as `[1, 2]`
 */ module.exports.ARR = 4;
/**
 * allow partial objects like `{"a": 1, "b":` to be parsed as `{"a": 1}`
 */ module.exports.OBJ = 8;
/**
 * allow `nu` to be parsed as `null`
 */ module.exports.NULL = 16;
/**
 * allow `tr` to be parsed as `true`, and `fa` to be parsed as `false`
 */ module.exports.BOOL = 32;
/**
 * allow `Na` to be parsed as `NaN`
 */ module.exports.NAN = 64;
/**
 * allow `Inf` to be parsed as `Infinity`
 */ module.exports.INFINITY = 128;
/**
 * allow `-Inf` to be parsed as `-Infinity`
 */ module.exports._INFINITY = 256;
module.exports.INF = module.exports.INFINITY | module.exports._INFINITY;
module.exports.SPECIAL = module.exports.NULL | module.exports.BOOL | module.exports.INF | module.exports.NAN;
module.exports.ATOM = module.exports.STR | module.exports.NUM | module.exports.SPECIAL;
module.exports.COLLECTION = module.exports.ARR | module.exports.OBJ;
module.exports.ALL = module.exports.ATOM | module.exports.COLLECTION;
/**
 * Control what types you allow to be partially parsed.
 * The default is to allow all types to be partially parsed, which in most casees is the best option.
 * @example
 * If you don't want to allow partial objects, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, Allow.ARR); // [ { a: 1, b: 2 } ]
 * ```
 * Or you can use `~` to disallow a type:
 * ```ts
 * parse(`[{"a": 1, "b": 2}, {"a": 3,`, ~Allow.OBJ); // [ { a: 1, b: 2 } ]
 * ```
 * @example
 * If you don't want to allow partial strings, you can use the following code:
 * ```ts
 * import { Allow, parse } from "partial-json";
 * parse(`["complete string", "incompl`, ~Allow.STR); // [ 'complete string' ]
 * ```
 */ module.exports.Allow = {
    STR: module.exports.STR,
    NUM: module.exports.NUM,
    ARR: module.exports.ARR,
    OBJ: module.exports.OBJ,
    NULL: module.exports.NULL,
    BOOL: module.exports.BOOL,
    NAN: module.exports.NAN,
    INFINITY: module.exports.INFINITY,
    _INFINITY: module.exports._INFINITY,
    INF: module.exports.INF,
    SPECIAL: module.exports.SPECIAL,
    ATOM: module.exports.ATOM,
    COLLECTION: module.exports.COLLECTION,
    ALL: module.exports.ALL
};
module.exports.default = module.exports.Allow;

});

parcelRegister("h3M3Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4ZLyq = parcelRequire("4ZLyq");


var $h0VcS = parcelRequire("h0VcS");




var $4gJu8 = parcelRequire("4gJu8");

function $6469ee68ac90b18d$export$916f6bbdfa1987d0(onObservableInit, initialState, inputs) {
    const [state, callback] = (0, $4gJu8.useStatefulObservableLazyEffect)(onObservableInit, initialState);
    (0, $cozmU.useEffect)(()=>{
        callback({
            inputs: inputs,
            state: initialState
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, inputs);
    return [
        state,
        callback
    ];
}



var $aedCm = parcelRequire("aedCm");


var $aJxVU = parcelRequire("aJxVU");

function $999d634f0b4f56e4$export$d6e2ae1e990d7e71(request, config, onStateChange) {
    const refetchId = (0, $cozmU.useRef)(crypto.randomUUID());
    const [state, setState] = (0, $6469ee68ac90b18d$export$916f6bbdfa1987d0)((0, $aedCm.convoAIStreamingEffect), (0, $aJxVU.getDefaultConvoAIStreamingState)(), [
        request,
        config,
        refetchId.current
    ]);
    (0, $h0VcS.useObservableEffect)((input$)=>input$.pipe((0, $4ZLyq.tap)(([nextState, onStateChangeCalback])=>onStateChangeCalback?.(nextState))), [
        state,
        onStateChange
    ]);
    const refetch = (0, $cozmU.useCallback)(()=>{
        refetchId.current = crypto.randomUUID();
        setState({
            inputs: [
                request,
                config,
                refetchId.current
            ],
            state: (0, $aJxVU.getDefaultConvoAIStreamingState)()
        });
    }, [
        request,
        config,
        setState
    ]);
    return [
        state,
        refetch
    ];
}
module.exports["useConvoAIStreaming"] = $999d634f0b4f56e4$export$d6e2ae1e990d7e71;

});

parcelRegister("aLFsc", function(module, exports) {
"use strict";
var $7d6e73073ed4f084$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7d6e73073ed4f084$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7d6e73073ed4f084$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Allow = module.exports.MalformedJSON = module.exports.PartialJSON = module.exports.parseJSON = module.exports.parse = void 0;

Object.defineProperty(module.exports, "Allow", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9HbQX")).Allow;
    }
});

$7d6e73073ed4f084$var$__exportStar((parcelRequire("9HbQX")), module.exports);
class $7d6e73073ed4f084$var$PartialJSON extends Error {
}
module.exports.PartialJSON = $7d6e73073ed4f084$var$PartialJSON;
class $7d6e73073ed4f084$var$MalformedJSON extends Error {
}
module.exports.MalformedJSON = $7d6e73073ed4f084$var$MalformedJSON;
/**
 * Parse incomplete JSON
 * @param {string} jsonString Partial JSON to be parsed
 * @param {number} allowPartial Specify what types are allowed to be partial, see {@link Allow} for details
 * @returns The parsed JSON
 * @throws {PartialJSON} If the JSON is incomplete (related to the `allow` parameter)
 * @throws {MalformedJSON} If the JSON is malformed
 */ function $7d6e73073ed4f084$var$parseJSON(jsonString, allowPartial = (parcelRequire("9HbQX")).Allow.ALL) {
    if (typeof jsonString !== "string") throw new TypeError(`expecting str, got ${typeof jsonString}`);
    if (!jsonString.trim()) throw new Error(`${jsonString} is empty`);
    return $7d6e73073ed4f084$var$_parseJSON(jsonString.trim(), allowPartial);
}
module.exports.parseJSON = $7d6e73073ed4f084$var$parseJSON;
const $7d6e73073ed4f084$var$_parseJSON = (jsonString, allow)=>{
    const length = jsonString.length;
    let index = 0;
    const markPartialJSON = (msg)=>{
        throw new $7d6e73073ed4f084$var$PartialJSON(`${msg} at position ${index}`);
    };
    const throwMalformedError = (msg)=>{
        throw new $7d6e73073ed4f084$var$MalformedJSON(`${msg} at position ${index}`);
    };
    const parseAny = ()=>{
        skipBlank();
        if (index >= length) markPartialJSON("Unexpected end of input");
        if (jsonString[index] === '"') return parseStr();
        if (jsonString[index] === "{") return parseObj();
        if (jsonString[index] === "[") return parseArr();
        if (jsonString.substring(index, index + 4) === "null" || (parcelRequire("9HbQX")).Allow.NULL & allow && length - index < 4 && "null".startsWith(jsonString.substring(index))) {
            index += 4;
            return null;
        }
        if (jsonString.substring(index, index + 4) === "true" || (parcelRequire("9HbQX")).Allow.BOOL & allow && length - index < 4 && "true".startsWith(jsonString.substring(index))) {
            index += 4;
            return true;
        }
        if (jsonString.substring(index, index + 5) === "false" || (parcelRequire("9HbQX")).Allow.BOOL & allow && length - index < 5 && "false".startsWith(jsonString.substring(index))) {
            index += 5;
            return false;
        }
        if (jsonString.substring(index, index + 8) === "Infinity" || (parcelRequire("9HbQX")).Allow.INFINITY & allow && length - index < 8 && "Infinity".startsWith(jsonString.substring(index))) {
            index += 8;
            return Infinity;
        }
        if (jsonString.substring(index, index + 9) === "-Infinity" || (parcelRequire("9HbQX")).Allow._INFINITY & allow && 1 < length - index && length - index < 9 && "-Infinity".startsWith(jsonString.substring(index))) {
            index += 9;
            return -Infinity;
        }
        if (jsonString.substring(index, index + 3) === "NaN" || (parcelRequire("9HbQX")).Allow.NAN & allow && length - index < 3 && "NaN".startsWith(jsonString.substring(index))) {
            index += 3;
            return NaN;
        }
        return parseNum();
    };
    const parseStr = ()=>{
        const start = index;
        let escape = false;
        index++; // skip initial quote
        while(index < length && (jsonString[index] !== '"' || escape && jsonString[index - 1] === "\\")){
            escape = jsonString[index] === "\\" ? !escape : false;
            index++;
        }
        if (jsonString.charAt(index) == '"') try {
            return JSON.parse(jsonString.substring(start, ++index - Number(escape)));
        } catch (e) {
            throwMalformedError(String(e));
        }
        else if ((parcelRequire("9HbQX")).Allow.STR & allow) try {
            return JSON.parse(jsonString.substring(start, index - Number(escape)) + '"');
        } catch (e) {
            // SyntaxError: Invalid escape sequence
            return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("\\")) + '"');
        }
        markPartialJSON("Unterminated string literal");
    };
    const parseObj = ()=>{
        index++; // skip initial brace
        skipBlank();
        const obj = {};
        try {
            while(jsonString[index] !== "}"){
                skipBlank();
                if (index >= length && (parcelRequire("9HbQX")).Allow.OBJ & allow) return obj;
                const key = parseStr();
                skipBlank();
                index++; // skip colon
                try {
                    const value = parseAny();
                    obj[key] = value;
                } catch (e) {
                    if ((parcelRequire("9HbQX")).Allow.OBJ & allow) return obj;
                    else throw e;
                }
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("9HbQX")).Allow.OBJ & allow) return obj;
            else markPartialJSON("Expected '}' at end of object");
        }
        index++; // skip final brace
        return obj;
    };
    const parseArr = ()=>{
        index++; // skip initial bracket
        const arr = [];
        try {
            while(jsonString[index] !== "]"){
                arr.push(parseAny());
                skipBlank();
                if (jsonString[index] === ",") index++; // skip comma
            }
        } catch (e) {
            if ((parcelRequire("9HbQX")).Allow.ARR & allow) return arr;
            markPartialJSON("Expected ']' at end of array");
        }
        index++; // skip final bracket
        return arr;
    };
    const parseNum = ()=>{
        if (index === 0) {
            if (jsonString === "-") throwMalformedError("Not sure what '-' is");
            try {
                return JSON.parse(jsonString);
            } catch (e) {
                if ((parcelRequire("9HbQX")).Allow.NUM & allow) try {
                    return JSON.parse(jsonString.substring(0, jsonString.lastIndexOf("e")));
                } catch (e) {}
                throwMalformedError(String(e));
            }
        }
        const start = index;
        if (jsonString[index] === "-") index++;
        while(jsonString[index] && ",]}".indexOf(jsonString[index]) === -1)index++;
        if (index == length && !((parcelRequire("9HbQX")).Allow.NUM & allow)) markPartialJSON("Unterminated number literal");
        try {
            return JSON.parse(jsonString.substring(start, index));
        } catch (e) {
            if (jsonString.substring(start, index) === "-") markPartialJSON("Not sure what '-' is");
            try {
                return JSON.parse(jsonString.substring(start, jsonString.lastIndexOf("e")));
            } catch (e) {
                throwMalformedError(String(e));
            }
        }
    };
    const skipBlank = ()=>{
        while(index < length && " \n\r\t".includes(jsonString[index]))index++;
    };
    return parseAny();
};
const $7d6e73073ed4f084$var$parse = $7d6e73073ed4f084$var$parseJSON;
module.exports.parse = $7d6e73073ed4f084$var$parse;

});


//# sourceMappingURL=FullPageEditorComponent.039234a1.js.map
